// do not manually modify this auto-generated file!!

export const allLocales = [
  {
    lang: 'ar',
    namespace: 'designSystem',
    file: 'common',
    translations: {
      dataTable: {
        noSearchResultsFound: 'No search results found.',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'designSystem',
    file: 'common',
    translations: {
      dataTable: {
        noSearchResultsFound: 'No search results found.',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'designSystem',
    file: 'common',
    translations: {
      welcome: 'स्वागत है',
    },
  },
  {
    lang: 'ru',
    namespace: 'designSystem',
    file: 'common',
    translations: {
      welcome: 'Добро пожаловать',
    },
  },
  {
    lang: 'zh',
    namespace: 'designSystem',
    file: 'common',
    translations: {
      welcome: '欢迎',
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'common',
    translations: {
      cancel: 'إلغاء',
      save: 'حفظ',
      loading: 'جاري التحميل...',
      delete: 'حذف المنظمة',
      submit: 'إرسال',
      search: 'بحث',
      genericError: 'Something went wrong. Try again',
      navMenu: {
        users: 'المستخدمين',
        teams: 'الفرق',
        projects: 'المشاريع',
        orgs: 'المنظمات',
        logs: 'السجلات',
        userPreferences: 'تفضيلات المستخدم',
        logout: 'تسجيل الخروج',
        orgPrefix: 'لـ',
        superAdmin: 'المشرف العام',
      },
      products: {
        analytics: 'التحليلات',
        manager: 'المدير',
        agentAssist: 'مركز الاتصال',
        youDontHaveAccess: 'ليس لديك صلاحية الوصول إلى هذه الأداة',
        proStudio: 'ستوديو برو',
        analyticsDescription: 'إفتح الرؤى وتحسين العمليات.',
        managerDescription: 'تنظيم فريقك والمشاريع بكفاءة.',
        agentAssistDescription: 'منصة التواصل العميلي الذكية.',
        proStudioDescription: 'إنشاء عمليات ذكية باستخدام الذكاء الاصطناعي.',
        selectToolToView: 'حدد أداة لعرض {{projectName}}',
      },
      homepage: {
        header: {
          tools: 'أدوات',
        },
        projects: {
          createProject: 'إنشاء مشروع',
          yourProjects: 'مشاريعك',
          project: 'مشروع',
          tools: 'أدوات',
          lastUpdated: 'آخر تحديث',
          toGetStartedCreateProject: 'للبدء، أنشئ مشروعك الأول.',
          nothingToShowHere: 'لا يوجد شيء لعرضه هنا...',
          YouDontHaveAccessToTheToolsInThisProject:
            'ليس لديك حق الوصول إلى الأدوات في هذا المشروع. يرجى الاتصال بمسؤول.',
          YouDontHaveAccessToThisTool: 'ليس لديك حق الوصول إلى هذه الأداة.',
          manageProject: 'إدارة المشروع',
        },
        contacts: {
          needHelp: 'بحاجة الى مساعدة؟',
          yourBrowserDoesNotSupportVideoTag:
            'المتصفح الخاص بك لا يدعم علامة الفيديو.',
          startChat: 'ابدأ الدردشة',
          learnMore: 'تعلم المزيد',
          visitOurSite: 'قم بزيارة موقعنا',
          seeOurBlog: 'انظر الى مدونتنا',
          blog: 'مدونة',
          haveQuestions: 'هل لديك أسئلة؟',
          helpCenter: 'مركز المساعدة',
        },
        noToolAccessMessage:
          'ليس لديك حق الوصول إلى أي مشاريع {{appName}} في هذه المنظمة. تم إعادة توجيهك إلى الرئيسية.',
      },
      firstName: 'الاسم الأول',
      lastName: 'الاسم الأخير',
      emailAddress: 'البريد الإلكتروني',
      permissionAndAccessTable: {
        teamEmptyState: 'لم يتم العثور على أي فرق.',
        addProject: 'إضافة مشروع',
        orgTitle: 'منظمة',
        projectTitle: 'مشروع',
        roleTitle: 'دور',
        toolTitle: 'أداة',
        orgParent: 'الوالد: {{name}}',
        roles: {
          viewOnly: 'للعرض فقط',
        },
        projectsEmptyState:
          'لا يوجد لدى هذه المنظمة أي مشاريع. أنشئ واحدًا للبدء.',
        projectsEmptyStateForViewUser:
          'لا توجد مشاريع لهذه المنظمة. تواصل مع أحد المشرفين للبدء.',
        noProjectsAssigned: 'لم يتم تعيين أي مشاريع',
        addTeam: 'إضافة فريق',
        noPermissionsAssigned: 'لا يوجد وصول - تعيين دور',
        managerRoleTooltip:
          'يؤدي تعيين دور المدير لهذه المنظمة إلى تعيينه لجميع المنظمات الفرعية الحالية والمستقبلية.',
        teamRoleTooltip:
          'يرث المستخدمون في الفريق جميع الأدوار الخاصة بهذا الفريق.',
        projectRemoveDisabledTooltip:
          'لا يمكنك حذف هذا المشروع لأن دورًا واحدًا على الأقل موروث من خلال فريق. قم بتحديث أدوار الفريق لهذا المشروع أو قم بإلغاء تعيين المستخدم من الفريق لتمكين الحذف.',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'logs',
    translations: {
      title: 'السجلات',
      table: {
        column1: 'الإجراء',
        column2: 'المستخدم',
        column3: 'الوقت',
      },
      empty: 'لا توجد بيانات',
      showing: 'عرض',
      of: 'من',
      page: 'الصفحة',
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'organizations',
    translations: {
      childOrgsList: {
        childOrgs: 'المنظمات الفرعية ({{count}})',
        createOrg: 'إنشاء منظمة فرعية',
        editOrg: 'تحرير المنظمة',
        viewOrg: 'عرض المنظمة',
        created: 'تم الإنشاء {{date}}',
        table: {
          name: 'الاسم',
          users: 'المستخدمين',
          teams: 'الفرق',
          projects: 'المشاريع',
          childOrgs: 'المنظمات الفرعية',
          updated: 'آخر تحديث',
        },
        createToGetStarted: 'أنشئ منظمة للبدء.',
      },
      orgDetails: {
        title: 'تفاصيل المنظمة',
      },
      createOrg: {
        title: 'إنشاء منظمة فرعية',
        cancel: 'إلغاء',
        create: 'إنشاء منظمة فرعية',
        creating: 'إنشاء منظمة للأطفال...',
        name: 'الاسم*',
        loginMethods: 'طرق الدخول',
        authProvider: 'مقدم المصادقة*',
        icon: 'الأيقونة',
        accountManager: 'مدير الحساب',
        clientId: 'معرف العميل',
        clientIdSaml: 'عنوان URL لتسجيل الدخول مرة واحدة',
        clientSecret: 'سر العميل',
        clientSecretSaml: 'شهادة X.509',
        issuerURL: 'معرف URI الخاص بالجهة المصدرة',
        issuerURLSaml: 'معرف كيان مزود الخدمة',
        issuerURLHelpText: 'المعرف الفريد لمزود الخدمة (SP) الخاص بك.',
        usernameAttribute: 'اسم السمة اسم المستخدم',
        emailAttribute: 'اسم سمة البريد الإلكتروني',
        redirectURL: 'رابط التحويل',
        entityIssuer: 'معرف كيان مزود الهوية (الجهة المصدرة)',
        entityIssuerHelpText:
          'المعرف الفريد لموفر هوية المستخدم (IdP). هذا الحقل اختياري، ويُرجى ملؤه فقط إذا طلبه موفر هويتك.',
        redirectURLHelpText:
          'استخدم هذا الرابط وأضفه إلى قائمة الروابط المسموحة بها في إعدادات التطبيق الخاص بك في مقدم المصادقة. يتطلب هذا أن يتم توجيه المستخدمين بنجاح إلى المنظمة بعد تسجيل الدخول.',
        placeholders: {
          name: 'الاسم',
          authProvider: 'اختر مقدم المصادقة',
          accountManager: 'اختر مدير الحساب',
          dragPicture: 'اسحب صورة هنا',
          selectFile: 'حدد ملفًا',
          emailDomain: '@domain.com',
        },
        nameIDPolicyFormat: 'تنسيق سياسة معرف الاسم',
        fieldIsRequired: '{{field}} مطلوب.',
        nameIDPolicyFormatHelpText:
          'صيغة مُعرِّف اسم المستخدم. هذا الحقل اختياري، ويُرجى ملؤه فقط إذا طلبه مُزوِّد هويتك.',
      },
      editOrg: {
        cancel: 'إلغاء',
        back: 'خلف',
        save: 'حفظ',
        saving: 'توفير...',
        delete: 'حذف المنظمة',
        deleteModal: {
          cancel: 'إلغاء',
          removeOrg: 'حذف المنظمة',
          areYouSure: 'هل أنت متأكد؟',
          description:
            'حذف هذه المنظمة سيؤدي إلى حذف {{usersCount}} من المستخدمين و{{projectsCount}} من المشاريع. لا يمكن التراجع عن ذلك.',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'preferences',
    translations: {
      title: 'حسابي',
      general: {
        details: 'التفاصيل',
        name: 'الاسم*',
        email_address: 'عنوان البريد الإلكتروني*',
        job_title: 'المسمى الوظيفي',
        profile_picture: 'الصورة الشخصية',
        cookie_policy: 'سياسة ملفات تعريف الارتباط',
        other_policies: 'السياسات الأخرى',
        reset_password: 'إعادة تعيين كلمة المرور',
        reset_password_help:
          'Googleلإعادة تعيين كلمة المرور، قم بزيارة حسابك على',
        language_timezone: 'اللغة والمنطقة الزمنية',
        default_language: 'اللغة الافتراضية',
        default_timezone: 'المنطقة الزمنية',
        add_job_title: 'أضف المسمى الوظيفي',
        add_name: 'أضف الاسم',
        add_surname: 'أضف اللقب',
        add_email_address: 'أضف عنوان البريد الإلكتروني',
        cookie_policy_label_prefix: 'الموافقة على',
        cookie_policy_label_suffix: 'لمساعدتنا في تحسين تجربتك',
        privacy_policy: 'سياسة الخصوصية',
        terms_conditions: 'الشروط والأحكام',
        dsar_form: 'نموذج DSAR',
        upload_profile_picture_on_google:
          'Googleللاستبدال أو الإزالة، قم بزيارة حسابك على',
        upload_a_file_here: 'ارفع ملفًا هنا',
        select_a_language: 'اختر لغة',
        select_a_time_zone: 'اختر منطقة زمنية',
        language_select_hint: 'لا ينطبق على مركز الاتصال والتحليلات',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'projects',
    translations: {
      projectsList: {
        projects: 'المشاريع',
        createProject: 'إنشاء مشروع',
        table: {
          name: 'الاسم',
          users: 'المستخدمين',
          tools: 'الأدوات',
          updated: 'آخر تحديث',
        },
      },
      sidebar: {
        backToProjects: 'الرجوعالى المشاريع',
        general: 'عام',
        environments: 'البيئات',
        environmentName: '{{environmentName}}',
        projectDetails: 'تفاصيل المشروع',
        appletDetails: 'تفاصيل التطبيق',
      },
      environments: {
        development: 'التطوير',
        testing: 'الاختبار',
        production: 'الإنتاج',
        staging: 'التدريج',
      },
      projectDetails: {
        deleteModal: {
          areYouSure: 'هل أنت متأكد؟',
          youWillLose: 'ستفقد نهائيًا:',
          accessToProjectTools: 'الوصول إلى أدوات المشروع',
          dataInsideProjectTools: 'البيانات داخل أدوات المشروع',
          rolesAssignedForProjectTools: 'الأدوار المعينة لأدوات المشروع',
          removeProject: 'حذف المشروع',
          cancel: 'إلغاء',
          removingProject: 'جارٍ حذف المشروع...',
        },
        createAppletModal: {
          step1: {
            title: 'إنشاء تطبيق',
            subTitle:
              'تطبيق Pypestream هو بيئة التشغيل لوظائف منصة Pypestream على موقع معين. يستدعي كود App Loader منصة Pypestream ويسترجع وينفذ أي تعليمات برمجية إضافية على الصفحة بناءً على شروط معينة. يتضمن ذلك كود تتبع التحليلات وكود الدردشة وعناصر من محرك الأتمتة.',
            name: 'اسم التطبيق',
            description: 'الوصف (اختياري)',
            required: 'هذا الحقل مطلوب',
          },
          step2: {
            title: 'اختر قالب التطبيق للبدء',
            subTitle:
              'تساعدك قوالب التطبيقات على بناء التطبيقات مع إعدادات أقل',
            required: 'يرجى اختيار تطبيق واحد',
            applets: {
              analytics: 'تحليلات',
              pype: 'Pype',
              custom: 'مخصص',
            },
          },
          step3: {
            title: 'نجاح!',
            subTitle: 'تم إنشاء التطبيق الجديد...',
            button: 'تم',
          },
          nextStep: 'التالي',
          backStep: 'رجوع',
        },
        deleteAppletModal: {
          areYouSure: 'هل أنت متأكد؟',
          youWillLose: 'ستفقد نهائيًا:',
          accessToApplet: 'الوصول إلى التطبيق',
          removeApplet: 'حذف التطبيق',
          cancel: 'إلغاء',
        },
        updateAppletInstanceStatusModal: {
          title: 'هل أنت متأكد؟',
          description: 'وصف تبديل الحالة',
          confirmButton: 'تحديث التطبيق',
          cancelButton: 'إلغاء',
        },
        deleteToolModal: {
          title: 'هل تريد حذف نسخة {{tool}} هذه؟',
          subTitle:
            'يؤدي حذف نسخة {{tool}} هذه إلى حذف جميع البيانات المرتبطة بها. ولا يؤثر هذا على نسخ {{tool}} في المشاريع الأخرى.',
          deleteConfirmationHint: 'للتحقق، اكتب "{{tool}}" أدناه',
          deleteButton: 'يمسح',
        },
        environmentURLModal: {
          title: 'تعيين عناوين URL لـ {{environmentName}}',
          subTitle:
            'تنظم المشاريع العمل حول ممتلكات رقمية مثل المواقع الإلكترونية. يجب ربط كل شيء في المشروع بنطاق ويمكن تغيير الإعدادات في إعدادات المشروع.',
          addURLButton: 'إضافة عنوان URL لـ {{environmentName}}',
        },
        cancel: 'إلغاء',
        save: 'حفظ التغييرات',
        saving: 'توفير...',
        delete: 'حذف المشروع',
        created: 'تم الإنشاء {{date}}',
        unsavedChanges: 'هناك تغييرات لم يتم حفظها',
        generalTab: {
          title: 'عام',
          details: {
            detailsCaption: 'التفاصيل',
            name: 'الاسم',
            description: 'الوصف',
            projectIcon: 'أيقونة المشروع',
            placeholders: {
              addName: 'أضف الاسم',
              addDescription: 'أضف الوصف',
              dragPhoto: 'قم بسحب الصورة إلى هنا',
              selectFile: 'حدد ملفًا',
            },
          },
          tools: {
            toolsCaption: 'الأدوات',
            configureToolsYouNeed: 'قم بإعداد الأدوات التي تحتاجها لمشروعك',
            selectOneOrMoreProducts: 'يرجى اختيار أداة أو أكثر',
            editTools: 'أدوات التحرير',
          },
          languageAndTimezone: {
            languageCaption: 'الإعدادات اللغوية',
            defaultLanguage: 'اللغة الافتراضية',
            defaultTimezone: 'المنطقة الزمنية',
            placeholders: {
              selectLanguage: 'اختر اللغة',
              selectTimezone: 'اختر المنطقة الزمنية',
            },
            helpText: {
              locale: 'ينطبق فقط على مركز الاتصال',
              timezone: 'ينطبق فقط على للتحليلات',
            },
          },
        },
        environmentsTab: {
          title: 'نظرة عامة على النشر',
          appletsSection: {
            title: 'تطبيقات الويب',
            addButton: 'إضافة تطبيق',
            description:
              'تطبيق Pypestream هو بيئة التشغيل لوظائف منصة Pypestream على موقع معين.',
            status: 'سحابة',
            trigger: {
              title: 'مشغل',
              label: 'لم يتم تعيين مشغل',
            },
            actions: {
              title: 'إجراءات',
              label: 'لم يتم تعيين إجراءات',
            },
          },
          platformSection: {
            title: 'تكامل المنصة',
            addButton: 'إضافة تكاملات',
          },
          summarySection: {
            developmentUrls: 'عناوين URL الخاصة بـ {{environmentName}}',
            appInterfaces: 'واجهات التطبيقات',
            variables: 'المتغيرات',
          },
          caption: 'البيئات',
          environmentName: '{{environmentName}}',
          description:
            'تنظم المشاريع العمل حول ممتلكات عبر الإنترنت مثل الموقع الإلكتروني. يجب ربط كل شيء في المشروع بنطاق، وبشكل اختياري، نطاقاته الفرعية.',
          addEnvironmentUrl: 'إضافة عنوان URL لـ {{environmentName}}',
          gqlPlaygroundsButton: 'ملعب GQL للتطبيقات',
        },
      },
      createProject: {
        step1: {
          title: 'إنشاء مشروع',
          name: 'اسم المشروع',
          description: 'الوصف (اختياري)',
          icon: 'أيقونة المشروع (اختياري)',
        },
        step2: {
          title: 'عناوين URL للبيئات',
          field1: 'الإنتاج',
          field1Button: 'إضافة عنوان URL للإنتاج',
          field2: 'التدريج',
          field2Button: 'إضافة عنوان URL للتدريج',
          field3: 'التطوير',
          field3Button: 'إضافة عنوان URL للتطوير',
          errors: {
            default: 'يجب أن يكون هذا الحقل عنوان URL صالحًا.',
            invalidDomain: 'النطاق الأعلى غير صالح',
            invalidURL: 'عنوان URL غير صالح',
            intersection:
              'عنوان URL هذا ({{intersection}}) مستخدم في مشروع آخر',
          },
        },
        step3: {
          title: 'اختر الأدوات للدمج',
          required: 'يرجى اختيار أداة واحدة أو أكثر',
        },
        step4: {
          title: 'التعريب',
        },
        step5: {
          title: 'نجاح!',
          subTitle: 'تم إنشاء المشروع الجديد...',
          button: 'تم',
        },
        required: 'هذا الحقل مطلوب',
        nextStep: 'التالي',
        backStep: 'السابق',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'super-admin',
    translations: {
      title: 'المشرف العام',
      permission: 'ليس لديك إذن لعرض هذه الصفحة',
      section1: {
        title: 'هذا الزر لالتقاط لقطة من قاعدة البيانات',
        button: 'التقاط لقطة',
      },
      section2: {
        title: 'رابط إلى صفحة إعدادات التحليلات',
        button: 'التحليلات',
      },
      section3: {
        title: 'رابط إلى صفحة المشرف العام لمركز الاتصال',
        button: 'مركز الاتصال',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'teams',
    translations: {
      teamsList: {
        teams: 'الفرق',
        createTeam: 'إنشاء فريق',
        table: {
          name: 'الاسم',
          users: 'المستخدمين',
          updated: 'آخر تحديث',
        },
        createToGetStarted: 'أنشئ فريقًا للبدء.',
      },
      teamDetails: {
        createTeam: 'إنشاء فريق',
        deleteTeam: 'حذف الفريق',
        teamInfo: {
          name: 'اسم',
          description: 'وصف',
          contactCenterAccess:
            'يؤدي منح فريق حق الوصول إلى نسخة مركز الاتصال إلى إنشاء فريق مرتبط بها. لا يمكن إدارة الفرق إلا هنا، وليس في مركز الاتصال.',
        },
        teamUsers: {
          teamMembers: 'أعضاء الفريق',
          teamMembersSubTitle: 'يرث أعضاء الفريق جميع الأدوار المخصصة للفريق.',
          teamMembersOtherOrgs: 'أعضاء الفريق في المنظمات الأخرى',
          teamMembersOtherOrgsSubTitle:
            'لا يمكن إدارة أعضاء الفريق في منظمات أخرى من هذه الشاشة. لإزالتهم من هذا الفريق، انتقل إلى إعدادات المستخدم الخاصة بهم.',
          user: 'مستخدم',
          lastActive: 'آخر نشاط',
          addUsers: 'إضافة المستخدمين',
          noUsers: 'لا يوجد مستخدمين في هذه المنظمة',
          noUsersInTeam: 'لا يوجد مستخدمين في هذا الفريق.',
        },
        deleteTeamModal: {
          mainTitle: 'حذف الفريق {{teamName}}؟',
          subTitle: 'سيؤدي حذف {{teamName}} إلى:',
          line1: 'إزالة الأدوار الموروثة من جميع المستخدمين في هذا الفريق',
          line2: 'حذف أي فرق مرتبطة في حالات مركز الاتصال المرتبطة',
          cancel: 'يلغي',
          delete: 'يمسح',
          deleting: 'جاري الحذف...',
        },
        snackbar: {
          createTeamText: 'عندما تكون مستعدًا، قم بإنشاء الفريق',
          updateTeamText: 'هناك تغييرات غير محفوظة',
          cancel: 'يلغي',
          create: 'إنشاء فريق',
          creating: 'إنشاء فريق...',
          update: 'حفظ التغييرات',
          updating: 'حفظ التغييرات...',
        },
        permissionAndAccessTitle: 'الأدوار',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'manager',
    file: 'users',
    translations: {
      usersList: {
        users: 'المستخدمين',
        createUser: 'إنشاء مستخدم',
        bulkInviteUsers: 'دعوة جماعية',
        bulkInviting: 'دعوة...',
        table: {
          name: 'الاسم',
          email: 'البريد الإلكتروني',
          lastActive: 'آخر نشاط',
          invited: 'تم الدعوة',
        },
        createToGetStarted: 'أنشئ مستخدمًا للبدء.',
      },
      userDetails: {
        title: 'تفاصيل المستخدم',
        permissionAndAccessTitle: 'الأدوار',
        deleteUserConfirmationModal: {
          description:
            'سيتم إزالة جميع صلاحياتهم. لا يمكن التراجع عن هذا الإجراء.',
          title: 'حذف {{userName}}؟',
        },
        agentConversationLimit: 'حد محادثة الوكيل',
        agentConversationLimitTooltip:
          'الحد الأقصى لعدد المحادثات التي يمكن تعيينها لوكيل في وقت واحد.',
        smartOrgMenu: 'القائمة التنظيمية الذكية',
        smartOrgMenuTooltip:
          'يعرض فقط المنظمات التي يمكنك الوصول إلى أداة واحدة على الأقل منها أو التي تكون فيها عضوًا في فريق. تبقى المنظمات الرئيسية مرئية إذا كانت تحتوي على منظمات فرعية مرئية. تبقى منظمتك الرئيسية مرئية.',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'common',
    translations: {
      cancel: 'Cancel',
      save: 'Save Changes',
      loading: 'Loading...',
      delete: 'Delete',
      submit: 'Submit',
      search: 'Search',
      genericError: 'Something went wrong. Try again',
      navMenu: {
        users: 'Users',
        teams: 'Teams',
        projects: 'Projects',
        orgs: 'Orgs',
        logs: 'Logs',
        userPreferences: 'My Account',
        logout: 'Logout',
        orgPrefix: 'for',
        superAdmin: 'Super Admin',
      },
      products: {
        analytics: 'Analytics',
        manager: 'Manager',
        agentAssist: 'Contact Center',
        youDontHaveAccess: 'You don’t have access to this tool',
        proStudio: 'Pro Studio',
        analyticsDescription: 'Unlock insights and optimize workflows.',
        managerDescription: 'Organize your team and projects efficiently.',
        agentAssistDescription: 'AI powered customer engagement platform.',
        proStudioDescription: 'Build AI powered workflows.',
        selectToolToView: 'Select a tool to view {{projectName}}',
      },
      homepage: {
        header: {
          tools: 'Tools',
        },
        projects: {
          createProject: 'Create Project',
          yourProjects: 'Your Projects',
          project: 'Project',
          tools: 'Tools',
          lastUpdated: 'Last updated',
          toGetStartedCreateProject:
            'To get started, create your first project.',
          nothingToShowHere: 'Nothing to show here...',
          YouDontHaveAccessToTheToolsInThisProject:
            'You do not have access to the tools in this project. Contact an admin.',
          YouDontHaveAccessToThisTool: 'You do not have access to this tool.',
          manageProject: 'Manage Project',
        },
        contacts: {
          needHelp: 'Need Help?',
          yourBrowserDoesNotSupportVideoTag:
            'Your browser does not support the video tag.',
          startChat: 'Start Chat',
          learnMore: 'Learn More...',
          visitOurSite: 'Visit our site',
          seeOurBlog: 'See our blog',
          blog: 'Blog',
          haveQuestions: 'Have questions?',
          helpCenter: 'Help Center',
        },
        noToolAccessMessage:
          "You don't have access to any {{appName}} projects in this Organization. You've been brought to Home.",
      },
      firstName: 'First Name',
      lastName: 'Last Name',
      emailAddress: 'Email Address',
      permissionAndAccessTable: {
        teamEmptyState: 'No teams found.',
        addProject: 'Add Project',
        orgTitle: 'Org',
        projectTitle: 'Project',
        roleTitle: 'Role',
        toolTitle: 'Tool',
        orgParent: 'Parent: {{name}}',
        roles: {
          viewOnly: 'View Only',
        },
        projectsEmptyState:
          'This Org has no Projects. Create one to get started.',
        projectsEmptyStateForViewUser:
          'This Org has no Projects. Contact an admin to get started.',
        noProjectsAssigned: 'No projects assigned',
        addTeam: 'Add Team',
        noPermissionsAssigned: 'No access — assign a role',
        managerRoleTooltip:
          'Assigning a Manager role for this Org assigns it for all current and future Child Orgs.',
        teamRoleTooltip: 'Users on a Team inherit all roles of that Team.',
        projectRemoveDisabledTooltip:
          'You cannot remove this project because at least one role is inherited through a team. Update the team’s roles for this project or unassign the user from the team to enable removal.',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'logs',
    translations: {
      title: 'Logs',
      table: {
        column1: 'Action',
        column2: 'User',
        column3: 'When',
      },
      empty: 'No data',
      showing: 'Showing',
      of: 'of',
      page: 'page',
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'organizations',
    translations: {
      childOrgsList: {
        childOrgs: 'Child Orgs ({{count}})',
        createOrg: 'Create Child Org',
        editOrg: 'Edit Org',
        viewOrg: 'View Org',
        created: 'Created {{date}}',
        table: {
          name: 'Name',
          users: 'Users',
          teams: 'Teams',
          projects: 'Projects',
          childOrgs: 'Child Orgs',
          updated: 'Last updated',
        },
        createToGetStarted: 'Create an org to get started.',
      },
      orgDetails: {
        title: 'Org Details',
      },
      createOrg: {
        title: 'Create Child Org',
        cancel: 'Cancel',
        create: 'Create Org',
        creating: 'Creating Org...',
        name: 'Name*',
        loginMethods: 'Login Methods',
        icon: 'Icon',
        accountManager: 'Account Manager',
        clientId: 'Client ID',
        clientIdSaml: 'Single Sign-On URL',
        clientSecret: 'Client Secret',
        clientSecretSaml: 'X.509 Certificate',
        issuerURL: 'Issuer URI',
        issuerURLSaml: 'Service Provider Entity ID',
        issuerURLHelpText:
          'The unique identifier for your Service Provider (SP).',
        usernameAttribute: 'Username Attribute Name',
        emailAttribute: 'Email Attribute Name',
        redirectURL: 'Redirect URI',
        entityIssuer: 'Identity Provider Entity ID (Issuer)',
        entityIssuerHelpText:
          "The unique identifier for the user's Identity Provider (IdP). This field is optional and should only be filled in if your identity provider requires it.",
        redirectURLHelpText:
          'Copy this URI and add it to the list of allowed redirect URIs in your OpenID Connect provider’s application settings. This is required for users to be successfully redirected back after logging in.',
        placeholders: {
          name: 'Name',
          loginMethod: 'Select login method',
          accountManager: 'Select account manager',
          dragPicture: 'Drag a photo here',
          selectFile: 'Select a file',
          emailDomain: '@domain.com',
        },
        nameIDPolicyFormat: 'Name ID Policy Format',
        fieldIsRequired: '{{field}} is required.',
        nameIDPolicyFormatHelpText:
          'The format of the user’s NameID. This field is optional and should only be filled in if your identity provider requires it.',
      },
      editOrg: {
        cancel: 'Cancel',
        back: 'Back',
        save: 'Save Changes',
        saving: 'Saving...',
        delete: 'Delete Org',
        deleteModal: {
          cancel: 'Cancel',
          removeOrg: 'Delete Org',
          areYouSure: 'Are you sure?',
          description:
            'Deleting this Org will delete all users, Projects, and Child Orgs associated with it, including their users and projects. This cannot be undone.',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'preferences',
    translations: {
      title: 'My Account',
      general: {
        details: 'Details',
        name: 'Name*',
        email_address: 'Email address*',
        job_title: 'Job Title',
        profile_picture: 'Profile Picture',
        cookie_policy: 'Cookie Policy',
        other_policies: 'Other Policies',
        reset_password: 'Reset Password',
        reset_password_help:
          'To reset your password, visit your Google account',
        language_timezone: 'Language & Timezone',
        default_language: 'Default language',
        default_timezone: 'Timezone',
        add_job_title: 'Add Job Title',
        add_name: 'Add Name',
        add_surname: 'Add Surname',
        add_email_address: 'Add Email address',
        cookie_policy_label_prefix: 'Opt in to the',
        cookie_policy_label_suffix: 'to help us improve your experience',
        privacy_policy: 'Privacy Policy',
        terms_conditions: 'Terms & Conditions',
        dsar_form: 'DSAR Form',
        upload_profile_picture_on_google:
          'To replace or remove, visit your Google account',
        upload_a_file_here: 'Upload a file here',
        select_a_language: 'Select a language',
        select_a_time_zone: 'Select a time zone',
        language_select_hint: 'Does not apply to Contact Center and Analytics',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'projects',
    translations: {
      projectsList: {
        projects: 'Projects',
        createProject: 'Create Project',
        table: {
          name: 'Name',
          users: 'Users',
          tools: 'Tools',
          updated: 'Last updated',
        },
      },
      sidebar: {
        backToProjects: 'All Projects',
        general: 'General',
        environments: 'Environments',
        environmentName: '{{environmentName}}',
        projectDetails: 'Project Details',
        appletDetails: 'Applet Details',
      },
      environments: {
        development: 'Development',
        testing: 'Testing',
        production: 'Production',
        staging: 'Staging',
      },
      projectDetails: {
        deleteModal: {
          areYouSure: 'Are you sure?',
          youWillLose: "You'll permanently lose:",
          accessToProjectTools: "access to this Project's tool instances",
          dataInsideProjectTools:
            "all data inside this Project's tool instances",
          rolesAssignedForProjectTools:
            "all roles assigned for this Project's tool instances",
          removeProject: 'Delete Project',
          cancel: 'Cancel',
          removingProject: 'Deleting Project...',
        },
        createAppletModal: {
          step1: {
            title: 'Create an Applet',
            subTitle:
              'The Pypestream Applet is the runtime environment for Pypestream platform functionality on a given website. The App Loader code snippet calls the Pypestream platform and retrieves and executes any additional code needed on the page assuming certain conditions are met. This includes Analytics tracking code, chat widget code, and Elements from the automation engine.',
            name: 'Applet Name',
            description: 'Description (optional)',
            required: 'This is a required field',
          },
          step2: {
            title: 'Select applet template to start with',
            subTitle:
              'Applets templates help you to build applets with less configurations',
            required: 'Please select one applet',
            applets: {
              analytics: 'Analytics',
              pype: 'Pype',
              custom: 'Custom',
            },
          },
          step3: {
            title: 'Success!',
            subTitle: 'New applet has been created...',
            button: 'Done',
          },
          nextStep: 'Next',
          backStep: 'Back',
        },
        deleteAppletModal: {
          areYouSure: 'Are you sure?',
          youWillLose: "You'll permanently lose:",
          accessToApplet: 'access to this Applet instance',
          removeApplet: 'Delete Applet',
          cancel: 'Cancel',
        },
        updateAppletInstanceStatusModal: {
          title: 'Are you sure?',
          description: 'Toggle status description',
          confirmButton: 'Update Applet',
          cancelButton: 'Cancel',
        },
        deleteToolModal: {
          title: 'Delete this {{tool}} instance?',
          subTitle:
            'Deleting this {{tool}} instance deletes all associated data. This does not affect {{tool}} instances in other Projects.',
          deleteConfirmationHint: 'To verify, type "{{tool}}" below',
          deleteButton: 'Delete',
        },
        environmentURLModal: {
          title: 'Set {{environmentName}} URLs',
          subTitle:
            'Projects organize work around an online property like a website. Everything in the project must be tied to a domain and, optionally, its subdomains. You can make changes in project settings.',
          addURLButton: 'Add {{environmentName}} URL',
        },
        cancel: 'Cancel',
        save: 'Save Changes',
        saving: 'Saving...',
        delete: 'Delete Project',
        created: 'Created {{date}}',
        unsavedChanges: 'There are unsaved changes',
        generalTab: {
          title: 'General',
          details: {
            detailsCaption: 'Details',
            name: 'Name*',
            description: 'Description',
            projectIcon: 'Project Icon',
            placeholders: {
              addName: 'Add Name',
              addDescription: 'Add description',
              dragPhoto: 'Drag a photo here',
              selectFile: 'Select a file',
            },
          },
          tools: {
            toolsCaption: 'Tools',
            configureToolsYouNeed:
              'Configure the tools you need for your project',
            selectOneOrMoreProducts: 'Please select one or more tools',
            editTools: 'Edit Tools',
          },
          languageAndTimezone: {
            languageCaption: 'Localization',
            defaultLanguage: 'Default language',
            defaultTimezone: 'Timezone',
            placeholders: {
              selectLanguage: 'Select language',
              selectTimezone: 'Select timezone',
            },
            helpText: {
              locale: 'Applies only to Contact Center',
              timezone: 'Applies only to Analytics',
            },
          },
        },
        environmentsTab: {
          title: 'Deployment Overview',
          appletsSection: {
            title: 'Web Applets',
            addButton: 'Add Applet',
            description:
              'The Pypestream Applet is the runtime environment for Pypestream platform functionality on a given website.',
            status: 'Cloud',
            trigger: {
              title: 'Trigger',
              label: "You haven't set a triggers",
            },
            actions: {
              title: 'Actions',
              label: "You haven't set an actions",
            },
          },
          platformSection: {
            title: 'Platform Integrations',
            addButton: 'Add Integrations',
          },
          summarySection: {
            developmentUrls: '{{environmentName}} URLs',
            appInterfaces: 'App Interfaces',
            variables: 'Variables',
          },
          caption: 'Environments',
          environmentName: '{{environmentName}}',
          description:
            'Projects organize work around an online property like a website. Everything in the project must be tied to a domain and, optionally, its subdomains.',
          addEnvironmentUrl: 'Add {{environmentName}} URL',
          gqlPlaygroundsButton: 'GQL playground for Applets',
        },
      },
      createProject: {
        step1: {
          title: 'Create a project',
          name: 'Project name',
          description: 'Description (optional)',
          icon: 'Project Icon (optional)',
        },
        step2: {
          title: 'Environments URLs',
          field1: 'Production',
          field1Button: 'Add Production URL',
          field2: 'Staging',
          field2Button: 'Add Staging URL',
          field3: 'Development',
          field3Button: 'Add Development URL',
          errors: {
            default: 'This field should be a valid url.',
            invalidDomain: 'The top level domain is invalid',
            invalidURL: 'The URL is invalid',
            intersection:
              'This URL ({{intersection}}) is used in another project',
          },
        },
        step3: {
          title: 'Select tooling to integrate',
          required: 'Please select one or more tools',
        },
        step4: {
          title: 'Localization',
        },
        step5: {
          title: 'Success!',
          subTitle: 'New project has been created...',
          button: 'Done',
        },
        required: 'This is a required field',
        nextStep: 'Next',
        backStep: 'Back',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'super-admin',
    translations: {
      title: 'Super Admin',
      permission: 'You don&apos;t have permission to see this page',
      section1: {
        title: 'This button is for making a snapshot of DB',
        button: 'Make Snapshot',
      },
      section2: {
        title: 'Link to Analytics Settings Page',
        button: 'Analytics',
      },
      section3: {
        title: 'Link to Contact Center Super Admin Page',
        button: 'Contact Center',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'teams',
    translations: {
      teamsList: {
        teams: 'Teams',
        createTeam: 'Create Team',
        table: {
          name: 'Name',
          users: 'Users',
          updated: 'Last updated',
        },
        createToGetStarted: 'Create a team to get started.',
      },
      teamDetails: {
        createTeam: 'Create Team',
        deleteTeam: 'Delete Team',
        teamInfo: {
          name: 'Name',
          description: 'Description',
          contactCenterAccess:
            'Giving a Team access to a Contact Center instance creates a linked Team in that instance. Teams can only be managed here, not in Contact Center.',
        },
        teamUsers: {
          teamMembers: 'Team Members',
          teamMembersSubTitle:
            'Team members inherit all roles assigned to the Team.',
          teamMembersOtherOrgs: 'Team Members in Other Orgs',
          teamMembersOtherOrgsSubTitle:
            'Team members in other Orgs cannot be managed from this screen. To remove them from this Team, go to their user settings.',
          user: 'User',
          lastActive: 'Last Active',
          addUsers: 'Add Users',
          noUsers: 'There are no users in this Org',
          noUsersInTeam: 'There are no users in this team.',
        },
        deleteTeamModal: {
          mainTitle: 'Delete team {{teamName}}?',
          subTitle: 'Deleting {{teamName}} will:',
          line1: 'Remove inherited roles from all users in this team',
          line2:
            'Delete any linked teams in associated Contact Center instances',
          cancel: 'Cancel',
          delete: 'Delete',
          deleting: 'Deleting...',
        },
        snackbar: {
          createTeamText: 'When you are ready, create the team',
          updateTeamText: 'There are unsaved changes',
          cancel: 'Cancel',
          create: 'Create Team',
          creating: 'Creating Team...',
          update: 'Save Changes',
          updating: 'Saving Changes...',
        },
        permissionAndAccessTitle: 'Roles',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'manager',
    file: 'users',
    translations: {
      usersList: {
        users: 'Users',
        inviteUser: 'Invite User',
        importUsers: 'Import Users',
        importing: 'Importing...',
        createUser: 'Create User',
        bulkInviteUsers: 'Bulk Invite',
        bulkInviting: 'Inviting...',
        table: {
          name: 'Name',
          email: 'Email',
          lastActive: 'Last Active',
          invited: 'Invited',
        },
        createToGetStarted: 'Create a user to get started.',
      },
      userDetails: {
        title: 'User Details',
        permissionAndAccessTitle: 'Roles',
        deleteUserConfirmationModal: {
          description:
            'This will remove all of their access. This cannot be undone.',
          title: 'Delete {{userName}}?',
        },
        agentConversationLimit: 'Agent Conversation Limit',
        agentConversationLimitTooltip:
          'Maximum number of conversations that an agent can be assigned at one time.',
        smartOrgMenu: 'Smart Org Menu',
        smartOrgMenuTooltip:
          'Shows only Orgs where you have access to at least one Tool or are a member of a Team. Parent Orgs stay visible if they contain visible child Orgs. Your top Org stays visible.',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'manager',
    file: 'common',
    translations: {
      cancel: 'lorem',
      save: 'lorem',
      genericError: 'Something went wrong. Try again',
    },
  },
  {
    lang: 'hi',
    namespace: 'manager',
    file: 'preferences',
    translations: {
      title: 'lorem',
      general: {
        details: 'lorem',
        name: 'lorem',
        email_address: 'lorem',
        job_title: 'lorem',
        profile_picture: 'lorem',
        cookie_policy: 'lorem',
        other_policies: 'lorem',
        reset_password: 'lorem',
        reset_password_help: 'lorem',
        language_timezone: 'lorem',
        default_language: 'lorem',
        default_timezone: 'lorem',
        add_job_title: 'lorem',
        add_name: 'lorem',
        add_surname: 'lorem',
        add_email_address: 'lorem',
        cookie_policy_label_prefix: 'lorem',
        cookie_policy_label_suffix: 'lorem',
        privacy_policy: 'lorem',
        terms_conditions: 'lorem',
        dsar_form: 'lorem',
        upload_profile_picture_on_google: 'lorem',
        upload_a_file_here: 'lorem',
        select_a_language: 'lorem',
        select_a_time_zone: 'lorem',
        applies_only_to_manager: 'lorem',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'manager',
    file: 'common',
    translations: {
      cancel: 'lorem',
      save: 'lorem',
      genericError: 'Something went wrong. Try again',
    },
  },
  {
    lang: 'ru',
    namespace: 'manager',
    file: 'preferences',
    translations: {
      title: 'lorem',
      general: {
        details: 'lorem',
        name: 'lorem',
        email_address: 'lorem',
        job_title: 'lorem',
        profile_picture: 'lorem',
        cookie_policy: 'lorem',
        other_policies: 'lorem',
        reset_password: 'lorem',
        reset_password_help: 'lorem',
        language_timezone: 'lorem',
        default_language: 'lorem',
        default_timezone: 'lorem',
        add_job_title: 'lorem',
        add_name: 'lorem',
        add_surname: 'lorem',
        add_email_address: 'lorem',
        cookie_policy_label_prefix: 'lorem',
        cookie_policy_label_suffix: 'lorem',
        privacy_policy: 'lorem',
        terms_conditions: 'lorem',
        dsar_form: 'lorem',
        upload_profile_picture_on_google: 'lorem',
        upload_a_file_here: 'lorem',
        select_a_language: 'lorem',
        select_a_time_zone: 'lorem',
        applies_only_to_manager: 'lorem',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'manager',
    file: 'common',
    translations: {
      cancel: 'lorem',
      save: 'lorem',
      genericError: 'Something went wrong. Try again',
    },
  },
  {
    lang: 'zh',
    namespace: 'manager',
    file: 'preferences',
    translations: {
      title: 'lorem',
      general: {
        details: 'lorem',
        name: 'lorem',
        email_address: 'lorem',
        job_title: 'lorem',
        profile_picture: 'lorem',
        cookie_policy: 'lorem',
        other_policies: 'lorem',
        reset_password: 'lorem',
        reset_password_help: 'lorem',
        language_timezone: 'lorem',
        default_language: 'lorem',
        default_timezone: 'lorem',
        add_job_title: 'lorem',
        add_name: 'lorem',
        add_surname: 'lorem',
        add_email_address: 'lorem',
        cookie_policy_label_prefix: 'lorem',
        cookie_policy_label_suffix: 'lorem',
        privacy_policy: 'lorem',
        terms_conditions: 'lorem',
        dsar_form: 'lorem',
        upload_profile_picture_on_google: 'lorem',
        upload_a_file_here: 'lorem',
        select_a_language: 'lorem',
        select_a_time_zone: 'lorem',
        applies_only_to_manager: 'lorem',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'navigation',
    file: 'common',
    translations: {
      logo: {
        prefix: 'لـ',
      },
      mega: {
        sidebar: {
          title: 'المشاريع',
          empty: 'لا توجد مشاريع متاحة',
          goHome: 'الرئيسية',
          home: 'الرئيسية',
          error: 'لقد حدث خطأ ما. يرجى إعادة تحميل الصفحة.',
        },
        content: {
          title: 'الاختصارات',
          empty: {
            part1: 'اختر',
            part2: 'مشروعًا',
            part3: 'من القائمة للبدء',
          },
          help: {
            part1: 'تحتاج إلى مساعدة في شيء؟ تواصل مع أخصائي',
            part2: 'هنا',
          },
        },
      },
      userDropdown: {
        superAdmin: 'المشرف العام',
        userAccount: 'حسابي',
        logout: 'تسجيل الخروج',
      },
      error: {
        generic: 'حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا.',
        retry: 'إعادة المحاولة',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'navigation',
    file: 'common',
    translations: {
      logo: {
        prefix: 'for',
      },
      mega: {
        sidebar: {
          title: 'Projects',
          empty: 'No available projects',
          goHome: 'Go Home',
          home: 'Home',
          error: 'Somethings went wrong. Please reload page.',
        },
        content: {
          title: 'Tools',
          empty: {
            part1: 'Select a',
            part2: 'project',
            part3: 'from the menu to get started',
          },
          help: {
            part1: 'Need help with something? Contact a specialist',
            part2: 'here',
          },
        },
      },
      userDropdown: {
        superAdmin: 'Super Admin',
        userAccount: 'My Account',
        logout: 'Logout',
      },
      error: {
        generic: 'Something went wrong. Please try again later.',
        retry: 'Retry',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'navigation',
    file: 'common',
    translations: {
      logo: {
        prefix: 'for',
      },
      mega: {
        sidebar: {
          title: 'Projects',
          empty: 'No available projects',
          home: 'होम',
          goHome: 'होम पर जाएं',
        },
        content: {
          title: 'Tools',
          empty: {
            part1: 'Select a',
            part2: 'project',
            part3: 'from the menu to get started',
          },
          help: {
            part1: 'Need help with something? Contact a specialist',
            part2: 'here',
          },
        },
      },
      userDropdown: {
        logout: 'Logout',
      },
      error: {
        generic: 'कुछ गलत हो गया। कृपया बाद में पुनः प्रयास करें।',
        retry: 'पुनः प्रयास',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'navigation',
    file: 'common',
    translations: {
      logo: {
        prefix: 'for',
      },
      mega: {
        sidebar: {
          title: 'Projects',
          empty: 'No available projects',
          home: 'Главная',
          goHome: 'Вернуться домой',
        },
        content: {
          title: 'Tools',
          empty: {
            part1: 'Select a',
            part2: 'project',
            part3: 'from the menu to get started',
          },
          help: {
            part1: 'Need help with something? Contact a specialist',
            part2: 'here',
          },
        },
      },
      userDropdown: {
        logout: 'Logout',
      },
      error: {
        generic: 'Что-то пошло не так. Пожалуйста, повторите попытку позже.',
        retry: 'Повторить',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'navigation',
    file: 'common',
    translations: {
      logo: {
        prefix: 'for',
      },
      mega: {
        sidebar: {
          title: 'Projects',
          empty: 'No available projects',
          home: '首页',
          goHome: '返回首页',
        },
        content: {
          title: 'Tools',
          empty: {
            part1: 'Select a',
            part2: 'project',
            part3: 'from the menu to get started',
          },
          help: {
            part1: 'Need help with something? Contact a specialist',
            part2: 'here',
          },
        },
      },
      userDropdown: {
        logout: 'Logout',
      },
      error: {
        generic: '出了点问题，请稍后再试。',
        retry: '重试',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'onboarding',
    file: 'common',
    translations: {
      title: 'إنهاء إعداد ملفك الشخصي',
      subTitle: 'باقي بضع أسئلة فقط لك...',
      firstName: 'الاسم الأول',
      lastName: 'الاسم الأخير',
      picture: 'الصورة الشخصية',
      upload_profile_picture_on_google:
        'لتغيير الصورة أو إزالتها، قم بزيارة حسابك على Google',
      upload_a_file_here: 'ارفع ملفًا هنا',
      selectFile: 'حدد ملفًا',
      changePicture: 'تغيير الصورة الشخصية',
      jobTitle: 'المسمى الوظيفي',
      terms_conditions_prefix: 'الموافقة على',
      terms_conditions: 'الشروط والأحكام',
      and: 'و',
      privacy_policy: 'سياسة الخصوصية',
      cookie_policy_label_prefix: 'الموافقة على',
      cookie_policy: 'سياسة ملفات تعريف الارتباط',
      cookie_policy_label_suffix: 'لمساعدتنا في تحسين تجربتك',
      button: 'حفظ التغييرات',
      loading: 'جاري التحميل...',
      error: {
        generic: 'حدث خطأ ما. يرجى المحاولة مرة أخرى لاحقًا.',
        retry: 'إعادة المحاولة',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'onboarding',
    file: 'common',
    translations: {
      title: 'Finish up your profile',
      subTitle: 'Just a couple more questions for you...',
      firstName: 'First Name',
      lastName: 'Last Name',
      picture: 'Profile Picture',
      upload_profile_picture_on_google:
        'To replace or remove, visit your Google account',
      upload_a_file_here: 'Upload a file here',
      selectFile: 'Select a file',
      changePicture: 'Change profile picture',
      jobTitle: 'Job Title',
      terms_conditions_prefix: 'Agree to',
      terms_conditions: 'Terms and Conditions',
      and: 'and',
      privacy_policy: 'Privacy Policy',
      cookie_policy_label_prefix: 'Opt in to the',
      cookie_policy: 'Cookie Policy',
      cookie_policy_label_suffix: 'to help us improve your experience',
      button: 'Save Changes',
      loading: 'Loading...',
      error: {
        generic: 'Something went wrong. Please try again later.',
        retry: 'Retry',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'onboarding',
    file: 'common',
    translations: {
      welcome: 'स्वागत है',
      error: {
        generic: 'कुछ गलत हो गया। कृपया बाद में पुनः प्रयास करें।',
        retry: 'पुनः प्रयास',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'onboarding',
    file: 'common',
    translations: {
      welcome: 'Добро пожаловать',
      error: {
        generic: 'Что-то пошло не так. Пожалуйста, повторите попытку позже.',
        retry: 'Повторить',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'onboarding',
    file: 'common',
    translations: {
      welcome: '欢迎',
      error: {
        generic: '出了点问题，请稍后再试。',
        retry: '重试',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'actions',
    translations: {
      title: '_Actions',
      subtitle: {
        part1:
          '_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read',
        part2: '_the documentation',
      },
      section1: {
        title: '_Configuration',
        label: '_File Name',
        action: '_Upload Config',
      },
      section2: {
        title: '_Functions',
        label: '_File Name',
        action: '_Upload Scripts',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this script?',
      },
      editorModal: {
        save: {
          label: '_Save',
          progress: '_Saving',
        },
        cancel: '_Cancel',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'channel-details',
    translations: {
      title: {
        create: '_Create Channel',
        update: '_Update Channel',
      },
      form: {
        titles: {
          'channel-details': '_Channel Details',
          'branding-options': '_Branding Options',
          'sizing-options': '_Sizing Options',
          'agent-support-platform': '_Agent Support Platform',
          preview: '_Preview',
        },
        labels: {
          'channel-name': '_Channel Name',
          environment: '_Environment',
          'launcher-name': '_Launcher Name',
          logo: '_Logo',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          'account-id': '_Account Id',
          'inbox-id': '_Inbox Id',
          or: '_or',
        },
        placeholders: {
          'channel-name': '_Channel Name',
          environment: '_Select Environment',
          'launcher-name': '_Engage with us',
          logo: '_Logo URL',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          pixels: '_Pixels',
        },
        'validation-messages': {
          integration:
            '_This field is required when other agent support fields are filled',
          env: '_Environment is required',
          name: '_Channel name is required',
          projectId: '_Project ID is required',
          customerId: '_Customer ID is required',
          botId: '_Bot ID is required',
          'brand-moment-upload':
            '_Could not resolve the uploaded Brand Moment URL',
        },
        'help-texts': {
          env: '_Cannot be changed after channel is created.',
          preview:
            '_The position and size of the channel are not reflected in this preview.',
        },
        buttons: {
          cancel: '_Cancel',
          save: '_Save',
          reset: '_Reset',
          edit: '_Edit Style Sheet',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'channels',
    translations: {
      title: '_Channels',
      subtitle:
        '_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).',
      add_channel: '_Add Channel',
      table: {
        column1: '_Name',
        column2: '_Environment',
        column3: '_Last edited',
      },
      deleteChannelModal: {
        title: '_Are you sure?',
        description:
          '_Are you sure you want to delete this channel? Users will no longer be able to access your solution using it.',
        cancel: '_Cancel',
        delete: '_Delete Channel',
      },
      toasts: {
        appIdCopied: '_App ID has been copied to your clipboard.',
        embedCodeCopied: '_Embed code has been copied to your clipboard.',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'common',
    translations: {
      product: '_Pro Studio',
      loading: '_Loading',
      orgPrefix: '_for',
      versionPrefix: '_from',
      userNamePrefix: '_by',
      environments: {
        sandbox: '_Sandbox',
        live: '_Live',
      },
      versions: {
        draft: '_Draft',
        sandbox: '_Sandbox',
        live: '_Live',
      },
      deleteFilePopover: {
        cancel: '_Cancel',
        delete: '_Delete',
      },
      deleteTaskModal: {
        title: '_Delete Task?',
        description:
          '_Are you sure you want to delete "{{taskName}}"? This will also remove the associated decision node from the workflow.',
        cancel: '_Cancel',
        delete: '_Delete',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'files',
    translations: {
      title: '_Media and Files',
      description: {
        part1:
          "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        part2: '_Designing Agents',
      },
      filepond: {
        previewLabel: '_Drag a file here',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this asset?',
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'homepage',
    translations: {
      title: '_Solutions',
      create: '_Create Solution',
      table: {
        column1: '_Solution Name',
        column2: '_Last Updated',
      },
      modal: {
        title: '_Create Solution',
        form: {
          name: {
            placeholder: '_SolutionName',
            validation: {
              uniqueness: '_Uniqueness',
              length: '_Use 1–100 characters.',
            },
          },
        },
        buttons: {
          create: '_Create',
          creating: '_Creating...',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'navigation',
    translations: {
      nav_links: {
        versions: '_Versions',
        channels: '_Channels',
        actions: '_Actions',
        workflows: '_Workflows',
        publish: '_Publish',
        files: '_Files',
      },
      settings: {
        title: '_Solution Type',
        radio_group: {
          radio1: '_Main',
          radio2: '_Survey',
          radio3: '_Unknown',
        },
        button: '_Delete',
      },
      delete_solution_modal: {
        title: '_Delete this solution?',
        subtitle: {
          part1: '_Deleting',
          part2:
            '_deletes all associated data. This does not affect solutions in other Projects.',
        },
        verify: {
          part1: '_To verify, type',
          part2: '_below',
        },
        buttons: {
          decline: '_Cancel',
          accept: '_Delete',
        },
      },
      publish_modal: {
        title: {
          part1: '_Publish',
          solution_type: '_Survey',
        },
        button: {
          static: '_Publish',
          loading: '_Publishing...',
        },
        form: {
          part1: {
            title: '_Select an environment:',
          },
          part2: {
            title: '_For the following solution',
            select: {
              placeholder: '_Select solution',
              loading_placeholder: '_Loading solutions…',
            },
          },
        },
        toast: {
          publishing_in_progress_header:
            "_Publishing is in progress, you've been switched to view mode.",
          publishing_in_progress_text:
            "_We'll let you know when the solution is published and you can make edits again.",
          published_success:
            "_The solution has been published, you've been switched to edit mode.",
          publish_failed:
            '_There was an error publishing this solution. Please reach out to your Pypestream point of contact for assistance',
          save_failed_before_publish:
            '_Failed to save pending changes. Please try publishing again.',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'pype-designer',
    translations: {
      title: 'Pype Designer',
      reset: 'Reset',
      open_designer: 'Pype Designer',
      channel_label: 'Channel',
      environment_label: 'Environment',
      app_id_label: 'App ID',
      use_iframe_label: 'Iframe mode',
      theme_label: 'Theme',
      token_group_colors: 'Colors',
      token_group_radius: 'Radius',
      token_group_size: 'Size',
      token_group_utility: 'Utility',
      theme_section_title: 'Theme',
      theme_picker_label: 'Base theme',
      colors_section_title: 'Colors',
      radius_section_title: 'Radius',
      radius_boxes_label: 'Boxes',
      radius_fields_label: 'Fields',
      radius_selectors_label: 'Selectors',
      preset_sharp: 'Sharp',
      preset_rounded: 'Rounded',
      preset_soft: 'Soft',
      preset_pill: 'Pill',
      effects_section_title: 'Effects',
      effects_depth_label: 'Depth effect',
      effects_depth_description: '3D depth on fields & selectors',
      effects_noise_label: 'Noise effect',
      effects_noise_description: 'Noise pattern on fields & selectors',
      sizes_section_title: 'Sizes',
      sizes_fields_label: 'Fields',
      sizes_selectors_label: 'Selectors',
      border_width_section_title: 'Border width',
      border_width_label: 'All components',
      part_overrides_title: 'Part overrides',
      part_overrides_hint: 'Override ::part() CSS for component parts.',
      component_label: 'Component',
      part_label: 'Part',
      part_placeholder: '— select part —',
      remove_group: 'Remove',
      css_property_placeholder: 'background-color',
      add_declaration: 'Add property',
      add_override: 'Add part override',
      raw_css_label: 'Raw CSS',
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'versions',
    translations: {
      duplo_cloud_id: {
        copy: '_Copy DuploCloud ID',
        message: '_DuploCloud ID copied to clipboard',
      },
      cards: {
        title: '_Environments',
        button: '_Edit Workflows',
        empty:
          '_To create a new draft, make an edit in the Workflows tab or load an older version.',
        draft_date_label: '_Last edited',
        no_published_label:
          '_Nothing has been published on the {{env}} Environment.',
      },
      table: {
        title: '_Published Versions',
        column1: '_Version',
        column2: '_Environment',
        column3: '_Last published',
        buttons: {
          load_as_draft: '_Load as draft',
          republish: '_Republish',
        },
      },
      load_as_draft_modal: {
        title: {
          part1: '_Load',
          part2: '_as draft',
        },
        radio_group: {
          radio1: '_Restore all files',
          radio2: '_Restore without Actions',
        },
        button: '_Confirm',
      },
      republish_modal: {
        title: '_Republish',
        subtitle: '_Select environment:',
        button: {
          static: '_Republish',
          loading: '_Republishing...',
        },
        radio_group: {
          radio1: '_Republish all files',
          radio2: '_Republish without Actions',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pro-studio',
    file: 'workflows',
    translations: {
      csv_upload_modal: {
        title: '_Replace all nodes in this solution?',
        subtitle:
          '_Importing this CSV will replace all nodes in this solution.',
        buttons: {
          save: '_Replace Nodes',
          uploading: '_Uploading...',
          cancel: '_Cancel',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'actions',
    translations: {
      title: 'Actions',
      subtitle: {
        part1:
          'Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read',
        part2: 'the documentation',
      },
      section1: {
        title: 'Configuration',
        label: 'File Name',
        action: 'Upload Config',
      },
      section2: {
        title: 'Functions',
        label: 'File Name',
        action: 'Upload Scripts',
      },
      deleteFilePopover: {
        title: 'Are you sure you want to delete this script?',
      },
      editorModal: {
        save: {
          label: 'Save',
          progress: 'Saving',
        },
        cancel: 'Cancel',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'channel-details',
    translations: {
      title: {
        create: 'Create Channel',
        update: 'Update Channel',
      },
      form: {
        titles: {
          'channel-details': 'Channel Details',
          'branding-options': 'Branding Options',
          'sizing-options': 'Sizing Options',
          'agent-support-platform': 'Agent Support Platform',
          preview: 'Preview',
        },
        labels: {
          'channel-name': 'Channel Name',
          environment: 'Environment',
          'launcher-name': 'Launcher Name',
          logo: 'Logo',
          'brand-moment-url': 'Brand Moment URL',
          'brand-color': 'Brand Color',
          'solution-bubble-color': 'Solution Bubble Color',
          'solution-text-color': 'Solution Text Color',
          'user-bubble-color': 'User Bubble Color',
          'user-text-color': 'User Text Color',
          'button-color': 'Button Color',
          'button-text-color': 'Button Text Color',
          width: 'Width',
          height: 'Height',
          'account-id': 'Account Id',
          'inbox-id': 'Inbox Id',
          or: 'or',
        },
        placeholders: {
          'channel-name': 'Channel Name',
          environment: 'Select Environment',
          'launcher-name': 'Engage with us',
          logo: 'Logo URL',
          'brand-moment-url': 'Brand Moment URL',
          'brand-color': 'Brand Color',
          'solution-bubble-color': 'Solution Bubble Color',
          'solution-text-color': 'Solution Text Color',
          'user-bubble-color': 'User Bubble Color',
          'user-text-color': 'User Text Color',
          'button-color': 'Button Color',
          'button-text-color': 'Button Text Color',
          width: 'Width',
          height: 'Height',
          pixels: 'Pixels',
        },
        'validation-messages': {
          integration:
            'This field is required when other agent support fields are filled',
          env: 'Environment is required',
          name: 'Channel name is required',
          projectId: 'Project ID is required',
          customerId: 'Customer ID is required',
          botId: 'Bot ID is required',
          'brand-moment-upload':
            'Could not resolve the uploaded Brand Moment URL',
        },
        'help-texts': {
          env: 'Cannot be changed after channel is created.',
          preview:
            'The position and size of the channel are not reflected in this preview.',
        },
        buttons: {
          cancel: 'Cancel',
          save: 'Save',
          reset: 'Reset',
          edit: 'Edit Style Sheet',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'channels',
    translations: {
      title: 'Channels',
      subtitle:
        'Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).',
      addchannel: 'Add Channel',
      table: {
        column1: 'Name',
        column2: 'Environment',
        column3: 'Last edited',
      },
      deleteChannelModal: {
        title: 'Are you sure?',
        description:
          'Are you sure you want to delete this channel? Users will no longer be able to access your solution using it.',
        cancel: 'Cancel',
        delete: 'Delete Channel',
      },
      toasts: {
        appIdCopied: 'App ID has been copied to your clipboard.',
        embedCodeCopied: 'Embed code has been copied to your clipboard.',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'common',
    translations: {
      product: 'Pro Studio',
      loading: 'Loading',
      orgPrefix: 'for',
      versionPrefix: 'from',
      userNamePrefix: 'by',
      environments: {
        sandbox: 'Sandbox',
        live: 'Live',
      },
      versions: {
        draft: 'Draft',
        sandbox: 'Sandbox',
        live: 'Live',
      },
      deleteFilePopover: {
        cancel: 'Cancel',
        delete: 'Delete',
      },
      deleteTaskModal: {
        title: 'Delete Task?',
        description:
          'Are you sure you want to delete "{{taskName}}"? This will also remove the associated decision node from the workflow.',
        cancel: 'Cancel',
        delete: 'Delete',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'files',
    translations: {
      title: 'Media and Files',
      description: {
        part1:
          "In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        part2: 'Designing Agents',
      },
      filepond: {
        previewLabel: 'Drag a file here',
      },
      deleteFilePopover: {
        title: 'Are you sure you want to delete this asset?',
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'homepage',
    translations: {
      title: 'Solutions',
      create: 'Create Solution',
      table: {
        column1: 'Solution Title',
        column2: 'Last Updated',
      },
      modal: {
        title: 'Create Solution',
        form: {
          name: {
            placeholder: 'Solution Title',
            validation: {
              uniqueness: 'Uniqueness',
              length: 'Use 1–100 characters.',
            },
          },
        },
        buttons: {
          create: 'Create',
          creating: 'Creating...',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'navigation',
    translations: {
      nav_links: {
        versions: 'Versions',
        channels: 'Channels',
        actions: 'Actions',
        workflows: 'Workflows',
        publish: 'Publish',
        files: 'Files',
      },
      settings: {
        title: 'Solution Type',
        radio_group: {
          radio1: 'Main',
          radio2: 'Survey',
          radio3: 'Unknown',
        },
        button: 'Delete',
      },
      delete_solution_modal: {
        title: 'Delete this solution?',
        subtitle: {
          part1: 'Deleting',
          part2:
            'deletes all associated data. This does not affect solutions in other Projects.',
        },
        verify: {
          part1: 'To verify, type',
          part2: 'below',
        },
        buttons: {
          decline: 'Cancel',
          accept: 'Delete',
        },
      },
      publish_modal: {
        title: {
          part1: 'Publish',
          solution_type: 'Survey',
        },
        active_coworkers: {
          banner_message:
            'Other people are working on this solution. Review any changes before publishing. Publishing now may discard their in-progress edits.',
        },
        button: {
          static: 'Publish',
          loading: 'Publishing',
          publish_anyway: 'Publish anyway',
        },
        form: {
          part1: {
            title: 'Select an environment:',
          },
          part2: {
            title: 'For the following solution',
            select: {
              placeholder: 'Select solution',
              loading_placeholder: 'Loading solutions…',
            },
          },
        },
        toast: {
          publishing_in_progress_header:
            "Publishing is in progress, you've been switched to view mode.",
          publishing_in_progress_text:
            "We'll let you know when the solution is published and you can make edits again.",
          published_success:
            "The solution has been published, you've been switched to edit mode.",
          publish_failed:
            'There was an error publishing this solution. Please reach out to your Pypestream point of contact for assistance',
          save_failed_before_publish:
            'Failed to save pending changes. Please try publishing again.',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'performance',
    translations: {
      title: 'Performance metrics',
      subtitle: 'type="{{type}}" · {{filtered}} of {{total}} rows',
      filters: {
        from: 'From',
        to: 'To',
        scenario: 'Scenario',
        metric: 'Metric',
        all: 'All',
      },
      scenarios: {
        'cold-render': 'Cold render',
        scroll: 'Scroll',
        'single-drag': 'Single drag',
        'search-typing': 'Search typing',
        'idle-snapshot': 'Idle snapshot',
      },
      metrics: {
        jsHeapUsedSize: 'JS heap used',
        scriptingMs: 'Scripting CPU',
        meanFps: 'Mean FPS',
        domRows: 'DOM rows',
        wallMs: 'Wall time',
      },
      table: {
        created: 'Created',
        scenario: 'Scenario',
        rows: 'Rows',
        commit: 'Commit',
        branch: 'Branch',
        pr: 'PR',
        heap: 'Heap',
        scripting: 'Scripting (ms)',
        fps: 'FPS',
        domRows: 'DOM rows',
        details: 'Details',
      },
      chart: {
        caption: '{{metric}} over time, one line per dataset size',
        noData: 'No data for scenario "{{scenario}}".',
      },
      errors: {
        loadFailed: 'Failed to load metrics: {{message}}',
      },
      empty: {
        title: 'No perf metrics found.',
        hint: 'Run the bench in CI (label “with-performance-test”) or upload locally via scripts/upload-perf-metrics.mjs.',
      },
      detail: {
        title: '{{scenario}} · {{size}} rows',
        labels: {
          id: 'id',
          createdAt: 'createdAt',
          commit: 'commit',
          branch: 'branch',
          pr: 'PR',
          runId: 'runId',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'pype-designer',
    translations: {
      title: 'Pype Designer',
      reset: 'Reset',
      save: 'Save',
      saving: 'Saving...',
      save_changes: 'Save Changes',
      cancel: 'Cancel',
      unsaved_changes: 'There are unsaved changes',
      open_designer: 'Pype Designer',
      channel_label: 'Channel',
      environment_label: 'Environment',
      app_id_label: 'App ID',
      use_iframe_label: 'Iframe mode',
      theme_label: 'Theme',
      token_group_colors: 'Colors',
      token_group_radius: 'Radius',
      token_group_size: 'Size',
      token_group_utility: 'Utility',
      theme_section_title: 'Theme',
      theme_picker_label: 'Base theme',
      colors_section_title: 'Colors',
      radius_section_title: 'Radius',
      radius_boxes_label: 'Boxes',
      radius_fields_label: 'Fields',
      radius_selectors_label: 'Selectors',
      preset_sharp: 'Sharp',
      preset_rounded: 'Rounded',
      preset_soft: 'Soft',
      preset_pill: 'Pill',
      effects_section_title: 'Effects',
      effects_depth_label: 'Depth effect',
      effects_depth_description: '3D depth on fields & selectors',
      effects_noise_label: 'Noise effect',
      effects_noise_description: 'Noise pattern on fields & selectors',
      sizes_section_title: 'Sizes',
      sizes_fields_label: 'Fields',
      sizes_selectors_label: 'Selectors',
      border_width_section_title: 'Border width',
      border_width_label: 'All components',
      part_overrides_title: 'Part overrides',
      part_overrides_hint: 'Override ::part() CSS for component parts.',
      component_label: 'Component',
      part_label: 'Part',
      part_placeholder: '— select part —',
      remove_group: 'Remove',
      css_property_placeholder: 'background-color',
      add_declaration: 'Add property',
      add_override: 'Add part override',
      raw_css_label: 'Raw CSS',
      shell_section_title: 'Shell',
      modality_label: 'Modality',
      fullpage_iframe_disabled_hint:
        'Iframe mode is not supported in fullpage modality.',
      shell_size_label: 'Frame size (optional)',
      lock_ratio_label: 'Lock ratio',
      branding_section_title: 'Branding',
      customer_name_label: 'Customer name',
      display_name_label: 'Display name',
      customer_logo_url_label: 'Customer logo URL',
      banner_url_label: 'Banner URL',
      brand_moment_url_label: 'Brand moment URL',
      launcher_name_label: 'Launcher name',
      hide_pypestream_branding_label: 'Hide Pypestream branding',
      design_config_json_label: 'WidgetAppConfig JSON',
      design_config_json_description:
        'Backend contract — the exact JSON sent to the engagement API on save.',
      dirty_modal_title: 'You have unsaved changes',
      dirty_modal_description:
        'Save your edits to the widget design before leaving, or discard them to continue without saving.',
      dirty_modal_cancel: 'Cancel',
      dirty_modal_discard: 'Discard changes',
      dirty_modal_save: 'Save and continue',
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'versions',
    translations: {
      duplo_cloud_id: {
        copy: 'Copy DuploCloud ID',
        message: 'DuploCloud ID copied to clipboard',
      },
      cards: {
        title: 'Environments',
        button: 'Edit Workflows',
        empty:
          'To create a new draft, make an edit in the Workflows tab or load an older version.',
        draft_date_label: 'Last edited',
        no_published_label:
          'Nothing has been published on the {{env}} Environment.',
      },
      table: {
        title: 'Published Versions',
        column1: 'Version',
        column2: 'Environment',
        column3: 'Last published',
        buttons: {
          load_as_draft: 'Load as draft',
          republish: 'Republish',
        },
      },
      load_as_draft_modal: {
        title: {
          part1: 'Load',
          part2: 'as draft',
        },
        radio_group: {
          radio1: 'Restore all files',
          radio2: 'Restore without Actions',
        },
        button: 'Confirm',
      },
      republish_modal: {
        title: 'Republish',
        subtitle: 'Select environment:',
        button: {
          static: 'Republish',
          loading: 'Republishing...',
        },
        radio_group: {
          radio1: 'Republish all files',
          radio2: 'Republish without Actions',
        },
      },
    },
  },
  {
    lang: 'en',
    namespace: 'pro-studio',
    file: 'workflows',
    translations: {
      csv_upload_modal: {
        title: 'Replace all nodes in this solution?',
        subtitle: 'Importing this CSV will replace all nodes in this solution.',
        buttons: {
          save: 'Replace Nodes',
          uploading: 'Uploading...',
          cancel: 'Cancel',
        },
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'actions',
    translations: {
      title: '_Actions',
      subtitle: {
        part1:
          '_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read',
        part2: '_the documentation',
      },
      section1: {
        title: '_Configuration',
        label: '_File Name',
        action: '_Upload Config',
      },
      section2: {
        title: '_Functions',
        label: '_File Name',
        action: '_Upload Scripts',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this script?',
      },
      editorModal: {
        save: {
          label: '_Save',
          progress: '_Saving',
        },
        cancel: '_Cancel',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'channel-details',
    translations: {
      title: {
        create: '_Create Channel',
        update: '_Update Channel',
      },
      form: {
        titles: {
          'channel-details': '_Channel Details',
          'branding-options': '_Branding Options',
          'sizing-options': '_Sizing Options',
          'agent-support-platform': '_Agent Support Platform',
          preview: '_Preview',
        },
        labels: {
          'channel-name': '_Channel Name',
          environment: '_Environment',
          'launcher-name': '_Launcher Name',
          logo: '_Logo',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          'account-id': '_Account Id',
          'inbox-id': '_Inbox Id',
          or: '_or',
        },
        placeholders: {
          'channel-name': '_Channel Name',
          environment: '_Select Environment',
          'launcher-name': '_Engage with us',
          logo: '_Logo URL',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          pixels: '_Pixels',
        },
        'validation-messages': {
          integration:
            '_This field is required when other agent support fields are filled',
          env: '_Environment is required',
          name: '_Channel name is required',
          projectId: '_Project ID is required',
          customerId: '_Customer ID is required',
          botId: '_Bot ID is required',
          'brand-moment-upload':
            '_Could not resolve the uploaded Brand Moment URL',
        },
        'help-texts': {
          env: '_Cannot be changed after channel is created.',
          preview:
            '_The position and size of the channel are not reflected in this preview.',
        },
        buttons: {
          cancel: '_Cancel',
          save: '_Save',
          reset: '_Reset',
          edit: '_Edit Style Sheet',
        },
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'channels',
    translations: {
      title: '_Channels',
      subtitle:
        '_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).',
      add_channel: '_Add Channel',
      table: {
        column1: '_Name',
        column2: '_Environment',
        column3: '_Last edited',
      },
      deleteChannelModal: {
        title: '_Are you sure?',
        description:
          '_Are you sure you want to delete this channel? Users will no longer be able to access your solution using it.',
        cancel: '_Cancel',
        delete: '_Delete Channel',
      },
      toasts: {
        appIdCopied: '_App ID has been copied to your clipboard.',
        embedCodeCopied: '_Embed code has been copied to your clipboard.',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'common',
    translations: {
      product: '_Pro Studio',
      loading: '_Loading',
      orgPrefix: '_for',
      versionPrefix: '_from',
      userNamePrefix: '_by',
      environments: {
        sandbox: '_Sandbox',
        live: '_Live',
      },
      versions: {
        draft: '_Draft',
        sandbox: '_Sandbox',
        live: '_Live',
      },
      deleteFilePopover: {
        cancel: '_Cancel',
        delete: '_Delete',
      },
      deleteTaskModal: {
        title: '_Delete Task?',
        description:
          '_Are you sure you want to delete "{{taskName}}"? This will also remove the associated decision node from the workflow.',
        cancel: '_Cancel',
        delete: '_Delete',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'files',
    translations: {
      title: '_Media and Files',
      description: {
        part1:
          "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        part2: '_Designing Agents',
      },
      filepond: {
        previewLabel: '_Drag a file here',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this asset?',
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'homepage',
    translations: {
      title: '_Solutions',
      create: '_Create Solution',
      table: {
        column1: '_Solution Name',
        column2: '_Last Updated',
      },
      modal: {
        title: '_Create Solution',
        form: {
          name: {
            placeholder: '_SolutionName',
            validation: {
              uniqueness: '_Uniqueness',
              length: '_Use 1–100 characters.',
            },
          },
        },
        buttons: {
          create: '_Create',
          creating: '_Creating...',
        },
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'navigation',
    translations: {
      nav_links: {
        versions: '_Versions',
        channels: '_Channels',
        actions: '_Actions',
        workflows: '_Workflows',
        publish: '_Publish',
        files: '_Files',
      },
      settings: {
        title: '_Solution Type',
        radio_group: {
          radio1: '_Main',
          radio2: '_Survey',
          radio3: '_Unknown',
        },
        button: '_Delete',
      },
      delete_solution_modal: {
        title: '_Delete this solution?',
        subtitle: {
          part1: '_Deleting',
          part2:
            '_deletes all associated data. This does not affect solutions in other Projects.',
        },
        verify: {
          part1: '_To verify, type',
          part2: '_below',
        },
        buttons: {
          decline: '_Cancel',
          accept: '_Delete',
        },
      },
      publish_modal: {
        title: {
          part1: '_Publish',
          solution_type: '_Survey',
        },
        button: {
          static: '_Publish',
          loading: '_Publishing...',
        },
        form: {
          part1: {
            title: '_Select an environment:',
          },
          part2: {
            title: '_For the following solution',
            select: {
              placeholder: '_Select solution',
              loading_placeholder: '_Loading solutions…',
            },
          },
        },
        toast: {
          publishing_in_progress_header:
            "_Publishing is in progress, you've been switched to view mode.",
          publishing_in_progress_text:
            "_We'll let you know when the solution is published and you can make edits again.",
          published_success:
            "_The solution has been published, you've been switched to edit mode.",
          publish_failed:
            '_There was an error publishing this solution. Please reach out to your Pypestream point of contact for assistance',
          save_failed_before_publish:
            '_Failed to save pending changes. Please try publishing again.',
        },
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'pype-designer',
    translations: {
      title: 'Pype Designer',
      reset: 'Reset',
      open_designer: 'Pype Designer',
      channel_label: 'Channel',
      environment_label: 'Environment',
      app_id_label: 'App ID',
      use_iframe_label: 'Iframe mode',
      theme_label: 'Theme',
      token_group_colors: 'Colors',
      token_group_radius: 'Radius',
      token_group_size: 'Size',
      token_group_utility: 'Utility',
      theme_section_title: 'Theme',
      theme_picker_label: 'Base theme',
      colors_section_title: 'Colors',
      radius_section_title: 'Radius',
      radius_boxes_label: 'Boxes',
      radius_fields_label: 'Fields',
      radius_selectors_label: 'Selectors',
      preset_sharp: 'Sharp',
      preset_rounded: 'Rounded',
      preset_soft: 'Soft',
      preset_pill: 'Pill',
      effects_section_title: 'Effects',
      effects_depth_label: 'Depth effect',
      effects_depth_description: '3D depth on fields & selectors',
      effects_noise_label: 'Noise effect',
      effects_noise_description: 'Noise pattern on fields & selectors',
      sizes_section_title: 'Sizes',
      sizes_fields_label: 'Fields',
      sizes_selectors_label: 'Selectors',
      border_width_section_title: 'Border width',
      border_width_label: 'All components',
      part_overrides_title: 'Part overrides',
      part_overrides_hint: 'Override ::part() CSS for component parts.',
      component_label: 'Component',
      part_label: 'Part',
      part_placeholder: '— select part —',
      remove_group: 'Remove',
      css_property_placeholder: 'background-color',
      add_declaration: 'Add property',
      add_override: 'Add part override',
      raw_css_label: 'Raw CSS',
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'versions',
    translations: {
      duplo_cloud_id: {
        copy: '_Copy DuploCloud ID',
        message: '_DuploCloud ID copied to clipboard',
      },
      cards: {
        title: '_Environments',
        button: '_Edit Workflows',
        empty:
          '_To create a new draft, make an edit in the Workflows tab or load an older version.',
        draft_date_label: '_Last edited',
        no_published_label:
          '_Nothing has been published on the {{env}} Environment.',
      },
      table: {
        title: '_Published Versions',
        column1: '_Version',
        column2: '_Environment',
        column3: '_Last published',
        buttons: {
          load_as_draft: '_Load as draft',
          republish: '_Republish',
        },
      },
      load_as_draft_modal: {
        title: {
          part1: '_Load',
          part2: '_as draft',
        },
        radio_group: {
          radio1: '_Restore all files',
          radio2: '_Restore without Actions',
        },
        button: '_Confirm',
      },
      republish_modal: {
        title: '_Republish',
        subtitle: '_Select environment:',
        button: {
          static: '_Republish',
          loading: '_Republishing...',
        },
        radio_group: {
          radio1: '_Republish all files',
          radio2: '_Republish without Actions',
        },
      },
    },
  },
  {
    lang: 'hi',
    namespace: 'pro-studio',
    file: 'workflows',
    translations: {
      csv_upload_modal: {
        title: '_Replace all nodes in this solution?',
        subtitle:
          '_Importing this CSV will replace all nodes in this solution.',
        buttons: {
          save: '_Replace Nodes',
          uploading: '_Uploading...',
          cancel: '_Cancel',
        },
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'actions',
    translations: {
      title: '_Actions',
      subtitle: {
        part1:
          '_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read',
        part2: '_the documentation',
      },
      section1: {
        title: '_Configuration',
        label: '_File Name',
        action: '_Upload Config',
      },
      section2: {
        title: '_Functions',
        label: '_File Name',
        action: '_Upload Scripts',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this script?',
      },
      editorModal: {
        save: {
          label: '_Save',
          progress: '_Saving',
        },
        cancel: '_Cancel',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'channel-details',
    translations: {
      title: {
        create: '_Create Channel',
        update: '_Update Channel',
      },
      form: {
        titles: {
          'channel-details': '_Channel Details',
          'branding-options': '_Branding Options',
          'sizing-options': '_Sizing Options',
          'agent-support-platform': '_Agent Support Platform',
          preview: '_Preview',
        },
        labels: {
          'channel-name': '_Channel Name',
          environment: '_Environment',
          'launcher-name': '_Launcher Name',
          logo: '_Logo',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          'account-id': '_Account Id',
          'inbox-id': '_Inbox Id',
          or: '_or',
        },
        placeholders: {
          'channel-name': '_Channel Name',
          environment: '_Select Environment',
          'launcher-name': '_Engage with us',
          logo: '_Logo URL',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          pixels: '_Pixels',
        },
        'validation-messages': {
          integration:
            '_This field is required when other agent support fields are filled',
          env: '_Environment is required',
          name: '_Channel name is required',
          projectId: '_Project ID is required',
          customerId: '_Customer ID is required',
          botId: '_Bot ID is required',
          'brand-moment-upload':
            '_Could not resolve the uploaded Brand Moment URL',
        },
        'help-texts': {
          env: '_Cannot be changed after channel is created.',
          preview:
            '_The position and size of the channel are not reflected in this preview.',
        },
        buttons: {
          cancel: '_Cancel',
          save: '_Save',
          reset: '_Reset',
          edit: '_Edit Style Sheet',
        },
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'channels',
    translations: {
      title: '_Channels',
      subtitle:
        '_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).',
      add_channel: '_Add Channel',
      table: {
        column1: '_Name',
        column2: '_Environment',
        column3: '_Last edited',
      },
      deleteChannelModal: {
        title: '_Are you sure?',
        description:
          '_Are you sure you want to delete this channel? Users will no longer be able to access your solution using it.',
        cancel: '_Cancel',
        delete: '_Delete Channel',
      },
      toasts: {
        appIdCopied: '_App ID has been copied to your clipboard.',
        embedCodeCopied: '_Embed code has been copied to your clipboard.',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'common',
    translations: {
      product: '_Pro Studio',
      loading: '_Loading',
      orgPrefix: '_for',
      versionPrefix: '_from',
      userNamePrefix: '_by',
      environments: {
        sandbox: '_Sandbox',
        live: '_Live',
      },
      versions: {
        draft: '_Draft',
        sandbox: '_Sandbox',
        live: '_Live',
      },
      deleteFilePopover: {
        cancel: '_Cancel',
        delete: '_Delete',
      },
      deleteTaskModal: {
        title: '_Delete Task?',
        description:
          '_Are you sure you want to delete "{{taskName}}"? This will also remove the associated decision node from the workflow.',
        cancel: '_Cancel',
        delete: '_Delete',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'files',
    translations: {
      title: '_Media and Files',
      description: {
        part1:
          "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        part2: '_Designing Agents',
      },
      filepond: {
        previewLabel: '_Drag a file here',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this asset?',
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'homepage',
    translations: {
      title: '_Solutions',
      create: '_Create Solution',
      table: {
        column1: '_Solution Name',
        column2: '_Last Updated',
      },
      modal: {
        title: '_Create Solution',
        form: {
          name: {
            placeholder: '_SolutionName',
            validation: {
              uniqueness: '_Uniqueness',
              length: '_Use 1–100 characters.',
            },
          },
        },
        buttons: {
          create: '_Create',
          creating: '_Creating...',
        },
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'navigation',
    translations: {
      nav_links: {
        versions: '_Versions',
        channels: '_Channels',
        actions: '_Actions',
        workflows: '_Workflows',
        publish: '_Publish',
        files: '_Files',
      },
      settings: {
        title: '_Solution Type',
        radio_group: {
          radio1: '_Main',
          radio2: '_Survey',
          radio3: '_Unknown',
        },
        button: '_Delete',
      },
      delete_solution_modal: {
        title: '_Delete this solution?',
        subtitle: {
          part1: '_Deleting',
          part2:
            '_deletes all associated data. This does not affect solutions in other Projects.',
        },
        verify: {
          part1: '_To verify, type',
          part2: '_below',
        },
        buttons: {
          decline: '_Cancel',
          accept: '_Delete',
        },
      },
      publish_modal: {
        title: {
          part1: '_Publish',
          solution_type: '_Survey',
        },
        button: {
          static: '_Publish',
          loading: '_Publishing...',
        },
        form: {
          part1: {
            title: '_Select an environment:',
          },
          part2: {
            title: '_For the following solution',
            select: {
              placeholder: '_Select solution',
              loading_placeholder: '_Loading solutions…',
            },
          },
        },
        toast: {
          publishing_in_progress_header:
            "_Publishing is in progress, you've been switched to view mode.",
          publishing_in_progress_text:
            "_We'll let you know when the solution is published and you can make edits again.",
          published_success:
            "_The solution has been published, you've been switched to edit mode.",
          publish_failed:
            '_There was an error publishing this solution. Please reach out to your Pypestream point of contact for assistance',
          save_failed_before_publish:
            '_Failed to save pending changes. Please try publishing again.',
        },
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'pype-designer',
    translations: {
      title: 'Pype Designer',
      reset: 'Reset',
      open_designer: 'Pype Designer',
      channel_label: 'Channel',
      environment_label: 'Environment',
      app_id_label: 'App ID',
      use_iframe_label: 'Iframe mode',
      theme_label: 'Theme',
      token_group_colors: 'Colors',
      token_group_radius: 'Radius',
      token_group_size: 'Size',
      token_group_utility: 'Utility',
      theme_section_title: 'Theme',
      theme_picker_label: 'Base theme',
      colors_section_title: 'Colors',
      radius_section_title: 'Radius',
      radius_boxes_label: 'Boxes',
      radius_fields_label: 'Fields',
      radius_selectors_label: 'Selectors',
      preset_sharp: 'Sharp',
      preset_rounded: 'Rounded',
      preset_soft: 'Soft',
      preset_pill: 'Pill',
      effects_section_title: 'Effects',
      effects_depth_label: 'Depth effect',
      effects_depth_description: '3D depth on fields & selectors',
      effects_noise_label: 'Noise effect',
      effects_noise_description: 'Noise pattern on fields & selectors',
      sizes_section_title: 'Sizes',
      sizes_fields_label: 'Fields',
      sizes_selectors_label: 'Selectors',
      border_width_section_title: 'Border width',
      border_width_label: 'All components',
      part_overrides_title: 'Part overrides',
      part_overrides_hint: 'Override ::part() CSS for component parts.',
      component_label: 'Component',
      part_label: 'Part',
      part_placeholder: '— select part —',
      remove_group: 'Remove',
      css_property_placeholder: 'background-color',
      add_declaration: 'Add property',
      add_override: 'Add part override',
      raw_css_label: 'Raw CSS',
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'versions',
    translations: {
      duplo_cloud_id: {
        copy: '_Copy DuploCloud ID',
        message: '_DuploCloud ID copied to clipboard',
      },
      cards: {
        title: '_Environments',
        button: '_Edit Workflows',
        empty:
          '_To create a new draft, make an edit in the Workflows tab or load an older version.',
        draft_date_label: '_Last edited',
        no_published_label:
          '_Nothing has been published on the {{env}} Environment.',
      },
      table: {
        title: '_Published Versions',
        column1: '_Version',
        column2: '_Environment',
        column3: '_Last published',
        buttons: {
          load_as_draft: '_Load as draft',
          republish: '_Republish',
        },
      },
      load_as_draft_modal: {
        title: {
          part1: '_Load',
          part2: '_as draft',
        },
        radio_group: {
          radio1: '_Restore all files',
          radio2: '_Restore without Actions',
        },
        button: '_Confirm',
      },
      republish_modal: {
        title: '_Republish',
        subtitle: '_Select environment:',
        button: {
          static: '_Republish',
          loading: '_Republishing...',
        },
        radio_group: {
          radio1: '_Republish all files',
          radio2: '_Republish without Actions',
        },
      },
    },
  },
  {
    lang: 'ru',
    namespace: 'pro-studio',
    file: 'workflows',
    translations: {
      csv_upload_modal: {
        title: '_Replace all nodes in this solution?',
        subtitle:
          '_Importing this CSV will replace all nodes in this solution.',
        buttons: {
          save: '_Replace Nodes',
          uploading: '_Uploading...',
          cancel: '_Cancel',
        },
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'actions',
    translations: {
      title: '_Actions',
      subtitle: {
        part1:
          '_Actions allow the designer to perform custom integrations and special logic. Actions must have corresponding script(s), utils, and config files uploaded below. Actions must have a .py extension. For more information regarding Actions, please read',
        part2: '_the documentation',
      },
      section1: {
        title: '_Configuration',
        label: '_File Name',
        action: '_Upload Config',
      },
      section2: {
        title: '_Functions',
        label: '_File Name',
        action: '_Upload Scripts',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this script?',
      },
      editorModal: {
        save: {
          label: '_Save',
          progress: '_Saving',
        },
        cancel: '_Cancel',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'channel-details',
    translations: {
      title: {
        create: '_Create Channel',
        update: '_Update Channel',
      },
      form: {
        titles: {
          'channel-details': '_Channel Details',
          'branding-options': '_Branding Options',
          'sizing-options': '_Sizing Options',
          'agent-support-platform': '_Agent Support Platform',
          preview: '_Preview',
        },
        labels: {
          'channel-name': '_Channel Name',
          environment: '_Environment',
          'launcher-name': '_Launcher Name',
          logo: '_Logo',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          'account-id': '_Account Id',
          'inbox-id': '_Inbox Id',
          or: '_or',
        },
        placeholders: {
          'channel-name': '_Channel Name',
          environment: '_Select Environment',
          'launcher-name': '_Engage with us',
          logo: '_Logo URL',
          'brand-moment-url': '_Brand Moment URL',
          'brand-color': '_Brand Color',
          'solution-bubble-color': '_Solution Bubble Color',
          'solution-text-color': '_Solution Text Color',
          'user-bubble-color': '_User Bubble Color',
          'user-text-color': '_User Text Color',
          'button-color': '_Button Color',
          'button-text-color': '_Button Text Color',
          width: '_Width',
          height: '_Height',
          pixels: '_Pixels',
        },
        'validation-messages': {
          integration:
            '_This field is required when other agent support fields are filled',
          env: '_Environment is required',
          name: '_Channel name is required',
          projectId: '_Project ID is required',
          customerId: '_Customer ID is required',
          botId: '_Bot ID is required',
          'brand-moment-upload':
            '_Could not resolve the uploaded Brand Moment URL',
        },
        'help-texts': {
          env: '_Cannot be changed after channel is created.',
          preview:
            '_The position and size of the channel are not reflected in this preview.',
        },
        buttons: {
          cancel: '_Cancel',
          save: '_Save',
          reset: '_Reset',
          edit: '_Edit Style Sheet',
        },
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'channels',
    translations: {
      title: '_Channels',
      subtitle:
        '_Channels are how your users will interact with your solution. For example, you can place a Pype on your website or in the future publish your solution to a 3rd party messaging channel (e.g. Facebook).',
      add_channel: '_Add Channel',
      table: {
        column1: '_Name',
        column2: '_Environment',
        column3: '_Last edited',
      },
      deleteChannelModal: {
        title: '_Are you sure?',
        description:
          '_Are you sure you want to delete this channel? Users will no longer be able to access your solution using it.',
        cancel: '_Cancel',
        delete: '_Delete Channel',
      },
      toasts: {
        appIdCopied: '_App ID has been copied to your clipboard.',
        embedCodeCopied: '_Embed code has been copied to your clipboard.',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'common',
    translations: {
      product: '_Pro Studio',
      loading: '_Loading',
      orgPrefix: '_for',
      versionPrefix: '_from',
      userNamePrefix: '_by',
      environments: {
        sandbox: '_Sandbox',
        live: '_Live',
      },
      versions: {
        draft: '_Draft',
        sandbox: '_Sandbox',
        live: '_Live',
      },
      deleteFilePopover: {
        cancel: '_Cancel',
        delete: '_Delete',
      },
      deleteTaskModal: {
        title: '_Delete Task?',
        description:
          '_Are you sure you want to delete "{{taskName}}"? This will also remove the associated decision node from the workflow.',
        cancel: '_Cancel',
        delete: '_Delete',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'files',
    translations: {
      title: '_Media and Files',
      description: {
        part1:
          "_In order for your solution to display images, documents, or videos to the user, these assets must first be uploaded here. The asset's URL can then be included within the Workflows tab. For more information regarding acceptable file formats and restrictions on file size, please refer to",
        part2: '_Designing Agents',
      },
      filepond: {
        previewLabel: '_Drag a file here',
      },
      deleteFilePopover: {
        title: '_Are you sure you want to delete this asset?',
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'homepage',
    translations: {
      title: '_Solutions',
      create: '_Create Solution',
      table: {
        column1: '_Solution Name',
        column2: '_Last Updated',
      },
      modal: {
        title: '_Create Solution',
        form: {
          name: {
            placeholder: '_SolutionName',
            validation: {
              uniqueness: '_Uniqueness',
              length: '_Use 1–100 characters.',
            },
          },
        },
        buttons: {
          create: '_Create',
          creating: '_Creating...',
        },
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'navigation',
    translations: {
      nav_links: {
        versions: '_Versions',
        channels: '_Channels',
        actions: '_Actions',
        workflows: '_Workflows',
        publish: '_Publish',
        files: '_Files',
      },
      settings: {
        title: '_Solution Type',
        radio_group: {
          radio1: '_Main',
          radio2: '_Survey',
          radio3: '_Unknown',
        },
        button: '_Delete',
      },
      delete_solution_modal: {
        title: '_Delete this solution?',
        subtitle: {
          part1: '_Deleting',
          part2:
            '_deletes all associated data. This does not affect solutions in other Projects.',
        },
        verify: {
          part1: '_To verify, type',
          part2: '_below',
        },
        buttons: {
          decline: '_Cancel',
          accept: '_Delete',
        },
      },
      publish_modal: {
        title: {
          part1: '_Publish',
          solution_type: '_Survey',
        },
        button: {
          static: '_Publish',
          loading: '_Publishing...',
        },
        form: {
          part1: {
            title: '_Select an environment:',
          },
          part2: {
            title: '_For the following solution',
            select: {
              placeholder: '_Select solution',
              loading_placeholder: '_Loading solutions…',
            },
          },
        },
        toast: {
          publishing_in_progress_header:
            "_Publishing is in progress, you've been switched to view mode.",
          publishing_in_progress_text:
            "_We'll let you know when the solution is published and you can make edits again.",
          published_success:
            "_The solution has been published, you've been switched to edit mode.",
          publish_failed:
            '_There was an error publishing this solution. Please reach out to your Pypestream point of contact for assistance',
          save_failed_before_publish:
            '_Failed to save pending changes. Please try publishing again.',
        },
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'pype-designer',
    translations: {
      title: 'Pype Designer',
      reset: 'Reset',
      open_designer: 'Pype Designer',
      channel_label: 'Channel',
      environment_label: 'Environment',
      app_id_label: 'App ID',
      use_iframe_label: 'Iframe mode',
      theme_label: 'Theme',
      token_group_colors: 'Colors',
      token_group_radius: 'Radius',
      token_group_size: 'Size',
      token_group_utility: 'Utility',
      theme_section_title: 'Theme',
      theme_picker_label: 'Base theme',
      colors_section_title: 'Colors',
      radius_section_title: 'Radius',
      radius_boxes_label: 'Boxes',
      radius_fields_label: 'Fields',
      radius_selectors_label: 'Selectors',
      preset_sharp: 'Sharp',
      preset_rounded: 'Rounded',
      preset_soft: 'Soft',
      preset_pill: 'Pill',
      effects_section_title: 'Effects',
      effects_depth_label: 'Depth effect',
      effects_depth_description: '3D depth on fields & selectors',
      effects_noise_label: 'Noise effect',
      effects_noise_description: 'Noise pattern on fields & selectors',
      sizes_section_title: 'Sizes',
      sizes_fields_label: 'Fields',
      sizes_selectors_label: 'Selectors',
      border_width_section_title: 'Border width',
      border_width_label: 'All components',
      part_overrides_title: 'Part overrides',
      part_overrides_hint: 'Override ::part() CSS for component parts.',
      component_label: 'Component',
      part_label: 'Part',
      part_placeholder: '— select part —',
      remove_group: 'Remove',
      css_property_placeholder: 'background-color',
      add_declaration: 'Add property',
      add_override: 'Add part override',
      raw_css_label: 'Raw CSS',
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'versions',
    translations: {
      duplo_cloud_id: {
        copy: '_Copy DuploCloud ID',
        message: '_DuploCloud ID copied to clipboard',
      },
      cards: {
        title: '_Environments',
        button: '_Edit Workflows',
        empty:
          '_To create a new draft, make an edit in the Workflows tab or load an older version.',
        draft_date_label: '_Last edited',
        no_published_label:
          '_Nothing has been published on the {{env}} Environment.',
      },
      table: {
        title: '_Published Versions',
        column1: '_Version',
        column2: '_Environment',
        column3: '_Last published',
        buttons: {
          load_as_draft: '_Load as draft',
          republish: '_Republish',
        },
      },
      load_as_draft_modal: {
        title: {
          part1: '_Load',
          part2: '_as draft',
        },
        radio_group: {
          radio1: '_Restore all files',
          radio2: '_Restore without Actions',
        },
        button: '_Confirm',
      },
      republish_modal: {
        title: '_Republish',
        subtitle: '_Select environment:',
        button: {
          static: '_Republish',
          loading: '_Republishing...',
        },
        radio_group: {
          radio1: '_Republish all files',
          radio2: '_Republish without Actions',
        },
      },
    },
  },
  {
    lang: 'zh',
    namespace: 'pro-studio',
    file: 'workflows',
    translations: {
      csv_upload_modal: {
        title: '_Replace all nodes in this solution?',
        subtitle:
          '_Importing this CSV will replace all nodes in this solution.',
        buttons: {
          save: '_Replace Nodes',
          uploading: '_Uploading...',
          cancel: '_Cancel',
        },
      },
    },
  },
  {
    lang: 'ar',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'لقد انتهت هذه المحادثة.',
      agentConnected: 'تم توصيلك بأحد الوكلاء بنجاح.',
      downloadTranscript: 'تنزيل النص',
      startNewConversation: 'بدء محادثة جديدة',
      returnToConversation: 'العودة إلى المحادثة',
      connecting: 'جارٍ الاتصال...',
      retry: 'إعادة المحاولة',
      network: {
        retry: 'إعادة الاتصال',
      },
      reconnecting: 'جارٍ إعادة الاتصال...',
      connectionLost: 'تم فقدان الاتصال بالإنترنت',
      reconnectDescription:
        'تم فقدان الاتصال بالإنترنت. انقر على "إعادة الاتصال" للمحاولة مرة أخرى.',
      typeMessage: 'اكتب رسالة',
      inputSelect: 'اختر خيارًا',
      inputSelectOrType: 'اختر خيارًا أو اكتب رسالة',
      secureInput: 'اكتب رسالة آمنة',
      secureValueHidden: 'قيمة آمنة مخفية',
      startChat: 'بدء المحادثة',
      settings: 'الإعدادات',
      cancel: 'إلغاء',
      confirm: 'تأكيد',
      close: 'إغلاق',
      next: 'التالي',
      brandingTagline: 'عزّز أعمالك بوكلاء ذكاء اصطناعي أذكياء',
      poweredBy: 'مدعوم بواسطة',
      pypestreamCom: 'Pypestream.com',
      assistant: 'المساعد',
      assistantThinking: 'المساعد يفكّر',
      youSaid: 'لقد قلت',
      assistantSays: 'يقول المساعد',
      agentSays: 'يقول {{name}}',
      joinMeeting: 'الانضمام إلى الاجتماع',
      meetingInProgress: 'الاجتماع جارٍ — انقر لإعادة الانضمام',
      meetingExpired: 'رابط الاجتماع (منتهي الصلاحية)',
      embeddedContent: 'محتوى مضمّن',
      openInNewTab: 'فتح في علامة تبويب جديدة',
      skipToMain: 'تخطّي إلى المحتوى الرئيسي',
      loadingCustomerSolution: 'جارٍ تحميل حل {{customerName}}',
      loadingSolution: 'جارٍ تحميل الحل',
      customerLogoAlt: 'شعار {{customerName}}',
      selectDate: 'اختر التاريخ',
      selectTime: 'اختر الوقت',
      browseOptions: 'تصفّح الخيارات',
      carouselRoleDescription: 'عرض دوّار',
      carouselSlideLabel: 'الشريحة {{current}} من {{total}}',
      carouselPrevious: 'العنصر السابق',
      carouselNext: 'العنصر التالي',
      carouselGoToItem: 'الانتقال إلى العنصر {{index}}',
      collapse: 'طيّ',
      expand: 'توسيع',
      messageHistory: 'سجل الرسائل',
      reduce: 'تصغير',
      today: 'اليوم',
      at: 'في',
      a11yOptionsCount_zero: 'لا توجد خيارات.',
      a11yOptionsCount_one: 'يوجد خيار واحد.',
      a11yOptionsCount_two: 'يوجد خياران.',
      a11yOptionsCount_few: 'يوجد {{count}} خيارات.',
      a11yOptionsCount_many: 'يوجد {{count}} خيارًا.',
      a11yOptionsCount_other: 'يوجد {{count}} خيار.',
      listpickerSelectAll: 'تحديد الكل',
      listpickerSelectOption: 'اختر خيارًا',
      listpickerSearchAriaLabel: 'البحث عن خيارات التصفية',
      listpickerSearchPlaceholder: 'بحث…',
      listpickerNoResults: 'لا توجد خيارات مطابقة.',
      listpickerResults_zero: 'لا نتائج',
      listpickerResults_one: 'نتيجة واحدة',
      listpickerResults_two: 'نتيجتان',
      listpickerResults_few: '{{count}} نتائج',
      listpickerResults_many: '{{count}} نتيجة',
      listpickerResults_other: '{{count}} نتيجة',
      listpickerCondensed_zero: 'لم يتم التحديد',
      listpickerCondensed_one: 'تم تحديد واحد',
      listpickerCondensed_two: 'تم تحديد اثنين',
      listpickerCondensed_few: 'تم تحديد {{count}}',
      listpickerCondensed_many: 'تم تحديد {{count}}',
      listpickerCondensed_other: 'تم تحديد {{count}}',
      listpickerSelectAction: 'تحديد',
      scrollToLatest: 'التمرير إلى أحدث رسالة',
      scrollToUnread_zero: 'لا رسائل جديدة، انتقل إلى الأحدث',
      scrollToUnread_one: 'رسالة جديدة واحدة، انتقل إلى الأحدث',
      scrollToUnread_two: 'رسالتان جديدتان، انتقل إلى الأحدث',
      scrollToUnread_few: '{{count}} رسائل جديدة، انتقل إلى الأحدث',
      scrollToUnread_many: '{{count}} رسالة جديدة، انتقل إلى الأحدث',
      scrollToUnread_other: '{{count}} رسالة جديدة، انتقل إلى الأحدث',
      showPassword: 'إظهار المحتوى الآمن',
      hidePassword: 'إخفاء المحتوى الآمن',
      clear: 'مسح',
      send: 'إرسال',
      yesterday: 'أمس',
      chatEndedActions: 'إجراءات بعد انتهاء المحادثة',
      openConversationDialog: 'فتح نافذة المحادثة مع {{title}}',
      agentTyping: 'الوكيل يكتب',
      agentAway: 'وكلاؤنا غير متاحين حاليًا.',
      agentBusy: 'وكلاؤنا مشغولون حاليًا. يُرجى الانتظار...',
      waitingForAgent: 'جارٍ توصيلك بأحد الوكلاء...',
      waitingForAgentWithSkill: 'جارٍ توصيلك بوكيل {{skill}}...',
      talkingWithAgent: 'محادثة مع {{name}}',
      home: 'الرئيسية',
      back: 'رجوع',
      menu: 'القائمة',
      minimize: 'تصغير',
      endConversation: 'إنهاء المحادثة',
      engageWithUs: 'تواصل معنا',
      noMessagesYet: 'لا توجد رسائل بعد',
      tryAgain: 'حاول مرة أخرى',
      rating: 'التقييم',
      shareLocation: 'مشاركة الموقع',
      locationShared: 'تمت مشاركة الموقع',
      locationError: 'تعذّر تحديد موقعك',
      locationPermissionDenied: 'تم رفض إذن الوصول إلى الموقع',
      geolocationUnavailable: 'خدمات تحديد الموقع غير متاحة',
      selectFile: 'اختر ملفًا',
      upload: 'رفع',
      uploadComplete: 'اكتمل الرفع',
      uploadFailed: 'فشل الرفع',
      fileTooLarge: 'الملف كبير جدًا',
      dragOrClick: 'اسحب ملفًا أو انقر للاختيار',
      document: 'مستند',
      audioContent: 'محتوى صوتي',
      videoContent: 'محتوى فيديو',
      unsupportedContent: 'محتوى غير مدعوم',
      unavailable: {
        error: {
          title: 'حدث خطأ ما',
          body: 'تعذّر تحميل المحادثة. يُرجى المحاولة مرة أخرى.',
          retry: 'حاول مرة أخرى',
        },
        maintenance: {
          title: 'المحادثة غير متاحة مؤقتًا',
          body: 'نجري صيانة مجدولة. يُرجى المعاودة قريبًا.',
        },
      },
      image: 'صورة',
    },
  },
  {
    lang: 'bg',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Този разговор приключи.',
      agentConnected: 'Успешно сте свързани с агент.',
      downloadTranscript: 'Изтегляне на разговора',
      startNewConversation: 'Започни нов разговор',
      returnToConversation: 'Обратно към разговора',
      connecting: 'Свързване...',
      retry: 'Опитай отново',
      network: {
        retry: 'Повторно свързване',
      },
      reconnecting: 'Повторно свързване...',
      connectionLost: 'Връзката с интернет е загубена',
      reconnectDescription:
        'Връзката с интернет е загубена. Щракнете върху „Повторно свързване“, за да опитате отново.',
      typeMessage: 'Въведете съобщение',
      inputSelect: 'Изберете опция',
      inputSelectOrType: 'Изберете опция или въведете съобщение',
      secureInput: 'Въведете защитено съобщение',
      secureValueHidden: 'Скрита защитена стойност',
      startChat: 'Започни чат',
      settings: 'Настройки',
      cancel: 'Отказ',
      confirm: 'Потвърди',
      close: 'Затвори',
      next: 'Напред',
      brandingTagline: 'Развийте бизнеса си с интелигентни AI агенти',
      poweredBy: 'Задвижвано от',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Асистент',
      assistantThinking: 'Асистентът мисли',
      youSaid: 'Вие казахте',
      assistantSays: 'Асистентът казва',
      agentSays: '{{name}} казва',
      joinMeeting: 'Присъедини се към срещата',
      meetingInProgress:
        'Срещата е в ход — щракнете, за да се присъедините отново',
      meetingExpired: 'Връзка към среща (изтекла)',
      embeddedContent: 'Вградено съдържание',
      openInNewTab: 'Отвори в нов раздел',
      skipToMain: 'Прескочи към основното съдържание',
      loadingCustomerSolution: 'Зареждане на решението на {{customerName}}',
      loadingSolution: 'Зареждане на решението',
      customerLogoAlt: 'Лого на {{customerName}}',
      selectDate: 'Изберете дата',
      selectTime: 'Изберете час',
      browseOptions: 'Прегледай опциите',
      carouselRoleDescription: 'Въртележка',
      carouselSlideLabel: 'Слайд {{current}} от {{total}}',
      carouselPrevious: 'Предишен елемент',
      carouselNext: 'Следващ елемент',
      carouselGoToItem: 'Към елемент {{index}}',
      collapse: 'Свий',
      expand: 'Разгъни',
      messageHistory: 'История на съобщенията',
      reduce: 'Намали',
      today: 'Днес',
      at: 'в',
      a11yOptionsCount_zero: 'Има {{count}} опции.',
      a11yOptionsCount_one: 'Има 1 опция.',
      a11yOptionsCount_two: 'Има {{count}} опции.',
      a11yOptionsCount_few: 'Има {{count}} опции.',
      a11yOptionsCount_many: 'Има {{count}} опции.',
      a11yOptionsCount_other: 'Има {{count}} опции.',
      listpickerSelectAll: 'Избери всички',
      listpickerSelectOption: 'Изберете опция',
      listpickerSearchAriaLabel: 'Търсене на опции за филтриране',
      listpickerSearchPlaceholder: 'Търсене…',
      listpickerNoResults: 'Няма съвпадащи опции.',
      listpickerResults_zero: '{{count}} резултата',
      listpickerResults_one: '1 резултат',
      listpickerResults_two: '{{count}} резултата',
      listpickerResults_few: '{{count}} резултата',
      listpickerResults_many: '{{count}} резултата',
      listpickerResults_other: '{{count}} резултата',
      listpickerCondensed_zero: '{{count}} избрани',
      listpickerCondensed_one: '1 избрана',
      listpickerCondensed_two: '{{count}} избрани',
      listpickerCondensed_few: '{{count}} избрани',
      listpickerCondensed_many: '{{count}} избрани',
      listpickerCondensed_other: '{{count}} избрани',
      listpickerSelectAction: 'Избери',
      scrollToLatest: 'Към най-новото съобщение',
      scrollToUnread_zero: '{{count}} нови съобщения, към най-новото',
      scrollToUnread_one: '1 ново съобщение, към най-новото',
      scrollToUnread_two: '{{count}} нови съобщения, към най-новото',
      scrollToUnread_few: '{{count}} нови съобщения, към най-новото',
      scrollToUnread_many: '{{count}} нови съобщения, към най-новото',
      scrollToUnread_other: '{{count}} нови съобщения, към най-новото',
      showPassword: 'Покажи защитеното съдържание',
      hidePassword: 'Скрий защитеното съдържание',
      clear: 'Изчисти',
      send: 'Изпрати',
      yesterday: 'Вчера',
      chatEndedActions: 'Действия след края на чата',
      openConversationDialog: 'Отвори прозореца за разговор с {{title}}',
      agentTyping: 'Агентът пише',
      agentAway: 'Нашите агенти в момента не са налични.',
      agentBusy: 'Нашите агенти в момента са заети. Моля, изчакайте...',
      waitingForAgent: 'Свързваме ви с агент...',
      waitingForAgentWithSkill: 'Свързваме ви с агент за {{skill}}...',
      talkingWithAgent: 'Разговор с {{name}}',
      home: 'Начало',
      back: 'Назад',
      menu: 'Меню',
      minimize: 'Намали',
      endConversation: 'Приключи чата',
      engageWithUs: 'Свържете се с нас',
      noMessagesYet: 'Все още няма съобщения',
      tryAgain: 'Опитай отново',
      rating: 'Оценка',
      shareLocation: 'Сподели местоположение',
      locationShared: 'Местоположението е споделено',
      locationError: 'Местоположението ви не може да бъде извлечено',
      locationPermissionDenied: 'Достъпът до местоположението е отказан',
      geolocationUnavailable: 'Услугите за местоположение не са налични',
      selectFile: 'Изберете файл',
      upload: 'Качи',
      uploadComplete: 'Качването завърши',
      uploadFailed: 'Качването е неуспешно',
      fileTooLarge: 'Файлът е твърде голям',
      dragOrClick: 'Плъзнете файл или щракнете, за да изберете',
      document: 'Документ',
      audioContent: 'Аудио съдържание',
      videoContent: 'Видео съдържание',
      unsupportedContent: 'Неподдържано съдържание',
      unavailable: {
        error: {
          title: 'Нещо се обърка',
          body: 'Не успяхме да заредим чата. Опитайте отново.',
          retry: 'Опитай отново',
        },
        maintenance: {
          title: 'Чатът е временно недостъпен',
          body: 'Извършваме планирана поддръжка. Върнете се скоро.',
        },
      },
      image: 'Изображение',
    },
  },
  {
    lang: 'bn',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'এই কথোপকথনটি শেষ হয়েছে।',
      agentConnected: 'আপনি সফলভাবে একজন এজেন্টের সাথে সংযুক্ত হয়েছেন।',
      downloadTranscript: 'ট্রান্সক্রিপ্ট ডাউনলোড করুন',
      startNewConversation: 'নতুন কথোপকথন শুরু করুন',
      returnToConversation: 'কথোপকথনে ফিরে যান',
      connecting: 'সংযোগ করা হচ্ছে...',
      retry: 'আবার চেষ্টা করুন',
      network: {
        retry: 'পুনরায় সংযোগ করুন',
      },
      reconnecting: 'পুনরায় সংযোগ করা হচ্ছে...',
      connectionLost: 'ইন্টারনেট সংযোগ বিচ্ছিন্ন হয়েছে',
      reconnectDescription:
        "ইন্টারনেট সংযোগ বিচ্ছিন্ন হয়েছে। আবার চেষ্টা করতে 'পুনরায় সংযোগ করুন' এ ক্লিক করুন।",
      typeMessage: 'বার্তা টাইপ করুন',
      inputSelect: 'একটি বিকল্প নির্বাচন করুন',
      inputSelectOrType: 'একটি বিকল্প নির্বাচন করুন বা বার্তা টাইপ করুন',
      secureInput: 'নিরাপদ বার্তা টাইপ করুন',
      secureValueHidden: 'লুকানো নিরাপদ মান',
      startChat: 'চ্যাট শুরু করুন',
      settings: 'সেটিংস',
      cancel: 'বাতিল করুন',
      confirm: 'নিশ্চিত করুন',
      close: 'বন্ধ করুন',
      next: 'পরবর্তী',
      brandingTagline:
        'বুদ্ধিমান AI এজেন্ট দিয়ে আপনার ব্যবসাকে শক্তিশালী করুন',
      poweredBy: 'চালিত',
      pypestreamCom: 'Pypestream.com',
      assistant: 'সহকারী',
      assistantThinking: 'সহকারী ভাবছে',
      youSaid: 'আপনি বলেছেন',
      assistantSays: 'সহকারী বলে',
      agentSays: '{{name}} বলেন',
      joinMeeting: 'মিটিংয়ে যোগ দিন',
      meetingInProgress: 'মিটিং চলছে — পুনরায় যোগ দিতে ক্লিক করুন',
      meetingExpired: 'মিটিং লিঙ্ক (মেয়াদোত্তীর্ণ)',
      embeddedContent: 'এমবেড করা বিষয়বস্তু',
      openInNewTab: 'নতুন ট্যাবে খুলুন',
      skipToMain: 'মূল বিষয়বস্তুতে যান',
      loadingCustomerSolution: '{{customerName}} সমাধান লোড হচ্ছে',
      loadingSolution: 'সমাধান লোড হচ্ছে',
      customerLogoAlt: '{{customerName}} লোগো',
      selectDate: 'তারিখ নির্বাচন করুন',
      selectTime: 'সময় নির্বাচন করুন',
      browseOptions: 'বিকল্পগুলি দেখুন',
      carouselRoleDescription: 'ক্যারোজেল',
      carouselSlideLabel: 'স্লাইড {{current}} / {{total}}',
      carouselPrevious: 'পূর্ববর্তী আইটেম',
      carouselNext: 'পরবর্তী আইটেম',
      carouselGoToItem: 'আইটেম {{index}} এ যান',
      collapse: 'সংকুচিত করুন',
      expand: 'প্রসারিত করুন',
      messageHistory: 'বার্তার ইতিহাস',
      reduce: 'ছোট করুন',
      today: 'আজ',
      at: '',
      a11yOptionsCount_zero: '{{count}}টি বিকল্প রয়েছে।',
      a11yOptionsCount_one: '1টি বিকল্প রয়েছে।',
      a11yOptionsCount_two: '{{count}}টি বিকল্প রয়েছে।',
      a11yOptionsCount_few: '{{count}}টি বিকল্প রয়েছে।',
      a11yOptionsCount_many: '{{count}}টি বিকল্প রয়েছে।',
      a11yOptionsCount_other: '{{count}}টি বিকল্প রয়েছে।',
      listpickerSelectAll: 'সব নির্বাচন করুন',
      listpickerSelectOption: 'একটি বিকল্প নির্বাচন করুন',
      listpickerSearchAriaLabel: 'ফিল্টার বিকল্প অনুসন্ধান করুন',
      listpickerSearchPlaceholder: 'অনুসন্ধান…',
      listpickerNoResults: 'কোনো মিল থাকা বিকল্প নেই।',
      listpickerResults_zero: '{{count}}টি ফলাফল',
      listpickerResults_one: '1টি ফলাফল',
      listpickerResults_two: '{{count}}টি ফলাফল',
      listpickerResults_few: '{{count}}টি ফলাফল',
      listpickerResults_many: '{{count}}টি ফলাফল',
      listpickerResults_other: '{{count}}টি ফলাফল',
      listpickerCondensed_zero: '{{count}}টি নির্বাচিত',
      listpickerCondensed_one: '1টি নির্বাচিত',
      listpickerCondensed_two: '{{count}}টি নির্বাচিত',
      listpickerCondensed_few: '{{count}}টি নির্বাচিত',
      listpickerCondensed_many: '{{count}}টি নির্বাচিত',
      listpickerCondensed_other: '{{count}}টি নির্বাচিত',
      listpickerSelectAction: 'নির্বাচন করুন',
      scrollToLatest: 'সর্বশেষ বার্তায় স্ক্রোল করুন',
      scrollToUnread_zero: '{{count}}টি নতুন বার্তা, সর্বশেষে যান',
      scrollToUnread_one: '1টি নতুন বার্তা, সর্বশেষে যান',
      scrollToUnread_two: '{{count}}টি নতুন বার্তা, সর্বশেষে যান',
      scrollToUnread_few: '{{count}}টি নতুন বার্তা, সর্বশেষে যান',
      scrollToUnread_many: '{{count}}টি নতুন বার্তা, সর্বশেষে যান',
      scrollToUnread_other: '{{count}}টি নতুন বার্তা, সর্বশেষে যান',
      showPassword: 'নিরাপদ বিষয়বস্তু দেখান',
      hidePassword: 'নিরাপদ বিষয়বস্তু লুকান',
      clear: 'সাফ করুন',
      send: 'পাঠান',
      yesterday: 'গতকাল',
      chatEndedActions: 'চ্যাট শেষ হওয়ার পরের কাজ',
      openConversationDialog: '{{title}} এর সাথে কথোপকথন ডায়ালগ খুলুন',
      agentTyping: 'এজেন্ট টাইপ করছেন',
      agentAway: 'আমাদের এজেন্টরা এই মুহূর্তে উপলব্ধ নয়।',
      agentBusy:
        'আমাদের এজেন্টরা এই মুহূর্তে ব্যস্ত। অনুগ্রহ করে অপেক্ষা করুন...',
      waitingForAgent: 'আপনাকে একজন এজেন্টের সাথে সংযুক্ত করা হচ্ছে...',
      waitingForAgentWithSkill:
        'আপনাকে একজন {{skill}} এজেন্টের সাথে সংযুক্ত করা হচ্ছে...',
      talkingWithAgent: '{{name}} এর সাথে কথা বলছেন',
      home: 'হোম',
      back: 'পিছনে',
      menu: 'মেনু',
      minimize: 'ছোট করুন',
      endConversation: 'চ্যাট শেষ করুন',
      engageWithUs: 'আমাদের সাথে যোগাযোগ করুন',
      noMessagesYet: 'এখনও কোনো বার্তা নেই',
      tryAgain: 'আবার চেষ্টা করুন',
      rating: 'রেটিং',
      shareLocation: 'অবস্থান শেয়ার করুন',
      locationShared: 'অবস্থান শেয়ার করা হয়েছে',
      locationError: 'আপনার অবস্থান পুনরুদ্ধার করা যায়নি',
      locationPermissionDenied: 'অবস্থানের অনুমতি প্রত্যাখ্যাত',
      geolocationUnavailable: 'অবস্থান পরিষেবা উপলব্ধ নয়',
      selectFile: 'একটি ফাইল নির্বাচন করুন',
      upload: 'আপলোড করুন',
      uploadComplete: 'আপলোড সম্পূর্ণ',
      uploadFailed: 'আপলোড ব্যর্থ',
      fileTooLarge: 'ফাইলটি খুব বড়',
      dragOrClick: 'একটি ফাইল টেনে আনুন বা নির্বাচন করতে ক্লিক করুন',
      document: 'নথি',
      audioContent: 'অডিও বিষয়বস্তু',
      videoContent: 'ভিডিও বিষয়বস্তু',
      unsupportedContent: 'অসমর্থিত বিষয়বস্তু',
      unavailable: {
        error: {
          title: 'কিছু ভুল হয়েছে',
          body: 'আমরা চ্যাট লোড করতে পারিনি। অনুগ্রহ করে আবার চেষ্টা করুন।',
          retry: 'আবার চেষ্টা করুন',
        },
        maintenance: {
          title: 'চ্যাট সাময়িকভাবে অনুপলব্ধ',
          body: 'আমরা নির্ধারিত রক্ষণাবেক্ষণ করছি। অনুগ্রহ করে শীঘ্রই ফিরে আসুন।',
        },
      },
      image: 'ছবি',
    },
  },
  {
    lang: 'cs',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Tato konverzace byla ukončena.',
      agentConnected: 'Byli jste úspěšně spojeni s operátorem.',
      downloadTranscript: 'Stáhnout přepis',
      startNewConversation: 'Zahájit novou konverzaci',
      returnToConversation: 'Zpět ke konverzaci',
      connecting: 'Připojování...',
      retry: 'Zkusit znovu',
      network: {
        retry: 'Znovu připojit',
      },
      reconnecting: 'Opětovné připojování...',
      connectionLost: 'Připojení k internetu bylo ztraceno',
      reconnectDescription:
        'Připojení k internetu bylo ztraceno. Kliknutím na Znovu připojit to zkuste znovu.',
      typeMessage: 'Napište zprávu',
      inputSelect: 'Vyberte možnost',
      inputSelectOrType: 'Vyberte možnost nebo napište zprávu',
      secureInput: 'Napište zabezpečenou zprávu',
      secureValueHidden: 'Skrytá zabezpečená hodnota',
      startChat: 'Zahájit chat',
      settings: 'Nastavení',
      cancel: 'Zrušit',
      confirm: 'Potvrdit',
      close: 'Zavřít',
      next: 'Další',
      brandingTagline: 'Posilte své podnikání s inteligentními agenty AI',
      poweredBy: 'Poháněno technologií',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asistent',
      assistantThinking: 'Asistent přemýšlí',
      youSaid: 'Řekli jste',
      assistantSays: 'Asistent říká',
      agentSays: '{{name}} říká',
      joinMeeting: 'Připojit se ke schůzce',
      meetingInProgress: 'Schůzka probíhá — kliknutím se znovu připojíte',
      meetingExpired: 'Odkaz na schůzku (vypršel)',
      embeddedContent: 'Vložený obsah',
      openInNewTab: 'Otevřít na nové kartě',
      skipToMain: 'Přeskočit na hlavní obsah',
      loadingCustomerSolution: 'Načítání řešení {{customerName}}',
      loadingSolution: 'Načítání řešení',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Vyberte datum',
      selectTime: 'Vyberte čas',
      browseOptions: 'Procházet možnosti',
      carouselRoleDescription: 'Karusel',
      carouselSlideLabel: 'Snímek {{current}} z {{total}}',
      carouselPrevious: 'Předchozí položka',
      carouselNext: 'Další položka',
      carouselGoToItem: 'Přejít na položku {{index}}',
      collapse: 'Sbalit',
      expand: 'Rozbalit',
      messageHistory: 'Historie zpráv',
      reduce: 'Zmenšit',
      today: 'Dnes',
      at: 'v',
      a11yOptionsCount_zero: 'Je {{count}} možností.',
      a11yOptionsCount_one: 'Je 1 možnost.',
      a11yOptionsCount_two: 'Je {{count}} možností.',
      a11yOptionsCount_few: 'Jsou {{count}} možnosti.',
      a11yOptionsCount_many: 'Je {{count}} možnosti.',
      a11yOptionsCount_other: 'Je {{count}} možností.',
      listpickerSelectAll: 'Vybrat vše',
      listpickerSelectOption: 'Vyberte možnost',
      listpickerSearchAriaLabel: 'Hledat možnosti filtru',
      listpickerSearchPlaceholder: 'Hledat…',
      listpickerNoResults: 'Žádné odpovídající možnosti.',
      listpickerResults_zero: '{{count}} výsledků',
      listpickerResults_one: '1 výsledek',
      listpickerResults_two: '{{count}} výsledků',
      listpickerResults_few: '{{count}} výsledky',
      listpickerResults_many: '{{count}} výsledku',
      listpickerResults_other: '{{count}} výsledků',
      listpickerCondensed_zero: 'Vybráno {{count}}',
      listpickerCondensed_one: 'Vybráno 1',
      listpickerCondensed_two: 'Vybráno {{count}}',
      listpickerCondensed_few: 'Vybráno {{count}}',
      listpickerCondensed_many: 'Vybráno {{count}}',
      listpickerCondensed_other: 'Vybráno {{count}}',
      listpickerSelectAction: 'Vybrat',
      scrollToLatest: 'Přejít na nejnovější zprávu',
      scrollToUnread_zero: '{{count}} nových zpráv, přejít na nejnovější',
      scrollToUnread_one: '1 nová zpráva, přejít na nejnovější',
      scrollToUnread_two: '{{count}} nových zpráv, přejít na nejnovější',
      scrollToUnread_few: '{{count}} nové zprávy, přejít na nejnovější',
      scrollToUnread_many: '{{count}} nové zprávy, přejít na nejnovější',
      scrollToUnread_other: '{{count}} nových zpráv, přejít na nejnovější',
      showPassword: 'Zobrazit zabezpečený obsah',
      hidePassword: 'Skrýt zabezpečený obsah',
      clear: 'Vymazat',
      send: 'Odeslat',
      yesterday: 'Včera',
      chatEndedActions: 'Akce po ukončení chatu',
      openConversationDialog: 'Otevřít okno konverzace s {{title}}',
      agentTyping: 'Operátor píše',
      agentAway: 'Naši operátoři jsou momentálně nedostupní.',
      agentBusy:
        'Naši operátoři jsou momentálně zaneprázdněni. Vyčkejte prosím...',
      waitingForAgent: 'Spojujeme vás s operátorem...',
      waitingForAgentWithSkill: 'Spojujeme vás s operátorem pro {{skill}}...',
      talkingWithAgent: 'Hovoříte s {{name}}',
      home: 'Domů',
      back: 'Zpět',
      menu: 'Nabídka',
      minimize: 'Minimalizovat',
      endConversation: 'Ukončit chat',
      engageWithUs: 'Kontaktujte nás',
      noMessagesYet: 'Zatím žádné zprávy',
      tryAgain: 'Zkusit znovu',
      rating: 'Hodnocení',
      shareLocation: 'Sdílet polohu',
      locationShared: 'Poloha sdílena',
      locationError: 'Vaši polohu se nepodařilo získat',
      locationPermissionDenied: 'Přístup k poloze byl zamítnut',
      geolocationUnavailable: 'Služby určování polohy nejsou dostupné',
      selectFile: 'Vyberte soubor',
      upload: 'Nahrát',
      uploadComplete: 'Nahrávání dokončeno',
      uploadFailed: 'Nahrávání se nezdařilo',
      fileTooLarge: 'Soubor je příliš velký',
      dragOrClick: 'Přetáhněte soubor nebo klikněte pro výběr',
      document: 'Dokument',
      audioContent: 'Zvukový obsah',
      videoContent: 'Videoobsah',
      unsupportedContent: 'Nepodporovaný obsah',
      unavailable: {
        error: {
          title: 'Něco se pokazilo',
          body: 'Chat se nepodařilo načíst. Zkuste to znovu.',
          retry: 'Zkusit znovu',
        },
        maintenance: {
          title: 'Chat je dočasně nedostupný',
          body: 'Provádíme plánovanou údržbu. Vraťte se prosím brzy.',
        },
      },
      image: 'Obrázek',
    },
  },
  {
    lang: 'da',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Denne samtale er afsluttet.',
      agentConnected: 'Du er blevet forbundet til en medarbejder.',
      downloadTranscript: 'Download udskrift',
      startNewConversation: 'Start ny samtale',
      returnToConversation: 'Tilbage til samtalen',
      connecting: 'Opretter forbindelse...',
      retry: 'Prøv igen',
      network: {
        retry: 'Opret forbindelse igen',
      },
      reconnecting: 'Opretter forbindelse igen...',
      connectionLost: 'Internetforbindelsen er mistet',
      reconnectDescription:
        'Internetforbindelsen er mistet. Klik på Opret forbindelse igen for at prøve igen.',
      typeMessage: 'Skriv en besked',
      inputSelect: 'Vælg en mulighed',
      inputSelectOrType: 'Vælg en mulighed, eller skriv en besked',
      secureInput: 'Skriv en sikker besked',
      secureValueHidden: 'Skjult sikker værdi',
      startChat: 'Start chat',
      settings: 'Indstillinger',
      cancel: 'Annuller',
      confirm: 'Bekræft',
      close: 'Luk',
      next: 'Næste',
      brandingTagline: 'Styrk din virksomhed med intelligente AI-agenter',
      poweredBy: 'Leveret af',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistent',
      assistantThinking: 'Assistenten tænker',
      youSaid: 'Du sagde',
      assistantSays: 'Assistenten siger',
      agentSays: '{{name}} siger',
      joinMeeting: 'Deltag i møde',
      meetingInProgress: 'Møde i gang — klik for at deltage igen',
      meetingExpired: 'Mødelink (udløbet)',
      embeddedContent: 'Indlejret indhold',
      openInNewTab: 'Åbn i ny fane',
      skipToMain: 'Gå til hovedindhold',
      loadingCustomerSolution: 'Indlæser {{customerName}}-løsning',
      loadingSolution: 'Indlæser løsning',
      customerLogoAlt: '{{customerName}}-logo',
      selectDate: 'Vælg dato',
      selectTime: 'Vælg tidspunkt',
      browseOptions: 'Gennemse muligheder',
      carouselRoleDescription: 'Karrusel',
      carouselSlideLabel: 'Slide {{current}} af {{total}}',
      carouselPrevious: 'Forrige element',
      carouselNext: 'Næste element',
      carouselGoToItem: 'Gå til element {{index}}',
      collapse: 'Skjul',
      expand: 'Udvid',
      messageHistory: 'Beskedhistorik',
      reduce: 'Formindsk',
      today: 'I dag',
      at: 'kl.',
      a11yOptionsCount_zero: 'Der er {{count}} muligheder.',
      a11yOptionsCount_one: 'Der er 1 mulighed.',
      a11yOptionsCount_two: 'Der er {{count}} muligheder.',
      a11yOptionsCount_few: 'Der er {{count}} muligheder.',
      a11yOptionsCount_many: 'Der er {{count}} muligheder.',
      a11yOptionsCount_other: 'Der er {{count}} muligheder.',
      listpickerSelectAll: 'Vælg alle',
      listpickerSelectOption: 'Vælg en mulighed',
      listpickerSearchAriaLabel: 'Søg efter filtermuligheder',
      listpickerSearchPlaceholder: 'Søg…',
      listpickerNoResults: 'Ingen matchende muligheder.',
      listpickerResults_zero: '{{count}} resultater',
      listpickerResults_one: '1 resultat',
      listpickerResults_two: '{{count}} resultater',
      listpickerResults_few: '{{count}} resultater',
      listpickerResults_many: '{{count}} resultater',
      listpickerResults_other: '{{count}} resultater',
      listpickerCondensed_zero: '{{count}} valgt',
      listpickerCondensed_one: '1 valgt',
      listpickerCondensed_two: '{{count}} valgt',
      listpickerCondensed_few: '{{count}} valgt',
      listpickerCondensed_many: '{{count}} valgt',
      listpickerCondensed_other: '{{count}} valgt',
      listpickerSelectAction: 'Vælg',
      scrollToLatest: 'Rul til den seneste besked',
      scrollToUnread_zero: '{{count}} nye beskeder, gå til seneste',
      scrollToUnread_one: '1 ny besked, gå til seneste',
      scrollToUnread_two: '{{count}} nye beskeder, gå til seneste',
      scrollToUnread_few: '{{count}} nye beskeder, gå til seneste',
      scrollToUnread_many: '{{count}} nye beskeder, gå til seneste',
      scrollToUnread_other: '{{count}} nye beskeder, gå til seneste',
      showPassword: 'Vis sikkert indhold',
      hidePassword: 'Skjul sikkert indhold',
      clear: 'Ryd',
      send: 'Send',
      yesterday: 'I går',
      chatEndedActions: 'Handlinger efter afsluttet chat',
      openConversationDialog: 'Åbn samtalevindue med {{title}}',
      agentTyping: 'Medarbejderen skriver',
      agentAway: 'Vores medarbejdere er ikke tilgængelige i øjeblikket.',
      agentBusy: 'Vores medarbejdere er optaget i øjeblikket. Vent venligst...',
      waitingForAgent: 'Du bliver forbundet til en medarbejder...',
      waitingForAgentWithSkill:
        'Du bliver forbundet til en medarbejder til {{skill}}...',
      talkingWithAgent: 'Taler med {{name}}',
      home: 'Hjem',
      back: 'Tilbage',
      menu: 'Menu',
      minimize: 'Minimer',
      endConversation: 'Afslut chat',
      engageWithUs: 'Kontakt os',
      noMessagesYet: 'Ingen beskeder endnu',
      tryAgain: 'Prøv igen',
      rating: 'Bedømmelse',
      shareLocation: 'Del placering',
      locationShared: 'Placering delt',
      locationError: 'Din placering kunne ikke hentes',
      locationPermissionDenied: 'Placeringstilladelse nægtet',
      geolocationUnavailable: 'Placeringstjenester er ikke tilgængelige',
      selectFile: 'Vælg en fil',
      upload: 'Upload',
      uploadComplete: 'Upload fuldført',
      uploadFailed: 'Upload mislykkedes',
      fileTooLarge: 'Filen er for stor',
      dragOrClick: 'Træk en fil, eller klik for at vælge',
      document: 'Dokument',
      audioContent: 'Lydindhold',
      videoContent: 'Videoindhold',
      unsupportedContent: 'Indhold, der ikke understøttes',
      unavailable: {
        error: {
          title: 'Noget gik galt',
          body: 'Vi kunne ikke indlæse chatten. Prøv igen.',
          retry: 'Prøv igen',
        },
        maintenance: {
          title: 'Chatten er midlertidigt utilgængelig',
          body: 'Vi udfører planlagt vedligeholdelse. Kom snart tilbage.',
        },
      },
      image: 'Billede',
    },
  },
  {
    lang: 'de',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Diese Unterhaltung ist beendet.',
      agentConnected: 'Sie wurden erfolgreich mit einem Mitarbeiter verbunden.',
      downloadTranscript: 'Transkript herunterladen',
      startNewConversation: 'Neue Unterhaltung starten',
      returnToConversation: 'Zurück zur Unterhaltung',
      connecting: 'Verbindung wird hergestellt...',
      retry: 'Wiederholen',
      network: {
        retry: 'Erneut verbinden',
      },
      reconnecting: 'Verbindung wird wiederhergestellt...',
      connectionLost: 'Die Internetverbindung wurde unterbrochen',
      reconnectDescription:
        'Die Internetverbindung wurde unterbrochen. Klicken Sie auf „Erneut verbinden“, um es erneut zu versuchen.',
      typeMessage: 'Nachricht eingeben',
      inputSelect: 'Option auswählen',
      inputSelectOrType: 'Option auswählen oder Nachricht eingeben',
      secureInput: 'Sichere Nachricht eingeben',
      secureValueHidden: 'Verborgener sicherer Wert',
      startChat: 'Chat starten',
      settings: 'Einstellungen',
      cancel: 'Abbrechen',
      confirm: 'Bestätigen',
      close: 'Schließen',
      next: 'Weiter',
      brandingTagline:
        'Bringen Sie Ihr Unternehmen mit intelligenten KI-Agenten voran',
      poweredBy: 'Bereitgestellt von',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistent',
      assistantThinking: 'Der Assistent denkt nach',
      youSaid: 'Sie sagten',
      assistantSays: 'Der Assistent sagt',
      agentSays: '{{name}} sagt',
      joinMeeting: 'Meeting beitreten',
      meetingInProgress: 'Meeting läuft — zum Wiederbeitreten klicken',
      meetingExpired: 'Meeting-Link (abgelaufen)',
      embeddedContent: 'Eingebetteter Inhalt',
      openInNewTab: 'In neuem Tab öffnen',
      skipToMain: 'Zum Hauptinhalt springen',
      loadingCustomerSolution: '{{customerName}}-Lösung wird geladen',
      loadingSolution: 'Lösung wird geladen',
      customerLogoAlt: '{{customerName}}-Logo',
      selectDate: 'Datum auswählen',
      selectTime: 'Uhrzeit auswählen',
      browseOptions: 'Optionen durchsuchen',
      carouselRoleDescription: 'Karussell',
      carouselSlideLabel: 'Folie {{current}} von {{total}}',
      carouselPrevious: 'Vorheriges Element',
      carouselNext: 'Nächstes Element',
      carouselGoToItem: 'Zu Element {{index}} gehen',
      collapse: 'Einklappen',
      expand: 'Ausklappen',
      messageHistory: 'Nachrichtenverlauf',
      reduce: 'Verkleinern',
      today: 'Heute',
      at: 'um',
      a11yOptionsCount_zero: 'Es gibt {{count}} Optionen.',
      a11yOptionsCount_one: 'Es gibt 1 Option.',
      a11yOptionsCount_two: 'Es gibt {{count}} Optionen.',
      a11yOptionsCount_few: 'Es gibt {{count}} Optionen.',
      a11yOptionsCount_many: 'Es gibt {{count}} Optionen.',
      a11yOptionsCount_other: 'Es gibt {{count}} Optionen.',
      listpickerSelectAll: 'Alle auswählen',
      listpickerSelectOption: 'Wählen Sie eine Option',
      listpickerSearchAriaLabel: 'Nach Filteroptionen suchen',
      listpickerSearchPlaceholder: 'Suchen…',
      listpickerNoResults: 'Keine passenden Optionen.',
      listpickerResults_zero: '{{count}} Ergebnisse',
      listpickerResults_one: '1 Ergebnis',
      listpickerResults_two: '{{count}} Ergebnisse',
      listpickerResults_few: '{{count}} Ergebnisse',
      listpickerResults_many: '{{count}} Ergebnisse',
      listpickerResults_other: '{{count}} Ergebnisse',
      listpickerCondensed_zero: '{{count}} ausgewählt',
      listpickerCondensed_one: '1 ausgewählt',
      listpickerCondensed_two: '{{count}} ausgewählt',
      listpickerCondensed_few: '{{count}} ausgewählt',
      listpickerCondensed_many: '{{count}} ausgewählt',
      listpickerCondensed_other: '{{count}} ausgewählt',
      listpickerSelectAction: 'Auswählen',
      scrollToLatest: 'Zur neuesten Nachricht scrollen',
      scrollToUnread_zero: '{{count}} neue Nachrichten, zur neuesten scrollen',
      scrollToUnread_one: '1 neue Nachricht, zur neuesten scrollen',
      scrollToUnread_two: '{{count}} neue Nachrichten, zur neuesten scrollen',
      scrollToUnread_few: '{{count}} neue Nachrichten, zur neuesten scrollen',
      scrollToUnread_many: '{{count}} neue Nachrichten, zur neuesten scrollen',
      scrollToUnread_other: '{{count}} neue Nachrichten, zur neuesten scrollen',
      showPassword: 'Sicheren Inhalt anzeigen',
      hidePassword: 'Sicheren Inhalt ausblenden',
      clear: 'Löschen',
      send: 'Senden',
      yesterday: 'Gestern',
      chatEndedActions: 'Aktionen nach Chat-Ende',
      openConversationDialog: 'Konversationsdialog mit {{title}} öffnen',
      agentTyping: 'Der Mitarbeiter schreibt',
      agentAway: 'Unsere Mitarbeiter sind derzeit nicht verfügbar.',
      agentBusy:
        'Unsere Mitarbeiter sind derzeit beschäftigt. Bitte haben Sie einen Moment Geduld...',
      waitingForAgent: 'Sie werden mit einem Mitarbeiter verbunden...',
      waitingForAgentWithSkill:
        'Sie werden mit einem {{skill}}-Mitarbeiter verbunden...',
      talkingWithAgent: 'Gespräch mit {{name}}',
      home: 'Startseite',
      back: 'Zurück',
      menu: 'Menü',
      minimize: 'Minimieren',
      endConversation: 'Chat beenden',
      engageWithUs: 'Kontaktieren Sie uns',
      noMessagesYet: 'Noch keine Nachrichten',
      tryAgain: 'Erneut versuchen',
      rating: 'Bewertung',
      shareLocation: 'Standort teilen',
      locationShared: 'Standort geteilt',
      locationError: 'Ihr Standort konnte nicht ermittelt werden',
      locationPermissionDenied: 'Standortberechtigung verweigert',
      geolocationUnavailable: 'Standortdienste sind nicht verfügbar',
      selectFile: 'Datei auswählen',
      upload: 'Hochladen',
      uploadComplete: 'Hochladen abgeschlossen',
      uploadFailed: 'Hochladen fehlgeschlagen',
      fileTooLarge: 'Die Datei ist zu groß',
      dragOrClick: 'Datei hierher ziehen oder zum Auswählen klicken',
      document: 'Dokument',
      audioContent: 'Audioinhalt',
      videoContent: 'Videoinhalt',
      unsupportedContent: 'Nicht unterstützter Inhalt',
      unavailable: {
        error: {
          title: 'Etwas ist schiefgelaufen',
          body: 'Der Chat konnte nicht geladen werden. Bitte versuchen Sie es erneut.',
          retry: 'Erneut versuchen',
        },
        maintenance: {
          title: 'Chat vorübergehend nicht verfügbar',
          body: 'Wir führen planmäßige Wartungsarbeiten durch. Bitte schauen Sie bald wieder vorbei.',
        },
      },
      image: 'Bild',
    },
  },
  {
    lang: 'el',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Αυτή η συνομιλία έχει λήξει.',
      agentConnected: 'Συνδεθήκατε με έναν εκπρόσωπο.',
      downloadTranscript: 'Λήψη απομαγνητοφώνησης',
      startNewConversation: 'Έναρξη νέας συνομιλίας',
      returnToConversation: 'Επιστροφή στη συνομιλία',
      connecting: 'Σύνδεση...',
      retry: 'Επανάληψη',
      network: {
        retry: 'Επανασύνδεση',
      },
      reconnecting: 'Επανασύνδεση...',
      connectionLost: 'Η σύνδεση στο διαδίκτυο χάθηκε',
      reconnectDescription:
        'Η σύνδεση στο διαδίκτυο χάθηκε. Κάντε κλικ στην Επανασύνδεση για νέα προσπάθεια.',
      typeMessage: 'Πληκτρολογήστε μήνυμα',
      inputSelect: 'Επιλέξτε μια επιλογή',
      inputSelectOrType: 'Επιλέξτε μια επιλογή ή πληκτρολογήστε μήνυμα',
      secureInput: 'Πληκτρολογήστε ασφαλές μήνυμα',
      secureValueHidden: 'Κρυφή ασφαλής τιμή',
      startChat: 'Έναρξη συνομιλίας',
      settings: 'Ρυθμίσεις',
      cancel: 'Ακύρωση',
      confirm: 'Επιβεβαίωση',
      close: 'Κλείσιμο',
      next: 'Επόμενο',
      brandingTagline: 'Ενισχύστε την επιχείρησή σας με έξυπνους πράκτορες AI',
      poweredBy: 'Με την υποστήριξη',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Βοηθός',
      assistantThinking: 'Ο βοηθός σκέφτεται',
      youSaid: 'Είπατε',
      assistantSays: 'Ο βοηθός λέει',
      agentSays: 'Ο/Η {{name}} λέει',
      joinMeeting: 'Συμμετοχή στη σύσκεψη',
      meetingInProgress:
        'Η σύσκεψη είναι σε εξέλιξη — κάντε κλικ για επανασύνδεση',
      meetingExpired: 'Σύνδεσμος σύσκεψης (έληξε)',
      embeddedContent: 'Ενσωματωμένο περιεχόμενο',
      openInNewTab: 'Άνοιγμα σε νέα καρτέλα',
      skipToMain: 'Μετάβαση στο κύριο περιεχόμενο',
      loadingCustomerSolution: 'Φόρτωση της λύσης {{customerName}}',
      loadingSolution: 'Φόρτωση λύσης',
      customerLogoAlt: 'Λογότυπο {{customerName}}',
      selectDate: 'Επιλέξτε ημερομηνία',
      selectTime: 'Επιλέξτε ώρα',
      browseOptions: 'Περιήγηση επιλογών',
      carouselRoleDescription: 'Καρουζέλ',
      carouselSlideLabel: 'Διαφάνεια {{current}} από {{total}}',
      carouselPrevious: 'Προηγούμενο στοιχείο',
      carouselNext: 'Επόμενο στοιχείο',
      carouselGoToItem: 'Μετάβαση στο στοιχείο {{index}}',
      collapse: 'Σύμπτυξη',
      expand: 'Ανάπτυξη',
      messageHistory: 'Ιστορικό μηνυμάτων',
      reduce: 'Σμίκρυνση',
      today: 'Σήμερα',
      at: 'στις',
      a11yOptionsCount_zero: 'Υπάρχουν {{count}} επιλογές.',
      a11yOptionsCount_one: 'Υπάρχει 1 επιλογή.',
      a11yOptionsCount_two: 'Υπάρχουν {{count}} επιλογές.',
      a11yOptionsCount_few: 'Υπάρχουν {{count}} επιλογές.',
      a11yOptionsCount_many: 'Υπάρχουν {{count}} επιλογές.',
      a11yOptionsCount_other: 'Υπάρχουν {{count}} επιλογές.',
      listpickerSelectAll: 'Επιλογή όλων',
      listpickerSelectOption: 'Επιλέξτε μια επιλογή',
      listpickerSearchAriaLabel: 'Αναζήτηση επιλογών φίλτρου',
      listpickerSearchPlaceholder: 'Αναζήτηση…',
      listpickerNoResults: 'Δεν υπάρχουν αντίστοιχες επιλογές.',
      listpickerResults_zero: '{{count}} αποτελέσματα',
      listpickerResults_one: '1 αποτέλεσμα',
      listpickerResults_two: '{{count}} αποτελέσματα',
      listpickerResults_few: '{{count}} αποτελέσματα',
      listpickerResults_many: '{{count}} αποτελέσματα',
      listpickerResults_other: '{{count}} αποτελέσματα',
      listpickerCondensed_zero: '{{count}} επιλεγμένα',
      listpickerCondensed_one: '1 επιλεγμένο',
      listpickerCondensed_two: '{{count}} επιλεγμένα',
      listpickerCondensed_few: '{{count}} επιλεγμένα',
      listpickerCondensed_many: '{{count}} επιλεγμένα',
      listpickerCondensed_other: '{{count}} επιλεγμένα',
      listpickerSelectAction: 'Επιλογή',
      scrollToLatest: 'Μετάβαση στο πιο πρόσφατο μήνυμα',
      scrollToUnread_zero: '{{count}} νέα μηνύματα, μετάβαση στο πιο πρόσφατο',
      scrollToUnread_one: '1 νέο μήνυμα, μετάβαση στο πιο πρόσφατο',
      scrollToUnread_two: '{{count}} νέα μηνύματα, μετάβαση στο πιο πρόσφατο',
      scrollToUnread_few: '{{count}} νέα μηνύματα, μετάβαση στο πιο πρόσφατο',
      scrollToUnread_many: '{{count}} νέα μηνύματα, μετάβαση στο πιο πρόσφατο',
      scrollToUnread_other: '{{count}} νέα μηνύματα, μετάβαση στο πιο πρόσφατο',
      showPassword: 'Εμφάνιση ασφαλούς περιεχομένου',
      hidePassword: 'Απόκρυψη ασφαλούς περιεχομένου',
      clear: 'Εκκαθάριση',
      send: 'Αποστολή',
      yesterday: 'Χθες',
      chatEndedActions: 'Ενέργειες μετά τη λήξη της συνομιλίας',
      openConversationDialog: 'Άνοιγμα παραθύρου συνομιλίας με {{title}}',
      agentTyping: 'Ο εκπρόσωπος πληκτρολογεί',
      agentAway: 'Οι εκπρόσωποί μας δεν είναι διαθέσιμοι αυτήν τη στιγμή.',
      agentBusy:
        'Οι εκπρόσωποί μας είναι απασχολημένοι αυτήν τη στιγμή. Περιμένετε...',
      waitingForAgent: 'Σας συνδέουμε με έναν εκπρόσωπο...',
      waitingForAgentWithSkill:
        'Σας συνδέουμε με έναν εκπρόσωπο για {{skill}}...',
      talkingWithAgent: 'Συνομιλία με {{name}}',
      home: 'Αρχική',
      back: 'Πίσω',
      menu: 'Μενού',
      minimize: 'Ελαχιστοποίηση',
      endConversation: 'Τερματισμός συνομιλίας',
      engageWithUs: 'Επικοινωνήστε μαζί μας',
      noMessagesYet: 'Δεν υπάρχουν ακόμη μηνύματα',
      tryAgain: 'Δοκιμάστε ξανά',
      rating: 'Βαθμολογία',
      shareLocation: 'Κοινή χρήση τοποθεσίας',
      locationShared: 'Η τοποθεσία κοινοποιήθηκε',
      locationError: 'Δεν ήταν δυνατή η ανάκτηση της τοποθεσίας σας',
      locationPermissionDenied: 'Η άδεια τοποθεσίας απορρίφθηκε',
      geolocationUnavailable: 'Οι υπηρεσίες τοποθεσίας δεν είναι διαθέσιμες',
      selectFile: 'Επιλέξτε αρχείο',
      upload: 'Μεταφόρτωση',
      uploadComplete: 'Η μεταφόρτωση ολοκληρώθηκε',
      uploadFailed: 'Η μεταφόρτωση απέτυχε',
      fileTooLarge: 'Το αρχείο είναι πολύ μεγάλο',
      dragOrClick: 'Σύρετε ένα αρχείο ή κάντε κλικ για επιλογή',
      document: 'Έγγραφο',
      audioContent: 'Περιεχόμενο ήχου',
      videoContent: 'Περιεχόμενο βίντεο',
      unsupportedContent: 'Μη υποστηριζόμενο περιεχόμενο',
      unavailable: {
        error: {
          title: 'Κάτι πήγε στραβά',
          body: 'Δεν ήταν δυνατή η φόρτωση της συνομιλίας. Δοκιμάστε ξανά.',
          retry: 'Δοκιμάστε ξανά',
        },
        maintenance: {
          title: 'Η συνομιλία δεν είναι προσωρινά διαθέσιμη',
          body: 'Πραγματοποιούμε προγραμματισμένη συντήρηση. Επιστρέψτε σύντομα.',
        },
      },
      image: 'Εικόνα',
    },
  },
  {
    lang: 'en',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'This conversation has ended.',
      agentConnected: 'You have been successfully connected to an agent.',
      downloadTranscript: 'Download Transcript',
      startNewConversation: 'Start New Conversation',
      returnToConversation: 'Return to Conversation',
      connecting: 'Connecting...',
      retry: 'Retry',
      network: {
        retry: 'Reconnect',
      },
      reconnecting: 'Reconnecting...',
      connectionLost: 'Internet connection has been lost',
      reconnectDescription:
        'Internet connection has been lost. Click Reconnect to retry.',
      typeMessage: 'Type message',
      inputSelect: 'Select option',
      inputSelectOrType: 'Select option or type message',
      secureInput: 'Type secure message',
      secureValueHidden: 'Hidden secure value',
      startChat: 'Start chat',
      settings: 'Settings',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      next: 'Next',
      brandingTagline: 'Supercharge your Business with Intelligent AI Agents',
      poweredBy: 'Powered by',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistant',
      assistantThinking: 'Assistant is thinking',
      youSaid: 'You said',
      assistantSays: 'Assistant says',
      agentSays: '{{name}} says',
      joinMeeting: 'Join Meeting',
      meetingInProgress: 'Meeting in progress — click to rejoin',
      meetingExpired: 'Meeting link (expired)',
      embeddedContent: 'Embedded content',
      openInNewTab: 'Open in new tab',
      skipToMain: 'Skip to main content',
      loadingCustomerSolution: 'Loading {{customerName}} Solution',
      loadingSolution: 'Loading Solution',
      customerLogoAlt: '{{customerName}} Logo',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      browseOptions: 'Browse Options',
      carouselRoleDescription: 'Carousel',
      carouselSlideLabel: 'Slide {{current}} of {{total}}',
      carouselPrevious: 'Previous item',
      carouselNext: 'Next item',
      carouselGoToItem: 'Go to item {{index}}',
      collapse: 'Collapse',
      expand: 'Expand',
      messageHistory: 'Message history',
      reduce: 'Reduce',
      today: 'Today',
      at: 'at',
      a11yOptionsCount_one: 'There is 1 option.',
      a11yOptionsCount_other: 'There are {{count}} options.',
      listpickerSelectAll: 'Select all',
      listpickerSelectOption: 'Select an option',
      listpickerSearchAriaLabel: 'Search for filter options',
      listpickerSearchPlaceholder: 'Search…',
      listpickerNoResults: 'No options match.',
      listpickerResults_one: '1 result',
      listpickerResults_other: '{{count}} results',
      listpickerCondensed_one: '1 selected',
      listpickerCondensed_other: '{{count}} selected',
      listpickerSelectAction: 'Select',
      scrollToLatest: 'Scroll to latest message',
      scrollToUnread_one: '1 new message, scroll to latest',
      scrollToUnread_other: '{{count}} new messages, scroll to latest',
      showPassword: 'Show secure content',
      hidePassword: 'Hide secure content',
      clear: 'Clear',
      send: 'Send',
      yesterday: 'Yesterday',
      chatEndedActions: 'Chat ended actions',
      openConversationDialog: 'Open conversation dialog with {{title}}',
      agentTyping: 'Agent is typing',
      agentAway: 'Our agents are currently unavailable.',
      agentBusy: 'Our agents are currently busy. Please hold on...',
      waitingForAgent: 'Connecting you to an agent...',
      waitingForAgentWithSkill: 'Connecting you to a {{skill}} agent...',
      talkingWithAgent: 'Talking with {{name}}',
      home: 'Home',
      back: 'Back',
      menu: 'Menu',
      primaryNavigation: 'Navigation',
      minimize: 'Minimize',
      endConversation: 'End chat',
      engageWithUs: 'Engage with us',
      noMessagesYet: 'No messages yet',
      tryAgain: 'Try again',
      rating: 'Rating',
      shareLocation: 'Share location',
      locationShared: 'Location shared',
      locationError: 'Unable to retrieve your location',
      locationPermissionDenied: 'Location permission denied',
      geolocationUnavailable: 'Location services are unavailable',
      selectFile: 'Select a file',
      upload: 'Upload',
      uploadComplete: 'Upload complete',
      uploadFailed: 'Upload failed',
      fileTooLarge: 'File is too large',
      dragOrClick: 'Drag a file or click to choose',
      document: 'Document',
      audioContent: 'Audio content',
      videoContent: 'Video content',
      unsupportedContent: 'Unsupported content',
      unavailable: {
        error: {
          title: 'Something went wrong',
          body: "We couldn't load the chat. Please try again.",
          retry: 'Try again',
        },
        maintenance: {
          title: 'Chat is temporarily unavailable',
          body: 'We are doing scheduled maintenance. Please check back soon.',
        },
      },
      image: 'Image',
    },
  },
  {
    lang: 'en-AU',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'This conversation has ended.',
      agentConnected: 'You have been successfully connected to an agent.',
      downloadTranscript: 'Download Transcript',
      startNewConversation: 'Start New Conversation',
      returnToConversation: 'Return to Conversation',
      connecting: 'Connecting...',
      retry: 'Retry',
      network: {
        retry: 'Reconnect',
      },
      reconnecting: 'Reconnecting...',
      connectionLost: 'Internet connection has been lost',
      reconnectDescription:
        'Internet connection has been lost. Click Reconnect to retry.',
      typeMessage: 'Type message',
      inputSelect: 'Select option',
      inputSelectOrType: 'Select option or type message',
      secureInput: 'Type secure message',
      secureValueHidden: 'Hidden secure value',
      startChat: 'Start chat',
      settings: 'Settings',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      next: 'Next',
      brandingTagline: 'Supercharge your Business with Intelligent AI Agents',
      poweredBy: 'Powered by',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistant',
      assistantThinking: 'Assistant is thinking',
      youSaid: 'You said',
      assistantSays: 'Assistant says',
      agentSays: '{{name}} says',
      joinMeeting: 'Join Meeting',
      meetingInProgress: 'Meeting in progress — click to rejoin',
      meetingExpired: 'Meeting link (expired)',
      embeddedContent: 'Embedded content',
      openInNewTab: 'Open in new tab',
      skipToMain: 'Skip to main content',
      loadingCustomerSolution: 'Loading {{customerName}} Solution',
      loadingSolution: 'Loading Solution',
      customerLogoAlt: '{{customerName}} Logo',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      browseOptions: 'Browse Options',
      carouselRoleDescription: 'Carousel',
      carouselSlideLabel: 'Slide {{current}} of {{total}}',
      carouselPrevious: 'Previous item',
      carouselNext: 'Next item',
      carouselGoToItem: 'Go to item {{index}}',
      collapse: 'Collapse',
      expand: 'Expand',
      messageHistory: 'Message history',
      reduce: 'Reduce',
      today: 'Today',
      at: 'at',
      a11yOptionsCount_zero: 'There are {{count}} options.',
      a11yOptionsCount_one: 'There is 1 option.',
      a11yOptionsCount_two: 'There are {{count}} options.',
      a11yOptionsCount_few: 'There are {{count}} options.',
      a11yOptionsCount_many: 'There are {{count}} options.',
      a11yOptionsCount_other: 'There are {{count}} options.',
      listpickerSelectAll: 'Select all',
      listpickerSelectOption: 'Select an option',
      listpickerSearchAriaLabel: 'Search for filter options',
      listpickerSearchPlaceholder: 'Search…',
      listpickerNoResults: 'No options match.',
      listpickerResults_zero: '{{count}} results',
      listpickerResults_one: '1 result',
      listpickerResults_two: '{{count}} results',
      listpickerResults_few: '{{count}} results',
      listpickerResults_many: '{{count}} results',
      listpickerResults_other: '{{count}} results',
      listpickerCondensed_zero: '{{count}} selected',
      listpickerCondensed_one: '1 selected',
      listpickerCondensed_two: '{{count}} selected',
      listpickerCondensed_few: '{{count}} selected',
      listpickerCondensed_many: '{{count}} selected',
      listpickerCondensed_other: '{{count}} selected',
      listpickerSelectAction: 'Select',
      scrollToLatest: 'Scroll to latest message',
      scrollToUnread_zero: '{{count}} new messages, scroll to latest',
      scrollToUnread_one: '1 new message, scroll to latest',
      scrollToUnread_two: '{{count}} new messages, scroll to latest',
      scrollToUnread_few: '{{count}} new messages, scroll to latest',
      scrollToUnread_many: '{{count}} new messages, scroll to latest',
      scrollToUnread_other: '{{count}} new messages, scroll to latest',
      showPassword: 'Show secure content',
      hidePassword: 'Hide secure content',
      clear: 'Clear',
      send: 'Send',
      yesterday: 'Yesterday',
      chatEndedActions: 'Chat ended actions',
      openConversationDialog: 'Open conversation dialog with {{title}}',
      agentTyping: 'Agent is typing',
      agentAway: 'Our agents are currently unavailable.',
      agentBusy: 'Our agents are currently busy. Please hold on...',
      waitingForAgent: 'Connecting you to an agent...',
      waitingForAgentWithSkill: 'Connecting you to a {{skill}} agent...',
      talkingWithAgent: 'Talking with {{name}}',
      home: 'Home',
      back: 'Back',
      menu: 'Menu',
      minimize: 'Minimize',
      endConversation: 'End chat',
      engageWithUs: 'Engage with us',
      noMessagesYet: 'No messages yet',
      tryAgain: 'Try again',
      rating: 'Rating',
      shareLocation: 'Share location',
      locationShared: 'Location shared',
      locationError: 'Unable to retrieve your location',
      locationPermissionDenied: 'Location permission denied',
      geolocationUnavailable: 'Location services are unavailable',
      selectFile: 'Select a file',
      upload: 'Upload',
      uploadComplete: 'Upload complete',
      uploadFailed: 'Upload failed',
      fileTooLarge: 'File is too large',
      dragOrClick: 'Drag a file or click to choose',
      document: 'Document',
      audioContent: 'Audio content',
      videoContent: 'Video content',
      unsupportedContent: 'Unsupported content',
      unavailable: {
        error: {
          title: 'Something went wrong',
          body: "We couldn't load the chat. Please try again.",
          retry: 'Try again',
        },
        maintenance: {
          title: 'Chat is temporarily unavailable',
          body: 'We are doing scheduled maintenance. Please check back soon.',
        },
      },
      image: 'Image',
    },
  },
  {
    lang: 'en-GB',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'This conversation has ended.',
      agentConnected: 'You have been successfully connected to an agent.',
      downloadTranscript: 'Download Transcript',
      startNewConversation: 'Start New Conversation',
      returnToConversation: 'Return to Conversation',
      connecting: 'Connecting...',
      retry: 'Retry',
      network: {
        retry: 'Reconnect',
      },
      reconnecting: 'Reconnecting...',
      connectionLost: 'Internet connection has been lost',
      reconnectDescription:
        'Internet connection has been lost. Click Reconnect to retry.',
      typeMessage: 'Type message',
      inputSelect: 'Select option',
      inputSelectOrType: 'Select option or type message',
      secureInput: 'Type secure message',
      secureValueHidden: 'Hidden secure value',
      startChat: 'Start chat',
      settings: 'Settings',
      cancel: 'Cancel',
      confirm: 'Confirm',
      close: 'Close',
      next: 'Next',
      brandingTagline: 'Supercharge your Business with Intelligent AI Agents',
      poweredBy: 'Powered by',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistant',
      assistantThinking: 'Assistant is thinking',
      youSaid: 'You said',
      assistantSays: 'Assistant says',
      agentSays: '{{name}} says',
      joinMeeting: 'Join Meeting',
      meetingInProgress: 'Meeting in progress — click to rejoin',
      meetingExpired: 'Meeting link (expired)',
      embeddedContent: 'Embedded content',
      openInNewTab: 'Open in new tab',
      skipToMain: 'Skip to main content',
      loadingCustomerSolution: 'Loading {{customerName}} Solution',
      loadingSolution: 'Loading Solution',
      customerLogoAlt: '{{customerName}} Logo',
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      browseOptions: 'Browse Options',
      carouselRoleDescription: 'Carousel',
      carouselSlideLabel: 'Slide {{current}} of {{total}}',
      carouselPrevious: 'Previous item',
      carouselNext: 'Next item',
      carouselGoToItem: 'Go to item {{index}}',
      collapse: 'Collapse',
      expand: 'Expand',
      messageHistory: 'Message history',
      reduce: 'Reduce',
      today: 'Today',
      at: 'at',
      a11yOptionsCount_zero: 'There are {{count}} options.',
      a11yOptionsCount_one: 'There is 1 option.',
      a11yOptionsCount_two: 'There are {{count}} options.',
      a11yOptionsCount_few: 'There are {{count}} options.',
      a11yOptionsCount_many: 'There are {{count}} options.',
      a11yOptionsCount_other: 'There are {{count}} options.',
      listpickerSelectAll: 'Select all',
      listpickerSelectOption: 'Select an option',
      listpickerSearchAriaLabel: 'Search for filter options',
      listpickerSearchPlaceholder: 'Search…',
      listpickerNoResults: 'No options match.',
      listpickerResults_zero: '{{count}} results',
      listpickerResults_one: '1 result',
      listpickerResults_two: '{{count}} results',
      listpickerResults_few: '{{count}} results',
      listpickerResults_many: '{{count}} results',
      listpickerResults_other: '{{count}} results',
      listpickerCondensed_zero: '{{count}} selected',
      listpickerCondensed_one: '1 selected',
      listpickerCondensed_two: '{{count}} selected',
      listpickerCondensed_few: '{{count}} selected',
      listpickerCondensed_many: '{{count}} selected',
      listpickerCondensed_other: '{{count}} selected',
      listpickerSelectAction: 'Select',
      scrollToLatest: 'Scroll to latest message',
      scrollToUnread_zero: '{{count}} new messages, scroll to latest',
      scrollToUnread_one: '1 new message, scroll to latest',
      scrollToUnread_two: '{{count}} new messages, scroll to latest',
      scrollToUnread_few: '{{count}} new messages, scroll to latest',
      scrollToUnread_many: '{{count}} new messages, scroll to latest',
      scrollToUnread_other: '{{count}} new messages, scroll to latest',
      showPassword: 'Show secure content',
      hidePassword: 'Hide secure content',
      clear: 'Clear',
      send: 'Send',
      yesterday: 'Yesterday',
      chatEndedActions: 'Chat ended actions',
      openConversationDialog: 'Open conversation dialog with {{title}}',
      agentTyping: 'Agent is typing',
      agentAway: 'Our agents are currently unavailable.',
      agentBusy: 'Our agents are currently busy. Please hold on...',
      waitingForAgent: 'Connecting you to an agent...',
      waitingForAgentWithSkill: 'Connecting you to a {{skill}} agent...',
      talkingWithAgent: 'Talking with {{name}}',
      home: 'Home',
      back: 'Back',
      menu: 'Menu',
      minimize: 'Minimize',
      endConversation: 'End chat',
      engageWithUs: 'Engage with us',
      noMessagesYet: 'No messages yet',
      tryAgain: 'Try again',
      rating: 'Rating',
      shareLocation: 'Share location',
      locationShared: 'Location shared',
      locationError: 'Unable to retrieve your location',
      locationPermissionDenied: 'Location permission denied',
      geolocationUnavailable: 'Location services are unavailable',
      selectFile: 'Select a file',
      upload: 'Upload',
      uploadComplete: 'Upload complete',
      uploadFailed: 'Upload failed',
      fileTooLarge: 'File is too large',
      dragOrClick: 'Drag a file or click to choose',
      document: 'Document',
      audioContent: 'Audio content',
      videoContent: 'Video content',
      unsupportedContent: 'Unsupported content',
      unavailable: {
        error: {
          title: 'Something went wrong',
          body: "We couldn't load the chat. Please try again.",
          retry: 'Try again',
        },
        maintenance: {
          title: 'Chat is temporarily unavailable',
          body: 'We are doing scheduled maintenance. Please check back soon.',
        },
      },
      image: 'Image',
    },
  },
  {
    lang: 'es',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Esta conversación ha finalizado.',
      agentConnected: 'Te has conectado correctamente con un agente.',
      downloadTranscript: 'Descargar la transcripción',
      startNewConversation: 'Iniciar una nueva conversación',
      returnToConversation: 'Volver a la conversación',
      connecting: 'Conectando...',
      retry: 'Reintentar',
      network: {
        retry: 'Reconectar',
      },
      reconnecting: 'Reconectando...',
      connectionLost: 'Se ha perdido la conexión a internet',
      reconnectDescription:
        'Se ha perdido la conexión a internet. Haz clic en Reconectar para reintentar.',
      typeMessage: 'Escribe un mensaje',
      inputSelect: 'Selecciona una opción',
      inputSelectOrType: 'Selecciona una opción o escribe un mensaje',
      secureInput: 'Escribe un mensaje seguro',
      secureValueHidden: 'Valor seguro oculto',
      startChat: 'Iniciar chat',
      settings: 'Configuración',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      close: 'Cerrar',
      next: 'Siguiente',
      brandingTagline: 'Impulsa tu negocio con agentes de IA inteligentes',
      poweredBy: 'Con la tecnología de',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asistente',
      assistantThinking: 'El asistente está pensando',
      youSaid: 'Dijiste',
      assistantSays: 'El asistente dice',
      agentSays: '{{name}} dice',
      joinMeeting: 'Unirse a la reunión',
      meetingInProgress: 'Reunión en curso — haz clic para volver a unirte',
      meetingExpired: 'Enlace de la reunión (caducado)',
      embeddedContent: 'Contenido incrustado',
      openInNewTab: 'Abrir en una pestaña nueva',
      skipToMain: 'Saltar al contenido principal',
      loadingCustomerSolution: 'Cargando la solución de {{customerName}}',
      loadingSolution: 'Cargando la solución',
      customerLogoAlt: 'Logotipo de {{customerName}}',
      selectDate: 'Seleccionar fecha',
      selectTime: 'Seleccionar hora',
      browseOptions: 'Explorar opciones',
      carouselRoleDescription: 'Carrusel',
      carouselSlideLabel: 'Diapositiva {{current}} de {{total}}',
      carouselPrevious: 'Elemento anterior',
      carouselNext: 'Elemento siguiente',
      carouselGoToItem: 'Ir al elemento {{index}}',
      collapse: 'Contraer',
      expand: 'Expandir',
      messageHistory: 'Historial de mensajes',
      reduce: 'Reducir',
      today: 'Hoy',
      at: 'a las',
      a11yOptionsCount_zero: 'Hay {{count}} opciones.',
      a11yOptionsCount_one: 'Hay 1 opción.',
      a11yOptionsCount_two: 'Hay {{count}} opciones.',
      a11yOptionsCount_few: 'Hay {{count}} opciones.',
      a11yOptionsCount_many: 'Hay {{count}} opciones.',
      a11yOptionsCount_other: 'Hay {{count}} opciones.',
      listpickerSelectAll: 'Seleccionar todo',
      listpickerSelectOption: 'Selecciona una opción',
      listpickerSearchAriaLabel: 'Buscar opciones de filtro',
      listpickerSearchPlaceholder: 'Buscar…',
      listpickerNoResults: 'No hay opciones que coincidan.',
      listpickerResults_zero: '{{count}} resultados',
      listpickerResults_one: '1 resultado',
      listpickerResults_two: '{{count}} resultados',
      listpickerResults_few: '{{count}} resultados',
      listpickerResults_many: '{{count}} resultados',
      listpickerResults_other: '{{count}} resultados',
      listpickerCondensed_zero: '{{count}} seleccionados',
      listpickerCondensed_one: '1 seleccionado',
      listpickerCondensed_two: '{{count}} seleccionados',
      listpickerCondensed_few: '{{count}} seleccionados',
      listpickerCondensed_many: '{{count}} seleccionados',
      listpickerCondensed_other: '{{count}} seleccionados',
      listpickerSelectAction: 'Seleccionar',
      scrollToLatest: 'Desplazarse al último mensaje',
      scrollToUnread_zero: '{{count}} mensajes nuevos, ir al último',
      scrollToUnread_one: '1 mensaje nuevo, ir al último',
      scrollToUnread_two: '{{count}} mensajes nuevos, ir al último',
      scrollToUnread_few: '{{count}} mensajes nuevos, ir al último',
      scrollToUnread_many: '{{count}} mensajes nuevos, ir al último',
      scrollToUnread_other: '{{count}} mensajes nuevos, ir al último',
      showPassword: 'Mostrar contenido seguro',
      hidePassword: 'Ocultar contenido seguro',
      clear: 'Borrar',
      send: 'Enviar',
      yesterday: 'Ayer',
      chatEndedActions: 'Acciones al finalizar el chat',
      openConversationDialog: 'Abrir el diálogo de conversación con {{title}}',
      agentTyping: 'El agente está escribiendo',
      agentAway: 'Nuestros agentes no están disponibles en este momento.',
      agentBusy:
        'Nuestros agentes están ocupados en este momento. Por favor, espera...',
      waitingForAgent: 'Conectándote con un agente...',
      waitingForAgentWithSkill: 'Conectándote con un agente de {{skill}}...',
      talkingWithAgent: 'Hablando con {{name}}',
      home: 'Inicio',
      back: 'Atrás',
      menu: 'Menú',
      minimize: 'Minimizar',
      endConversation: 'Finalizar chat',
      engageWithUs: 'Contáctanos',
      noMessagesYet: 'Aún no hay mensajes',
      tryAgain: 'Inténtalo de nuevo',
      rating: 'Valoración',
      shareLocation: 'Compartir ubicación',
      locationShared: 'Ubicación compartida',
      locationError: 'No se pudo obtener tu ubicación',
      locationPermissionDenied: 'Permiso de ubicación denegado',
      geolocationUnavailable: 'Los servicios de ubicación no están disponibles',
      selectFile: 'Seleccionar un archivo',
      upload: 'Subir',
      uploadComplete: 'Subida completa',
      uploadFailed: 'Error al subir',
      fileTooLarge: 'El archivo es demasiado grande',
      dragOrClick: 'Arrastra un archivo o haz clic para elegir',
      document: 'Documento',
      audioContent: 'Contenido de audio',
      videoContent: 'Contenido de video',
      unsupportedContent: 'Contenido no compatible',
      unavailable: {
        error: {
          title: 'Algo salió mal',
          body: 'No pudimos cargar el chat. Por favor, inténtalo de nuevo.',
          retry: 'Inténtalo de nuevo',
        },
        maintenance: {
          title: 'El chat no está disponible temporalmente',
          body: 'Estamos realizando un mantenimiento programado. Vuelve pronto.',
        },
      },
      image: 'Imagen',
    },
  },
  {
    lang: 'et',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'See vestlus on lõppenud.',
      agentConnected: 'Teid on edukalt ühendatud agendiga.',
      downloadTranscript: 'Laadi vestlus alla',
      startNewConversation: 'Alusta uut vestlust',
      returnToConversation: 'Tagasi vestluse juurde',
      connecting: 'Ühendamine...',
      retry: 'Proovi uuesti',
      network: {
        retry: 'Ühenda uuesti',
      },
      reconnecting: 'Uuesti ühendamine...',
      connectionLost: 'Internetiühendus on katkenud',
      reconnectDescription:
        'Internetiühendus on katkenud. Klõpsake „Ühenda uuesti“, et uuesti proovida.',
      typeMessage: 'Kirjuta sõnum',
      inputSelect: 'Vali valik',
      inputSelectOrType: 'Vali valik või kirjuta sõnum',
      secureInput: 'Kirjuta turvaline sõnum',
      secureValueHidden: 'Peidetud turvaline väärtus',
      startChat: 'Alusta vestlust',
      settings: 'Seaded',
      cancel: 'Tühista',
      confirm: 'Kinnita',
      close: 'Sulge',
      next: 'Edasi',
      brandingTagline:
        'Kiirenda oma äri intelligentsete tehisintellekti agentidega',
      poweredBy: 'Teenusepakkuja',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistent',
      assistantThinking: 'Assistent mõtleb',
      youSaid: 'Sa ütlesid',
      assistantSays: 'Assistent ütleb',
      agentSays: '{{name}} ütleb',
      joinMeeting: 'Liitu koosolekuga',
      meetingInProgress: 'Koosolek käib — klõpsake uuesti liitumiseks',
      meetingExpired: 'Koosoleku link (aegunud)',
      embeddedContent: 'Manustatud sisu',
      openInNewTab: 'Ava uuel vahekaardil',
      skipToMain: 'Liigu põhisisu juurde',
      loadingCustomerSolution: 'Laaditakse {{customerName}} lahendust',
      loadingSolution: 'Lahenduse laadimine',
      customerLogoAlt: '{{customerName}} logo',
      selectDate: 'Vali kuupäev',
      selectTime: 'Vali kellaaeg',
      browseOptions: 'Sirvi valikuid',
      carouselRoleDescription: 'Karussell',
      carouselSlideLabel: 'Slaid {{current}} / {{total}}',
      carouselPrevious: 'Eelmine üksus',
      carouselNext: 'Järgmine üksus',
      carouselGoToItem: 'Mine üksusele {{index}}',
      collapse: 'Ahenda',
      expand: 'Laienda',
      messageHistory: 'Sõnumite ajalugu',
      reduce: 'Vähenda',
      today: 'Täna',
      at: 'kell',
      a11yOptionsCount_zero: 'On {{count}} valikut.',
      a11yOptionsCount_one: 'On 1 valik.',
      a11yOptionsCount_two: 'On {{count}} valikut.',
      a11yOptionsCount_few: 'On {{count}} valikut.',
      a11yOptionsCount_many: 'On {{count}} valikut.',
      a11yOptionsCount_other: 'On {{count}} valikut.',
      listpickerSelectAll: 'Vali kõik',
      listpickerSelectOption: 'Vali valik',
      listpickerSearchAriaLabel: 'Otsi filtrivalikuid',
      listpickerSearchPlaceholder: 'Otsi…',
      listpickerNoResults: 'Sobivaid valikuid pole.',
      listpickerResults_zero: '{{count}} tulemust',
      listpickerResults_one: '1 tulemus',
      listpickerResults_two: '{{count}} tulemust',
      listpickerResults_few: '{{count}} tulemust',
      listpickerResults_many: '{{count}} tulemust',
      listpickerResults_other: '{{count}} tulemust',
      listpickerCondensed_zero: '{{count}} valitud',
      listpickerCondensed_one: '1 valitud',
      listpickerCondensed_two: '{{count}} valitud',
      listpickerCondensed_few: '{{count}} valitud',
      listpickerCondensed_many: '{{count}} valitud',
      listpickerCondensed_other: '{{count}} valitud',
      listpickerSelectAction: 'Vali',
      scrollToLatest: 'Keri uusima sõnumini',
      scrollToUnread_zero: '{{count}} uut sõnumit, liigu uusimale',
      scrollToUnread_one: '1 uus sõnum, liigu uusimale',
      scrollToUnread_two: '{{count}} uut sõnumit, liigu uusimale',
      scrollToUnread_few: '{{count}} uut sõnumit, liigu uusimale',
      scrollToUnread_many: '{{count}} uut sõnumit, liigu uusimale',
      scrollToUnread_other: '{{count}} uut sõnumit, liigu uusimale',
      showPassword: 'Näita turvalist sisu',
      hidePassword: 'Peida turvaline sisu',
      clear: 'Tühjenda',
      send: 'Saada',
      yesterday: 'Eile',
      chatEndedActions: 'Toimingud pärast vestluse lõppu',
      openConversationDialog: 'Ava vestlusaken: {{title}}',
      agentTyping: 'Agent kirjutab',
      agentAway: 'Meie agendid pole hetkel saadaval.',
      agentBusy: 'Meie agendid on hetkel hõivatud. Palun oodake...',
      waitingForAgent: 'Ühendame teid agendiga...',
      waitingForAgentWithSkill: 'Ühendame teid {{skill}} agendiga...',
      talkingWithAgent: 'Vestlus kasutajaga {{name}}',
      home: 'Avaleht',
      back: 'Tagasi',
      menu: 'Menüü',
      minimize: 'Minimeeri',
      endConversation: 'Lõpeta vestlus',
      engageWithUs: 'Võtke meiega ühendust',
      noMessagesYet: 'Sõnumeid veel pole',
      tryAgain: 'Proovi uuesti',
      rating: 'Hinnang',
      shareLocation: 'Jaga asukohta',
      locationShared: 'Asukoht jagatud',
      locationError: 'Teie asukohta ei õnnestunud hankida',
      locationPermissionDenied: 'Asukohaluba keelatud',
      geolocationUnavailable: 'Asukohateenused pole saadaval',
      selectFile: 'Vali fail',
      upload: 'Laadi üles',
      uploadComplete: 'Üleslaadimine lõpetatud',
      uploadFailed: 'Üleslaadimine ebaõnnestus',
      fileTooLarge: 'Fail on liiga suur',
      dragOrClick: 'Lohista fail või klõpsa valimiseks',
      document: 'Dokument',
      audioContent: 'Helisisu',
      videoContent: 'Videosisu',
      unsupportedContent: 'Toetamata sisu',
      unavailable: {
        error: {
          title: 'Midagi läks valesti',
          body: 'Vestlust ei õnnestunud laadida. Proovige uuesti.',
          retry: 'Proovi uuesti',
        },
        maintenance: {
          title: 'Vestlus on ajutiselt kättesaamatu',
          body: 'Teostame plaanilist hooldust. Tulge varsti tagasi.',
        },
      },
      image: 'Pilt',
    },
  },
  {
    lang: 'fi',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Tämä keskustelu on päättynyt.',
      agentConnected: 'Sinut on yhdistetty asiakaspalvelijaan.',
      downloadTranscript: 'Lataa keskustelu',
      startNewConversation: 'Aloita uusi keskustelu',
      returnToConversation: 'Takaisin keskusteluun',
      connecting: 'Yhdistetään...',
      retry: 'Yritä uudelleen',
      network: {
        retry: 'Yhdistä uudelleen',
      },
      reconnecting: 'Yhdistetään uudelleen...',
      connectionLost: 'Internetyhteys on katkennut',
      reconnectDescription:
        'Internetyhteys on katkennut. Napsauta Yhdistä uudelleen yrittääksesi uudelleen.',
      typeMessage: 'Kirjoita viesti',
      inputSelect: 'Valitse vaihtoehto',
      inputSelectOrType: 'Valitse vaihtoehto tai kirjoita viesti',
      secureInput: 'Kirjoita suojattu viesti',
      secureValueHidden: 'Piilotettu suojattu arvo',
      startChat: 'Aloita keskustelu',
      settings: 'Asetukset',
      cancel: 'Peruuta',
      confirm: 'Vahvista',
      close: 'Sulje',
      next: 'Seuraava',
      brandingTagline: 'Tehosta liiketoimintaasi älykkäillä tekoälyagenteilla',
      poweredBy: 'Palvelun tarjoaa',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Avustaja',
      assistantThinking: 'Avustaja miettii',
      youSaid: 'Sanoit',
      assistantSays: 'Avustaja sanoo',
      agentSays: '{{name}} sanoo',
      joinMeeting: 'Liity kokoukseen',
      meetingInProgress: 'Kokous käynnissä — napsauta liittyäksesi uudelleen',
      meetingExpired: 'Kokouslinkki (vanhentunut)',
      embeddedContent: 'Upotettu sisältö',
      openInNewTab: 'Avaa uudessa välilehdessä',
      skipToMain: 'Siirry pääsisältöön',
      loadingCustomerSolution: 'Ladataan {{customerName}}-ratkaisua',
      loadingSolution: 'Ladataan ratkaisua',
      customerLogoAlt: '{{customerName}}-logo',
      selectDate: 'Valitse päivämäärä',
      selectTime: 'Valitse aika',
      browseOptions: 'Selaa vaihtoehtoja',
      carouselRoleDescription: 'Karuselli',
      carouselSlideLabel: 'Dia {{current}} / {{total}}',
      carouselPrevious: 'Edellinen kohde',
      carouselNext: 'Seuraava kohde',
      carouselGoToItem: 'Siirry kohteeseen {{index}}',
      collapse: 'Tiivistä',
      expand: 'Laajenna',
      messageHistory: 'Viestihistoria',
      reduce: 'Pienennä',
      today: 'Tänään',
      at: 'klo',
      a11yOptionsCount_zero: '{{count}} vaihtoehtoa.',
      a11yOptionsCount_one: '1 vaihtoehto.',
      a11yOptionsCount_two: '{{count}} vaihtoehtoa.',
      a11yOptionsCount_few: '{{count}} vaihtoehtoa.',
      a11yOptionsCount_many: '{{count}} vaihtoehtoa.',
      a11yOptionsCount_other: '{{count}} vaihtoehtoa.',
      listpickerSelectAll: 'Valitse kaikki',
      listpickerSelectOption: 'Valitse vaihtoehto',
      listpickerSearchAriaLabel: 'Hae suodatinvaihtoehtoja',
      listpickerSearchPlaceholder: 'Hae…',
      listpickerNoResults: 'Ei vastaavia vaihtoehtoja.',
      listpickerResults_zero: '{{count}} tulosta',
      listpickerResults_one: '1 tulos',
      listpickerResults_two: '{{count}} tulosta',
      listpickerResults_few: '{{count}} tulosta',
      listpickerResults_many: '{{count}} tulosta',
      listpickerResults_other: '{{count}} tulosta',
      listpickerCondensed_zero: '{{count}} valittu',
      listpickerCondensed_one: '1 valittu',
      listpickerCondensed_two: '{{count}} valittu',
      listpickerCondensed_few: '{{count}} valittu',
      listpickerCondensed_many: '{{count}} valittu',
      listpickerCondensed_other: '{{count}} valittu',
      listpickerSelectAction: 'Valitse',
      scrollToLatest: 'Vieritä uusimpaan viestiin',
      scrollToUnread_zero: '{{count}} uutta viestiä, siirry uusimpaan',
      scrollToUnread_one: '1 uusi viesti, siirry uusimpaan',
      scrollToUnread_two: '{{count}} uutta viestiä, siirry uusimpaan',
      scrollToUnread_few: '{{count}} uutta viestiä, siirry uusimpaan',
      scrollToUnread_many: '{{count}} uutta viestiä, siirry uusimpaan',
      scrollToUnread_other: '{{count}} uutta viestiä, siirry uusimpaan',
      showPassword: 'Näytä suojattu sisältö',
      hidePassword: 'Piilota suojattu sisältö',
      clear: 'Tyhjennä',
      send: 'Lähetä',
      yesterday: 'Eilen',
      chatEndedActions: 'Toiminnot keskustelun päätyttyä',
      openConversationDialog: 'Avaa keskusteluikkuna: {{title}}',
      agentTyping: 'Asiakaspalvelija kirjoittaa',
      agentAway: 'Asiakaspalvelijamme eivät ole tällä hetkellä käytettävissä.',
      agentBusy:
        'Asiakaspalvelijamme ovat tällä hetkellä varattuja. Odota hetki...',
      waitingForAgent: 'Yhdistämme sinut asiakaspalvelijaan...',
      waitingForAgentWithSkill:
        'Yhdistämme sinut {{skill}}-asiakaspalvelijaan...',
      talkingWithAgent: 'Keskustelet henkilön {{name}} kanssa',
      home: 'Etusivu',
      back: 'Takaisin',
      menu: 'Valikko',
      minimize: 'Pienennä',
      endConversation: 'Lopeta keskustelu',
      engageWithUs: 'Ota yhteyttä',
      noMessagesYet: 'Ei vielä viestejä',
      tryAgain: 'Yritä uudelleen',
      rating: 'Arvio',
      shareLocation: 'Jaa sijainti',
      locationShared: 'Sijainti jaettu',
      locationError: 'Sijaintiasi ei voitu hakea',
      locationPermissionDenied: 'Sijaintilupa evätty',
      geolocationUnavailable: 'Sijaintipalvelut eivät ole käytettävissä',
      selectFile: 'Valitse tiedosto',
      upload: 'Lataa',
      uploadComplete: 'Lataus valmis',
      uploadFailed: 'Lataus epäonnistui',
      fileTooLarge: 'Tiedosto on liian suuri',
      dragOrClick: 'Vedä tiedosto tai valitse napsauttamalla',
      document: 'Asiakirja',
      audioContent: 'Äänisisältö',
      videoContent: 'Videosisältö',
      unsupportedContent: 'Ei tuettu sisältö',
      unavailable: {
        error: {
          title: 'Jokin meni pieleen',
          body: 'Keskustelua ei voitu ladata. Yritä uudelleen.',
          retry: 'Yritä uudelleen',
        },
        maintenance: {
          title: 'Keskustelu ei ole tilapäisesti käytettävissä',
          body: 'Suoritamme ajoitettua huoltoa. Palaa pian takaisin.',
        },
      },
      image: 'Kuva',
    },
  },
  {
    lang: 'fr',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Cette conversation est terminée.',
      agentConnected: 'Vous avez été mis en relation avec un agent.',
      downloadTranscript: 'Télécharger la transcription',
      startNewConversation: 'Démarrer une nouvelle conversation',
      returnToConversation: 'Revenir à la conversation',
      connecting: 'Connexion...',
      retry: 'Réessayer',
      network: {
        retry: 'Se reconnecter',
      },
      reconnecting: 'Reconnexion...',
      connectionLost: 'La connexion internet a été perdue',
      reconnectDescription:
        'La connexion internet a été perdue. Cliquez sur Se reconnecter pour réessayer.',
      typeMessage: 'Saisissez un message',
      inputSelect: 'Sélectionnez une option',
      inputSelectOrType: 'Sélectionnez une option ou saisissez un message',
      secureInput: 'Saisissez un message sécurisé',
      secureValueHidden: 'Valeur sécurisée masquée',
      startChat: 'Démarrer la discussion',
      settings: 'Paramètres',
      cancel: 'Annuler',
      confirm: 'Confirmer',
      close: 'Fermer',
      next: 'Suivant',
      brandingTagline:
        'Boostez votre entreprise avec des agents IA intelligents',
      poweredBy: 'Propulsé par',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistant',
      assistantThinking: "L'assistant réfléchit",
      youSaid: 'Vous avez dit',
      assistantSays: "L'assistant dit",
      agentSays: '{{name}} dit',
      joinMeeting: 'Rejoindre la réunion',
      meetingInProgress: 'Réunion en cours — cliquez pour rejoindre',
      meetingExpired: 'Lien de réunion (expiré)',
      embeddedContent: 'Contenu intégré',
      openInNewTab: 'Ouvrir dans un nouvel onglet',
      skipToMain: 'Passer au contenu principal',
      loadingCustomerSolution: 'Chargement de la solution {{customerName}}',
      loadingSolution: 'Chargement de la solution',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Sélectionner une date',
      selectTime: "Sélectionner l'heure",
      browseOptions: 'Parcourir les options',
      carouselRoleDescription: 'Carrousel',
      carouselSlideLabel: 'Diapositive {{current}} sur {{total}}',
      carouselPrevious: 'Élément précédent',
      carouselNext: 'Élément suivant',
      carouselGoToItem: "Aller à l'élément {{index}}",
      collapse: 'Réduire',
      expand: 'Développer',
      messageHistory: 'Historique des messages',
      reduce: 'Réduire',
      today: "Aujourd'hui",
      at: 'à',
      a11yOptionsCount_zero: 'Il y a {{count}} options.',
      a11yOptionsCount_one: 'Il y a 1 option.',
      a11yOptionsCount_two: 'Il y a {{count}} options.',
      a11yOptionsCount_few: 'Il y a {{count}} options.',
      a11yOptionsCount_many: 'Il y a {{count}} options.',
      a11yOptionsCount_other: 'Il y a {{count}} options.',
      listpickerSelectAll: 'Tout sélectionner',
      listpickerSelectOption: 'Sélectionnez une option',
      listpickerSearchAriaLabel: 'Rechercher des options de filtre',
      listpickerSearchPlaceholder: 'Rechercher…',
      listpickerNoResults: 'Aucune option correspondante.',
      listpickerResults_zero: '{{count}} résultats',
      listpickerResults_one: '1 résultat',
      listpickerResults_two: '{{count}} résultats',
      listpickerResults_few: '{{count}} résultats',
      listpickerResults_many: '{{count}} résultats',
      listpickerResults_other: '{{count}} résultats',
      listpickerCondensed_zero: '{{count}} sélectionnés',
      listpickerCondensed_one: '1 sélectionné',
      listpickerCondensed_two: '{{count}} sélectionnés',
      listpickerCondensed_few: '{{count}} sélectionnés',
      listpickerCondensed_many: '{{count}} sélectionnés',
      listpickerCondensed_other: '{{count}} sélectionnés',
      listpickerSelectAction: 'Sélectionner',
      scrollToLatest: 'Aller au dernier message',
      scrollToUnread_zero: '{{count}} nouveaux messages, aller au dernier',
      scrollToUnread_one: '1 nouveau message, aller au dernier',
      scrollToUnread_two: '{{count}} nouveaux messages, aller au dernier',
      scrollToUnread_few: '{{count}} nouveaux messages, aller au dernier',
      scrollToUnread_many: '{{count}} nouveaux messages, aller au dernier',
      scrollToUnread_other: '{{count}} nouveaux messages, aller au dernier',
      showPassword: 'Afficher le contenu sécurisé',
      hidePassword: 'Masquer le contenu sécurisé',
      clear: 'Effacer',
      send: 'Envoyer',
      yesterday: 'Hier',
      chatEndedActions: 'Actions de fin de discussion',
      openConversationDialog:
        'Ouvrir la boîte de dialogue de conversation avec {{title}}',
      agentTyping: "L'agent est en train d'écrire",
      agentAway: 'Nos agents ne sont pas disponibles pour le moment.',
      agentBusy: 'Nos agents sont actuellement occupés. Veuillez patienter...',
      waitingForAgent: 'Mise en relation avec un agent...',
      waitingForAgentWithSkill: 'Mise en relation avec un agent {{skill}}...',
      talkingWithAgent: 'Discussion avec {{name}}',
      home: 'Accueil',
      back: 'Retour',
      menu: 'Menu',
      minimize: 'Réduire',
      endConversation: 'Terminer la discussion',
      engageWithUs: 'Contactez-nous',
      noMessagesYet: "Aucun message pour l'instant",
      tryAgain: 'Réessayer',
      rating: 'Évaluation',
      shareLocation: 'Partager la position',
      locationShared: 'Position partagée',
      locationError: 'Impossible de récupérer votre position',
      locationPermissionDenied: 'Autorisation de localisation refusée',
      geolocationUnavailable:
        'Les services de localisation ne sont pas disponibles',
      selectFile: 'Sélectionner un fichier',
      upload: 'Téléverser',
      uploadComplete: 'Téléversement terminé',
      uploadFailed: 'Échec du téléversement',
      fileTooLarge: 'Le fichier est trop volumineux',
      dragOrClick: 'Glissez un fichier ou cliquez pour choisir',
      document: 'Document',
      audioContent: 'Contenu audio',
      videoContent: 'Contenu vidéo',
      unsupportedContent: 'Contenu non pris en charge',
      unavailable: {
        error: {
          title: "Une erreur s'est produite",
          body: "Nous n'avons pas pu charger la discussion. Veuillez réessayer.",
          retry: 'Réessayer',
        },
        maintenance: {
          title: 'La discussion est temporairement indisponible',
          body: 'Nous effectuons une maintenance planifiée. Revenez bientôt.',
        },
      },
      image: 'Image',
    },
  },
  {
    lang: 'he',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'השיחה הזו הסתיימה.',
      agentConnected: 'חוברת בהצלחה לנציג.',
      downloadTranscript: 'הורדת תמליל',
      startNewConversation: 'התחלת שיחה חדשה',
      returnToConversation: 'חזרה לשיחה',
      connecting: 'מתחבר...',
      retry: 'נסה שוב',
      network: {
        retry: 'התחבר מחדש',
      },
      reconnecting: 'מתחבר מחדש...',
      connectionLost: 'החיבור לאינטרנט אבד',
      reconnectDescription:
        "החיבור לאינטרנט אבד. לחץ על 'התחבר מחדש' כדי לנסות שוב.",
      typeMessage: 'הקלד הודעה',
      inputSelect: 'בחר אפשרות',
      inputSelectOrType: 'בחר אפשרות או הקלד הודעה',
      secureInput: 'הקלד הודעה מאובטחת',
      secureValueHidden: 'ערך מאובטח מוסתר',
      startChat: "התחל צ'אט",
      settings: 'הגדרות',
      cancel: 'ביטול',
      confirm: 'אישור',
      close: 'סגור',
      next: 'הבא',
      brandingTagline: 'האיצו את העסק שלכם עם סוכני AI חכמים',
      poweredBy: 'מופעל על ידי',
      pypestreamCom: 'Pypestream.com',
      assistant: 'עוזר',
      assistantThinking: 'העוזר חושב',
      youSaid: 'אמרת',
      assistantSays: 'העוזר אומר',
      agentSays: '{{name}} אומר',
      joinMeeting: 'הצטרף לפגישה',
      meetingInProgress: 'פגישה מתקיימת — לחץ כדי להצטרף מחדש',
      meetingExpired: 'קישור לפגישה (פג תוקף)',
      embeddedContent: 'תוכן מוטמע',
      openInNewTab: 'פתח בכרטיסייה חדשה',
      skipToMain: 'דלג לתוכן הראשי',
      loadingCustomerSolution: 'טוען את הפתרון של {{customerName}}',
      loadingSolution: 'טוען פתרון',
      customerLogoAlt: 'הלוגו של {{customerName}}',
      selectDate: 'בחר תאריך',
      selectTime: 'בחר שעה',
      browseOptions: 'עיין באפשרויות',
      carouselRoleDescription: 'קרוסלה',
      carouselSlideLabel: 'שקופית {{current}} מתוך {{total}}',
      carouselPrevious: 'הפריט הקודם',
      carouselNext: 'הפריט הבא',
      carouselGoToItem: 'עבור לפריט {{index}}',
      collapse: 'כווץ',
      expand: 'הרחב',
      messageHistory: 'היסטוריית הודעות',
      reduce: 'הקטן',
      today: 'היום',
      at: 'בשעה',
      a11yOptionsCount_zero: 'יש {{count}} אפשרויות.',
      a11yOptionsCount_one: 'יש אפשרות אחת.',
      a11yOptionsCount_two: 'יש {{count}} אפשרויות.',
      a11yOptionsCount_few: 'יש {{count}} אפשרויות.',
      a11yOptionsCount_many: 'יש {{count}} אפשרויות.',
      a11yOptionsCount_other: 'יש {{count}} אפשרויות.',
      listpickerSelectAll: 'בחר הכול',
      listpickerSelectOption: 'בחר אפשרות',
      listpickerSearchAriaLabel: 'חפש אפשרויות סינון',
      listpickerSearchPlaceholder: 'חיפוש…',
      listpickerNoResults: 'אין אפשרויות תואמות.',
      listpickerResults_zero: '{{count}} תוצאות',
      listpickerResults_one: 'תוצאה אחת',
      listpickerResults_two: '{{count}} תוצאות',
      listpickerResults_few: '{{count}} תוצאות',
      listpickerResults_many: '{{count}} תוצאות',
      listpickerResults_other: '{{count}} תוצאות',
      listpickerCondensed_zero: '{{count}} נבחרו',
      listpickerCondensed_one: 'נבחרה אחת',
      listpickerCondensed_two: '{{count}} נבחרו',
      listpickerCondensed_few: '{{count}} נבחרו',
      listpickerCondensed_many: '{{count}} נבחרו',
      listpickerCondensed_other: '{{count}} נבחרו',
      listpickerSelectAction: 'בחר',
      scrollToLatest: 'גלול להודעה האחרונה',
      scrollToUnread_zero: '{{count}} הודעות חדשות, גלול לאחרונה',
      scrollToUnread_one: 'הודעה חדשה אחת, גלול לאחרונה',
      scrollToUnread_two: '{{count}} הודעות חדשות, גלול לאחרונה',
      scrollToUnread_few: '{{count}} הודעות חדשות, גלול לאחרונה',
      scrollToUnread_many: '{{count}} הודעות חדשות, גלול לאחרונה',
      scrollToUnread_other: '{{count}} הודעות חדשות, גלול לאחרונה',
      showPassword: 'הצג תוכן מאובטח',
      hidePassword: 'הסתר תוכן מאובטח',
      clear: 'נקה',
      send: 'שלח',
      yesterday: 'אתמול',
      chatEndedActions: "פעולות לאחר סיום הצ'אט",
      openConversationDialog: 'פתח את חלון השיחה עם {{title}}',
      agentTyping: 'הנציג מקליד',
      agentAway: 'הנציגים שלנו אינם זמינים כרגע.',
      agentBusy: 'הנציגים שלנו עסוקים כרגע. נא להמתין...',
      waitingForAgent: 'מחברים אותך לנציג...',
      waitingForAgentWithSkill: 'מחברים אותך לנציג בנושא {{skill}}...',
      talkingWithAgent: 'בשיחה עם {{name}}',
      home: 'בית',
      back: 'חזרה',
      menu: 'תפריט',
      minimize: 'מזער',
      endConversation: "סיים צ'אט",
      engageWithUs: 'צור איתנו קשר',
      noMessagesYet: 'אין הודעות עדיין',
      tryAgain: 'נסה שוב',
      rating: 'דירוג',
      shareLocation: 'שתף מיקום',
      locationShared: 'המיקום שותף',
      locationError: 'לא ניתן לאחזר את המיקום שלך',
      locationPermissionDenied: 'ההרשאה למיקום נדחתה',
      geolocationUnavailable: 'שירותי המיקום אינם זמינים',
      selectFile: 'בחר קובץ',
      upload: 'העלה',
      uploadComplete: 'ההעלאה הושלמה',
      uploadFailed: 'ההעלאה נכשלה',
      fileTooLarge: 'הקובץ גדול מדי',
      dragOrClick: 'גרור קובץ או לחץ כדי לבחור',
      document: 'מסמך',
      audioContent: 'תוכן שמע',
      videoContent: 'תוכן וידאו',
      unsupportedContent: 'תוכן שאינו נתמך',
      unavailable: {
        error: {
          title: 'משהו השתבש',
          body: "לא הצלחנו לטעון את הצ'אט. נסה שוב.",
          retry: 'נסה שוב',
        },
        maintenance: {
          title: "הצ'אט אינו זמין באופן זמני",
          body: 'אנו מבצעים תחזוקה מתוכננת. חזור בקרוב.',
        },
      },
      image: 'תמונה',
    },
  },
  {
    lang: 'hi',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'यह बातचीत समाप्त हो गई है।',
      agentConnected: 'आप सफलतापूर्वक एक एजेंट से जुड़ गए हैं।',
      downloadTranscript: 'ट्रांसक्रिप्ट डाउनलोड करें',
      startNewConversation: 'नई बातचीत शुरू करें',
      returnToConversation: 'बातचीत पर लौटें',
      connecting: 'कनेक्ट हो रहा है...',
      retry: 'पुनः प्रयास करें',
      network: {
        retry: 'पुनः कनेक्ट करें',
      },
      reconnecting: 'पुनः कनेक्ट हो रहा है...',
      connectionLost: 'इंटरनेट कनेक्शन टूट गया है',
      reconnectDescription:
        'इंटरनेट कनेक्शन टूट गया है। पुनः प्रयास के लिए “पुनः कनेक्ट करें” पर क्लिक करें।',
      typeMessage: 'संदेश टाइप करें',
      inputSelect: 'विकल्प चुनें',
      inputSelectOrType: 'विकल्प चुनें या संदेश टाइप करें',
      secureInput: 'सुरक्षित संदेश टाइप करें',
      secureValueHidden: 'छिपा हुआ सुरक्षित मान',
      startChat: 'चैट शुरू करें',
      settings: 'सेटिंग्स',
      cancel: 'रद्द करें',
      confirm: 'पुष्टि करें',
      close: 'बंद करें',
      next: 'अगला',
      brandingTagline:
        'बुद्धिमान AI एजेंट्स के साथ अपने व्यवसाय को सशक्त बनाएं',
      poweredBy: 'द्वारा संचालित',
      pypestreamCom: 'Pypestream.com',
      assistant: 'सहायक',
      assistantThinking: 'सहायक सोच रहा है',
      youSaid: 'आपने कहा',
      assistantSays: 'सहायक कहता है',
      agentSays: '{{name}} कहते हैं',
      joinMeeting: 'मीटिंग में शामिल हों',
      meetingInProgress: 'मीटिंग जारी है — फिर से जुड़ने के लिए क्लिक करें',
      meetingExpired: 'मीटिंग लिंक (समाप्त)',
      embeddedContent: 'एम्बेडेड सामग्री',
      openInNewTab: 'नए टैब में खोलें',
      skipToMain: 'मुख्य सामग्री पर जाएं',
      loadingCustomerSolution: '{{customerName}} समाधान लोड हो रहा है',
      loadingSolution: 'समाधान लोड हो रहा है',
      customerLogoAlt: '{{customerName}} लोगो',
      selectDate: 'तारीख चुनें',
      selectTime: 'समय चुनें',
      browseOptions: 'विकल्प देखें',
      carouselRoleDescription: 'कैरोसेल',
      carouselSlideLabel: 'स्लाइड {{current}} / {{total}}',
      carouselPrevious: 'पिछला आइटम',
      carouselNext: 'अगला आइटम',
      carouselGoToItem: 'आइटम {{index}} पर जाएं',
      collapse: 'संक्षिप्त करें',
      expand: 'विस्तृत करें',
      messageHistory: 'संदेश इतिहास',
      reduce: 'घटाएं',
      today: 'आज',
      at: 'पर',
      a11yOptionsCount_one: '1 विकल्प है।',
      a11yOptionsCount_other: '{{count}} विकल्प हैं।',
      listpickerSelectAll: 'सभी चुनें',
      listpickerSelectOption: 'एक विकल्प चुनें',
      listpickerSearchAriaLabel: 'फ़िल्टर विकल्प खोजें',
      listpickerSearchPlaceholder: 'खोजें…',
      listpickerNoResults: 'कोई मेल खाता विकल्प नहीं।',
      listpickerResults_one: '1 परिणाम',
      listpickerResults_other: '{{count}} परिणाम',
      listpickerCondensed_one: '1 चयनित',
      listpickerCondensed_other: '{{count}} चयनित',
      listpickerSelectAction: 'चुनें',
      scrollToLatest: 'नवीनतम संदेश पर स्क्रॉल करें',
      scrollToUnread_one: '1 नया संदेश, नवीनतम पर स्क्रॉल करें',
      scrollToUnread_other: '{{count}} नए संदेश, नवीनतम पर स्क्रॉल करें',
      showPassword: 'सुरक्षित सामग्री दिखाएं',
      hidePassword: 'सुरक्षित सामग्री छिपाएं',
      clear: 'साफ़ करें',
      send: 'भेजें',
      yesterday: 'कल',
      chatEndedActions: 'चैट समाप्ति क्रियाएं',
      openConversationDialog: '{{title}} के साथ बातचीत डायलॉग खोलें',
      agentTyping: 'एजेंट टाइप कर रहा है',
      agentAway: 'हमारे एजेंट वर्तमान में उपलब्ध नहीं हैं।',
      agentBusy: 'हमारे एजेंट वर्तमान में व्यस्त हैं। कृपया प्रतीक्षा करें...',
      waitingForAgent: 'आपको एजेंट से जोड़ा जा रहा है...',
      waitingForAgentWithSkill: 'आपको {{skill}} एजेंट से जोड़ा जा रहा है...',
      talkingWithAgent: '{{name}} के साथ बातचीत',
      home: 'होम',
      back: 'वापस',
      menu: 'मेन्यू',
      minimize: 'छोटा करें',
      endConversation: 'चैट समाप्त करें',
      engageWithUs: 'हमसे जुड़ें',
      noMessagesYet: 'अभी तक कोई संदेश नहीं',
      tryAgain: 'पुनः प्रयास करें',
      rating: 'रेटिंग',
      shareLocation: 'स्थान साझा करें',
      locationShared: 'स्थान साझा किया गया',
      locationError: 'आपका स्थान प्राप्त नहीं किया जा सका',
      locationPermissionDenied: 'स्थान अनुमति अस्वीकृत',
      geolocationUnavailable: 'स्थान सेवाएं उपलब्ध नहीं हैं',
      selectFile: 'फ़ाइल चुनें',
      upload: 'अपलोड करें',
      uploadComplete: 'अपलोड पूर्ण',
      uploadFailed: 'अपलोड विफल',
      fileTooLarge: 'फ़ाइल बहुत बड़ी है',
      dragOrClick: 'फ़ाइल खींचें या चुनने के लिए क्लिक करें',
      document: 'दस्तावेज़',
      audioContent: 'ऑडियो सामग्री',
      videoContent: 'वीडियो सामग्री',
      unsupportedContent: 'असमर्थित सामग्री',
      unavailable: {
        error: {
          title: 'कुछ गलत हो गया',
          body: 'हम चैट लोड नहीं कर सके। कृपया पुनः प्रयास करें।',
          retry: 'पुनः प्रयास करें',
        },
        maintenance: {
          title: 'चैट अस्थायी रूप से अनुपलब्ध है',
          body: 'हम निर्धारित रखरखाव कर रहे हैं। कृपया कुछ देर बाद पुनः देखें।',
        },
      },
      image: 'छवि',
    },
  },
  {
    lang: 'hr',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Ovaj razgovor je završen.',
      agentConnected: 'Uspješno ste povezani s agentom.',
      downloadTranscript: 'Preuzmi transkript',
      startNewConversation: 'Započni novi razgovor',
      returnToConversation: 'Natrag na razgovor',
      connecting: 'Povezivanje...',
      retry: 'Pokušaj ponovno',
      network: {
        retry: 'Ponovno poveži',
      },
      reconnecting: 'Ponovno povezivanje...',
      connectionLost: 'Internetska veza je izgubljena',
      reconnectDescription:
        'Internetska veza je izgubljena. Kliknite Ponovno poveži za novi pokušaj.',
      typeMessage: 'Upišite poruku',
      inputSelect: 'Odaberite opciju',
      inputSelectOrType: 'Odaberite opciju ili upišite poruku',
      secureInput: 'Upišite sigurnu poruku',
      secureValueHidden: 'Skrivena sigurna vrijednost',
      startChat: 'Započni chat',
      settings: 'Postavke',
      cancel: 'Odustani',
      confirm: 'Potvrdi',
      close: 'Zatvori',
      next: 'Dalje',
      brandingTagline: 'Osnažite svoje poslovanje s inteligentnim AI agentima',
      poweredBy: 'Pokreće',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asistent',
      assistantThinking: 'Asistent razmišlja',
      youSaid: 'Rekli ste',
      assistantSays: 'Asistent kaže',
      agentSays: '{{name}} kaže',
      joinMeeting: 'Pridruži se sastanku',
      meetingInProgress:
        'Sastanak je u tijeku — kliknite za ponovno pridruživanje',
      meetingExpired: 'Poveznica na sastanak (istekla)',
      embeddedContent: 'Ugrađeni sadržaj',
      openInNewTab: 'Otvori u novoj kartici',
      skipToMain: 'Preskoči na glavni sadržaj',
      loadingCustomerSolution: 'Učitavanje rješenja {{customerName}}',
      loadingSolution: 'Učitavanje rješenja',
      customerLogoAlt: 'Logotip {{customerName}}',
      selectDate: 'Odaberite datum',
      selectTime: 'Odaberite vrijeme',
      browseOptions: 'Pregledaj opcije',
      carouselRoleDescription: 'Vrtuljak',
      carouselSlideLabel: 'Slajd {{current}} od {{total}}',
      carouselPrevious: 'Prethodna stavka',
      carouselNext: 'Sljedeća stavka',
      carouselGoToItem: 'Idi na stavku {{index}}',
      collapse: 'Sažmi',
      expand: 'Proširi',
      messageHistory: 'Povijest poruka',
      reduce: 'Smanji',
      today: 'Danas',
      at: 'u',
      a11yOptionsCount_zero: 'Postoji {{count}} opcija.',
      a11yOptionsCount_one: 'Postoji 1 opcija.',
      a11yOptionsCount_two: 'Postoji {{count}} opcija.',
      a11yOptionsCount_few: 'Postoje {{count}} opcije.',
      a11yOptionsCount_many: 'Postoji {{count}} opcija.',
      a11yOptionsCount_other: 'Postoji {{count}} opcija.',
      listpickerSelectAll: 'Odaberi sve',
      listpickerSelectOption: 'Odaberite opciju',
      listpickerSearchAriaLabel: 'Pretraži opcije filtra',
      listpickerSearchPlaceholder: 'Pretraži…',
      listpickerNoResults: 'Nema podudarnih opcija.',
      listpickerResults_zero: '{{count}} rezultata',
      listpickerResults_one: '1 rezultat',
      listpickerResults_two: '{{count}} rezultata',
      listpickerResults_few: '{{count}} rezultata',
      listpickerResults_many: '{{count}} rezultata',
      listpickerResults_other: '{{count}} rezultata',
      listpickerCondensed_zero: '{{count}} odabrano',
      listpickerCondensed_one: '1 odabrano',
      listpickerCondensed_two: '{{count}} odabrano',
      listpickerCondensed_few: '{{count}} odabrano',
      listpickerCondensed_many: '{{count}} odabrano',
      listpickerCondensed_other: '{{count}} odabrano',
      listpickerSelectAction: 'Odaberi',
      scrollToLatest: 'Pomakni na najnoviju poruku',
      scrollToUnread_zero: '{{count}} novih poruka, na najnoviju',
      scrollToUnread_one: '1 nova poruka, na najnoviju',
      scrollToUnread_two: '{{count}} novih poruka, na najnoviju',
      scrollToUnread_few: '{{count}} nove poruke, na najnoviju',
      scrollToUnread_many: '{{count}} novih poruka, na najnoviju',
      scrollToUnread_other: '{{count}} novih poruka, na najnoviju',
      showPassword: 'Prikaži siguran sadržaj',
      hidePassword: 'Sakrij siguran sadržaj',
      clear: 'Očisti',
      send: 'Pošalji',
      yesterday: 'Jučer',
      chatEndedActions: 'Radnje nakon završetka chata',
      openConversationDialog: 'Otvori prozor razgovora s {{title}}',
      agentTyping: 'Agent tipka',
      agentAway: 'Naši agenti trenutačno nisu dostupni.',
      agentBusy: 'Naši agenti trenutačno su zauzeti. Pričekajte...',
      waitingForAgent: 'Povezujemo vas s agentom...',
      waitingForAgentWithSkill: 'Povezujemo vas s agentom za {{skill}}...',
      talkingWithAgent: 'Razgovor s {{name}}',
      home: 'Početna',
      back: 'Natrag',
      menu: 'Izbornik',
      minimize: 'Minimiziraj',
      endConversation: 'Završi chat',
      engageWithUs: 'Kontaktirajte nas',
      noMessagesYet: 'Još nema poruka',
      tryAgain: 'Pokušaj ponovno',
      rating: 'Ocjena',
      shareLocation: 'Podijeli lokaciju',
      locationShared: 'Lokacija podijeljena',
      locationError: 'Nije moguće dohvatiti vašu lokaciju',
      locationPermissionDenied: 'Dopuštenje za lokaciju odbijeno',
      geolocationUnavailable: 'Usluge lokacije nisu dostupne',
      selectFile: 'Odaberite datoteku',
      upload: 'Prenesi',
      uploadComplete: 'Prijenos dovršen',
      uploadFailed: 'Prijenos nije uspio',
      fileTooLarge: 'Datoteka je prevelika',
      dragOrClick: 'Povucite datoteku ili kliknite za odabir',
      document: 'Dokument',
      audioContent: 'Audiosadržaj',
      videoContent: 'Videosadržaj',
      unsupportedContent: 'Nepodržani sadržaj',
      unavailable: {
        error: {
          title: 'Nešto je pošlo po zlu',
          body: 'Nismo mogli učitati chat. Pokušajte ponovno.',
          retry: 'Pokušaj ponovno',
        },
        maintenance: {
          title: 'Chat je privremeno nedostupan',
          body: 'Provodimo planirano održavanje. Vratite se uskoro.',
        },
      },
      image: 'Slika',
    },
  },
  {
    lang: 'ht',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Konvèsasyon sa a fini.',
      agentConnected: 'Ou konekte avèk yon ajan avèk siksè.',
      downloadTranscript: 'Telechaje transkripsyon an',
      startNewConversation: 'Kòmanse yon nouvo konvèsasyon',
      returnToConversation: 'Retounen nan konvèsasyon an',
      connecting: 'Koneksyon...',
      retry: 'Eseye ankò',
      network: {
        retry: 'Rekonekte',
      },
      reconnecting: 'Rekoneksyon...',
      connectionLost: 'Koneksyon entènèt la pèdi',
      reconnectDescription:
        'Koneksyon entènèt la pèdi. Klike sou Rekonekte pou eseye ankò.',
      typeMessage: 'Tape yon mesaj',
      inputSelect: 'Chwazi yon opsyon',
      inputSelectOrType: 'Chwazi yon opsyon oswa tape yon mesaj',
      secureInput: 'Tape yon mesaj sekirize',
      secureValueHidden: 'Valè sekirize kache',
      startChat: 'Kòmanse chat la',
      settings: 'Paramèt',
      cancel: 'Anile',
      confirm: 'Konfime',
      close: 'Fèmen',
      next: 'Pwochen',
      brandingTagline: 'Ranfòse biznis ou avèk ajan AI entèlijan',
      poweredBy: 'Alimante pa',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asistan',
      assistantThinking: 'Asistan an ap reflechi',
      youSaid: 'Ou di',
      assistantSays: 'Asistan an di',
      agentSays: '{{name}} di',
      joinMeeting: 'Rantre nan reyinyon an',
      meetingInProgress: 'Reyinyon an ap fèt — klike pou rantre ankò',
      meetingExpired: 'Lyen reyinyon (ekspire)',
      embeddedContent: 'Kontni entegre',
      openInNewTab: 'Louvri nan yon nouvo onglè',
      skipToMain: 'Ale nan kontni prensipal la',
      loadingCustomerSolution: 'Chaje solisyon {{customerName}} an',
      loadingSolution: 'Chaje solisyon an',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Chwazi dat',
      selectTime: 'Chwazi lè',
      browseOptions: 'Gade opsyon yo',
      carouselRoleDescription: 'Kawousèl',
      carouselSlideLabel: 'Slid {{current}} sou {{total}}',
      carouselPrevious: 'Atik anvan',
      carouselNext: 'Atik apre',
      carouselGoToItem: 'Ale nan atik {{index}}',
      collapse: 'Ranje',
      expand: 'Elaji',
      messageHistory: 'Istwa mesaj yo',
      reduce: 'Redwi',
      today: 'Jodi a',
      at: 'a',
      a11yOptionsCount_zero: 'Gen {{count}} opsyon.',
      a11yOptionsCount_one: 'Gen 1 opsyon.',
      a11yOptionsCount_two: 'Gen {{count}} opsyon.',
      a11yOptionsCount_few: 'Gen {{count}} opsyon.',
      a11yOptionsCount_many: 'Gen {{count}} opsyon.',
      a11yOptionsCount_other: 'Gen {{count}} opsyon.',
      listpickerSelectAll: 'Chwazi tout',
      listpickerSelectOption: 'Chwazi yon opsyon',
      listpickerSearchAriaLabel: 'Chèche opsyon filtè',
      listpickerSearchPlaceholder: 'Chèche…',
      listpickerNoResults: 'Pa gen opsyon ki koresponn.',
      listpickerResults_zero: '{{count}} rezilta',
      listpickerResults_one: '1 rezilta',
      listpickerResults_two: '{{count}} rezilta',
      listpickerResults_few: '{{count}} rezilta',
      listpickerResults_many: '{{count}} rezilta',
      listpickerResults_other: '{{count}} rezilta',
      listpickerCondensed_zero: '{{count}} chwazi',
      listpickerCondensed_one: '1 chwazi',
      listpickerCondensed_two: '{{count}} chwazi',
      listpickerCondensed_few: '{{count}} chwazi',
      listpickerCondensed_many: '{{count}} chwazi',
      listpickerCondensed_other: '{{count}} chwazi',
      listpickerSelectAction: 'Chwazi',
      scrollToLatest: 'Woule nan dènye mesaj la',
      scrollToUnread_zero: '{{count}} nouvo mesaj, ale nan dènye a',
      scrollToUnread_one: '1 nouvo mesaj, ale nan dènye a',
      scrollToUnread_two: '{{count}} nouvo mesaj, ale nan dènye a',
      scrollToUnread_few: '{{count}} nouvo mesaj, ale nan dènye a',
      scrollToUnread_many: '{{count}} nouvo mesaj, ale nan dènye a',
      scrollToUnread_other: '{{count}} nouvo mesaj, ale nan dènye a',
      showPassword: 'Montre kontni sekirize',
      hidePassword: 'Kache kontni sekirize',
      clear: 'Efase',
      send: 'Voye',
      yesterday: 'Yè',
      chatEndedActions: 'Aksyon apre chat la fini',
      openConversationDialog: 'Louvri dyalòg konvèsasyon an avèk {{title}}',
      agentTyping: 'Ajan an ap tape',
      agentAway: 'Ajan nou yo pa disponib kounye a.',
      agentBusy: 'Ajan nou yo okipe kounye a. Tanpri tann...',
      waitingForAgent: 'N ap konekte ou avèk yon ajan...',
      waitingForAgentWithSkill: 'N ap konekte ou avèk yon ajan {{skill}}...',
      talkingWithAgent: 'Ap pale avèk {{name}}',
      home: 'Akèy',
      back: 'Retounen',
      menu: 'Meni',
      minimize: 'Minimize',
      endConversation: 'Fini chat la',
      engageWithUs: 'Kontakte nou',
      noMessagesYet: 'Poko gen mesaj',
      tryAgain: 'Eseye ankò',
      rating: 'Evalyasyon',
      shareLocation: 'Pataje kote ou ye',
      locationShared: 'Kote a pataje',
      locationError: 'Nou pa ka jwenn kote ou ye',
      locationPermissionDenied: 'Pèmisyon pou kote a refize',
      geolocationUnavailable: 'Sèvis lokalizasyon yo pa disponib',
      selectFile: 'Chwazi yon fichye',
      upload: 'Telechaje',
      uploadComplete: 'Telechajman fini',
      uploadFailed: 'Telechajman echwe',
      fileTooLarge: 'Fichye a twò gwo',
      dragOrClick: 'Trennen yon fichye oswa klike pou chwazi',
      document: 'Dokiman',
      audioContent: 'Kontni odyo',
      videoContent: 'Kontni videyo',
      unsupportedContent: 'Kontni ki pa sipòte',
      unavailable: {
        error: {
          title: 'Yon bagay pa mache',
          body: 'Nou pa t kapab chaje chat la. Tanpri eseye ankò.',
          retry: 'Eseye ankò',
        },
        maintenance: {
          title: 'Chat la pa disponib pou kounye a',
          body: 'N ap fè antretyen ki pwograme. Tanpri retounen byento.',
        },
      },
      image: 'Imaj',
    },
  },
  {
    lang: 'hu',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Ez a beszélgetés véget ért.',
      agentConnected: 'Sikeresen kapcsolódott egy ügyintézőhöz.',
      downloadTranscript: 'Átirat letöltése',
      startNewConversation: 'Új beszélgetés indítása',
      returnToConversation: 'Vissza a beszélgetéshez',
      connecting: 'Csatlakozás...',
      retry: 'Újra',
      network: {
        retry: 'Újracsatlakozás',
      },
      reconnecting: 'Újracsatlakozás...',
      connectionLost: 'Az internetkapcsolat megszakadt',
      reconnectDescription:
        'Az internetkapcsolat megszakadt. Kattintson az Újracsatlakozás gombra az újbóli próbálkozáshoz.',
      typeMessage: 'Írjon üzenetet',
      inputSelect: 'Válasszon egy lehetőséget',
      inputSelectOrType: 'Válasszon egy lehetőséget vagy írjon üzenetet',
      secureInput: 'Írjon biztonságos üzenetet',
      secureValueHidden: 'Rejtett biztonságos érték',
      startChat: 'Csevegés indítása',
      settings: 'Beállítások',
      cancel: 'Mégse',
      confirm: 'Megerősítés',
      close: 'Bezárás',
      next: 'Tovább',
      brandingTagline: 'Lendítse fel vállalkozását intelligens MI-ügynökökkel',
      poweredBy: 'Üzemelteti',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asszisztens',
      assistantThinking: 'Az asszisztens gondolkodik',
      youSaid: 'Ön ezt mondta',
      assistantSays: 'Az asszisztens ezt mondja',
      agentSays: '{{name}} ezt mondja',
      joinMeeting: 'Csatlakozás az értekezlethez',
      meetingInProgress:
        'Az értekezlet folyamatban van — kattintson az újbóli csatlakozáshoz',
      meetingExpired: 'Értekezlet-hivatkozás (lejárt)',
      embeddedContent: 'Beágyazott tartalom',
      openInNewTab: 'Megnyitás új lapon',
      skipToMain: 'Ugrás a fő tartalomra',
      loadingCustomerSolution: 'A(z) {{customerName}} megoldás betöltése',
      loadingSolution: 'Megoldás betöltése',
      customerLogoAlt: '{{customerName}} logó',
      selectDate: 'Válasszon dátumot',
      selectTime: 'Válasszon időpontot',
      browseOptions: 'Lehetőségek böngészése',
      carouselRoleDescription: 'Körhinta',
      carouselSlideLabel: '{{current}}. dia a(z) {{total}}-ból',
      carouselPrevious: 'Előző elem',
      carouselNext: 'Következő elem',
      carouselGoToItem: 'Ugrás a(z) {{index}}. elemre',
      collapse: 'Összecsukás',
      expand: 'Kibontás',
      messageHistory: 'Üzenetelőzmények',
      reduce: 'Kicsinyítés',
      today: 'Ma',
      at: '–',
      a11yOptionsCount_zero: '{{count}} lehetőség van.',
      a11yOptionsCount_one: '1 lehetőség van.',
      a11yOptionsCount_two: '{{count}} lehetőség van.',
      a11yOptionsCount_few: '{{count}} lehetőség van.',
      a11yOptionsCount_many: '{{count}} lehetőség van.',
      a11yOptionsCount_other: '{{count}} lehetőség van.',
      listpickerSelectAll: 'Összes kijelölése',
      listpickerSelectOption: 'Válasszon egy lehetőséget',
      listpickerSearchAriaLabel: 'Szűrési lehetőségek keresése',
      listpickerSearchPlaceholder: 'Keresés…',
      listpickerNoResults: 'Nincs megfelelő lehetőség.',
      listpickerResults_zero: '{{count}} találat',
      listpickerResults_one: '1 találat',
      listpickerResults_two: '{{count}} találat',
      listpickerResults_few: '{{count}} találat',
      listpickerResults_many: '{{count}} találat',
      listpickerResults_other: '{{count}} találat',
      listpickerCondensed_zero: '{{count}} kijelölve',
      listpickerCondensed_one: '1 kijelölve',
      listpickerCondensed_two: '{{count}} kijelölve',
      listpickerCondensed_few: '{{count}} kijelölve',
      listpickerCondensed_many: '{{count}} kijelölve',
      listpickerCondensed_other: '{{count}} kijelölve',
      listpickerSelectAction: 'Kiválasztás',
      scrollToLatest: 'Ugrás a legújabb üzenetre',
      scrollToUnread_zero: '{{count}} új üzenet, ugrás a legújabbra',
      scrollToUnread_one: '1 új üzenet, ugrás a legújabbra',
      scrollToUnread_two: '{{count}} új üzenet, ugrás a legújabbra',
      scrollToUnread_few: '{{count}} új üzenet, ugrás a legújabbra',
      scrollToUnread_many: '{{count}} új üzenet, ugrás a legújabbra',
      scrollToUnread_other: '{{count}} új üzenet, ugrás a legújabbra',
      showPassword: 'Biztonságos tartalom megjelenítése',
      hidePassword: 'Biztonságos tartalom elrejtése',
      clear: 'Törlés',
      send: 'Küldés',
      yesterday: 'Tegnap',
      chatEndedActions: 'Műveletek a csevegés befejezése után',
      openConversationDialog: 'Beszélgetési ablak megnyitása: {{title}}',
      agentTyping: 'Az ügyintéző gépel',
      agentAway: 'Ügyintézőink jelenleg nem érhetők el.',
      agentBusy: 'Ügyintézőink jelenleg elfoglaltak. Kérjük, várjon...',
      waitingForAgent: 'Összekapcsoljuk egy ügyintézővel...',
      waitingForAgentWithSkill: 'Összekapcsoljuk egy {{skill}} ügyintézővel...',
      talkingWithAgent: 'Beszélgetés vele: {{name}}',
      home: 'Kezdőlap',
      back: 'Vissza',
      menu: 'Menü',
      minimize: 'Kis méret',
      endConversation: 'Csevegés befejezése',
      engageWithUs: 'Lépjen kapcsolatba velünk',
      noMessagesYet: 'Még nincsenek üzenetek',
      tryAgain: 'Próbálja újra',
      rating: 'Értékelés',
      shareLocation: 'Hely megosztása',
      locationShared: 'Hely megosztva',
      locationError: 'Nem sikerült lekérni a tartózkodási helyét',
      locationPermissionDenied: 'Helyhozzáférés megtagadva',
      geolocationUnavailable:
        'A helymeghatározási szolgáltatások nem érhetők el',
      selectFile: 'Válasszon fájlt',
      upload: 'Feltöltés',
      uploadComplete: 'Feltöltés kész',
      uploadFailed: 'A feltöltés sikertelen',
      fileTooLarge: 'A fájl túl nagy',
      dragOrClick: 'Húzzon ide egy fájlt, vagy kattintson a kiválasztáshoz',
      document: 'Dokumentum',
      audioContent: 'Hangtartalom',
      videoContent: 'Videotartalom',
      unsupportedContent: 'Nem támogatott tartalom',
      unavailable: {
        error: {
          title: 'Valami hiba történt',
          body: 'Nem sikerült betölteni a csevegést. Próbálja újra.',
          retry: 'Próbálja újra',
        },
        maintenance: {
          title: 'A csevegés átmenetileg nem érhető el',
          body: 'Ütemezett karbantartást végzünk. Térjen vissza hamarosan.',
        },
      },
      image: 'Kép',
    },
  },
  {
    lang: 'id',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Percakapan ini telah berakhir.',
      agentConnected: 'Anda telah berhasil terhubung dengan agen.',
      downloadTranscript: 'Unduh transkrip',
      startNewConversation: 'Mulai percakapan baru',
      returnToConversation: 'Kembali ke percakapan',
      connecting: 'Menghubungkan...',
      retry: 'Coba lagi',
      network: {
        retry: 'Sambungkan ulang',
      },
      reconnecting: 'Menyambungkan ulang...',
      connectionLost: 'Koneksi internet terputus',
      reconnectDescription:
        'Koneksi internet terputus. Klik Sambungkan ulang untuk mencoba lagi.',
      typeMessage: 'Ketik pesan',
      inputSelect: 'Pilih opsi',
      inputSelectOrType: 'Pilih opsi atau ketik pesan',
      secureInput: 'Ketik pesan aman',
      secureValueHidden: 'Nilai aman tersembunyi',
      startChat: 'Mulai obrolan',
      settings: 'Pengaturan',
      cancel: 'Batal',
      confirm: 'Konfirmasi',
      close: 'Tutup',
      next: 'Berikutnya',
      brandingTagline: 'Tingkatkan bisnis Anda dengan agen AI cerdas',
      poweredBy: 'Didukung oleh',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asisten',
      assistantThinking: 'Asisten sedang berpikir',
      youSaid: 'Anda berkata',
      assistantSays: 'Asisten berkata',
      agentSays: '{{name}} berkata',
      joinMeeting: 'Gabung rapat',
      meetingInProgress:
        'Rapat sedang berlangsung — klik untuk bergabung kembali',
      meetingExpired: 'Tautan rapat (kedaluwarsa)',
      embeddedContent: 'Konten tersemat',
      openInNewTab: 'Buka di tab baru',
      skipToMain: 'Lewati ke konten utama',
      loadingCustomerSolution: 'Memuat solusi {{customerName}}',
      loadingSolution: 'Memuat solusi',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Pilih tanggal',
      selectTime: 'Pilih waktu',
      browseOptions: 'Jelajahi opsi',
      carouselRoleDescription: 'Korsel',
      carouselSlideLabel: 'Slide {{current}} dari {{total}}',
      carouselPrevious: 'Item sebelumnya',
      carouselNext: 'Item berikutnya',
      carouselGoToItem: 'Buka item {{index}}',
      collapse: 'Ciutkan',
      expand: 'Perluas',
      messageHistory: 'Riwayat pesan',
      reduce: 'Perkecil',
      today: 'Hari ini',
      at: 'pukul',
      a11yOptionsCount_zero: 'Ada {{count}} opsi.',
      a11yOptionsCount_one: 'Ada 1 opsi.',
      a11yOptionsCount_two: 'Ada {{count}} opsi.',
      a11yOptionsCount_few: 'Ada {{count}} opsi.',
      a11yOptionsCount_many: 'Ada {{count}} opsi.',
      a11yOptionsCount_other: 'Ada {{count}} opsi.',
      listpickerSelectAll: 'Pilih semua',
      listpickerSelectOption: 'Pilih opsi',
      listpickerSearchAriaLabel: 'Cari opsi filter',
      listpickerSearchPlaceholder: 'Cari…',
      listpickerNoResults: 'Tidak ada opsi yang cocok.',
      listpickerResults_zero: '{{count}} hasil',
      listpickerResults_one: '1 hasil',
      listpickerResults_two: '{{count}} hasil',
      listpickerResults_few: '{{count}} hasil',
      listpickerResults_many: '{{count}} hasil',
      listpickerResults_other: '{{count}} hasil',
      listpickerCondensed_zero: '{{count}} dipilih',
      listpickerCondensed_one: '1 dipilih',
      listpickerCondensed_two: '{{count}} dipilih',
      listpickerCondensed_few: '{{count}} dipilih',
      listpickerCondensed_many: '{{count}} dipilih',
      listpickerCondensed_other: '{{count}} dipilih',
      listpickerSelectAction: 'Pilih',
      scrollToLatest: 'Gulir ke pesan terbaru',
      scrollToUnread_zero: '{{count}} pesan baru, gulir ke terbaru',
      scrollToUnread_one: '1 pesan baru, gulir ke terbaru',
      scrollToUnread_two: '{{count}} pesan baru, gulir ke terbaru',
      scrollToUnread_few: '{{count}} pesan baru, gulir ke terbaru',
      scrollToUnread_many: '{{count}} pesan baru, gulir ke terbaru',
      scrollToUnread_other: '{{count}} pesan baru, gulir ke terbaru',
      showPassword: 'Tampilkan konten aman',
      hidePassword: 'Sembunyikan konten aman',
      clear: 'Hapus',
      send: 'Kirim',
      yesterday: 'Kemarin',
      chatEndedActions: 'Tindakan setelah obrolan berakhir',
      openConversationDialog: 'Buka dialog percakapan dengan {{title}}',
      agentTyping: 'Agen sedang mengetik',
      agentAway: 'Agen kami saat ini tidak tersedia.',
      agentBusy: 'Agen kami saat ini sibuk. Harap tunggu...',
      waitingForAgent: 'Menghubungkan Anda dengan agen...',
      waitingForAgentWithSkill: 'Menghubungkan Anda dengan agen {{skill}}...',
      talkingWithAgent: 'Berbicara dengan {{name}}',
      home: 'Beranda',
      back: 'Kembali',
      menu: 'Menu',
      minimize: 'Perkecil',
      endConversation: 'Akhiri obrolan',
      engageWithUs: 'Hubungi kami',
      noMessagesYet: 'Belum ada pesan',
      tryAgain: 'Coba lagi',
      rating: 'Peringkat',
      shareLocation: 'Bagikan lokasi',
      locationShared: 'Lokasi dibagikan',
      locationError: 'Tidak dapat mengambil lokasi Anda',
      locationPermissionDenied: 'Izin lokasi ditolak',
      geolocationUnavailable: 'Layanan lokasi tidak tersedia',
      selectFile: 'Pilih file',
      upload: 'Unggah',
      uploadComplete: 'Unggahan selesai',
      uploadFailed: 'Unggahan gagal',
      fileTooLarge: 'File terlalu besar',
      dragOrClick: 'Seret file atau klik untuk memilih',
      document: 'Dokumen',
      audioContent: 'Konten audio',
      videoContent: 'Konten video',
      unsupportedContent: 'Konten tidak didukung',
      unavailable: {
        error: {
          title: 'Terjadi kesalahan',
          body: 'Kami tidak dapat memuat obrolan. Silakan coba lagi.',
          retry: 'Coba lagi',
        },
        maintenance: {
          title: 'Obrolan sementara tidak tersedia',
          body: 'Kami sedang melakukan pemeliharaan terjadwal. Silakan kembali lagi nanti.',
        },
      },
      image: 'Gambar',
    },
  },
  {
    lang: 'is',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Þessu samtali er lokið.',
      agentConnected: 'Þú tengdist fulltrúa.',
      downloadTranscript: 'Sækja umritun',
      startNewConversation: 'Hefja nýtt samtal',
      returnToConversation: 'Til baka í samtalið',
      connecting: 'Tengist...',
      retry: 'Reyna aftur',
      network: {
        retry: 'Tengjast aftur',
      },
      reconnecting: 'Tengist aftur...',
      connectionLost: 'Internettengingin rofnaði',
      reconnectDescription:
        'Internettengingin rofnaði. Smelltu á Tengjast aftur til að reyna aftur.',
      typeMessage: 'Skrifaðu skilaboð',
      inputSelect: 'Veldu valkost',
      inputSelectOrType: 'Veldu valkost eða skrifaðu skilaboð',
      secureInput: 'Skrifaðu örugg skilaboð',
      secureValueHidden: 'Falið öruggt gildi',
      startChat: 'Hefja spjall',
      settings: 'Stillingar',
      cancel: 'Hætta við',
      confirm: 'Staðfesta',
      close: 'Loka',
      next: 'Áfram',
      brandingTagline:
        'Efldu fyrirtækið þitt með snjöllum gervigreindarfulltrúum',
      poweredBy: 'Keyrt af',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Aðstoðarmaður',
      assistantThinking: 'Aðstoðarmaðurinn hugsar',
      youSaid: 'Þú sagðir',
      assistantSays: 'Aðstoðarmaðurinn segir',
      agentSays: '{{name}} segir',
      joinMeeting: 'Taka þátt í fundi',
      meetingInProgress: 'Fundur í gangi — smelltu til að tengjast aftur',
      meetingExpired: 'Fundartengill (útrunninn)',
      embeddedContent: 'Innfellt efni',
      openInNewTab: 'Opna í nýjum flipa',
      skipToMain: 'Fara í meginefni',
      loadingCustomerSolution: 'Hleð inn {{customerName}} lausn',
      loadingSolution: 'Hleð inn lausn',
      customerLogoAlt: '{{customerName}} merki',
      selectDate: 'Veldu dagsetningu',
      selectTime: 'Veldu tíma',
      browseOptions: 'Skoða valkosti',
      carouselRoleDescription: 'Skjámynd',
      carouselSlideLabel: 'Skyggna {{current}} af {{total}}',
      carouselPrevious: 'Fyrra atriði',
      carouselNext: 'Næsta atriði',
      carouselGoToItem: 'Fara í atriði {{index}}',
      collapse: 'Fella saman',
      expand: 'Fletta út',
      messageHistory: 'Skilaboðasaga',
      reduce: 'Minnka',
      today: 'Í dag',
      at: 'kl.',
      a11yOptionsCount_zero: 'Það eru {{count}} valkostir.',
      a11yOptionsCount_one: 'Það er 1 valkostur.',
      a11yOptionsCount_two: 'Það eru {{count}} valkostir.',
      a11yOptionsCount_few: 'Það eru {{count}} valkostir.',
      a11yOptionsCount_many: 'Það eru {{count}} valkostir.',
      a11yOptionsCount_other: 'Það eru {{count}} valkostir.',
      listpickerSelectAll: 'Velja allt',
      listpickerSelectOption: 'Veldu valkost',
      listpickerSearchAriaLabel: 'Leita að síunarkostum',
      listpickerSearchPlaceholder: 'Leita…',
      listpickerNoResults: 'Engir samsvarandi valkostir.',
      listpickerResults_zero: '{{count}} niðurstöður',
      listpickerResults_one: '1 niðurstaða',
      listpickerResults_two: '{{count}} niðurstöður',
      listpickerResults_few: '{{count}} niðurstöður',
      listpickerResults_many: '{{count}} niðurstöður',
      listpickerResults_other: '{{count}} niðurstöður',
      listpickerCondensed_zero: '{{count}} valin',
      listpickerCondensed_one: '1 valið',
      listpickerCondensed_two: '{{count}} valin',
      listpickerCondensed_few: '{{count}} valin',
      listpickerCondensed_many: '{{count}} valin',
      listpickerCondensed_other: '{{count}} valin',
      listpickerSelectAction: 'Velja',
      scrollToLatest: 'Skruna á nýjustu skilaboðin',
      scrollToUnread_zero: '{{count}} ný skilaboð, á nýjustu',
      scrollToUnread_one: '1 ný skilaboð, á nýjustu',
      scrollToUnread_two: '{{count}} ný skilaboð, á nýjustu',
      scrollToUnread_few: '{{count}} ný skilaboð, á nýjustu',
      scrollToUnread_many: '{{count}} ný skilaboð, á nýjustu',
      scrollToUnread_other: '{{count}} ný skilaboð, á nýjustu',
      showPassword: 'Sýna öruggt efni',
      hidePassword: 'Fela öruggt efni',
      clear: 'Hreinsa',
      send: 'Senda',
      yesterday: 'Í gær',
      chatEndedActions: 'Aðgerðir eftir að spjalli lýkur',
      openConversationDialog: 'Opna samtalsglugga með {{title}}',
      agentTyping: 'Fulltrúinn skrifar',
      agentAway: 'Fulltrúar okkar eru ekki tiltækir sem stendur.',
      agentBusy:
        'Fulltrúar okkar eru uppteknir sem stendur. Vinsamlegast bíddu...',
      waitingForAgent: 'Við tengjum þig við fulltrúa...',
      waitingForAgentWithSkill: 'Við tengjum þig við {{skill}} fulltrúa...',
      talkingWithAgent: 'Talar við {{name}}',
      home: 'Heim',
      back: 'Til baka',
      menu: 'Valmynd',
      minimize: 'Minnka',
      endConversation: 'Ljúka spjalli',
      engageWithUs: 'Hafðu samband við okkur',
      noMessagesYet: 'Engin skilaboð enn',
      tryAgain: 'Reyna aftur',
      rating: 'Einkunn',
      shareLocation: 'Deila staðsetningu',
      locationShared: 'Staðsetningu deilt',
      locationError: 'Ekki tókst að sækja staðsetningu þína',
      locationPermissionDenied: 'Staðsetningarheimild hafnað',
      geolocationUnavailable: 'Staðsetningarþjónusta er ekki tiltæk',
      selectFile: 'Veldu skrá',
      upload: 'Hlaða upp',
      uploadComplete: 'Upphleðslu lokið',
      uploadFailed: 'Upphleðsla mistókst',
      fileTooLarge: 'Skráin er of stór',
      dragOrClick: 'Dragðu skrá eða smelltu til að velja',
      document: 'Skjal',
      audioContent: 'Hljóðefni',
      videoContent: 'Myndefni',
      unsupportedContent: 'Óstutt efni',
      unavailable: {
        error: {
          title: 'Eitthvað fór úrskeiðis',
          body: 'Okkur tókst ekki að hlaða spjallinu. Vinsamlegast reyndu aftur.',
          retry: 'Reyna aftur',
        },
        maintenance: {
          title: 'Spjall er tímabundið ótiltækt',
          body: 'Við erum að framkvæma áætlað viðhald. Vinsamlegast komdu aftur fljótlega.',
        },
      },
      image: 'Mynd',
    },
  },
  {
    lang: 'it',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Questa conversazione è terminata.',
      agentConnected: 'Sei stato collegato correttamente a un operatore.',
      downloadTranscript: 'Scarica la trascrizione',
      startNewConversation: 'Avvia una nuova conversazione',
      returnToConversation: 'Torna alla conversazione',
      connecting: 'Connessione in corso...',
      retry: 'Riprova',
      network: {
        retry: 'Riconnetti',
      },
      reconnecting: 'Riconnessione in corso...',
      connectionLost: 'La connessione a internet è stata persa',
      reconnectDescription:
        'La connessione a internet è stata persa. Clicca su Riconnetti per riprovare.',
      typeMessage: 'Scrivi un messaggio',
      inputSelect: "Seleziona un'opzione",
      inputSelectOrType: "Seleziona un'opzione o scrivi un messaggio",
      secureInput: 'Scrivi un messaggio sicuro',
      secureValueHidden: 'Valore sicuro nascosto',
      startChat: 'Avvia chat',
      settings: 'Impostazioni',
      cancel: 'Annulla',
      confirm: 'Conferma',
      close: 'Chiudi',
      next: 'Avanti',
      brandingTagline: 'Potenzia la tua azienda con agenti IA intelligenti',
      poweredBy: 'Con tecnologia',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistente',
      assistantThinking: "L'assistente sta pensando",
      youSaid: 'Hai detto',
      assistantSays: "L'assistente dice",
      agentSays: '{{name}} dice',
      joinMeeting: 'Partecipa alla riunione',
      meetingInProgress: 'Riunione in corso — clicca per rientrare',
      meetingExpired: 'Link della riunione (scaduto)',
      embeddedContent: 'Contenuto incorporato',
      openInNewTab: 'Apri in una nuova scheda',
      skipToMain: 'Vai al contenuto principale',
      loadingCustomerSolution: 'Caricamento della soluzione {{customerName}}',
      loadingSolution: 'Caricamento della soluzione',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Seleziona la data',
      selectTime: "Seleziona l'ora",
      browseOptions: 'Sfoglia le opzioni',
      carouselRoleDescription: 'Carosello',
      carouselSlideLabel: 'Diapositiva {{current}} di {{total}}',
      carouselPrevious: 'Elemento precedente',
      carouselNext: 'Elemento successivo',
      carouselGoToItem: "Vai all'elemento {{index}}",
      collapse: 'Comprimi',
      expand: 'Espandi',
      messageHistory: 'Cronologia dei messaggi',
      reduce: 'Riduci',
      today: 'Oggi',
      at: 'alle',
      a11yOptionsCount_zero: 'Ci sono {{count}} opzioni.',
      a11yOptionsCount_one: "C'è 1 opzione.",
      a11yOptionsCount_two: 'Ci sono {{count}} opzioni.',
      a11yOptionsCount_few: 'Ci sono {{count}} opzioni.',
      a11yOptionsCount_many: 'Ci sono {{count}} opzioni.',
      a11yOptionsCount_other: 'Ci sono {{count}} opzioni.',
      listpickerSelectAll: 'Seleziona tutto',
      listpickerSelectOption: "Seleziona un'opzione",
      listpickerSearchAriaLabel: 'Cerca opzioni di filtro',
      listpickerSearchPlaceholder: 'Cerca…',
      listpickerNoResults: 'Nessuna opzione corrispondente.',
      listpickerResults_zero: '{{count}} risultati',
      listpickerResults_one: '1 risultato',
      listpickerResults_two: '{{count}} risultati',
      listpickerResults_few: '{{count}} risultati',
      listpickerResults_many: '{{count}} risultati',
      listpickerResults_other: '{{count}} risultati',
      listpickerCondensed_zero: '{{count}} selezionati',
      listpickerCondensed_one: '1 selezionato',
      listpickerCondensed_two: '{{count}} selezionati',
      listpickerCondensed_few: '{{count}} selezionati',
      listpickerCondensed_many: '{{count}} selezionati',
      listpickerCondensed_other: '{{count}} selezionati',
      listpickerSelectAction: 'Seleziona',
      scrollToLatest: "Vai all'ultimo messaggio",
      scrollToUnread_zero: "{{count}} nuovi messaggi, vai all'ultimo",
      scrollToUnread_one: "1 nuovo messaggio, vai all'ultimo",
      scrollToUnread_two: "{{count}} nuovi messaggi, vai all'ultimo",
      scrollToUnread_few: "{{count}} nuovi messaggi, vai all'ultimo",
      scrollToUnread_many: "{{count}} nuovi messaggi, vai all'ultimo",
      scrollToUnread_other: "{{count}} nuovi messaggi, vai all'ultimo",
      showPassword: 'Mostra contenuto sicuro',
      hidePassword: 'Nascondi contenuto sicuro',
      clear: 'Cancella',
      send: 'Invia',
      yesterday: 'Ieri',
      chatEndedActions: 'Azioni a fine chat',
      openConversationDialog: 'Apri la finestra di conversazione con {{title}}',
      agentTyping: "L'operatore sta scrivendo",
      agentAway: 'I nostri operatori non sono al momento disponibili.',
      agentBusy: 'I nostri operatori sono al momento occupati. Attendi...',
      waitingForAgent: 'Ti stiamo mettendo in contatto con un operatore...',
      waitingForAgentWithSkill:
        'Ti stiamo mettendo in contatto con un operatore {{skill}}...',
      talkingWithAgent: 'Conversazione con {{name}}',
      home: 'Home',
      back: 'Indietro',
      menu: 'Menu',
      minimize: 'Riduci a icona',
      endConversation: 'Termina chat',
      engageWithUs: 'Contattaci',
      noMessagesYet: 'Ancora nessun messaggio',
      tryAgain: 'Riprova',
      rating: 'Valutazione',
      shareLocation: 'Condividi posizione',
      locationShared: 'Posizione condivisa',
      locationError: 'Impossibile recuperare la tua posizione',
      locationPermissionDenied: 'Autorizzazione alla posizione negata',
      geolocationUnavailable:
        'I servizi di localizzazione non sono disponibili',
      selectFile: 'Seleziona un file',
      upload: 'Carica',
      uploadComplete: 'Caricamento completato',
      uploadFailed: 'Caricamento non riuscito',
      fileTooLarge: 'Il file è troppo grande',
      dragOrClick: 'Trascina un file o clicca per sceglierlo',
      document: 'Documento',
      audioContent: 'Contenuto audio',
      videoContent: 'Contenuto video',
      unsupportedContent: 'Contenuto non supportato',
      unavailable: {
        error: {
          title: 'Qualcosa è andato storto',
          body: 'Non è stato possibile caricare la chat. Riprova.',
          retry: 'Riprova',
        },
        maintenance: {
          title: 'La chat non è temporaneamente disponibile',
          body: 'Stiamo eseguendo una manutenzione programmata. Torna presto.',
        },
      },
      image: 'Immagine',
    },
  },
  {
    lang: 'ja',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'この会話は終了しました。',
      agentConnected: '担当者に接続されました。',
      downloadTranscript: 'トランスクリプトをダウンロード',
      startNewConversation: '新しい会話を開始',
      returnToConversation: '会話に戻る',
      connecting: '接続中...',
      retry: '再試行',
      network: {
        retry: '再接続',
      },
      reconnecting: '再接続中...',
      connectionLost: 'インターネット接続が切断されました',
      reconnectDescription:
        'インターネット接続が切断されました。「再接続」をクリックして再試行してください。',
      typeMessage: 'メッセージを入力',
      inputSelect: 'オプションを選択',
      inputSelectOrType: 'オプションを選択するかメッセージを入力',
      secureInput: 'セキュアなメッセージを入力',
      secureValueHidden: '非表示のセキュアな値',
      startChat: 'チャットを開始',
      settings: '設定',
      cancel: 'キャンセル',
      confirm: '確認',
      close: '閉じる',
      next: '次へ',
      brandingTagline: 'インテリジェントなAIエージェントでビジネスを加速',
      poweredBy: '提供',
      pypestreamCom: 'Pypestream.com',
      assistant: 'アシスタント',
      assistantThinking: 'アシスタントが考えています',
      youSaid: 'あなたの発言',
      assistantSays: 'アシスタントの発言',
      agentSays: '{{name}}の発言',
      joinMeeting: '会議に参加',
      meetingInProgress: '会議が進行中です — クリックして再参加',
      meetingExpired: '会議リンク（期限切れ）',
      embeddedContent: '埋め込みコンテンツ',
      openInNewTab: '新しいタブで開く',
      skipToMain: 'メインコンテンツにスキップ',
      loadingCustomerSolution: '{{customerName}}のソリューションを読み込み中',
      loadingSolution: 'ソリューションを読み込み中',
      customerLogoAlt: '{{customerName}}のロゴ',
      selectDate: '日付を選択',
      selectTime: '時刻を選択',
      browseOptions: 'オプションを見る',
      carouselRoleDescription: 'カルーセル',
      carouselSlideLabel: 'スライド {{current}} / {{total}}',
      carouselPrevious: '前の項目',
      carouselNext: '次の項目',
      carouselGoToItem: '項目 {{index}} に移動',
      collapse: '折りたたむ',
      expand: '展開',
      messageHistory: 'メッセージ履歴',
      reduce: '縮小',
      today: '今日',
      at: '',
      a11yOptionsCount_zero: '{{count}}件のオプションがあります。',
      a11yOptionsCount_one: '1件のオプションがあります。',
      a11yOptionsCount_two: '{{count}}件のオプションがあります。',
      a11yOptionsCount_few: '{{count}}件のオプションがあります。',
      a11yOptionsCount_many: '{{count}}件のオプションがあります。',
      a11yOptionsCount_other: '{{count}}件のオプションがあります。',
      listpickerSelectAll: 'すべて選択',
      listpickerSelectOption: 'オプションを選択',
      listpickerSearchAriaLabel: 'フィルターオプションを検索',
      listpickerSearchPlaceholder: '検索…',
      listpickerNoResults: '一致するオプションはありません。',
      listpickerResults_zero: '{{count}}件の結果',
      listpickerResults_one: '1件の結果',
      listpickerResults_two: '{{count}}件の結果',
      listpickerResults_few: '{{count}}件の結果',
      listpickerResults_many: '{{count}}件の結果',
      listpickerResults_other: '{{count}}件の結果',
      listpickerCondensed_zero: '{{count}}件選択',
      listpickerCondensed_one: '1件選択',
      listpickerCondensed_two: '{{count}}件選択',
      listpickerCondensed_few: '{{count}}件選択',
      listpickerCondensed_many: '{{count}}件選択',
      listpickerCondensed_other: '{{count}}件選択',
      listpickerSelectAction: '選択',
      scrollToLatest: '最新のメッセージにスクロール',
      scrollToUnread_zero: '新着メッセージ{{count}}件、最新へスクロール',
      scrollToUnread_one: '新着メッセージ1件、最新へスクロール',
      scrollToUnread_two: '新着メッセージ{{count}}件、最新へスクロール',
      scrollToUnread_few: '新着メッセージ{{count}}件、最新へスクロール',
      scrollToUnread_many: '新着メッセージ{{count}}件、最新へスクロール',
      scrollToUnread_other: '新着メッセージ{{count}}件、最新へスクロール',
      showPassword: 'セキュアなコンテンツを表示',
      hidePassword: 'セキュアなコンテンツを非表示',
      clear: 'クリア',
      send: '送信',
      yesterday: '昨日',
      chatEndedActions: 'チャット終了後の操作',
      openConversationDialog: '{{title}}の会話ダイアログを開く',
      agentTyping: '担当者が入力中',
      agentAway: '現在、担当者は対応できません。',
      agentBusy: '現在、担当者は取り込み中です。少々お待ちください...',
      waitingForAgent: '担当者におつなぎしています...',
      waitingForAgentWithSkill: '{{skill}}の担当者におつなぎしています...',
      talkingWithAgent: '{{name}}と会話中',
      home: 'ホーム',
      back: '戻る',
      menu: 'メニュー',
      minimize: '最小化',
      endConversation: 'チャットを終了',
      engageWithUs: 'お問い合わせ',
      noMessagesYet: 'まだメッセージはありません',
      tryAgain: 'もう一度お試しください',
      rating: '評価',
      shareLocation: '位置情報を共有',
      locationShared: '位置情報を共有しました',
      locationError: '位置情報を取得できませんでした',
      locationPermissionDenied: '位置情報の許可が拒否されました',
      geolocationUnavailable: '位置情報サービスを利用できません',
      selectFile: 'ファイルを選択',
      upload: 'アップロード',
      uploadComplete: 'アップロード完了',
      uploadFailed: 'アップロードに失敗しました',
      fileTooLarge: 'ファイルが大きすぎます',
      dragOrClick: 'ファイルをドラッグするかクリックして選択',
      document: 'ドキュメント',
      audioContent: 'オーディオコンテンツ',
      videoContent: 'ビデオコンテンツ',
      unsupportedContent: 'サポートされていないコンテンツ',
      unavailable: {
        error: {
          title: '問題が発生しました',
          body: 'チャットを読み込めませんでした。もう一度お試しください。',
          retry: 'もう一度お試しください',
        },
        maintenance: {
          title: 'チャットは一時的に利用できません',
          body: '予定されたメンテナンスを実施しています。しばらくしてからもう一度ご確認ください。',
        },
      },
      image: '画像',
    },
  },
  {
    lang: 'ko',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: '이 대화가 종료되었습니다.',
      agentConnected: '상담원에게 연결되었습니다.',
      downloadTranscript: '대화 내용 다운로드',
      startNewConversation: '새 대화 시작',
      returnToConversation: '대화로 돌아가기',
      connecting: '연결 중...',
      retry: '다시 시도',
      network: {
        retry: '다시 연결',
      },
      reconnecting: '다시 연결 중...',
      connectionLost: '인터넷 연결이 끊겼습니다',
      reconnectDescription:
        '인터넷 연결이 끊겼습니다. 다시 연결을 클릭하여 다시 시도하세요.',
      typeMessage: '메시지 입력',
      inputSelect: '옵션 선택',
      inputSelectOrType: '옵션을 선택하거나 메시지를 입력하세요',
      secureInput: '보안 메시지 입력',
      secureValueHidden: '숨겨진 보안 값',
      startChat: '채팅 시작',
      settings: '설정',
      cancel: '취소',
      confirm: '확인',
      close: '닫기',
      next: '다음',
      brandingTagline: '지능형 AI 에이전트로 비즈니스를 강화하세요',
      poweredBy: '제공',
      pypestreamCom: 'Pypestream.com',
      assistant: '어시스턴트',
      assistantThinking: '어시스턴트가 생각 중입니다',
      youSaid: '내가 한 말',
      assistantSays: '어시스턴트가 하는 말',
      agentSays: '{{name}}님이 하는 말',
      joinMeeting: '회의 참여',
      meetingInProgress: '회의가 진행 중입니다 — 다시 참여하려면 클릭하세요',
      meetingExpired: '회의 링크(만료됨)',
      embeddedContent: '삽입된 콘텐츠',
      openInNewTab: '새 탭에서 열기',
      skipToMain: '본문으로 건너뛰기',
      loadingCustomerSolution: '{{customerName}} 솔루션 로드 중',
      loadingSolution: '솔루션 로드 중',
      customerLogoAlt: '{{customerName}} 로고',
      selectDate: '날짜 선택',
      selectTime: '시간 선택',
      browseOptions: '옵션 둘러보기',
      carouselRoleDescription: '캐러셀',
      carouselSlideLabel: '슬라이드 {{total}}개 중 {{current}}번째',
      carouselPrevious: '이전 항목',
      carouselNext: '다음 항목',
      carouselGoToItem: '{{index}}번 항목으로 이동',
      collapse: '접기',
      expand: '펼치기',
      messageHistory: '메시지 기록',
      reduce: '축소',
      today: '오늘',
      at: '',
      a11yOptionsCount_zero: '옵션이 {{count}}개 있습니다.',
      a11yOptionsCount_one: '옵션이 1개 있습니다.',
      a11yOptionsCount_two: '옵션이 {{count}}개 있습니다.',
      a11yOptionsCount_few: '옵션이 {{count}}개 있습니다.',
      a11yOptionsCount_many: '옵션이 {{count}}개 있습니다.',
      a11yOptionsCount_other: '옵션이 {{count}}개 있습니다.',
      listpickerSelectAll: '모두 선택',
      listpickerSelectOption: '옵션 선택',
      listpickerSearchAriaLabel: '필터 옵션 검색',
      listpickerSearchPlaceholder: '검색…',
      listpickerNoResults: '일치하는 옵션이 없습니다.',
      listpickerResults_zero: '결과 {{count}}개',
      listpickerResults_one: '결과 1개',
      listpickerResults_two: '결과 {{count}}개',
      listpickerResults_few: '결과 {{count}}개',
      listpickerResults_many: '결과 {{count}}개',
      listpickerResults_other: '결과 {{count}}개',
      listpickerCondensed_zero: '{{count}}개 선택됨',
      listpickerCondensed_one: '1개 선택됨',
      listpickerCondensed_two: '{{count}}개 선택됨',
      listpickerCondensed_few: '{{count}}개 선택됨',
      listpickerCondensed_many: '{{count}}개 선택됨',
      listpickerCondensed_other: '{{count}}개 선택됨',
      listpickerSelectAction: '선택',
      scrollToLatest: '최신 메시지로 스크롤',
      scrollToUnread_zero: '새 메시지 {{count}}개, 최신으로 스크롤',
      scrollToUnread_one: '새 메시지 1개, 최신으로 스크롤',
      scrollToUnread_two: '새 메시지 {{count}}개, 최신으로 스크롤',
      scrollToUnread_few: '새 메시지 {{count}}개, 최신으로 스크롤',
      scrollToUnread_many: '새 메시지 {{count}}개, 최신으로 스크롤',
      scrollToUnread_other: '새 메시지 {{count}}개, 최신으로 스크롤',
      showPassword: '보안 콘텐츠 표시',
      hidePassword: '보안 콘텐츠 숨기기',
      clear: '지우기',
      send: '보내기',
      yesterday: '어제',
      chatEndedActions: '채팅 종료 후 작업',
      openConversationDialog: '{{title}} 대화 창 열기',
      agentTyping: '상담원이 입력 중',
      agentAway: '현재 상담원이 대응할 수 없습니다.',
      agentBusy: '현재 상담원이 응대 중입니다. 잠시만 기다려 주세요...',
      waitingForAgent: '상담원에게 연결하고 있습니다...',
      waitingForAgentWithSkill: '{{skill}} 상담원에게 연결하고 있습니다...',
      talkingWithAgent: '{{name}}님과 대화 중',
      home: '홈',
      back: '뒤로',
      menu: '메뉴',
      minimize: '최소화',
      endConversation: '채팅 종료',
      engageWithUs: '문의하기',
      noMessagesYet: '아직 메시지가 없습니다',
      tryAgain: '다시 시도',
      rating: '평가',
      shareLocation: '위치 공유',
      locationShared: '위치를 공유했습니다',
      locationError: '위치를 가져올 수 없습니다',
      locationPermissionDenied: '위치 권한이 거부되었습니다',
      geolocationUnavailable: '위치 서비스를 사용할 수 없습니다',
      selectFile: '파일 선택',
      upload: '업로드',
      uploadComplete: '업로드 완료',
      uploadFailed: '업로드 실패',
      fileTooLarge: '파일이 너무 큽니다',
      dragOrClick: '파일을 끌어다 놓거나 클릭하여 선택하세요',
      document: '문서',
      audioContent: '오디오 콘텐츠',
      videoContent: '동영상 콘텐츠',
      unsupportedContent: '지원되지 않는 콘텐츠',
      unavailable: {
        error: {
          title: '문제가 발생했습니다',
          body: '채팅을 로드할 수 없습니다. 다시 시도하세요.',
          retry: '다시 시도',
        },
        maintenance: {
          title: '채팅을 일시적으로 사용할 수 없습니다',
          body: '예정된 유지관리를 진행하고 있습니다. 잠시 후 다시 확인해 주세요.',
        },
      },
      image: '이미지',
    },
  },
  {
    lang: 'lt',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Šis pokalbis baigtas.',
      agentConnected: 'Sėkmingai prisijungėte prie operatoriaus.',
      downloadTranscript: 'Atsisiųsti nuorašą',
      startNewConversation: 'Pradėti naują pokalbį',
      returnToConversation: 'Grįžti į pokalbį',
      connecting: 'Jungiamasi...',
      retry: 'Bandyti dar kartą',
      network: {
        retry: 'Prisijungti iš naujo',
      },
      reconnecting: 'Jungiamasi iš naujo...',
      connectionLost: 'Interneto ryšys nutrūko',
      reconnectDescription:
        'Interneto ryšys nutrūko. Spustelėkite „Prisijungti iš naujo“, kad bandytumėte dar kartą.',
      typeMessage: 'Įveskite žinutę',
      inputSelect: 'Pasirinkite parinktį',
      inputSelectOrType: 'Pasirinkite parinktį arba įveskite žinutę',
      secureInput: 'Įveskite saugią žinutę',
      secureValueHidden: 'Paslėpta saugi reikšmė',
      startChat: 'Pradėti pokalbį',
      settings: 'Nustatymai',
      cancel: 'Atšaukti',
      confirm: 'Patvirtinti',
      close: 'Uždaryti',
      next: 'Toliau',
      brandingTagline: 'Sustiprinkite savo verslą su išmaniaisiais DI agentais',
      poweredBy: 'Sukurta su',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asistentas',
      assistantThinking: 'Asistentas mąsto',
      youSaid: 'Jūs pasakėte',
      assistantSays: 'Asistentas sako',
      agentSays: '{{name}} sako',
      joinMeeting: 'Prisijungti prie susitikimo',
      meetingInProgress:
        'Susitikimas vyksta — spustelėkite, kad prisijungtumėte iš naujo',
      meetingExpired: 'Susitikimo nuoroda (nebegalioja)',
      embeddedContent: 'Įterptas turinys',
      openInNewTab: 'Atidaryti naujame skirtuke',
      skipToMain: 'Pereiti prie pagrindinio turinio',
      loadingCustomerSolution: 'Įkeliamas {{customerName}} sprendimas',
      loadingSolution: 'Įkeliamas sprendimas',
      customerLogoAlt: '{{customerName}} logotipas',
      selectDate: 'Pasirinkite datą',
      selectTime: 'Pasirinkite laiką',
      browseOptions: 'Naršyti parinktis',
      carouselRoleDescription: 'Karuselė',
      carouselSlideLabel: '{{current}} skaidrė iš {{total}}',
      carouselPrevious: 'Ankstesnis elementas',
      carouselNext: 'Kitas elementas',
      carouselGoToItem: 'Eiti į elementą {{index}}',
      collapse: 'Sutraukti',
      expand: 'Išskleisti',
      messageHistory: 'Žinučių istorija',
      reduce: 'Sumažinti',
      today: 'Šiandien',
      at: '',
      a11yOptionsCount_zero: 'Yra {{count}} parinkčių.',
      a11yOptionsCount_one: 'Yra 1 parinktis.',
      a11yOptionsCount_two: 'Yra {{count}} parinkčių.',
      a11yOptionsCount_few: 'Yra {{count}} parinktys.',
      a11yOptionsCount_many: 'Yra {{count}} parinkties.',
      a11yOptionsCount_other: 'Yra {{count}} parinkčių.',
      listpickerSelectAll: 'Pasirinkti viską',
      listpickerSelectOption: 'Pasirinkite parinktį',
      listpickerSearchAriaLabel: 'Ieškoti filtravimo parinkčių',
      listpickerSearchPlaceholder: 'Ieškoti…',
      listpickerNoResults: 'Nėra atitinkančių parinkčių.',
      listpickerResults_zero: '{{count}} rezultatų',
      listpickerResults_one: '1 rezultatas',
      listpickerResults_two: '{{count}} rezultatų',
      listpickerResults_few: '{{count}} rezultatai',
      listpickerResults_many: '{{count}} rezultato',
      listpickerResults_other: '{{count}} rezultatų',
      listpickerCondensed_zero: 'Pasirinkta {{count}}',
      listpickerCondensed_one: 'Pasirinkta 1',
      listpickerCondensed_two: 'Pasirinkta {{count}}',
      listpickerCondensed_few: 'Pasirinkta {{count}}',
      listpickerCondensed_many: 'Pasirinkta {{count}}',
      listpickerCondensed_other: 'Pasirinkta {{count}}',
      listpickerSelectAction: 'Pasirinkti',
      scrollToLatest: 'Slinkti į naujausią žinutę',
      scrollToUnread_zero: '{{count}} naujų žinučių, eiti į naujausią',
      scrollToUnread_one: '1 nauja žinutė, eiti į naujausią',
      scrollToUnread_two: '{{count}} naujų žinučių, eiti į naujausią',
      scrollToUnread_few: '{{count}} naujos žinutės, eiti į naujausią',
      scrollToUnread_many: '{{count}} naujos žinutės, eiti į naujausią',
      scrollToUnread_other: '{{count}} naujų žinučių, eiti į naujausią',
      showPassword: 'Rodyti saugų turinį',
      hidePassword: 'Slėpti saugų turinį',
      clear: 'Išvalyti',
      send: 'Siųsti',
      yesterday: 'Vakar',
      chatEndedActions: 'Veiksmai pasibaigus pokalbiui',
      openConversationDialog: 'Atidaryti pokalbio langą su {{title}}',
      agentTyping: 'Operatorius rašo',
      agentAway: 'Mūsų operatoriai šiuo metu nepasiekiami.',
      agentBusy: 'Mūsų operatoriai šiuo metu užimti. Palaukite...',
      waitingForAgent: 'Jungiame jus su operatoriumi...',
      waitingForAgentWithSkill: 'Jungiame jus su {{skill}} operatoriumi...',
      talkingWithAgent: 'Kalbatės su {{name}}',
      home: 'Pradžia',
      back: 'Atgal',
      menu: 'Meniu',
      minimize: 'Sumažinti',
      endConversation: 'Baigti pokalbį',
      engageWithUs: 'Susisiekite su mumis',
      noMessagesYet: 'Kol kas žinučių nėra',
      tryAgain: 'Bandyti dar kartą',
      rating: 'Įvertinimas',
      shareLocation: 'Bendrinti vietą',
      locationShared: 'Vieta bendrinama',
      locationError: 'Nepavyko nustatyti jūsų vietos',
      locationPermissionDenied: 'Vietos leidimas atmestas',
      geolocationUnavailable: 'Vietos nustatymo paslaugos nepasiekiamos',
      selectFile: 'Pasirinkite failą',
      upload: 'Įkelti',
      uploadComplete: 'Įkėlimas baigtas',
      uploadFailed: 'Įkelti nepavyko',
      fileTooLarge: 'Failas per didelis',
      dragOrClick: 'Vilkite failą arba spustelėkite norėdami pasirinkti',
      document: 'Dokumentas',
      audioContent: 'Garso turinys',
      videoContent: 'Vaizdo turinys',
      unsupportedContent: 'Nepalaikomas turinys',
      unavailable: {
        error: {
          title: 'Kažkas nepavyko',
          body: 'Nepavyko įkelti pokalbio. Bandykite dar kartą.',
          retry: 'Bandyti dar kartą',
        },
        maintenance: {
          title: 'Pokalbis laikinai nepasiekiamas',
          body: 'Atliekame suplanuotą priežiūrą. Grįžkite netrukus.',
        },
      },
      image: 'Vaizdas',
    },
  },
  {
    lang: 'lv',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Šī saruna ir beigusies.',
      agentConnected: 'Jūs esat veiksmīgi savienots ar aģentu.',
      downloadTranscript: 'Lejupielādēt sarakstu',
      startNewConversation: 'Sākt jaunu sarunu',
      returnToConversation: 'Atgriezties pie sarunas',
      connecting: 'Notiek savienošana...',
      retry: 'Mēģināt vēlreiz',
      network: {
        retry: 'Savienoties atkārtoti',
      },
      reconnecting: 'Notiek atkārtota savienošana...',
      connectionLost: 'Interneta savienojums ir zaudēts',
      reconnectDescription:
        'Interneta savienojums ir zaudēts. Noklikšķiniet uz “Savienoties atkārtoti”, lai mēģinātu vēlreiz.',
      typeMessage: 'Ierakstiet ziņojumu',
      inputSelect: 'Atlasiet opciju',
      inputSelectOrType: 'Atlasiet opciju vai ierakstiet ziņojumu',
      secureInput: 'Ierakstiet drošu ziņojumu',
      secureValueHidden: 'Slēpta droša vērtība',
      startChat: 'Sākt tērzēšanu',
      settings: 'Iestatījumi',
      cancel: 'Atcelt',
      confirm: 'Apstiprināt',
      close: 'Aizvērt',
      next: 'Tālāk',
      brandingTagline: 'Stipriniet savu uzņēmumu ar viediem MI aģentiem',
      poweredBy: 'Nodrošina',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asistents',
      assistantThinking: 'Asistents domā',
      youSaid: 'Jūs teicāt',
      assistantSays: 'Asistents saka',
      agentSays: '{{name}} saka',
      joinMeeting: 'Pievienoties sapulcei',
      meetingInProgress:
        'Sapulce norit — noklikšķiniet, lai pievienotos atkārtoti',
      meetingExpired: 'Sapulces saite (beigusies)',
      embeddedContent: 'Iegults saturs',
      openInNewTab: 'Atvērt jaunā cilnē',
      skipToMain: 'Pāriet uz galveno saturu',
      loadingCustomerSolution: 'Notiek {{customerName}} risinājuma ielāde',
      loadingSolution: 'Notiek risinājuma ielāde',
      customerLogoAlt: '{{customerName}} logotips',
      selectDate: 'Atlasiet datumu',
      selectTime: 'Atlasiet laiku',
      browseOptions: 'Pārlūkot opcijas',
      carouselRoleDescription: 'Karuselis',
      carouselSlideLabel: 'Slaids {{current}} no {{total}}',
      carouselPrevious: 'Iepriekšējais vienums',
      carouselNext: 'Nākamais vienums',
      carouselGoToItem: 'Pāriet uz vienumu {{index}}',
      collapse: 'Sakļaut',
      expand: 'Izvērst',
      messageHistory: 'Ziņojumu vēsture',
      reduce: 'Samazināt',
      today: 'Šodien',
      at: 'plkst.',
      a11yOptionsCount_zero: 'Nav opciju.',
      a11yOptionsCount_one: 'Ir {{count}} opcija.',
      a11yOptionsCount_two: 'Ir {{count}} opcijas.',
      a11yOptionsCount_few: 'Ir {{count}} opcijas.',
      a11yOptionsCount_many: 'Ir {{count}} opcijas.',
      a11yOptionsCount_other: 'Ir {{count}} opcijas.',
      listpickerSelectAll: 'Atlasīt visu',
      listpickerSelectOption: 'Atlasiet opciju',
      listpickerSearchAriaLabel: 'Meklēt filtra opcijas',
      listpickerSearchPlaceholder: 'Meklēt…',
      listpickerNoResults: 'Nav atbilstošu opciju.',
      listpickerResults_zero: '{{count}} rezultātu',
      listpickerResults_one: '{{count}} rezultāts',
      listpickerResults_two: '{{count}} rezultāti',
      listpickerResults_few: '{{count}} rezultāti',
      listpickerResults_many: '{{count}} rezultāti',
      listpickerResults_other: '{{count}} rezultāti',
      listpickerCondensed_zero: 'Atlasīti {{count}}',
      listpickerCondensed_one: 'Atlasīts {{count}}',
      listpickerCondensed_two: 'Atlasīti {{count}}',
      listpickerCondensed_few: 'Atlasīti {{count}}',
      listpickerCondensed_many: 'Atlasīti {{count}}',
      listpickerCondensed_other: 'Atlasīti {{count}}',
      listpickerSelectAction: 'Atlasīt',
      scrollToLatest: 'Ritināt uz jaunāko ziņojumu',
      scrollToUnread_zero: '{{count}} jaunu ziņojumu, uz jaunāko',
      scrollToUnread_one: '{{count}} jauns ziņojums, uz jaunāko',
      scrollToUnread_two: '{{count}} jauni ziņojumi, uz jaunāko',
      scrollToUnread_few: '{{count}} jauni ziņojumi, uz jaunāko',
      scrollToUnread_many: '{{count}} jauni ziņojumi, uz jaunāko',
      scrollToUnread_other: '{{count}} jauni ziņojumi, uz jaunāko',
      showPassword: 'Rādīt drošu saturu',
      hidePassword: 'Slēpt drošu saturu',
      clear: 'Notīrīt',
      send: 'Sūtīt',
      yesterday: 'Vakar',
      chatEndedActions: 'Darbības pēc tērzēšanas beigām',
      openConversationDialog: 'Atvērt sarunas logu ar {{title}}',
      agentTyping: 'Aģents raksta',
      agentAway: 'Mūsu aģenti pašlaik nav pieejami.',
      agentBusy: 'Mūsu aģenti pašlaik ir aizņemti. Lūdzu, uzgaidiet...',
      waitingForAgent: 'Savienojam jūs ar aģentu...',
      waitingForAgentWithSkill: 'Savienojam jūs ar {{skill}} aģentu...',
      talkingWithAgent: 'Saruna ar {{name}}',
      home: 'Sākums',
      back: 'Atpakaļ',
      menu: 'Izvēlne',
      minimize: 'Minimizēt',
      endConversation: 'Beigt tērzēšanu',
      engageWithUs: 'Sazinieties ar mums',
      noMessagesYet: 'Vēl nav ziņojumu',
      tryAgain: 'Mēģināt vēlreiz',
      rating: 'Vērtējums',
      shareLocation: 'Kopīgot atrašanās vietu',
      locationShared: 'Atrašanās vieta kopīgota',
      locationError: 'Neizdevās iegūt jūsu atrašanās vietu',
      locationPermissionDenied: 'Atrašanās vietas atļauja noraidīta',
      geolocationUnavailable: 'Atrašanās vietas pakalpojumi nav pieejami',
      selectFile: 'Atlasiet failu',
      upload: 'Augšupielādēt',
      uploadComplete: 'Augšupielāde pabeigta',
      uploadFailed: 'Augšupielāde neizdevās',
      fileTooLarge: 'Fails ir pārāk liels',
      dragOrClick: 'Velciet failu vai noklikšķiniet, lai izvēlētos',
      document: 'Dokuments',
      audioContent: 'Audio saturs',
      videoContent: 'Video saturs',
      unsupportedContent: 'Neatbalstīts saturs',
      unavailable: {
        error: {
          title: 'Radās kļūda',
          body: 'Neizdevās ielādēt tērzēšanu. Lūdzu, mēģiniet vēlreiz.',
          retry: 'Mēģināt vēlreiz',
        },
        maintenance: {
          title: 'Tērzēšana īslaicīgi nav pieejama',
          body: 'Mēs veicam plānotu apkopi. Lūdzu, atgriezieties drīz.',
        },
      },
      image: 'Attēls',
    },
  },
  {
    lang: 'mk',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Овој разговор заврши.',
      agentConnected: 'Успешно сте поврзани со агент.',
      downloadTranscript: 'Преземи транскрипт',
      startNewConversation: 'Започни нов разговор',
      returnToConversation: 'Назад кон разговорот',
      connecting: 'Поврзување...',
      retry: 'Обиди се повторно',
      network: {
        retry: 'Поврзи се повторно',
      },
      reconnecting: 'Повторно поврзување...',
      connectionLost: 'Врската со интернет е изгубена',
      reconnectDescription:
        'Врската со интернет е изгубена. Кликнете на „Поврзи се повторно“ за да се обидете повторно.',
      typeMessage: 'Напишете порака',
      inputSelect: 'Изберете опција',
      inputSelectOrType: 'Изберете опција или напишете порака',
      secureInput: 'Напишете безбедна порака',
      secureValueHidden: 'Скриена безбедна вредност',
      startChat: 'Започни разговор',
      settings: 'Поставки',
      cancel: 'Откажи',
      confirm: 'Потврди',
      close: 'Затвори',
      next: 'Следно',
      brandingTagline:
        'Зајакнете го вашиот бизнис со интелигентни агенти со ВИ',
      poweredBy: 'Овозможено од',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Асистент',
      assistantThinking: 'Асистентот размислува',
      youSaid: 'Рековте',
      assistantSays: 'Асистентот вели',
      agentSays: '{{name}} вели',
      joinMeeting: 'Приклучи се на состанокот',
      meetingInProgress:
        'Состанокот е во тек — кликнете за повторно приклучување',
      meetingExpired: 'Врска до состанок (истечена)',
      embeddedContent: 'Вградена содржина',
      openInNewTab: 'Отвори во ново јазиче',
      skipToMain: 'Прескокни до главната содржина',
      loadingCustomerSolution: 'Се вчитува решението на {{customerName}}',
      loadingSolution: 'Се вчитува решението',
      customerLogoAlt: 'Лого на {{customerName}}',
      selectDate: 'Изберете датум',
      selectTime: 'Изберете време',
      browseOptions: 'Прегледај опции',
      carouselRoleDescription: 'Ротатор',
      carouselSlideLabel: 'Слајд {{current}} од {{total}}',
      carouselPrevious: 'Претходна ставка',
      carouselNext: 'Следна ставка',
      carouselGoToItem: 'Оди на ставка {{index}}',
      collapse: 'Собери',
      expand: 'Прошири',
      messageHistory: 'Историја на пораки',
      reduce: 'Намали',
      today: 'Денес',
      at: 'во',
      a11yOptionsCount_zero: 'Има {{count}} опции.',
      a11yOptionsCount_one: 'Има 1 опција.',
      a11yOptionsCount_two: 'Има {{count}} опции.',
      a11yOptionsCount_few: 'Има {{count}} опции.',
      a11yOptionsCount_many: 'Има {{count}} опции.',
      a11yOptionsCount_other: 'Има {{count}} опции.',
      listpickerSelectAll: 'Избери сè',
      listpickerSelectOption: 'Изберете опција',
      listpickerSearchAriaLabel: 'Пребарај опции за филтрирање',
      listpickerSearchPlaceholder: 'Пребарај…',
      listpickerNoResults: 'Нема совпаѓачки опции.',
      listpickerResults_zero: '{{count}} резултати',
      listpickerResults_one: '1 резултат',
      listpickerResults_two: '{{count}} резултати',
      listpickerResults_few: '{{count}} резултати',
      listpickerResults_many: '{{count}} резултати',
      listpickerResults_other: '{{count}} резултати',
      listpickerCondensed_zero: '{{count}} избрани',
      listpickerCondensed_one: '1 избрана',
      listpickerCondensed_two: '{{count}} избрани',
      listpickerCondensed_few: '{{count}} избрани',
      listpickerCondensed_many: '{{count}} избрани',
      listpickerCondensed_other: '{{count}} избрани',
      listpickerSelectAction: 'Избери',
      scrollToLatest: 'Кон најновата порака',
      scrollToUnread_zero: '{{count}} нови пораки, кон најновата',
      scrollToUnread_one: '1 нова порака, кон најновата',
      scrollToUnread_two: '{{count}} нови пораки, кон најновата',
      scrollToUnread_few: '{{count}} нови пораки, кон најновата',
      scrollToUnread_many: '{{count}} нови пораки, кон најновата',
      scrollToUnread_other: '{{count}} нови пораки, кон најновата',
      showPassword: 'Прикажи безбедна содржина',
      hidePassword: 'Скриј безбедна содржина',
      clear: 'Исчисти',
      send: 'Испрати',
      yesterday: 'Вчера',
      chatEndedActions: 'Дејства по завршување на разговорот',
      openConversationDialog: 'Отвори прозорец за разговор со {{title}}',
      agentTyping: 'Агентот пишува',
      agentAway: 'Нашите агенти во моментов не се достапни.',
      agentBusy:
        'Нашите агенти во моментов се зафатени. Ве молиме почекајте...',
      waitingForAgent: 'Ве поврзуваме со агент...',
      waitingForAgentWithSkill: 'Ве поврзуваме со агент за {{skill}}...',
      talkingWithAgent: 'Разговор со {{name}}',
      home: 'Почетна',
      back: 'Назад',
      menu: 'Мени',
      minimize: 'Минимизирај',
      endConversation: 'Заврши разговор',
      engageWithUs: 'Контактирајте нè',
      noMessagesYet: 'Сè уште нема пораки',
      tryAgain: 'Обиди се повторно',
      rating: 'Оцена',
      shareLocation: 'Сподели локација',
      locationShared: 'Локацијата е споделена',
      locationError: 'Не може да се добие вашата локација',
      locationPermissionDenied: 'Дозволата за локација е одбиена',
      geolocationUnavailable: 'Услугите за локација не се достапни',
      selectFile: 'Изберете датотека',
      upload: 'Прикачи',
      uploadComplete: 'Прикачувањето заврши',
      uploadFailed: 'Прикачувањето не успеа',
      fileTooLarge: 'Датотеката е преголема',
      dragOrClick: 'Влечете датотека или кликнете за избор',
      document: 'Документ',
      audioContent: 'Аудио содржина',
      videoContent: 'Видео содржина',
      unsupportedContent: 'Неподдржана содржина',
      unavailable: {
        error: {
          title: 'Нешто тргна наопаку',
          body: 'Не можевме да го вчитаме разговорот. Обидете се повторно.',
          retry: 'Обиди се повторно',
        },
        maintenance: {
          title: 'Разговорот е привремено недостапен',
          body: 'Спроведуваме планирано одржување. Вратете се наскоро.',
        },
      },
      image: 'Слика',
    },
  },
  {
    lang: 'ms',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Perbualan ini telah tamat.',
      agentConnected: 'Anda telah berjaya disambungkan kepada ejen.',
      downloadTranscript: 'Muat turun transkrip',
      startNewConversation: 'Mulakan perbualan baharu',
      returnToConversation: 'Kembali ke perbualan',
      connecting: 'Menyambung...',
      retry: 'Cuba lagi',
      network: {
        retry: 'Sambung semula',
      },
      reconnecting: 'Menyambung semula...',
      connectionLost: 'Sambungan internet terputus',
      reconnectDescription:
        'Sambungan internet terputus. Klik Sambung semula untuk mencuba lagi.',
      typeMessage: 'Taip mesej',
      inputSelect: 'Pilih pilihan',
      inputSelectOrType: 'Pilih pilihan atau taip mesej',
      secureInput: 'Taip mesej selamat',
      secureValueHidden: 'Nilai selamat tersembunyi',
      startChat: 'Mulakan sembang',
      settings: 'Tetapan',
      cancel: 'Batal',
      confirm: 'Sahkan',
      close: 'Tutup',
      next: 'Seterusnya',
      brandingTagline: 'Perkasakan perniagaan anda dengan ejen AI pintar',
      poweredBy: 'Dikuasakan oleh',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Pembantu',
      assistantThinking: 'Pembantu sedang berfikir',
      youSaid: 'Anda berkata',
      assistantSays: 'Pembantu berkata',
      agentSays: '{{name}} berkata',
      joinMeeting: 'Sertai mesyuarat',
      meetingInProgress:
        'Mesyuarat sedang berlangsung — klik untuk menyertai semula',
      meetingExpired: 'Pautan mesyuarat (tamat tempoh)',
      embeddedContent: 'Kandungan terbenam',
      openInNewTab: 'Buka dalam tab baharu',
      skipToMain: 'Langkau ke kandungan utama',
      loadingCustomerSolution: 'Memuatkan penyelesaian {{customerName}}',
      loadingSolution: 'Memuatkan penyelesaian',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Pilih tarikh',
      selectTime: 'Pilih masa',
      browseOptions: 'Semak imbas pilihan',
      carouselRoleDescription: 'Karusel',
      carouselSlideLabel: 'Slaid {{current}} daripada {{total}}',
      carouselPrevious: 'Item sebelumnya',
      carouselNext: 'Item seterusnya',
      carouselGoToItem: 'Pergi ke item {{index}}',
      collapse: 'Runtuhkan',
      expand: 'Kembangkan',
      messageHistory: 'Sejarah mesej',
      reduce: 'Kecilkan',
      today: 'Hari ini',
      at: 'pada',
      a11yOptionsCount_zero: 'Terdapat {{count}} pilihan.',
      a11yOptionsCount_one: 'Terdapat 1 pilihan.',
      a11yOptionsCount_two: 'Terdapat {{count}} pilihan.',
      a11yOptionsCount_few: 'Terdapat {{count}} pilihan.',
      a11yOptionsCount_many: 'Terdapat {{count}} pilihan.',
      a11yOptionsCount_other: 'Terdapat {{count}} pilihan.',
      listpickerSelectAll: 'Pilih semua',
      listpickerSelectOption: 'Pilih pilihan',
      listpickerSearchAriaLabel: 'Cari pilihan penapis',
      listpickerSearchPlaceholder: 'Cari…',
      listpickerNoResults: 'Tiada pilihan yang sepadan.',
      listpickerResults_zero: '{{count}} hasil',
      listpickerResults_one: '1 hasil',
      listpickerResults_two: '{{count}} hasil',
      listpickerResults_few: '{{count}} hasil',
      listpickerResults_many: '{{count}} hasil',
      listpickerResults_other: '{{count}} hasil',
      listpickerCondensed_zero: '{{count}} dipilih',
      listpickerCondensed_one: '1 dipilih',
      listpickerCondensed_two: '{{count}} dipilih',
      listpickerCondensed_few: '{{count}} dipilih',
      listpickerCondensed_many: '{{count}} dipilih',
      listpickerCondensed_other: '{{count}} dipilih',
      listpickerSelectAction: 'Pilih',
      scrollToLatest: 'Tatal ke mesej terkini',
      scrollToUnread_zero: '{{count}} mesej baharu, tatal ke terkini',
      scrollToUnread_one: '1 mesej baharu, tatal ke terkini',
      scrollToUnread_two: '{{count}} mesej baharu, tatal ke terkini',
      scrollToUnread_few: '{{count}} mesej baharu, tatal ke terkini',
      scrollToUnread_many: '{{count}} mesej baharu, tatal ke terkini',
      scrollToUnread_other: '{{count}} mesej baharu, tatal ke terkini',
      showPassword: 'Tunjukkan kandungan selamat',
      hidePassword: 'Sembunyikan kandungan selamat',
      clear: 'Kosongkan',
      send: 'Hantar',
      yesterday: 'Semalam',
      chatEndedActions: 'Tindakan selepas sembang tamat',
      openConversationDialog: 'Buka dialog perbualan dengan {{title}}',
      agentTyping: 'Ejen sedang menaip',
      agentAway: 'Ejen kami tidak tersedia buat masa ini.',
      agentBusy: 'Ejen kami sibuk buat masa ini. Sila tunggu...',
      waitingForAgent: 'Menyambungkan anda kepada ejen...',
      waitingForAgentWithSkill: 'Menyambungkan anda kepada ejen {{skill}}...',
      talkingWithAgent: 'Bercakap dengan {{name}}',
      home: 'Laman utama',
      back: 'Kembali',
      menu: 'Menu',
      minimize: 'Minimumkan',
      endConversation: 'Tamatkan sembang',
      engageWithUs: 'Hubungi kami',
      noMessagesYet: 'Belum ada mesej',
      tryAgain: 'Cuba lagi',
      rating: 'Penilaian',
      shareLocation: 'Kongsi lokasi',
      locationShared: 'Lokasi dikongsi',
      locationError: 'Tidak dapat mendapatkan lokasi anda',
      locationPermissionDenied: 'Kebenaran lokasi ditolak',
      geolocationUnavailable: 'Perkhidmatan lokasi tidak tersedia',
      selectFile: 'Pilih fail',
      upload: 'Muat naik',
      uploadComplete: 'Muat naik selesai',
      uploadFailed: 'Muat naik gagal',
      fileTooLarge: 'Fail terlalu besar',
      dragOrClick: 'Seret fail atau klik untuk memilih',
      document: 'Dokumen',
      audioContent: 'Kandungan audio',
      videoContent: 'Kandungan video',
      unsupportedContent: 'Kandungan tidak disokong',
      unavailable: {
        error: {
          title: 'Sesuatu tidak kena',
          body: 'Kami tidak dapat memuatkan sembang. Sila cuba lagi.',
          retry: 'Cuba lagi',
        },
        maintenance: {
          title: 'Sembang tidak tersedia buat sementara waktu',
          body: 'Kami sedang menjalankan penyelenggaraan berjadual. Sila kembali sebentar lagi.',
        },
      },
      image: 'Imej',
    },
  },
  {
    lang: 'nl',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Dit gesprek is beëindigd.',
      agentConnected: 'Je bent verbonden met een medewerker.',
      downloadTranscript: 'Transcript downloaden',
      startNewConversation: 'Nieuw gesprek starten',
      returnToConversation: 'Terug naar het gesprek',
      connecting: 'Verbinden...',
      retry: 'Opnieuw proberen',
      network: {
        retry: 'Opnieuw verbinden',
      },
      reconnecting: 'Opnieuw verbinden...',
      connectionLost: 'De internetverbinding is verbroken',
      reconnectDescription:
        'De internetverbinding is verbroken. Klik op Opnieuw verbinden om het opnieuw te proberen.',
      typeMessage: 'Typ een bericht',
      inputSelect: 'Selecteer een optie',
      inputSelectOrType: 'Selecteer een optie of typ een bericht',
      secureInput: 'Typ een beveiligd bericht',
      secureValueHidden: 'Verborgen beveiligde waarde',
      startChat: 'Chat starten',
      settings: 'Instellingen',
      cancel: 'Annuleren',
      confirm: 'Bevestigen',
      close: 'Sluiten',
      next: 'Volgende',
      brandingTagline: 'Geef je bedrijf een boost met intelligente AI-agents',
      poweredBy: 'Mogelijk gemaakt door',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistent',
      assistantThinking: 'De assistent denkt na',
      youSaid: 'Je zei',
      assistantSays: 'De assistent zegt',
      agentSays: '{{name}} zegt',
      joinMeeting: 'Deelnemen aan vergadering',
      meetingInProgress: 'Vergadering bezig — klik om opnieuw deel te nemen',
      meetingExpired: 'Vergaderlink (verlopen)',
      embeddedContent: 'Ingesloten inhoud',
      openInNewTab: 'Openen in nieuw tabblad',
      skipToMain: 'Ga naar hoofdinhoud',
      loadingCustomerSolution: 'Oplossing van {{customerName}} laden',
      loadingSolution: 'Oplossing laden',
      customerLogoAlt: 'Logo van {{customerName}}',
      selectDate: 'Datum selecteren',
      selectTime: 'Tijd selecteren',
      browseOptions: 'Opties bekijken',
      carouselRoleDescription: 'Carrousel',
      carouselSlideLabel: 'Dia {{current}} van {{total}}',
      carouselPrevious: 'Vorig item',
      carouselNext: 'Volgend item',
      carouselGoToItem: 'Ga naar item {{index}}',
      collapse: 'Samenvouwen',
      expand: 'Uitvouwen',
      messageHistory: 'Berichtgeschiedenis',
      reduce: 'Verkleinen',
      today: 'Vandaag',
      at: 'om',
      a11yOptionsCount_zero: 'Er zijn {{count}} opties.',
      a11yOptionsCount_one: 'Er is 1 optie.',
      a11yOptionsCount_two: 'Er zijn {{count}} opties.',
      a11yOptionsCount_few: 'Er zijn {{count}} opties.',
      a11yOptionsCount_many: 'Er zijn {{count}} opties.',
      a11yOptionsCount_other: 'Er zijn {{count}} opties.',
      listpickerSelectAll: 'Alles selecteren',
      listpickerSelectOption: 'Selecteer een optie',
      listpickerSearchAriaLabel: 'Zoeken naar filteropties',
      listpickerSearchPlaceholder: 'Zoeken…',
      listpickerNoResults: 'Geen overeenkomende opties.',
      listpickerResults_zero: '{{count}} resultaten',
      listpickerResults_one: '1 resultaat',
      listpickerResults_two: '{{count}} resultaten',
      listpickerResults_few: '{{count}} resultaten',
      listpickerResults_many: '{{count}} resultaten',
      listpickerResults_other: '{{count}} resultaten',
      listpickerCondensed_zero: '{{count}} geselecteerd',
      listpickerCondensed_one: '1 geselecteerd',
      listpickerCondensed_two: '{{count}} geselecteerd',
      listpickerCondensed_few: '{{count}} geselecteerd',
      listpickerCondensed_many: '{{count}} geselecteerd',
      listpickerCondensed_other: '{{count}} geselecteerd',
      listpickerSelectAction: 'Selecteren',
      scrollToLatest: 'Naar het nieuwste bericht scrollen',
      scrollToUnread_zero: '{{count}} nieuwe berichten, naar het nieuwste',
      scrollToUnread_one: '1 nieuw bericht, naar het nieuwste',
      scrollToUnread_two: '{{count}} nieuwe berichten, naar het nieuwste',
      scrollToUnread_few: '{{count}} nieuwe berichten, naar het nieuwste',
      scrollToUnread_many: '{{count}} nieuwe berichten, naar het nieuwste',
      scrollToUnread_other: '{{count}} nieuwe berichten, naar het nieuwste',
      showPassword: 'Beveiligde inhoud tonen',
      hidePassword: 'Beveiligde inhoud verbergen',
      clear: 'Wissen',
      send: 'Verzenden',
      yesterday: 'Gisteren',
      chatEndedActions: 'Acties na afloop van de chat',
      openConversationDialog: 'Gespreksvenster openen met {{title}}',
      agentTyping: 'De medewerker typt',
      agentAway: 'Onze medewerkers zijn momenteel niet beschikbaar.',
      agentBusy: 'Onze medewerkers zijn momenteel bezet. Even geduld...',
      waitingForAgent: 'Je wordt verbonden met een medewerker...',
      waitingForAgentWithSkill:
        'Je wordt verbonden met een medewerker voor {{skill}}...',
      talkingWithAgent: 'In gesprek met {{name}}',
      home: 'Home',
      back: 'Terug',
      menu: 'Menu',
      minimize: 'Minimaliseren',
      endConversation: 'Chat beëindigen',
      engageWithUs: 'Neem contact met ons op',
      noMessagesYet: 'Nog geen berichten',
      tryAgain: 'Opnieuw proberen',
      rating: 'Beoordeling',
      shareLocation: 'Locatie delen',
      locationShared: 'Locatie gedeeld',
      locationError: 'Je locatie kan niet worden opgehaald',
      locationPermissionDenied: 'Locatietoestemming geweigerd',
      geolocationUnavailable: 'Locatievoorzieningen zijn niet beschikbaar',
      selectFile: 'Selecteer een bestand',
      upload: 'Uploaden',
      uploadComplete: 'Upload voltooid',
      uploadFailed: 'Uploaden mislukt',
      fileTooLarge: 'Bestand is te groot',
      dragOrClick: 'Sleep een bestand of klik om te kiezen',
      document: 'Document',
      audioContent: 'Audio-inhoud',
      videoContent: 'Video-inhoud',
      unsupportedContent: 'Niet-ondersteunde inhoud',
      unavailable: {
        error: {
          title: 'Er is iets misgegaan',
          body: 'We konden de chat niet laden. Probeer het opnieuw.',
          retry: 'Opnieuw proberen',
        },
        maintenance: {
          title: 'Chat is tijdelijk niet beschikbaar',
          body: 'We voeren gepland onderhoud uit. Kom binnenkort terug.',
        },
      },
      image: 'Afbeelding',
    },
  },
  {
    lang: 'no',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Denne samtalen er avsluttet.',
      agentConnected: 'Du er koblet til en kundebehandler.',
      downloadTranscript: 'Last ned utskrift',
      startNewConversation: 'Start ny samtale',
      returnToConversation: 'Tilbake til samtalen',
      connecting: 'Kobler til...',
      retry: 'Prøv igjen',
      network: {
        retry: 'Koble til på nytt',
      },
      reconnecting: 'Kobler til på nytt...',
      connectionLost: 'Internettforbindelsen er brutt',
      reconnectDescription:
        'Internettforbindelsen er brutt. Klikk på Koble til på nytt for å prøve igjen.',
      typeMessage: 'Skriv en melding',
      inputSelect: 'Velg et alternativ',
      inputSelectOrType: 'Velg et alternativ eller skriv en melding',
      secureInput: 'Skriv en sikker melding',
      secureValueHidden: 'Skjult sikker verdi',
      startChat: 'Start chat',
      settings: 'Innstillinger',
      cancel: 'Avbryt',
      confirm: 'Bekreft',
      close: 'Lukk',
      next: 'Neste',
      brandingTagline:
        'Gi virksomheten din et løft med intelligente AI-agenter',
      poweredBy: 'Drevet av',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistent',
      assistantThinking: 'Assistenten tenker',
      youSaid: 'Du sa',
      assistantSays: 'Assistenten sier',
      agentSays: '{{name}} sier',
      joinMeeting: 'Bli med i møte',
      meetingInProgress: 'Møte pågår — klikk for å bli med igjen',
      meetingExpired: 'Møtelenke (utløpt)',
      embeddedContent: 'Innebygd innhold',
      openInNewTab: 'Åpne i ny fane',
      skipToMain: 'Hopp til hovedinnhold',
      loadingCustomerSolution: 'Laster inn {{customerName}}-løsning',
      loadingSolution: 'Laster inn løsning',
      customerLogoAlt: '{{customerName}}-logo',
      selectDate: 'Velg dato',
      selectTime: 'Velg tidspunkt',
      browseOptions: 'Bla gjennom alternativer',
      carouselRoleDescription: 'Karusell',
      carouselSlideLabel: 'Lysbilde {{current}} av {{total}}',
      carouselPrevious: 'Forrige element',
      carouselNext: 'Neste element',
      carouselGoToItem: 'Gå til element {{index}}',
      collapse: 'Skjul',
      expand: 'Utvid',
      messageHistory: 'Meldingshistorikk',
      reduce: 'Forminsk',
      today: 'I dag',
      at: 'kl.',
      a11yOptionsCount_zero: 'Det er {{count}} alternativer.',
      a11yOptionsCount_one: 'Det er 1 alternativ.',
      a11yOptionsCount_two: 'Det er {{count}} alternativer.',
      a11yOptionsCount_few: 'Det er {{count}} alternativer.',
      a11yOptionsCount_many: 'Det er {{count}} alternativer.',
      a11yOptionsCount_other: 'Det er {{count}} alternativer.',
      listpickerSelectAll: 'Velg alle',
      listpickerSelectOption: 'Velg et alternativ',
      listpickerSearchAriaLabel: 'Søk etter filteralternativer',
      listpickerSearchPlaceholder: 'Søk…',
      listpickerNoResults: 'Ingen samsvarende alternativer.',
      listpickerResults_zero: '{{count}} resultater',
      listpickerResults_one: '1 resultat',
      listpickerResults_two: '{{count}} resultater',
      listpickerResults_few: '{{count}} resultater',
      listpickerResults_many: '{{count}} resultater',
      listpickerResults_other: '{{count}} resultater',
      listpickerCondensed_zero: '{{count}} valgt',
      listpickerCondensed_one: '1 valgt',
      listpickerCondensed_two: '{{count}} valgt',
      listpickerCondensed_few: '{{count}} valgt',
      listpickerCondensed_many: '{{count}} valgt',
      listpickerCondensed_other: '{{count}} valgt',
      listpickerSelectAction: 'Velg',
      scrollToLatest: 'Bla til den nyeste meldingen',
      scrollToUnread_zero: '{{count}} nye meldinger, gå til nyeste',
      scrollToUnread_one: '1 ny melding, gå til nyeste',
      scrollToUnread_two: '{{count}} nye meldinger, gå til nyeste',
      scrollToUnread_few: '{{count}} nye meldinger, gå til nyeste',
      scrollToUnread_many: '{{count}} nye meldinger, gå til nyeste',
      scrollToUnread_other: '{{count}} nye meldinger, gå til nyeste',
      showPassword: 'Vis sikkert innhold',
      hidePassword: 'Skjul sikkert innhold',
      clear: 'Tøm',
      send: 'Send',
      yesterday: 'I går',
      chatEndedActions: 'Handlinger etter avsluttet chat',
      openConversationDialog: 'Åpne samtalevindu med {{title}}',
      agentTyping: 'Kundebehandleren skriver',
      agentAway: 'Kundebehandlerne våre er utilgjengelige for øyeblikket.',
      agentBusy:
        'Kundebehandlerne våre er opptatt for øyeblikket. Vennligst vent...',
      waitingForAgent: 'Du kobles til en kundebehandler...',
      waitingForAgentWithSkill:
        'Du kobles til en kundebehandler for {{skill}}...',
      talkingWithAgent: 'Snakker med {{name}}',
      home: 'Hjem',
      back: 'Tilbake',
      menu: 'Meny',
      minimize: 'Minimer',
      endConversation: 'Avslutt chat',
      engageWithUs: 'Kontakt oss',
      noMessagesYet: 'Ingen meldinger ennå',
      tryAgain: 'Prøv igjen',
      rating: 'Vurdering',
      shareLocation: 'Del posisjon',
      locationShared: 'Posisjon delt',
      locationError: 'Kunne ikke hente posisjonen din',
      locationPermissionDenied: 'Posisjonstillatelse avslått',
      geolocationUnavailable: 'Posisjonstjenester er ikke tilgjengelige',
      selectFile: 'Velg en fil',
      upload: 'Last opp',
      uploadComplete: 'Opplasting fullført',
      uploadFailed: 'Opplastingen mislyktes',
      fileTooLarge: 'Filen er for stor',
      dragOrClick: 'Dra en fil eller klikk for å velge',
      document: 'Dokument',
      audioContent: 'Lydinnhold',
      videoContent: 'Videoinnhold',
      unsupportedContent: 'Innhold som ikke støttes',
      unavailable: {
        error: {
          title: 'Noe gikk galt',
          body: 'Vi kunne ikke laste inn chatten. Prøv igjen.',
          retry: 'Prøv igjen',
        },
        maintenance: {
          title: 'Chatten er midlertidig utilgjengelig',
          body: 'Vi utfører planlagt vedlikehold. Kom tilbake snart.',
        },
      },
      image: 'Bilde',
    },
  },
  {
    lang: 'pl',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Ta rozmowa została zakończona.',
      agentConnected: 'Zostałeś połączony z konsultantem.',
      downloadTranscript: 'Pobierz transkrypcję',
      startNewConversation: 'Rozpocznij nową rozmowę',
      returnToConversation: 'Wróć do rozmowy',
      connecting: 'Łączenie...',
      retry: 'Ponów',
      network: {
        retry: 'Połącz ponownie',
      },
      reconnecting: 'Ponowne łączenie...',
      connectionLost: 'Utracono połączenie z internetem',
      reconnectDescription:
        'Utracono połączenie z internetem. Kliknij „Połącz ponownie”, aby spróbować jeszcze raz.',
      typeMessage: 'Wpisz wiadomość',
      inputSelect: 'Wybierz opcję',
      inputSelectOrType: 'Wybierz opcję lub wpisz wiadomość',
      secureInput: 'Wpisz bezpieczną wiadomość',
      secureValueHidden: 'Ukryta bezpieczna wartość',
      startChat: 'Rozpocznij czat',
      settings: 'Ustawienia',
      cancel: 'Anuluj',
      confirm: 'Potwierdź',
      close: 'Zamknij',
      next: 'Dalej',
      brandingTagline: 'Wzmocnij swoją firmę dzięki inteligentnym agentom AI',
      poweredBy: 'Obsługiwane przez',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asystent',
      assistantThinking: 'Asystent myśli',
      youSaid: 'Powiedziałeś',
      assistantSays: 'Asystent mówi',
      agentSays: '{{name}} mówi',
      joinMeeting: 'Dołącz do spotkania',
      meetingInProgress: 'Spotkanie w toku — kliknij, aby dołączyć ponownie',
      meetingExpired: 'Link do spotkania (wygasł)',
      embeddedContent: 'Osadzona treść',
      openInNewTab: 'Otwórz w nowej karcie',
      skipToMain: 'Przejdź do treści głównej',
      loadingCustomerSolution: 'Wczytywanie rozwiązania {{customerName}}',
      loadingSolution: 'Wczytywanie rozwiązania',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Wybierz datę',
      selectTime: 'Wybierz godzinę',
      browseOptions: 'Przeglądaj opcje',
      carouselRoleDescription: 'Karuzela',
      carouselSlideLabel: 'Slajd {{current}} z {{total}}',
      carouselPrevious: 'Poprzedni element',
      carouselNext: 'Następny element',
      carouselGoToItem: 'Przejdź do elementu {{index}}',
      collapse: 'Zwiń',
      expand: 'Rozwiń',
      messageHistory: 'Historia wiadomości',
      reduce: 'Zmniejsz',
      today: 'Dzisiaj',
      at: 'o',
      a11yOptionsCount_zero: 'Jest {{count}} opcji.',
      a11yOptionsCount_one: 'Jest 1 opcja.',
      a11yOptionsCount_two: 'Jest {{count}} opcji.',
      a11yOptionsCount_few: 'Są {{count}} opcje.',
      a11yOptionsCount_many: 'Jest {{count}} opcji.',
      a11yOptionsCount_other: 'Jest {{count}} opcji.',
      listpickerSelectAll: 'Zaznacz wszystko',
      listpickerSelectOption: 'Wybierz opcję',
      listpickerSearchAriaLabel: 'Szukaj opcji filtrowania',
      listpickerSearchPlaceholder: 'Szukaj…',
      listpickerNoResults: 'Brak pasujących opcji.',
      listpickerResults_zero: '{{count}} wyniku',
      listpickerResults_one: '1 wynik',
      listpickerResults_two: '{{count}} wyniku',
      listpickerResults_few: '{{count}} wyniki',
      listpickerResults_many: '{{count}} wyników',
      listpickerResults_other: '{{count}} wyniku',
      listpickerCondensed_zero: 'Wybrano {{count}}',
      listpickerCondensed_one: 'Wybrano 1',
      listpickerCondensed_two: 'Wybrano {{count}}',
      listpickerCondensed_few: 'Wybrano {{count}}',
      listpickerCondensed_many: 'Wybrano {{count}}',
      listpickerCondensed_other: 'Wybrano {{count}}',
      listpickerSelectAction: 'Wybierz',
      scrollToLatest: 'Przewiń do najnowszej wiadomości',
      scrollToUnread_zero: '{{count}} nowych wiadomości, przejdź do najnowszej',
      scrollToUnread_one: '1 nowa wiadomość, przejdź do najnowszej',
      scrollToUnread_two: '{{count}} nowych wiadomości, przejdź do najnowszej',
      scrollToUnread_few: '{{count}} nowe wiadomości, przejdź do najnowszej',
      scrollToUnread_many: '{{count}} nowych wiadomości, przejdź do najnowszej',
      scrollToUnread_other:
        '{{count}} nowych wiadomości, przejdź do najnowszej',
      showPassword: 'Pokaż bezpieczną treść',
      hidePassword: 'Ukryj bezpieczną treść',
      clear: 'Wyczyść',
      send: 'Wyślij',
      yesterday: 'Wczoraj',
      chatEndedActions: 'Działania po zakończeniu czatu',
      openConversationDialog: 'Otwórz okno rozmowy z {{title}}',
      agentTyping: 'Konsultant pisze',
      agentAway: 'Nasi konsultanci są obecnie niedostępni.',
      agentBusy: 'Nasi konsultanci są obecnie zajęci. Prosimy o cierpliwość...',
      waitingForAgent: 'Łączymy Cię z konsultantem...',
      waitingForAgentWithSkill: 'Łączymy Cię z konsultantem ds. {{skill}}...',
      talkingWithAgent: 'Rozmowa z {{name}}',
      home: 'Strona główna',
      back: 'Wstecz',
      menu: 'Menu',
      minimize: 'Minimalizuj',
      endConversation: 'Zakończ czat',
      engageWithUs: 'Skontaktuj się z nami',
      noMessagesYet: 'Brak wiadomości',
      tryAgain: 'Spróbuj ponownie',
      rating: 'Ocena',
      shareLocation: 'Udostępnij lokalizację',
      locationShared: 'Lokalizacja udostępniona',
      locationError: 'Nie udało się pobrać Twojej lokalizacji',
      locationPermissionDenied: 'Odmówiono dostępu do lokalizacji',
      geolocationUnavailable: 'Usługi lokalizacji są niedostępne',
      selectFile: 'Wybierz plik',
      upload: 'Prześlij',
      uploadComplete: 'Przesyłanie zakończone',
      uploadFailed: 'Przesyłanie nie powiodło się',
      fileTooLarge: 'Plik jest za duży',
      dragOrClick: 'Przeciągnij plik lub kliknij, aby wybrać',
      document: 'Dokument',
      audioContent: 'Treść audio',
      videoContent: 'Treść wideo',
      unsupportedContent: 'Nieobsługiwana treść',
      unavailable: {
        error: {
          title: 'Coś poszło nie tak',
          body: 'Nie udało się wczytać czatu. Spróbuj ponownie.',
          retry: 'Spróbuj ponownie',
        },
        maintenance: {
          title: 'Czat jest tymczasowo niedostępny',
          body: 'Przeprowadzamy zaplanowaną konserwację. Wróć wkrótce.',
        },
      },
      image: 'Obraz',
    },
  },
  {
    lang: 'pt',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Esta conversa foi encerrada.',
      agentConnected: 'Você foi conectado com sucesso a um atendente.',
      downloadTranscript: 'Baixar transcrição',
      startNewConversation: 'Iniciar nova conversa',
      returnToConversation: 'Voltar à conversa',
      connecting: 'Conectando...',
      retry: 'Tentar novamente',
      network: {
        retry: 'Reconectar',
      },
      reconnecting: 'Reconectando...',
      connectionLost: 'A conexão com a internet foi perdida',
      reconnectDescription:
        'A conexão com a internet foi perdida. Clique em Reconectar para tentar novamente.',
      typeMessage: 'Digite uma mensagem',
      inputSelect: 'Selecione uma opção',
      inputSelectOrType: 'Selecione uma opção ou digite uma mensagem',
      secureInput: 'Digite uma mensagem segura',
      secureValueHidden: 'Valor seguro oculto',
      startChat: 'Iniciar chat',
      settings: 'Configurações',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      close: 'Fechar',
      next: 'Avançar',
      brandingTagline:
        'Impulsione o seu negócio com agentes de IA inteligentes',
      poweredBy: 'Desenvolvido por',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistente',
      assistantThinking: 'O assistente está pensando',
      youSaid: 'Você disse',
      assistantSays: 'O assistente diz',
      agentSays: '{{name}} diz',
      joinMeeting: 'Entrar na reunião',
      meetingInProgress: 'Reunião em andamento — clique para voltar a entrar',
      meetingExpired: 'Link da reunião (expirado)',
      embeddedContent: 'Conteúdo incorporado',
      openInNewTab: 'Abrir em uma nova aba',
      skipToMain: 'Ir para o conteúdo principal',
      loadingCustomerSolution: 'Carregando a solução {{customerName}}',
      loadingSolution: 'Carregando a solução',
      customerLogoAlt: 'Logotipo de {{customerName}}',
      selectDate: 'Selecionar data',
      selectTime: 'Selecionar horário',
      browseOptions: 'Explorar opções',
      carouselRoleDescription: 'Carrossel',
      carouselSlideLabel: 'Slide {{current}} de {{total}}',
      carouselPrevious: 'Item anterior',
      carouselNext: 'Próximo item',
      carouselGoToItem: 'Ir para o item {{index}}',
      collapse: 'Recolher',
      expand: 'Expandir',
      messageHistory: 'Histórico de mensagens',
      reduce: 'Reduzir',
      today: 'Hoje',
      at: 'às',
      a11yOptionsCount_zero: 'Há {{count}} opções.',
      a11yOptionsCount_one: 'Há 1 opção.',
      a11yOptionsCount_two: 'Há {{count}} opções.',
      a11yOptionsCount_few: 'Há {{count}} opções.',
      a11yOptionsCount_many: 'Há {{count}} opções.',
      a11yOptionsCount_other: 'Há {{count}} opções.',
      listpickerSelectAll: 'Selecionar tudo',
      listpickerSelectOption: 'Selecione uma opção',
      listpickerSearchAriaLabel: 'Pesquisar opções de filtro',
      listpickerSearchPlaceholder: 'Pesquisar…',
      listpickerNoResults: 'Nenhuma opção corresponde.',
      listpickerResults_zero: '{{count}} resultados',
      listpickerResults_one: '1 resultado',
      listpickerResults_two: '{{count}} resultados',
      listpickerResults_few: '{{count}} resultados',
      listpickerResults_many: '{{count}} resultados',
      listpickerResults_other: '{{count}} resultados',
      listpickerCondensed_zero: '{{count}} selecionados',
      listpickerCondensed_one: '1 selecionado',
      listpickerCondensed_two: '{{count}} selecionados',
      listpickerCondensed_few: '{{count}} selecionados',
      listpickerCondensed_many: '{{count}} selecionados',
      listpickerCondensed_other: '{{count}} selecionados',
      listpickerSelectAction: 'Selecionar',
      scrollToLatest: 'Rolar até a mensagem mais recente',
      scrollToUnread_zero: '{{count}} novas mensagens, ir para a mais recente',
      scrollToUnread_one: '1 nova mensagem, ir para a mais recente',
      scrollToUnread_two: '{{count}} novas mensagens, ir para a mais recente',
      scrollToUnread_few: '{{count}} novas mensagens, ir para a mais recente',
      scrollToUnread_many: '{{count}} novas mensagens, ir para a mais recente',
      scrollToUnread_other: '{{count}} novas mensagens, ir para a mais recente',
      showPassword: 'Mostrar conteúdo seguro',
      hidePassword: 'Ocultar conteúdo seguro',
      clear: 'Limpar',
      send: 'Enviar',
      yesterday: 'Ontem',
      chatEndedActions: 'Ações de fim de chat',
      openConversationDialog:
        'Abrir a caixa de diálogo da conversa com {{title}}',
      agentTyping: 'O atendente está digitando',
      agentAway: 'Nossos atendentes não estão disponíveis no momento.',
      agentBusy:
        'Nossos atendentes estão ocupados no momento. Por favor, aguarde...',
      waitingForAgent: 'Conectando você a um atendente...',
      waitingForAgentWithSkill:
        'Conectando você a um atendente de {{skill}}...',
      talkingWithAgent: 'Conversando com {{name}}',
      home: 'Início',
      back: 'Voltar',
      menu: 'Menu',
      minimize: 'Minimizar',
      endConversation: 'Encerrar chat',
      engageWithUs: 'Fale conosco',
      noMessagesYet: 'Ainda não há mensagens',
      tryAgain: 'Tentar novamente',
      rating: 'Avaliação',
      shareLocation: 'Compartilhar localização',
      locationShared: 'Localização compartilhada',
      locationError: 'Não foi possível obter a sua localização',
      locationPermissionDenied: 'Permissão de localização negada',
      geolocationUnavailable:
        'Os serviços de localização não estão disponíveis',
      selectFile: 'Selecionar um arquivo',
      upload: 'Enviar',
      uploadComplete: 'Envio concluído',
      uploadFailed: 'Falha no envio',
      fileTooLarge: 'O arquivo é muito grande',
      dragOrClick: 'Arraste um arquivo ou clique para escolher',
      document: 'Documento',
      audioContent: 'Conteúdo de áudio',
      videoContent: 'Conteúdo de vídeo',
      unsupportedContent: 'Conteúdo não suportado',
      unavailable: {
        error: {
          title: 'Algo deu errado',
          body: 'Não foi possível carregar o chat. Por favor, tente novamente.',
          retry: 'Tentar novamente',
        },
        maintenance: {
          title: 'O chat está temporariamente indisponível',
          body: 'Estamos realizando uma manutenção programada. Volte em breve.',
        },
      },
      image: 'Imagem',
    },
  },
  {
    lang: 'ro',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Această conversație s-a încheiat.',
      agentConnected: 'Ați fost conectat cu succes la un agent.',
      downloadTranscript: 'Descarcă transcrierea',
      startNewConversation: 'Începe o conversație nouă',
      returnToConversation: 'Înapoi la conversație',
      connecting: 'Se conectează...',
      retry: 'Reîncearcă',
      network: {
        retry: 'Reconectează-te',
      },
      reconnecting: 'Se reconectează...',
      connectionLost: 'Conexiunea la internet a fost pierdută',
      reconnectDescription:
        'Conexiunea la internet a fost pierdută. Faceți clic pe Reconectează-te pentru a reîncerca.',
      typeMessage: 'Scrieți un mesaj',
      inputSelect: 'Selectați o opțiune',
      inputSelectOrType: 'Selectați o opțiune sau scrieți un mesaj',
      secureInput: 'Scrieți un mesaj securizat',
      secureValueHidden: 'Valoare securizată ascunsă',
      startChat: 'Începe chatul',
      settings: 'Setări',
      cancel: 'Anulează',
      confirm: 'Confirmă',
      close: 'Închide',
      next: 'Înainte',
      brandingTagline: 'Impulsionați-vă afacerea cu agenți AI inteligenți',
      poweredBy: 'Susținut de',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asistent',
      assistantThinking: 'Asistentul se gândește',
      youSaid: 'Ați spus',
      assistantSays: 'Asistentul spune',
      agentSays: '{{name}} spune',
      joinMeeting: 'Alătură-te întâlnirii',
      meetingInProgress:
        'Întâlnire în curs — faceți clic pentru a vă reconecta',
      meetingExpired: 'Link întâlnire (expirat)',
      embeddedContent: 'Conținut încorporat',
      openInNewTab: 'Deschide într-o filă nouă',
      skipToMain: 'Salt la conținutul principal',
      loadingCustomerSolution: 'Se încarcă soluția {{customerName}}',
      loadingSolution: 'Se încarcă soluția',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Selectați data',
      selectTime: 'Selectați ora',
      browseOptions: 'Răsfoiește opțiunile',
      carouselRoleDescription: 'Carusel',
      carouselSlideLabel: 'Diapozitivul {{current}} din {{total}}',
      carouselPrevious: 'Elementul anterior',
      carouselNext: 'Elementul următor',
      carouselGoToItem: 'Mergi la elementul {{index}}',
      collapse: 'Restrânge',
      expand: 'Extinde',
      messageHistory: 'Istoricul mesajelor',
      reduce: 'Micșorează',
      today: 'Astăzi',
      at: 'la',
      a11yOptionsCount_zero: 'Există {{count}} de opțiuni.',
      a11yOptionsCount_one: 'Există 1 opțiune.',
      a11yOptionsCount_two: 'Există {{count}} de opțiuni.',
      a11yOptionsCount_few: 'Există {{count}} opțiuni.',
      a11yOptionsCount_many: 'Există {{count}} de opțiuni.',
      a11yOptionsCount_other: 'Există {{count}} de opțiuni.',
      listpickerSelectAll: 'Selectează tot',
      listpickerSelectOption: 'Selectați o opțiune',
      listpickerSearchAriaLabel: 'Căutați opțiuni de filtrare',
      listpickerSearchPlaceholder: 'Căutare…',
      listpickerNoResults: 'Nicio opțiune care se potrivește.',
      listpickerResults_zero: '{{count}} de rezultate',
      listpickerResults_one: '1 rezultat',
      listpickerResults_two: '{{count}} de rezultate',
      listpickerResults_few: '{{count}} rezultate',
      listpickerResults_many: '{{count}} de rezultate',
      listpickerResults_other: '{{count}} de rezultate',
      listpickerCondensed_zero: '{{count}} de selectate',
      listpickerCondensed_one: '1 selectat',
      listpickerCondensed_two: '{{count}} de selectate',
      listpickerCondensed_few: '{{count}} selectate',
      listpickerCondensed_many: '{{count}} de selectate',
      listpickerCondensed_other: '{{count}} de selectate',
      listpickerSelectAction: 'Selectează',
      scrollToLatest: 'Derulează la cel mai recent mesaj',
      scrollToUnread_zero: '{{count}} de mesaje noi, mergi la cel mai recent',
      scrollToUnread_one: '1 mesaj nou, mergi la cel mai recent',
      scrollToUnread_two: '{{count}} de mesaje noi, mergi la cel mai recent',
      scrollToUnread_few: '{{count}} mesaje noi, mergi la cel mai recent',
      scrollToUnread_many: '{{count}} de mesaje noi, mergi la cel mai recent',
      scrollToUnread_other: '{{count}} de mesaje noi, mergi la cel mai recent',
      showPassword: 'Afișează conținutul securizat',
      hidePassword: 'Ascunde conținutul securizat',
      clear: 'Golește',
      send: 'Trimite',
      yesterday: 'Ieri',
      chatEndedActions: 'Acțiuni după încheierea chatului',
      openConversationDialog: 'Deschide fereastra de conversație cu {{title}}',
      agentTyping: 'Agentul scrie',
      agentAway: 'Agenții noștri nu sunt disponibili momentan.',
      agentBusy:
        'Agenții noștri sunt momentan ocupați. Vă rugăm să așteptați...',
      waitingForAgent: 'Vă conectăm cu un agent...',
      waitingForAgentWithSkill: 'Vă conectăm cu un agent pentru {{skill}}...',
      talkingWithAgent: 'În conversație cu {{name}}',
      home: 'Acasă',
      back: 'Înapoi',
      menu: 'Meniu',
      minimize: 'Minimizează',
      endConversation: 'Încheie chatul',
      engageWithUs: 'Contactați-ne',
      noMessagesYet: 'Încă niciun mesaj',
      tryAgain: 'Încearcă din nou',
      rating: 'Evaluare',
      shareLocation: 'Partajează locația',
      locationShared: 'Locație partajată',
      locationError: 'Nu am putut prelua locația dvs.',
      locationPermissionDenied: 'Permisiunea de localizare a fost refuzată',
      geolocationUnavailable: 'Serviciile de localizare nu sunt disponibile',
      selectFile: 'Selectați un fișier',
      upload: 'Încarcă',
      uploadComplete: 'Încărcare finalizată',
      uploadFailed: 'Încărcarea a eșuat',
      fileTooLarge: 'Fișierul este prea mare',
      dragOrClick: 'Trageți un fișier sau faceți clic pentru a alege',
      document: 'Document',
      audioContent: 'Conținut audio',
      videoContent: 'Conținut video',
      unsupportedContent: 'Conținut neacceptat',
      unavailable: {
        error: {
          title: 'Ceva nu a mers bine',
          body: 'Nu am putut încărca chatul. Încercați din nou.',
          retry: 'Încearcă din nou',
        },
        maintenance: {
          title: 'Chatul este temporar indisponibil',
          body: 'Efectuăm o întreținere programată. Reveniți în curând.',
        },
      },
      image: 'Imagine',
    },
  },
  {
    lang: 'ru',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Этот разговор завершён.',
      agentConnected: 'Вы успешно подключены к оператору.',
      downloadTranscript: 'Скачать расшифровку',
      startNewConversation: 'Начать новый разговор',
      returnToConversation: 'Вернуться к разговору',
      connecting: 'Подключение...',
      retry: 'Повторить',
      network: {
        retry: 'Переподключиться',
      },
      reconnecting: 'Переподключение...',
      connectionLost: 'Интернет-соединение потеряно',
      reconnectDescription:
        'Интернет-соединение потеряно. Нажмите «Переподключиться», чтобы повторить.',
      typeMessage: 'Введите сообщение',
      inputSelect: 'Выберите вариант',
      inputSelectOrType: 'Выберите вариант или введите сообщение',
      secureInput: 'Введите защищённое сообщение',
      secureValueHidden: 'Скрытое защищённое значение',
      startChat: 'Начать чат',
      settings: 'Настройки',
      cancel: 'Отмена',
      confirm: 'Подтвердить',
      close: 'Закрыть',
      next: 'Далее',
      brandingTagline:
        'Ускорьте развитие бизнеса с помощью интеллектуальных ИИ-агентов',
      poweredBy: 'Работает на',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Ассистент',
      assistantThinking: 'Ассистент думает',
      youSaid: 'Вы сказали',
      assistantSays: 'Ассистент говорит',
      agentSays: '{{name}} говорит',
      joinMeeting: 'Присоединиться к встрече',
      meetingInProgress: 'Встреча идёт — нажмите, чтобы вернуться',
      meetingExpired: 'Ссылка на встречу (истекла)',
      embeddedContent: 'Встроенный контент',
      openInNewTab: 'Открыть в новой вкладке',
      skipToMain: 'Перейти к основному содержимому',
      loadingCustomerSolution: 'Загрузка решения {{customerName}}',
      loadingSolution: 'Загрузка решения',
      customerLogoAlt: 'Логотип {{customerName}}',
      selectDate: 'Выберите дату',
      selectTime: 'Выберите время',
      browseOptions: 'Просмотр вариантов',
      carouselRoleDescription: 'Карусель',
      carouselSlideLabel: 'Слайд {{current}} из {{total}}',
      carouselPrevious: 'Предыдущий элемент',
      carouselNext: 'Следующий элемент',
      carouselGoToItem: 'Перейти к элементу {{index}}',
      collapse: 'Свернуть',
      expand: 'Развернуть',
      messageHistory: 'История сообщений',
      reduce: 'Уменьшить',
      today: 'Сегодня',
      at: 'в',
      a11yOptionsCount_one: '{{count}} вариант.',
      a11yOptionsCount_few: '{{count}} варианта.',
      a11yOptionsCount_many: '{{count}} вариантов.',
      a11yOptionsCount_other: '{{count}} вариантов.',
      listpickerSelectAll: 'Выбрать все',
      listpickerSelectOption: 'Выберите вариант',
      listpickerSearchAriaLabel: 'Поиск вариантов фильтра',
      listpickerSearchPlaceholder: 'Поиск…',
      listpickerNoResults: 'Нет подходящих вариантов.',
      listpickerResults_one: '{{count}} результат',
      listpickerResults_few: '{{count}} результата',
      listpickerResults_many: '{{count}} результатов',
      listpickerResults_other: '{{count}} результатов',
      listpickerCondensed_one: 'Выбран {{count}}',
      listpickerCondensed_few: 'Выбрано {{count}}',
      listpickerCondensed_many: 'Выбрано {{count}}',
      listpickerCondensed_other: 'Выбрано {{count}}',
      listpickerSelectAction: 'Выбрать',
      scrollToLatest: 'Перейти к последнему сообщению',
      scrollToUnread_one: '{{count}} новое сообщение, перейти к последнему',
      scrollToUnread_few: '{{count}} новых сообщения, перейти к последнему',
      scrollToUnread_many: '{{count}} новых сообщений, перейти к последнему',
      scrollToUnread_other: '{{count}} новых сообщений, перейти к последнему',
      showPassword: 'Показать защищённое содержимое',
      hidePassword: 'Скрыть защищённое содержимое',
      clear: 'Очистить',
      send: 'Отправить',
      yesterday: 'Вчера',
      chatEndedActions: 'Действия после завершения чата',
      openConversationDialog: 'Открыть диалог беседы с {{title}}',
      agentTyping: 'Оператор печатает',
      agentAway: 'Наши операторы сейчас недоступны.',
      agentBusy: 'Наши операторы сейчас заняты. Пожалуйста, подождите...',
      waitingForAgent: 'Подключаем вас к оператору...',
      waitingForAgentWithSkill:
        'Подключаем вас к оператору по теме «{{skill}}»...',
      talkingWithAgent: 'Разговор с {{name}}',
      home: 'Главная',
      back: 'Назад',
      menu: 'Меню',
      minimize: 'Свернуть',
      endConversation: 'Завершить чат',
      engageWithUs: 'Свяжитесь с нами',
      noMessagesYet: 'Сообщений пока нет',
      tryAgain: 'Повторить попытку',
      rating: 'Оценка',
      shareLocation: 'Поделиться местоположением',
      locationShared: 'Местоположение отправлено',
      locationError: 'Не удалось определить ваше местоположение',
      locationPermissionDenied: 'Доступ к местоположению запрещён',
      geolocationUnavailable: 'Службы геолокации недоступны',
      selectFile: 'Выберите файл',
      upload: 'Загрузить',
      uploadComplete: 'Загрузка завершена',
      uploadFailed: 'Ошибка загрузки',
      fileTooLarge: 'Файл слишком большой',
      dragOrClick: 'Перетащите файл или нажмите, чтобы выбрать',
      document: 'Документ',
      audioContent: 'Аудиоконтент',
      videoContent: 'Видеоконтент',
      unsupportedContent: 'Неподдерживаемый контент',
      unavailable: {
        error: {
          title: 'Что-то пошло не так',
          body: 'Не удалось загрузить чат. Пожалуйста, попробуйте снова.',
          retry: 'Повторить попытку',
        },
        maintenance: {
          title: 'Чат временно недоступен',
          body: 'Проводится плановое обслуживание. Пожалуйста, зайдите позже.',
        },
      },
      image: 'Изображение',
    },
  },
  {
    lang: 'sk',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Táto konverzácia sa skončila.',
      agentConnected: 'Boli ste úspešne spojení s operátorom.',
      downloadTranscript: 'Stiahnuť prepis',
      startNewConversation: 'Začať novú konverzáciu',
      returnToConversation: 'Späť ku konverzácii',
      connecting: 'Pripájanie...',
      retry: 'Skúsiť znova',
      network: {
        retry: 'Znova pripojiť',
      },
      reconnecting: 'Opätovné pripájanie...',
      connectionLost: 'Pripojenie na internet sa stratilo',
      reconnectDescription:
        'Pripojenie na internet sa stratilo. Kliknutím na Znova pripojiť to skúste znova.',
      typeMessage: 'Napíšte správu',
      inputSelect: 'Vyberte možnosť',
      inputSelectOrType: 'Vyberte možnosť alebo napíšte správu',
      secureInput: 'Napíšte zabezpečenú správu',
      secureValueHidden: 'Skrytá zabezpečená hodnota',
      startChat: 'Začať chat',
      settings: 'Nastavenia',
      cancel: 'Zrušiť',
      confirm: 'Potvrdiť',
      close: 'Zavrieť',
      next: 'Ďalej',
      brandingTagline: 'Posilnite svoje podnikanie s inteligentnými agentmi AI',
      poweredBy: 'Poháňané technológiou',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asistent',
      assistantThinking: 'Asistent premýšľa',
      youSaid: 'Povedali ste',
      assistantSays: 'Asistent hovorí',
      agentSays: '{{name}} hovorí',
      joinMeeting: 'Pripojiť sa k schôdzke',
      meetingInProgress: 'Schôdzka prebieha — kliknutím sa znova pripojíte',
      meetingExpired: 'Odkaz na schôdzku (vypršal)',
      embeddedContent: 'Vložený obsah',
      openInNewTab: 'Otvoriť na novej karte',
      skipToMain: 'Preskočiť na hlavný obsah',
      loadingCustomerSolution: 'Načítava sa riešenie {{customerName}}',
      loadingSolution: 'Načítava sa riešenie',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Vyberte dátum',
      selectTime: 'Vyberte čas',
      browseOptions: 'Prehľadávať možnosti',
      carouselRoleDescription: 'Karusel',
      carouselSlideLabel: 'Snímka {{current}} z {{total}}',
      carouselPrevious: 'Predchádzajúca položka',
      carouselNext: 'Ďalšia položka',
      carouselGoToItem: 'Prejsť na položku {{index}}',
      collapse: 'Zbaliť',
      expand: 'Rozbaliť',
      messageHistory: 'História správ',
      reduce: 'Zmenšiť',
      today: 'Dnes',
      at: 'o',
      a11yOptionsCount_zero: 'Je {{count}} možností.',
      a11yOptionsCount_one: 'Je 1 možnosť.',
      a11yOptionsCount_two: 'Je {{count}} možností.',
      a11yOptionsCount_few: 'Sú {{count}} možnosti.',
      a11yOptionsCount_many: 'Je {{count}} možnosti.',
      a11yOptionsCount_other: 'Je {{count}} možností.',
      listpickerSelectAll: 'Vybrať všetko',
      listpickerSelectOption: 'Vyberte možnosť',
      listpickerSearchAriaLabel: 'Hľadať možnosti filtra',
      listpickerSearchPlaceholder: 'Hľadať…',
      listpickerNoResults: 'Žiadne zodpovedajúce možnosti.',
      listpickerResults_zero: '{{count}} výsledkov',
      listpickerResults_one: '1 výsledok',
      listpickerResults_two: '{{count}} výsledkov',
      listpickerResults_few: '{{count}} výsledky',
      listpickerResults_many: '{{count}} výsledku',
      listpickerResults_other: '{{count}} výsledkov',
      listpickerCondensed_zero: 'Vybraté {{count}}',
      listpickerCondensed_one: 'Vybraté 1',
      listpickerCondensed_two: 'Vybraté {{count}}',
      listpickerCondensed_few: 'Vybraté {{count}}',
      listpickerCondensed_many: 'Vybraté {{count}}',
      listpickerCondensed_other: 'Vybraté {{count}}',
      listpickerSelectAction: 'Vybrať',
      scrollToLatest: 'Prejsť na najnovšiu správu',
      scrollToUnread_zero: '{{count}} nových správ, prejsť na najnovšiu',
      scrollToUnread_one: '1 nová správa, prejsť na najnovšiu',
      scrollToUnread_two: '{{count}} nových správ, prejsť na najnovšiu',
      scrollToUnread_few: '{{count}} nové správy, prejsť na najnovšiu',
      scrollToUnread_many: '{{count}} novej správy, prejsť na najnovšiu',
      scrollToUnread_other: '{{count}} nových správ, prejsť na najnovšiu',
      showPassword: 'Zobraziť zabezpečený obsah',
      hidePassword: 'Skryť zabezpečený obsah',
      clear: 'Vymazať',
      send: 'Odoslať',
      yesterday: 'Včera',
      chatEndedActions: 'Akcie po ukončení chatu',
      openConversationDialog: 'Otvoriť okno konverzácie s {{title}}',
      agentTyping: 'Operátor píše',
      agentAway: 'Naši operátori sú momentálne nedostupní.',
      agentBusy:
        'Naši operátori sú momentálne zaneprázdnení. Počkajte prosím...',
      waitingForAgent: 'Spájame vás s operátorom...',
      waitingForAgentWithSkill: 'Spájame vás s operátorom pre {{skill}}...',
      talkingWithAgent: 'Hovoríte s {{name}}',
      home: 'Domov',
      back: 'Späť',
      menu: 'Ponuka',
      minimize: 'Minimalizovať',
      endConversation: 'Ukončiť chat',
      engageWithUs: 'Kontaktujte nás',
      noMessagesYet: 'Zatiaľ žiadne správy',
      tryAgain: 'Skúsiť znova',
      rating: 'Hodnotenie',
      shareLocation: 'Zdieľať polohu',
      locationShared: 'Poloha zdieľaná',
      locationError: 'Vašu polohu sa nepodarilo získať',
      locationPermissionDenied: 'Prístup k polohe bol zamietnutý',
      geolocationUnavailable: 'Služby určovania polohy nie sú dostupné',
      selectFile: 'Vyberte súbor',
      upload: 'Nahrať',
      uploadComplete: 'Nahrávanie dokončené',
      uploadFailed: 'Nahrávanie zlyhalo',
      fileTooLarge: 'Súbor je príliš veľký',
      dragOrClick: 'Presuňte súbor alebo kliknite na výber',
      document: 'Dokument',
      audioContent: 'Zvukový obsah',
      videoContent: 'Videoobsah',
      unsupportedContent: 'Nepodporovaný obsah',
      unavailable: {
        error: {
          title: 'Niečo sa pokazilo',
          body: 'Chat sa nepodarilo načítať. Skúste to znova.',
          retry: 'Skúsiť znova',
        },
        maintenance: {
          title: 'Chat je dočasne nedostupný',
          body: 'Vykonávame plánovanú údržbu. Vráťte sa prosím čoskoro.',
        },
      },
      image: 'Obrázok',
    },
  },
  {
    lang: 'sl',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Ta pogovor je končan.',
      agentConnected: 'Uspešno ste povezani z agentom.',
      downloadTranscript: 'Prenesi prepis',
      startNewConversation: 'Začni nov pogovor',
      returnToConversation: 'Nazaj na pogovor',
      connecting: 'Povezovanje...',
      retry: 'Poskusi znova',
      network: {
        retry: 'Znova poveži',
      },
      reconnecting: 'Ponovno povezovanje...',
      connectionLost: 'Internetna povezava je bila prekinjena',
      reconnectDescription:
        'Internetna povezava je bila prekinjena. Kliknite Znova poveži za ponovni poskus.',
      typeMessage: 'Vnesite sporočilo',
      inputSelect: 'Izberite možnost',
      inputSelectOrType: 'Izberite možnost ali vnesite sporočilo',
      secureInput: 'Vnesite varno sporočilo',
      secureValueHidden: 'Skrita varna vrednost',
      startChat: 'Začni klepet',
      settings: 'Nastavitve',
      cancel: 'Prekliči',
      confirm: 'Potrdi',
      close: 'Zapri',
      next: 'Naprej',
      brandingTagline: 'Okrepite svoje podjetje z inteligentnimi agenti UI',
      poweredBy: 'Poganja',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Pomočnik',
      assistantThinking: 'Pomočnik razmišlja',
      youSaid: 'Rekli ste',
      assistantSays: 'Pomočnik pravi',
      agentSays: '{{name}} pravi',
      joinMeeting: 'Pridruži se sestanku',
      meetingInProgress: 'Sestanek poteka — kliknite za ponovno pridružitev',
      meetingExpired: 'Povezava do sestanka (potekla)',
      embeddedContent: 'Vgrajena vsebina',
      openInNewTab: 'Odpri v novem zavihku',
      skipToMain: 'Preskoči na glavno vsebino',
      loadingCustomerSolution: 'Nalaganje rešitve {{customerName}}',
      loadingSolution: 'Nalaganje rešitve',
      customerLogoAlt: 'Logotip {{customerName}}',
      selectDate: 'Izberite datum',
      selectTime: 'Izberite čas',
      browseOptions: 'Prebrskaj možnosti',
      carouselRoleDescription: 'Vrtiljak',
      carouselSlideLabel: 'Prosojnica {{current}} od {{total}}',
      carouselPrevious: 'Prejšnji element',
      carouselNext: 'Naslednji element',
      carouselGoToItem: 'Pojdi na element {{index}}',
      collapse: 'Strni',
      expand: 'Razširi',
      messageHistory: 'Zgodovina sporočil',
      reduce: 'Pomanjšaj',
      today: 'Danes',
      at: 'ob',
      a11yOptionsCount_zero: 'Na voljo je {{count}} možnosti.',
      a11yOptionsCount_one: 'Na voljo je 1 možnost.',
      a11yOptionsCount_two: 'Na voljo sta {{count}} možnosti.',
      a11yOptionsCount_few: 'Na voljo so {{count}} možnosti.',
      a11yOptionsCount_many: 'Na voljo je {{count}} možnosti.',
      a11yOptionsCount_other: 'Na voljo je {{count}} možnosti.',
      listpickerSelectAll: 'Izberi vse',
      listpickerSelectOption: 'Izberite možnost',
      listpickerSearchAriaLabel: 'Iskanje možnosti filtra',
      listpickerSearchPlaceholder: 'Iskanje…',
      listpickerNoResults: 'Ni ujemajočih se možnosti.',
      listpickerResults_zero: '{{count}} rezultatov',
      listpickerResults_one: '1 rezultat',
      listpickerResults_two: '{{count}} rezultata',
      listpickerResults_few: '{{count}} rezultati',
      listpickerResults_many: '{{count}} rezultatov',
      listpickerResults_other: '{{count}} rezultatov',
      listpickerCondensed_zero: '{{count}} izbranih',
      listpickerCondensed_one: '1 izbran',
      listpickerCondensed_two: '{{count}} izbrana',
      listpickerCondensed_few: '{{count}} izbrani',
      listpickerCondensed_many: '{{count}} izbranih',
      listpickerCondensed_other: '{{count}} izbranih',
      listpickerSelectAction: 'Izberi',
      scrollToLatest: 'Pomakni se na najnovejše sporočilo',
      scrollToUnread_zero: '{{count}} novih sporočil, na najnovejše',
      scrollToUnread_one: '1 novo sporočilo, na najnovejše',
      scrollToUnread_two: '{{count}} novi sporočili, na najnovejše',
      scrollToUnread_few: '{{count}} nova sporočila, na najnovejše',
      scrollToUnread_many: '{{count}} novih sporočil, na najnovejše',
      scrollToUnread_other: '{{count}} novih sporočil, na najnovejše',
      showPassword: 'Pokaži varno vsebino',
      hidePassword: 'Skrij varno vsebino',
      clear: 'Počisti',
      send: 'Pošlji',
      yesterday: 'Včeraj',
      chatEndedActions: 'Dejanja po koncu klepeta',
      openConversationDialog: 'Odpri pogovorno okno z {{title}}',
      agentTyping: 'Agent tipka',
      agentAway: 'Naši agenti trenutno niso na voljo.',
      agentBusy: 'Naši agenti so trenutno zasedeni. Počakajte...',
      waitingForAgent: 'Povezujemo vas z agentom...',
      waitingForAgentWithSkill: 'Povezujemo vas z agentom za {{skill}}...',
      talkingWithAgent: 'Pogovor z {{name}}',
      home: 'Domov',
      back: 'Nazaj',
      menu: 'Meni',
      minimize: 'Pomanjšaj',
      endConversation: 'Končaj klepet',
      engageWithUs: 'Stopite v stik z nami',
      noMessagesYet: 'Še ni sporočil',
      tryAgain: 'Poskusi znova',
      rating: 'Ocena',
      shareLocation: 'Deli lokacijo',
      locationShared: 'Lokacija deljena',
      locationError: 'Vaše lokacije ni mogoče pridobiti',
      locationPermissionDenied: 'Dovoljenje za lokacijo zavrnjeno',
      geolocationUnavailable: 'Lokacijske storitve niso na voljo',
      selectFile: 'Izberite datoteko',
      upload: 'Naloži',
      uploadComplete: 'Nalaganje končano',
      uploadFailed: 'Nalaganje ni uspelo',
      fileTooLarge: 'Datoteka je prevelika',
      dragOrClick: 'Povlecite datoteko ali kliknite za izbiro',
      document: 'Dokument',
      audioContent: 'Zvočna vsebina',
      videoContent: 'Videovsebina',
      unsupportedContent: 'Nepodprta vsebina',
      unavailable: {
        error: {
          title: 'Nekaj je šlo narobe',
          body: 'Klepeta ni bilo mogoče naložiti. Poskusite znova.',
          retry: 'Poskusi znova',
        },
        maintenance: {
          title: 'Klepet je začasno nedosegljiv',
          body: 'Izvajamo načrtovano vzdrževanje. Vrnite se kmalu.',
        },
      },
      image: 'Slika',
    },
  },
  {
    lang: 'sr',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Ovaj razgovor je završen.',
      agentConnected: 'Uspešno ste povezani sa agentom.',
      downloadTranscript: 'Preuzmi transkript',
      startNewConversation: 'Započni novi razgovor',
      returnToConversation: 'Nazad na razgovor',
      connecting: 'Povezivanje...',
      retry: 'Pokušaj ponovo',
      network: {
        retry: 'Ponovo poveži',
      },
      reconnecting: 'Ponovno povezivanje...',
      connectionLost: 'Internet veza je izgubljena',
      reconnectDescription:
        'Internet veza je izgubljena. Kliknite Ponovo poveži da pokušate ponovo.',
      typeMessage: 'Upišite poruku',
      inputSelect: 'Izaberite opciju',
      inputSelectOrType: 'Izaberite opciju ili upišite poruku',
      secureInput: 'Upišite bezbednu poruku',
      secureValueHidden: 'Skrivena bezbedna vrednost',
      startChat: 'Započni ćaskanje',
      settings: 'Podešavanja',
      cancel: 'Otkaži',
      confirm: 'Potvrdi',
      close: 'Zatvori',
      next: 'Dalje',
      brandingTagline: 'Osnažite svoje poslovanje inteligentnim AI agentima',
      poweredBy: 'Pokreće',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asistent',
      assistantThinking: 'Asistent razmišlja',
      youSaid: 'Rekli ste',
      assistantSays: 'Asistent kaže',
      agentSays: '{{name}} kaže',
      joinMeeting: 'Pridruži se sastanku',
      meetingInProgress:
        'Sastanak je u toku — kliknite da se ponovo pridružite',
      meetingExpired: 'Link ka sastanku (istekao)',
      embeddedContent: 'Ugrađeni sadržaj',
      openInNewTab: 'Otvori u novoj kartici',
      skipToMain: 'Pređi na glavni sadržaj',
      loadingCustomerSolution: 'Učitavanje rešenja {{customerName}}',
      loadingSolution: 'Učitavanje rešenja',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Izaberite datum',
      selectTime: 'Izaberite vreme',
      browseOptions: 'Pregledaj opcije',
      carouselRoleDescription: 'Vrteška',
      carouselSlideLabel: 'Slajd {{current}} od {{total}}',
      carouselPrevious: 'Prethodna stavka',
      carouselNext: 'Sledeća stavka',
      carouselGoToItem: 'Idi na stavku {{index}}',
      collapse: 'Skupi',
      expand: 'Proširi',
      messageHistory: 'Istorija poruka',
      reduce: 'Smanji',
      today: 'Danas',
      at: 'u',
      a11yOptionsCount_zero: 'Postoji {{count}} opcija.',
      a11yOptionsCount_one: 'Postoji 1 opcija.',
      a11yOptionsCount_two: 'Postoji {{count}} opcija.',
      a11yOptionsCount_few: 'Postoje {{count}} opcije.',
      a11yOptionsCount_many: 'Postoji {{count}} opcija.',
      a11yOptionsCount_other: 'Postoji {{count}} opcija.',
      listpickerSelectAll: 'Izaberi sve',
      listpickerSelectOption: 'Izaberite opciju',
      listpickerSearchAriaLabel: 'Pretraži opcije filtera',
      listpickerSearchPlaceholder: 'Pretraži…',
      listpickerNoResults: 'Nema podudarnih opcija.',
      listpickerResults_zero: '{{count}} rezultata',
      listpickerResults_one: '1 rezultat',
      listpickerResults_two: '{{count}} rezultata',
      listpickerResults_few: '{{count}} rezultata',
      listpickerResults_many: '{{count}} rezultata',
      listpickerResults_other: '{{count}} rezultata',
      listpickerCondensed_zero: '{{count}} izabrano',
      listpickerCondensed_one: '1 izabrano',
      listpickerCondensed_two: '{{count}} izabrano',
      listpickerCondensed_few: '{{count}} izabrano',
      listpickerCondensed_many: '{{count}} izabrano',
      listpickerCondensed_other: '{{count}} izabrano',
      listpickerSelectAction: 'Izaberi',
      scrollToLatest: 'Pomeri na najnoviju poruku',
      scrollToUnread_zero: '{{count}} novih poruka, na najnoviju',
      scrollToUnread_one: '1 nova poruka, na najnoviju',
      scrollToUnread_two: '{{count}} novih poruka, na najnoviju',
      scrollToUnread_few: '{{count}} nove poruke, na najnoviju',
      scrollToUnread_many: '{{count}} novih poruka, na najnoviju',
      scrollToUnread_other: '{{count}} novih poruka, na najnoviju',
      showPassword: 'Prikaži bezbedan sadržaj',
      hidePassword: 'Sakrij bezbedan sadržaj',
      clear: 'Obriši',
      send: 'Pošalji',
      yesterday: 'Juče',
      chatEndedActions: 'Radnje nakon završetka ćaskanja',
      openConversationDialog: 'Otvori prozor razgovora sa {{title}}',
      agentTyping: 'Agent kuca',
      agentAway: 'Naši agenti trenutno nisu dostupni.',
      agentBusy: 'Naši agenti su trenutno zauzeti. Sačekajte...',
      waitingForAgent: 'Povezujemo vas sa agentom...',
      waitingForAgentWithSkill: 'Povezujemo vas sa agentom za {{skill}}...',
      talkingWithAgent: 'Razgovor sa {{name}}',
      home: 'Početna',
      back: 'Nazad',
      menu: 'Meni',
      minimize: 'Umanji',
      endConversation: 'Završi ćaskanje',
      engageWithUs: 'Kontaktirajte nas',
      noMessagesYet: 'Još nema poruka',
      tryAgain: 'Pokušaj ponovo',
      rating: 'Ocena',
      shareLocation: 'Podeli lokaciju',
      locationShared: 'Lokacija podeljena',
      locationError: 'Nije moguće dobiti vašu lokaciju',
      locationPermissionDenied: 'Dozvola za lokaciju je odbijena',
      geolocationUnavailable: 'Usluge lokacije nisu dostupne',
      selectFile: 'Izaberite datoteku',
      upload: 'Otpremi',
      uploadComplete: 'Otpremanje završeno',
      uploadFailed: 'Otpremanje nije uspelo',
      fileTooLarge: 'Datoteka je prevelika',
      dragOrClick: 'Prevucite datoteku ili kliknite da izaberete',
      document: 'Dokument',
      audioContent: 'Audio sadržaj',
      videoContent: 'Video sadržaj',
      unsupportedContent: 'Nepodržani sadržaj',
      unavailable: {
        error: {
          title: 'Nešto je pošlo naopako',
          body: 'Nismo mogli da učitamo ćaskanje. Pokušajte ponovo.',
          retry: 'Pokušaj ponovo',
        },
        maintenance: {
          title: 'Ćaskanje je privremeno nedostupno',
          body: 'Sprovodimo planirano održavanje. Vratite se uskoro.',
        },
      },
      image: 'Slika',
    },
  },
  {
    lang: 'sr-CYRL',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Овај разговор је завршен.',
      agentConnected: 'Успешно сте повезани са агентом.',
      downloadTranscript: 'Преузми транскрипт',
      startNewConversation: 'Започни нови разговор',
      returnToConversation: 'Назад на разговор',
      connecting: 'Повезивање...',
      retry: 'Покушај поново',
      network: {
        retry: 'Поново повежи',
      },
      reconnecting: 'Поновно повезивање...',
      connectionLost: 'Интернет веза је изгубљена',
      reconnectDescription:
        'Интернет веза је изгубљена. Кликните Поново повежи да покушате поново.',
      typeMessage: 'Упишите поруку',
      inputSelect: 'Изаберите опцију',
      inputSelectOrType: 'Изаберите опцију или упишите поруку',
      secureInput: 'Упишите безбедну поруку',
      secureValueHidden: 'Скривена безбедна вредност',
      startChat: 'Започни ћаскање',
      settings: 'Подешавања',
      cancel: 'Откажи',
      confirm: 'Потврди',
      close: 'Затвори',
      next: 'Даље',
      brandingTagline: 'Оснажите своје пословање интелигентним АИ агентима',
      poweredBy: 'Покреће',
      pypestreamCom: 'Пyпестреам.цом',
      assistant: 'Асистент',
      assistantThinking: 'Асистент размишља',
      youSaid: 'Рекли сте',
      assistantSays: 'Асистент каже',
      agentSays: '{{name}} каже',
      joinMeeting: 'Придружи се састанку',
      meetingInProgress:
        'Састанак је у току — кликните да се поново придружите',
      meetingExpired: 'Линк ка састанку (истекао)',
      embeddedContent: 'Уграђени садржај',
      openInNewTab: 'Отвори у новој картици',
      skipToMain: 'Пређи на главни садржај',
      loadingCustomerSolution: 'Учитавање решења {{customerName}}',
      loadingSolution: 'Учитавање решења',
      customerLogoAlt: 'Лого {{customerName}}',
      selectDate: 'Изаберите датум',
      selectTime: 'Изаберите време',
      browseOptions: 'Прегледај опције',
      carouselRoleDescription: 'Вртешка',
      carouselSlideLabel: 'Слајд {{current}} од {{total}}',
      carouselPrevious: 'Претходна ставка',
      carouselNext: 'Следећа ставка',
      carouselGoToItem: 'Иди на ставку {{index}}',
      collapse: 'Скупи',
      expand: 'Прошири',
      messageHistory: 'Историја порука',
      reduce: 'Смањи',
      today: 'Данас',
      at: 'у',
      a11yOptionsCount_zero: 'Постоји {{count}} опција.',
      a11yOptionsCount_one: 'Постоји 1 опција.',
      a11yOptionsCount_two: 'Постоји {{count}} опција.',
      a11yOptionsCount_few: 'Постоје {{count}} опције.',
      a11yOptionsCount_many: 'Постоји {{count}} опција.',
      a11yOptionsCount_other: 'Постоји {{count}} опција.',
      listpickerSelectAll: 'Изабери све',
      listpickerSelectOption: 'Изаберите опцију',
      listpickerSearchAriaLabel: 'Претражи опције филтера',
      listpickerSearchPlaceholder: 'Претражи…',
      listpickerNoResults: 'Нема подударних опција.',
      listpickerResults_zero: '{{count}} резултата',
      listpickerResults_one: '1 резултат',
      listpickerResults_two: '{{count}} резултата',
      listpickerResults_few: '{{count}} резултата',
      listpickerResults_many: '{{count}} резултата',
      listpickerResults_other: '{{count}} резултата',
      listpickerCondensed_zero: '{{count}} изабрано',
      listpickerCondensed_one: '1 изабрано',
      listpickerCondensed_two: '{{count}} изабрано',
      listpickerCondensed_few: '{{count}} изабрано',
      listpickerCondensed_many: '{{count}} изабрано',
      listpickerCondensed_other: '{{count}} изабрано',
      listpickerSelectAction: 'Изабери',
      scrollToLatest: 'Помери на најновију поруку',
      scrollToUnread_zero: '{{count}} нових порука, на најновију',
      scrollToUnread_one: '1 нова порука, на најновију',
      scrollToUnread_two: '{{count}} нових порука, на најновију',
      scrollToUnread_few: '{{count}} нове поруке, на најновију',
      scrollToUnread_many: '{{count}} нових порука, на најновију',
      scrollToUnread_other: '{{count}} нових порука, на најновију',
      showPassword: 'Прикажи безбедан садржај',
      hidePassword: 'Сакриј безбедан садржај',
      clear: 'Обриши',
      send: 'Пошаљи',
      yesterday: 'Јуче',
      chatEndedActions: 'Радње након завршетка ћаскања',
      openConversationDialog: 'Отвори прозор разговора са {{title}}',
      agentTyping: 'Агент куца',
      agentAway: 'Наши агенти тренутно нису доступни.',
      agentBusy: 'Наши агенти су тренутно заузети. Сачекајте...',
      waitingForAgent: 'Повезујемо вас са агентом...',
      waitingForAgentWithSkill: 'Повезујемо вас са агентом за {{skill}}...',
      talkingWithAgent: 'Разговор са {{name}}',
      home: 'Почетна',
      back: 'Назад',
      menu: 'Мени',
      minimize: 'Умањи',
      endConversation: 'Заврши ћаскање',
      engageWithUs: 'Контактирајте нас',
      noMessagesYet: 'Још нема порука',
      tryAgain: 'Покушај поново',
      rating: 'Оцена',
      shareLocation: 'Подели локацију',
      locationShared: 'Локација подељена',
      locationError: 'Није могуће добити вашу локацију',
      locationPermissionDenied: 'Дозвола за локацију је одбијена',
      geolocationUnavailable: 'Услуге локације нису доступне',
      selectFile: 'Изаберите датотеку',
      upload: 'Отпреми',
      uploadComplete: 'Отпремање завршено',
      uploadFailed: 'Отпремање није успело',
      fileTooLarge: 'Датотека је превелика',
      dragOrClick: 'Превуците датотеку или кликните да изаберете',
      document: 'Документ',
      audioContent: 'Аудио садржај',
      videoContent: 'Видео садржај',
      unsupportedContent: 'Неподржани садржај',
      unavailable: {
        error: {
          title: 'Нешто је пошло наопако',
          body: 'Нисмо могли да учитамо ћаскање. Покушајте поново.',
          retry: 'Покушај поново',
        },
        maintenance: {
          title: 'Ћаскање је привремено недоступно',
          body: 'Спроводимо планирано одржавање. Вратите се ускоро.',
        },
      },
      image: 'Слика',
    },
  },
  {
    lang: 'sv',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Den här konversationen har avslutats.',
      agentConnected: 'Du har anslutits till en handläggare.',
      downloadTranscript: 'Ladda ner transkript',
      startNewConversation: 'Starta ny konversation',
      returnToConversation: 'Tillbaka till konversationen',
      connecting: 'Ansluter...',
      retry: 'Försök igen',
      network: {
        retry: 'Återanslut',
      },
      reconnecting: 'Återansluter...',
      connectionLost: 'Internetanslutningen har brutits',
      reconnectDescription:
        'Internetanslutningen har brutits. Klicka på Återanslut för att försöka igen.',
      typeMessage: 'Skriv ett meddelande',
      inputSelect: 'Välj ett alternativ',
      inputSelectOrType: 'Välj ett alternativ eller skriv ett meddelande',
      secureInput: 'Skriv ett säkert meddelande',
      secureValueHidden: 'Dolt säkert värde',
      startChat: 'Starta chatt',
      settings: 'Inställningar',
      cancel: 'Avbryt',
      confirm: 'Bekräfta',
      close: 'Stäng',
      next: 'Nästa',
      brandingTagline: 'Ge ditt företag ett lyft med intelligenta AI-agenter',
      poweredBy: 'Drivs av',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistent',
      assistantThinking: 'Assistenten tänker',
      youSaid: 'Du sa',
      assistantSays: 'Assistenten säger',
      agentSays: '{{name}} säger',
      joinMeeting: 'Anslut till möte',
      meetingInProgress: 'Möte pågår — klicka för att återansluta',
      meetingExpired: 'Möteslänk (utgången)',
      embeddedContent: 'Inbäddat innehåll',
      openInNewTab: 'Öppna i ny flik',
      skipToMain: 'Hoppa till huvudinnehållet',
      loadingCustomerSolution: 'Läser in {{customerName}}-lösning',
      loadingSolution: 'Läser in lösning',
      customerLogoAlt: '{{customerName}}-logotyp',
      selectDate: 'Välj datum',
      selectTime: 'Välj tid',
      browseOptions: 'Bläddra bland alternativ',
      carouselRoleDescription: 'Karusell',
      carouselSlideLabel: 'Bild {{current}} av {{total}}',
      carouselPrevious: 'Föregående objekt',
      carouselNext: 'Nästa objekt',
      carouselGoToItem: 'Gå till objekt {{index}}',
      collapse: 'Fäll ihop',
      expand: 'Expandera',
      messageHistory: 'Meddelandehistorik',
      reduce: 'Förminska',
      today: 'Idag',
      at: 'kl.',
      a11yOptionsCount_zero: 'Det finns {{count}} alternativ.',
      a11yOptionsCount_one: 'Det finns 1 alternativ.',
      a11yOptionsCount_two: 'Det finns {{count}} alternativ.',
      a11yOptionsCount_few: 'Det finns {{count}} alternativ.',
      a11yOptionsCount_many: 'Det finns {{count}} alternativ.',
      a11yOptionsCount_other: 'Det finns {{count}} alternativ.',
      listpickerSelectAll: 'Välj alla',
      listpickerSelectOption: 'Välj ett alternativ',
      listpickerSearchAriaLabel: 'Sök efter filteralternativ',
      listpickerSearchPlaceholder: 'Sök…',
      listpickerNoResults: 'Inga matchande alternativ.',
      listpickerResults_zero: '{{count}} resultat',
      listpickerResults_one: '1 resultat',
      listpickerResults_two: '{{count}} resultat',
      listpickerResults_few: '{{count}} resultat',
      listpickerResults_many: '{{count}} resultat',
      listpickerResults_other: '{{count}} resultat',
      listpickerCondensed_zero: '{{count}} valda',
      listpickerCondensed_one: '1 vald',
      listpickerCondensed_two: '{{count}} valda',
      listpickerCondensed_few: '{{count}} valda',
      listpickerCondensed_many: '{{count}} valda',
      listpickerCondensed_other: '{{count}} valda',
      listpickerSelectAction: 'Välj',
      scrollToLatest: 'Bläddra till senaste meddelandet',
      scrollToUnread_zero: '{{count}} nya meddelanden, gå till senaste',
      scrollToUnread_one: '1 nytt meddelande, gå till senaste',
      scrollToUnread_two: '{{count}} nya meddelanden, gå till senaste',
      scrollToUnread_few: '{{count}} nya meddelanden, gå till senaste',
      scrollToUnread_many: '{{count}} nya meddelanden, gå till senaste',
      scrollToUnread_other: '{{count}} nya meddelanden, gå till senaste',
      showPassword: 'Visa säkert innehåll',
      hidePassword: 'Dölj säkert innehåll',
      clear: 'Rensa',
      send: 'Skicka',
      yesterday: 'Igår',
      chatEndedActions: 'Åtgärder efter avslutad chatt',
      openConversationDialog: 'Öppna konversationsfönster med {{title}}',
      agentTyping: 'Handläggaren skriver',
      agentAway: 'Våra handläggare är för närvarande inte tillgängliga.',
      agentBusy: 'Våra handläggare är upptagna just nu. Vänta...',
      waitingForAgent: 'Du kopplas till en handläggare...',
      waitingForAgentWithSkill:
        'Du kopplas till en handläggare för {{skill}}...',
      talkingWithAgent: 'Pratar med {{name}}',
      home: 'Start',
      back: 'Tillbaka',
      menu: 'Meny',
      minimize: 'Minimera',
      endConversation: 'Avsluta chatt',
      engageWithUs: 'Kontakta oss',
      noMessagesYet: 'Inga meddelanden ännu',
      tryAgain: 'Försök igen',
      rating: 'Betyg',
      shareLocation: 'Dela plats',
      locationShared: 'Plats delad',
      locationError: 'Det gick inte att hämta din plats',
      locationPermissionDenied: 'Platsbehörighet nekad',
      geolocationUnavailable: 'Platstjänster är inte tillgängliga',
      selectFile: 'Välj en fil',
      upload: 'Ladda upp',
      uploadComplete: 'Uppladdning klar',
      uploadFailed: 'Uppladdningen misslyckades',
      fileTooLarge: 'Filen är för stor',
      dragOrClick: 'Dra en fil eller klicka för att välja',
      document: 'Dokument',
      audioContent: 'Ljudinnehåll',
      videoContent: 'Videoinnehåll',
      unsupportedContent: 'Innehåll som inte stöds',
      unavailable: {
        error: {
          title: 'Något gick fel',
          body: 'Vi kunde inte läsa in chatten. Försök igen.',
          retry: 'Försök igen',
        },
        maintenance: {
          title: 'Chatten är tillfälligt otillgänglig',
          body: 'Vi utför planerat underhåll. Kom tillbaka snart.',
        },
      },
      image: 'Bild',
    },
  },
  {
    lang: 'th',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'การสนทนานี้สิ้นสุดแล้ว',
      agentConnected: 'คุณเชื่อมต่อกับเจ้าหน้าที่เรียบร้อยแล้ว',
      downloadTranscript: 'ดาวน์โหลดบันทึกการสนทนา',
      startNewConversation: 'เริ่มการสนทนาใหม่',
      returnToConversation: 'กลับไปที่การสนทนา',
      connecting: 'กำลังเชื่อมต่อ...',
      retry: 'ลองใหม่',
      network: {
        retry: 'เชื่อมต่อใหม่',
      },
      reconnecting: 'กำลังเชื่อมต่อใหม่...',
      connectionLost: 'การเชื่อมต่ออินเทอร์เน็ตหลุด',
      reconnectDescription:
        'การเชื่อมต่ออินเทอร์เน็ตหลุด คลิกเชื่อมต่อใหม่เพื่อลองอีกครั้ง',
      typeMessage: 'พิมพ์ข้อความ',
      inputSelect: 'เลือกตัวเลือก',
      inputSelectOrType: 'เลือกตัวเลือกหรือพิมพ์ข้อความ',
      secureInput: 'พิมพ์ข้อความที่ปลอดภัย',
      secureValueHidden: 'ค่าที่ปลอดภัยที่ซ่อนอยู่',
      startChat: 'เริ่มแชท',
      settings: 'การตั้งค่า',
      cancel: 'ยกเลิก',
      confirm: 'ยืนยัน',
      close: 'ปิด',
      next: 'ถัดไป',
      brandingTagline: 'เพิ่มศักยภาพธุรกิจของคุณด้วยเอเจนต์ AI อัจฉริยะ',
      poweredBy: 'ขับเคลื่อนโดย',
      pypestreamCom: 'Pypestream.com',
      assistant: 'ผู้ช่วย',
      assistantThinking: 'ผู้ช่วยกำลังคิด',
      youSaid: 'คุณพูดว่า',
      assistantSays: 'ผู้ช่วยพูดว่า',
      agentSays: '{{name}} พูดว่า',
      joinMeeting: 'เข้าร่วมการประชุม',
      meetingInProgress: 'การประชุมกำลังดำเนินอยู่ — คลิกเพื่อเข้าร่วมอีกครั้ง',
      meetingExpired: 'ลิงก์การประชุม (หมดอายุ)',
      embeddedContent: 'เนื้อหาที่ฝัง',
      openInNewTab: 'เปิดในแท็บใหม่',
      skipToMain: 'ข้ามไปยังเนื้อหาหลัก',
      loadingCustomerSolution: 'กำลังโหลดโซลูชัน {{customerName}}',
      loadingSolution: 'กำลังโหลดโซลูชัน',
      customerLogoAlt: 'โลโก้ {{customerName}}',
      selectDate: 'เลือกวันที่',
      selectTime: 'เลือกเวลา',
      browseOptions: 'เรียกดูตัวเลือก',
      carouselRoleDescription: 'ภาพหมุน',
      carouselSlideLabel: 'สไลด์ {{current}} จาก {{total}}',
      carouselPrevious: 'รายการก่อนหน้า',
      carouselNext: 'รายการถัดไป',
      carouselGoToItem: 'ไปที่รายการ {{index}}',
      collapse: 'ยุบ',
      expand: 'ขยาย',
      messageHistory: 'ประวัติข้อความ',
      reduce: 'ย่อ',
      today: 'วันนี้',
      at: 'เวลา',
      a11yOptionsCount_zero: 'มี {{count}} ตัวเลือก',
      a11yOptionsCount_one: 'มี 1 ตัวเลือก',
      a11yOptionsCount_two: 'มี {{count}} ตัวเลือก',
      a11yOptionsCount_few: 'มี {{count}} ตัวเลือก',
      a11yOptionsCount_many: 'มี {{count}} ตัวเลือก',
      a11yOptionsCount_other: 'มี {{count}} ตัวเลือก',
      listpickerSelectAll: 'เลือกทั้งหมด',
      listpickerSelectOption: 'เลือกตัวเลือก',
      listpickerSearchAriaLabel: 'ค้นหาตัวเลือกตัวกรอง',
      listpickerSearchPlaceholder: 'ค้นหา…',
      listpickerNoResults: 'ไม่มีตัวเลือกที่ตรงกัน',
      listpickerResults_zero: '{{count}} ผลลัพธ์',
      listpickerResults_one: '1 ผลลัพธ์',
      listpickerResults_two: '{{count}} ผลลัพธ์',
      listpickerResults_few: '{{count}} ผลลัพธ์',
      listpickerResults_many: '{{count}} ผลลัพธ์',
      listpickerResults_other: '{{count}} ผลลัพธ์',
      listpickerCondensed_zero: 'เลือกแล้ว {{count}}',
      listpickerCondensed_one: 'เลือกแล้ว 1',
      listpickerCondensed_two: 'เลือกแล้ว {{count}}',
      listpickerCondensed_few: 'เลือกแล้ว {{count}}',
      listpickerCondensed_many: 'เลือกแล้ว {{count}}',
      listpickerCondensed_other: 'เลือกแล้ว {{count}}',
      listpickerSelectAction: 'เลือก',
      scrollToLatest: 'เลื่อนไปที่ข้อความล่าสุด',
      scrollToUnread_zero: 'ข้อความใหม่ {{count}} รายการ เลื่อนไปล่าสุด',
      scrollToUnread_one: 'ข้อความใหม่ 1 รายการ เลื่อนไปล่าสุด',
      scrollToUnread_two: 'ข้อความใหม่ {{count}} รายการ เลื่อนไปล่าสุด',
      scrollToUnread_few: 'ข้อความใหม่ {{count}} รายการ เลื่อนไปล่าสุด',
      scrollToUnread_many: 'ข้อความใหม่ {{count}} รายการ เลื่อนไปล่าสุด',
      scrollToUnread_other: 'ข้อความใหม่ {{count}} รายการ เลื่อนไปล่าสุด',
      showPassword: 'แสดงเนื้อหาที่ปลอดภัย',
      hidePassword: 'ซ่อนเนื้อหาที่ปลอดภัย',
      clear: 'ล้าง',
      send: 'ส่ง',
      yesterday: 'เมื่อวาน',
      chatEndedActions: 'การดำเนินการหลังจบแชท',
      openConversationDialog: 'เปิดหน้าต่างการสนทนากับ {{title}}',
      agentTyping: 'เจ้าหน้าที่กำลังพิมพ์',
      agentAway: 'ขณะนี้เจ้าหน้าที่ของเราไม่พร้อมให้บริการ',
      agentBusy: 'ขณะนี้เจ้าหน้าที่ของเราไม่ว่าง โปรดรอสักครู่...',
      waitingForAgent: 'กำลังเชื่อมต่อคุณกับเจ้าหน้าที่...',
      waitingForAgentWithSkill: 'กำลังเชื่อมต่อคุณกับเจ้าหน้าที่ {{skill}}...',
      talkingWithAgent: 'กำลังสนทนากับ {{name}}',
      home: 'หน้าแรก',
      back: 'ย้อนกลับ',
      menu: 'เมนู',
      minimize: 'ย่อเล็กสุด',
      endConversation: 'จบแชท',
      engageWithUs: 'ติดต่อเรา',
      noMessagesYet: 'ยังไม่มีข้อความ',
      tryAgain: 'ลองอีกครั้ง',
      rating: 'การให้คะแนน',
      shareLocation: 'แชร์ตำแหน่ง',
      locationShared: 'แชร์ตำแหน่งแล้ว',
      locationError: 'ไม่สามารถดึงตำแหน่งของคุณได้',
      locationPermissionDenied: 'การอนุญาตตำแหน่งถูกปฏิเสธ',
      geolocationUnavailable: 'บริการระบุตำแหน่งไม่พร้อมใช้งาน',
      selectFile: 'เลือกไฟล์',
      upload: 'อัปโหลด',
      uploadComplete: 'อัปโหลดเสร็จสมบูรณ์',
      uploadFailed: 'อัปโหลดไม่สำเร็จ',
      fileTooLarge: 'ไฟล์ใหญ่เกินไป',
      dragOrClick: 'ลากไฟล์หรือคลิกเพื่อเลือก',
      document: 'เอกสาร',
      audioContent: 'เนื้อหาเสียง',
      videoContent: 'เนื้อหาวิดีโอ',
      unsupportedContent: 'เนื้อหาที่ไม่รองรับ',
      unavailable: {
        error: {
          title: 'มีบางอย่างผิดพลาด',
          body: 'เราไม่สามารถโหลดแชทได้ โปรดลองอีกครั้ง',
          retry: 'ลองอีกครั้ง',
        },
        maintenance: {
          title: 'แชทไม่พร้อมใช้งานชั่วคราว',
          body: 'เรากำลังดำเนินการบำรุงรักษาตามกำหนด โปรดกลับมาใหม่อีกครั้งเร็วๆ นี้',
        },
      },
      image: 'รูปภาพ',
    },
  },
  {
    lang: 'tl',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Natapos na ang pag-uusap na ito.',
      agentConnected: 'Matagumpay kang naikonekta sa isang ahente.',
      downloadTranscript: 'I-download ang transcript',
      startNewConversation: 'Magsimula ng bagong pag-uusap',
      returnToConversation: 'Bumalik sa pag-uusap',
      connecting: 'Kumokonekta...',
      retry: 'Subukan ulit',
      network: {
        retry: 'Kumonekta muli',
      },
      reconnecting: 'Kumokonekta muli...',
      connectionLost: 'Nawala ang koneksyon sa internet',
      reconnectDescription:
        'Nawala ang koneksyon sa internet. I-click ang Kumonekta muli para subukang muli.',
      typeMessage: 'Mag-type ng mensahe',
      inputSelect: 'Pumili ng opsyon',
      inputSelectOrType: 'Pumili ng opsyon o mag-type ng mensahe',
      secureInput: 'Mag-type ng secure na mensahe',
      secureValueHidden: 'Nakatagong secure na halaga',
      startChat: 'Magsimula ng chat',
      settings: 'Mga setting',
      cancel: 'Kanselahin',
      confirm: 'Kumpirmahin',
      close: 'Isara',
      next: 'Susunod',
      brandingTagline:
        'Palakasin ang iyong negosyo gamit ang matatalinong AI agent',
      poweredBy: 'Pinapagana ng',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Assistant',
      assistantThinking: 'Nag-iisip ang assistant',
      youSaid: 'Sinabi mo',
      assistantSays: 'Sinabi ng assistant',
      agentSays: 'Sinabi ni {{name}}',
      joinMeeting: 'Sumali sa meeting',
      meetingInProgress: 'Isinasagawa ang meeting — i-click para sumali muli',
      meetingExpired: 'Link ng meeting (nag-expire na)',
      embeddedContent: 'Naka-embed na nilalaman',
      openInNewTab: 'Buksan sa bagong tab',
      skipToMain: 'Lumaktaw sa pangunahing nilalaman',
      loadingCustomerSolution: 'Nilo-load ang solusyon ng {{customerName}}',
      loadingSolution: 'Nilo-load ang solusyon',
      customerLogoAlt: 'Logo ng {{customerName}}',
      selectDate: 'Pumili ng petsa',
      selectTime: 'Pumili ng oras',
      browseOptions: 'Mag-browse ng mga opsyon',
      carouselRoleDescription: 'Carousel',
      carouselSlideLabel: 'Slide {{current}} ng {{total}}',
      carouselPrevious: 'Nakaraang item',
      carouselNext: 'Susunod na item',
      carouselGoToItem: 'Pumunta sa item {{index}}',
      collapse: 'I-collapse',
      expand: 'I-expand',
      messageHistory: 'Kasaysayan ng mensahe',
      reduce: 'Paliitin',
      today: 'Ngayon',
      at: 'nang',
      a11yOptionsCount_zero: 'May {{count}} na opsyon.',
      a11yOptionsCount_one: 'May 1 opsyon.',
      a11yOptionsCount_two: 'May {{count}} na opsyon.',
      a11yOptionsCount_few: 'May {{count}} na opsyon.',
      a11yOptionsCount_many: 'May {{count}} na opsyon.',
      a11yOptionsCount_other: 'May {{count}} na opsyon.',
      listpickerSelectAll: 'Piliin lahat',
      listpickerSelectOption: 'Pumili ng opsyon',
      listpickerSearchAriaLabel: 'Maghanap ng mga opsyon sa filter',
      listpickerSearchPlaceholder: 'Maghanap…',
      listpickerNoResults: 'Walang tumutugmang opsyon.',
      listpickerResults_zero: '{{count}} na resulta',
      listpickerResults_one: '1 resulta',
      listpickerResults_two: '{{count}} na resulta',
      listpickerResults_few: '{{count}} na resulta',
      listpickerResults_many: '{{count}} na resulta',
      listpickerResults_other: '{{count}} na resulta',
      listpickerCondensed_zero: '{{count}} napili',
      listpickerCondensed_one: '1 napili',
      listpickerCondensed_two: '{{count}} napili',
      listpickerCondensed_few: '{{count}} napili',
      listpickerCondensed_many: '{{count}} napili',
      listpickerCondensed_other: '{{count}} napili',
      listpickerSelectAction: 'Piliin',
      scrollToLatest: 'Mag-scroll sa pinakabagong mensahe',
      scrollToUnread_zero: '{{count}} bagong mensahe, pumunta sa pinakabago',
      scrollToUnread_one: '1 bagong mensahe, pumunta sa pinakabago',
      scrollToUnread_two: '{{count}} bagong mensahe, pumunta sa pinakabago',
      scrollToUnread_few: '{{count}} bagong mensahe, pumunta sa pinakabago',
      scrollToUnread_many: '{{count}} bagong mensahe, pumunta sa pinakabago',
      scrollToUnread_other: '{{count}} bagong mensahe, pumunta sa pinakabago',
      showPassword: 'Ipakita ang secure na nilalaman',
      hidePassword: 'Itago ang secure na nilalaman',
      clear: 'I-clear',
      send: 'Ipadala',
      yesterday: 'Kahapon',
      chatEndedActions: 'Mga aksyon pagkatapos ng chat',
      openConversationDialog:
        'Buksan ang dialog ng pag-uusap kasama si {{title}}',
      agentTyping: 'Nagta-type ang ahente',
      agentAway: 'Kasalukuyang hindi available ang aming mga ahente.',
      agentBusy:
        'Kasalukuyang abala ang aming mga ahente. Mangyaring maghintay...',
      waitingForAgent: 'Ikinokonekta ka sa isang ahente...',
      waitingForAgentWithSkill:
        'Ikinokonekta ka sa isang ahente para sa {{skill}}...',
      talkingWithAgent: 'Nakikipag-usap kay {{name}}',
      home: 'Home',
      back: 'Bumalik',
      menu: 'Menu',
      minimize: 'I-minimize',
      endConversation: 'Tapusin ang chat',
      engageWithUs: 'Makipag-ugnayan sa amin',
      noMessagesYet: 'Wala pang mensahe',
      tryAgain: 'Subukan ulit',
      rating: 'Rating',
      shareLocation: 'Ibahagi ang lokasyon',
      locationShared: 'Naibahagi ang lokasyon',
      locationError: 'Hindi makuha ang iyong lokasyon',
      locationPermissionDenied: 'Tinanggihan ang pahintulot sa lokasyon',
      geolocationUnavailable: 'Hindi available ang mga serbisyo ng lokasyon',
      selectFile: 'Pumili ng file',
      upload: 'Mag-upload',
      uploadComplete: 'Kumpleto na ang pag-upload',
      uploadFailed: 'Nabigo ang pag-upload',
      fileTooLarge: 'Masyadong malaki ang file',
      dragOrClick: 'Mag-drag ng file o mag-click para pumili',
      document: 'Dokumento',
      audioContent: 'Nilalamang audio',
      videoContent: 'Nilalamang video',
      unsupportedContent: 'Hindi suportadong nilalaman',
      unavailable: {
        error: {
          title: 'May nangyaring mali',
          body: 'Hindi namin ma-load ang chat. Pakisubukan muli.',
          retry: 'Subukan ulit',
        },
        maintenance: {
          title: 'Pansamantalang hindi available ang chat',
          body: 'Nagsasagawa kami ng nakaiskedyul na maintenance. Bumalik ka mamaya.',
        },
      },
      image: 'Larawan',
    },
  },
  {
    lang: 'tr',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Bu görüşme sona erdi.',
      agentConnected: 'Bir temsilciye başarıyla bağlandınız.',
      downloadTranscript: 'Dökümü indir',
      startNewConversation: 'Yeni görüşme başlat',
      returnToConversation: 'Görüşmeye dön',
      connecting: 'Bağlanıyor...',
      retry: 'Tekrar dene',
      network: {
        retry: 'Yeniden bağlan',
      },
      reconnecting: 'Yeniden bağlanıyor...',
      connectionLost: 'İnternet bağlantısı kesildi',
      reconnectDescription:
        "İnternet bağlantısı kesildi. Yeniden denemek için Yeniden bağlan'a tıklayın.",
      typeMessage: 'Mesaj yazın',
      inputSelect: 'Bir seçenek belirleyin',
      inputSelectOrType: 'Bir seçenek belirleyin veya mesaj yazın',
      secureInput: 'Güvenli mesaj yazın',
      secureValueHidden: 'Gizli güvenli değer',
      startChat: 'Sohbeti başlat',
      settings: 'Ayarlar',
      cancel: 'İptal',
      confirm: 'Onayla',
      close: 'Kapat',
      next: 'İleri',
      brandingTagline: 'İşinizi akıllı yapay zeka aracılarıyla güçlendirin',
      poweredBy: 'Destekleyen',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Asistan',
      assistantThinking: 'Asistan düşünüyor',
      youSaid: 'Şöyle dediniz',
      assistantSays: 'Asistan diyor ki',
      agentSays: '{{name}} diyor ki',
      joinMeeting: 'Toplantıya katıl',
      meetingInProgress:
        'Toplantı devam ediyor — yeniden katılmak için tıklayın',
      meetingExpired: 'Toplantı bağlantısı (süresi doldu)',
      embeddedContent: 'Gömülü içerik',
      openInNewTab: 'Yeni sekmede aç',
      skipToMain: 'Ana içeriğe geç',
      loadingCustomerSolution: '{{customerName}} çözümü yükleniyor',
      loadingSolution: 'Çözüm yükleniyor',
      customerLogoAlt: '{{customerName}} logosu',
      selectDate: 'Tarih seçin',
      selectTime: 'Saat seçin',
      browseOptions: 'Seçeneklere göz atın',
      carouselRoleDescription: 'Atlıkarınca',
      carouselSlideLabel: 'Slayt {{current}} / {{total}}',
      carouselPrevious: 'Önceki öğe',
      carouselNext: 'Sonraki öğe',
      carouselGoToItem: '{{index}}. öğeye git',
      collapse: 'Daralt',
      expand: 'Genişlet',
      messageHistory: 'Mesaj geçmişi',
      reduce: 'Küçült',
      today: 'Bugün',
      at: 'saat',
      a11yOptionsCount_zero: '{{count}} seçenek var.',
      a11yOptionsCount_one: '1 seçenek var.',
      a11yOptionsCount_two: '{{count}} seçenek var.',
      a11yOptionsCount_few: '{{count}} seçenek var.',
      a11yOptionsCount_many: '{{count}} seçenek var.',
      a11yOptionsCount_other: '{{count}} seçenek var.',
      listpickerSelectAll: 'Tümünü seç',
      listpickerSelectOption: 'Bir seçenek belirleyin',
      listpickerSearchAriaLabel: 'Filtre seçeneklerinde ara',
      listpickerSearchPlaceholder: 'Ara…',
      listpickerNoResults: 'Eşleşen seçenek yok.',
      listpickerResults_zero: '{{count}} sonuç',
      listpickerResults_one: '1 sonuç',
      listpickerResults_two: '{{count}} sonuç',
      listpickerResults_few: '{{count}} sonuç',
      listpickerResults_many: '{{count}} sonuç',
      listpickerResults_other: '{{count}} sonuç',
      listpickerCondensed_zero: '{{count}} seçildi',
      listpickerCondensed_one: '1 seçildi',
      listpickerCondensed_two: '{{count}} seçildi',
      listpickerCondensed_few: '{{count}} seçildi',
      listpickerCondensed_many: '{{count}} seçildi',
      listpickerCondensed_other: '{{count}} seçildi',
      listpickerSelectAction: 'Seç',
      scrollToLatest: 'En son mesaja kaydır',
      scrollToUnread_zero: '{{count}} yeni mesaj, en sona kaydır',
      scrollToUnread_one: '1 yeni mesaj, en sona kaydır',
      scrollToUnread_two: '{{count}} yeni mesaj, en sona kaydır',
      scrollToUnread_few: '{{count}} yeni mesaj, en sona kaydır',
      scrollToUnread_many: '{{count}} yeni mesaj, en sona kaydır',
      scrollToUnread_other: '{{count}} yeni mesaj, en sona kaydır',
      showPassword: 'Güvenli içeriği göster',
      hidePassword: 'Güvenli içeriği gizle',
      clear: 'Temizle',
      send: 'Gönder',
      yesterday: 'Dün',
      chatEndedActions: 'Sohbet sonu işlemleri',
      openConversationDialog: '{{title}} ile görüşme penceresini aç',
      agentTyping: 'Temsilci yazıyor',
      agentAway: 'Temsilcilerimiz şu anda uygun değil.',
      agentBusy: 'Temsilcilerimiz şu anda meşgul. Lütfen bekleyin...',
      waitingForAgent: 'Sizi bir temsilciye bağlıyoruz...',
      waitingForAgentWithSkill: 'Sizi bir {{skill}} temsilcisine bağlıyoruz...',
      talkingWithAgent: '{{name}} ile görüşülüyor',
      home: 'Ana sayfa',
      back: 'Geri',
      menu: 'Menü',
      minimize: 'Simge durumuna küçült',
      endConversation: 'Sohbeti sonlandır',
      engageWithUs: 'Bizimle iletişime geçin',
      noMessagesYet: 'Henüz mesaj yok',
      tryAgain: 'Tekrar dene',
      rating: 'Değerlendirme',
      shareLocation: 'Konumu paylaş',
      locationShared: 'Konum paylaşıldı',
      locationError: 'Konumunuz alınamadı',
      locationPermissionDenied: 'Konum izni reddedildi',
      geolocationUnavailable: 'Konum hizmetleri kullanılamıyor',
      selectFile: 'Bir dosya seçin',
      upload: 'Yükle',
      uploadComplete: 'Yükleme tamamlandı',
      uploadFailed: 'Yükleme başarısız',
      fileTooLarge: 'Dosya çok büyük',
      dragOrClick: 'Bir dosya sürükleyin veya seçmek için tıklayın',
      document: 'Belge',
      audioContent: 'Ses içeriği',
      videoContent: 'Video içeriği',
      unsupportedContent: 'Desteklenmeyen içerik',
      unavailable: {
        error: {
          title: 'Bir şeyler ters gitti',
          body: 'Sohbet yüklenemedi. Lütfen tekrar deneyin.',
          retry: 'Tekrar dene',
        },
        maintenance: {
          title: 'Sohbet geçici olarak kullanılamıyor',
          body: 'Planlı bakım gerçekleştiriyoruz. Lütfen kısa süre sonra tekrar gelin.',
        },
      },
      image: 'Görsel',
    },
  },
  {
    lang: 'uk',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Цю розмову завершено.',
      agentConnected: "Вас успішно з'єднано з оператором.",
      downloadTranscript: 'Завантажити стенограму',
      startNewConversation: 'Розпочати нову розмову',
      returnToConversation: 'Повернутися до розмови',
      connecting: "З'єднання...",
      retry: 'Повторити',
      network: {
        retry: 'Перепідключитися',
      },
      reconnecting: "Повторне з'єднання...",
      connectionLost: "З'єднання з інтернетом втрачено",
      reconnectDescription:
        "З'єднання з інтернетом втрачено. Натисніть «Перепідключитися», щоб повторити.",
      typeMessage: 'Введіть повідомлення',
      inputSelect: 'Виберіть варіант',
      inputSelectOrType: 'Виберіть варіант або введіть повідомлення',
      secureInput: 'Введіть захищене повідомлення',
      secureValueHidden: 'Приховане захищене значення',
      startChat: 'Почати чат',
      settings: 'Налаштування',
      cancel: 'Скасувати',
      confirm: 'Підтвердити',
      close: 'Закрити',
      next: 'Далі',
      brandingTagline:
        'Прискорте свій бізнес за допомогою інтелектуальних ШІ-агентів',
      poweredBy: 'Працює на',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Асистент',
      assistantThinking: 'Асистент думає',
      youSaid: 'Ви сказали',
      assistantSays: 'Асистент каже',
      agentSays: '{{name}} каже',
      joinMeeting: 'Приєднатися до зустрічі',
      meetingInProgress: 'Зустріч триває — натисніть, щоб приєднатися знову',
      meetingExpired: 'Посилання на зустріч (застаріле)',
      embeddedContent: 'Вбудований вміст',
      openInNewTab: 'Відкрити в новій вкладці',
      skipToMain: 'Перейти до основного вмісту',
      loadingCustomerSolution: 'Завантаження рішення {{customerName}}',
      loadingSolution: 'Завантаження рішення',
      customerLogoAlt: 'Логотип {{customerName}}',
      selectDate: 'Виберіть дату',
      selectTime: 'Виберіть час',
      browseOptions: 'Переглянути варіанти',
      carouselRoleDescription: 'Карусель',
      carouselSlideLabel: 'Слайд {{current}} з {{total}}',
      carouselPrevious: 'Попередній елемент',
      carouselNext: 'Наступний елемент',
      carouselGoToItem: 'Перейти до елемента {{index}}',
      collapse: 'Згорнути',
      expand: 'Розгорнути',
      messageHistory: 'Історія повідомлень',
      reduce: 'Зменшити',
      today: 'Сьогодні',
      at: 'о',
      a11yOptionsCount_zero: 'Є {{count}} варіанта.',
      a11yOptionsCount_one: 'Є 1 варіант.',
      a11yOptionsCount_two: 'Є {{count}} варіанта.',
      a11yOptionsCount_few: 'Є {{count}} варіанти.',
      a11yOptionsCount_many: 'Є {{count}} варіантів.',
      a11yOptionsCount_other: 'Є {{count}} варіанта.',
      listpickerSelectAll: 'Вибрати все',
      listpickerSelectOption: 'Виберіть варіант',
      listpickerSearchAriaLabel: 'Пошук параметрів фільтра',
      listpickerSearchPlaceholder: 'Пошук…',
      listpickerNoResults: 'Немає відповідних варіантів.',
      listpickerResults_zero: '{{count}} результату',
      listpickerResults_one: '1 результат',
      listpickerResults_two: '{{count}} результату',
      listpickerResults_few: '{{count}} результати',
      listpickerResults_many: '{{count}} результатів',
      listpickerResults_other: '{{count}} результату',
      listpickerCondensed_zero: 'Вибрано {{count}}',
      listpickerCondensed_one: 'Вибрано 1',
      listpickerCondensed_two: 'Вибрано {{count}}',
      listpickerCondensed_few: 'Вибрано {{count}}',
      listpickerCondensed_many: 'Вибрано {{count}}',
      listpickerCondensed_other: 'Вибрано {{count}}',
      listpickerSelectAction: 'Вибрати',
      scrollToLatest: 'Перейти до останнього повідомлення',
      scrollToUnread_zero: '{{count}} нового повідомлення, до останнього',
      scrollToUnread_one: '1 нове повідомлення, до останнього',
      scrollToUnread_two: '{{count}} нового повідомлення, до останнього',
      scrollToUnread_few: '{{count}} нові повідомлення, до останнього',
      scrollToUnread_many: '{{count}} нових повідомлень, до останнього',
      scrollToUnread_other: '{{count}} нового повідомлення, до останнього',
      showPassword: 'Показати захищений вміст',
      hidePassword: 'Приховати захищений вміст',
      clear: 'Очистити',
      send: 'Надіслати',
      yesterday: 'Учора',
      chatEndedActions: 'Дії після завершення чату',
      openConversationDialog: 'Відкрити вікно розмови з {{title}}',
      agentTyping: 'Оператор друкує',
      agentAway: 'Наші оператори наразі недоступні.',
      agentBusy: 'Наші оператори наразі зайняті. Зачекайте, будь ласка...',
      waitingForAgent: "З'єднуємо вас з оператором...",
      waitingForAgentWithSkill:
        "З'єднуємо вас з оператором із питання «{{skill}}»...",
      talkingWithAgent: 'Розмова з {{name}}',
      home: 'Головна',
      back: 'Назад',
      menu: 'Меню',
      minimize: 'Згорнути',
      endConversation: 'Завершити чат',
      engageWithUs: "Зв'яжіться з нами",
      noMessagesYet: 'Повідомлень поки немає',
      tryAgain: 'Спробувати ще раз',
      rating: 'Оцінка',
      shareLocation: 'Поділитися місцезнаходженням',
      locationShared: 'Місцезнаходження надіслано',
      locationError: 'Не вдалося визначити ваше місцезнаходження',
      locationPermissionDenied: 'Доступ до місцезнаходження відхилено',
      geolocationUnavailable: 'Служби геолокації недоступні',
      selectFile: 'Виберіть файл',
      upload: 'Завантажити',
      uploadComplete: 'Завантаження завершено',
      uploadFailed: 'Помилка завантаження',
      fileTooLarge: 'Файл завеликий',
      dragOrClick: 'Перетягніть файл або натисніть, щоб вибрати',
      document: 'Документ',
      audioContent: 'Аудіовміст',
      videoContent: 'Відеовміст',
      unsupportedContent: 'Непідтримуваний вміст',
      unavailable: {
        error: {
          title: 'Щось пішло не так',
          body: 'Не вдалося завантажити чат. Спробуйте ще раз.',
          retry: 'Спробувати ще раз',
        },
        maintenance: {
          title: 'Чат тимчасово недоступний',
          body: 'Ми проводимо планове обслуговування. Завітайте пізніше.',
        },
      },
      image: 'Зображення',
    },
  },
  {
    lang: 'ur',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'یہ گفتگو ختم ہو گئی ہے۔',
      agentConnected: 'آپ کامیابی سے ایک ایجنٹ سے منسلک ہو گئے ہیں۔',
      downloadTranscript: 'ٹرانسکرپٹ ڈاؤن لوڈ کریں',
      startNewConversation: 'نئی گفتگو شروع کریں',
      returnToConversation: 'گفتگو پر واپس جائیں',
      connecting: 'منسلک ہو رہا ہے...',
      retry: 'دوبارہ کوشش کریں',
      network: {
        retry: 'دوبارہ منسلک کریں',
      },
      reconnecting: 'دوبارہ منسلک ہو رہا ہے...',
      connectionLost: 'انٹرنیٹ کنکشن ختم ہو گیا',
      reconnectDescription:
        "انٹرنیٹ کنکشن ختم ہو گیا۔ دوبارہ کوشش کے لیے 'دوبارہ منسلک کریں' پر کلک کریں۔",
      typeMessage: 'پیغام ٹائپ کریں',
      inputSelect: 'ایک آپشن منتخب کریں',
      inputSelectOrType: 'ایک آپشن منتخب کریں یا پیغام ٹائپ کریں',
      secureInput: 'محفوظ پیغام ٹائپ کریں',
      secureValueHidden: 'چھپی ہوئی محفوظ قدر',
      startChat: 'چیٹ شروع کریں',
      settings: 'ترتیبات',
      cancel: 'منسوخ کریں',
      confirm: 'تصدیق کریں',
      close: 'بند کریں',
      next: 'اگلا',
      brandingTagline: 'ذہین AI ایجنٹس کے ساتھ اپنے کاروبار کو تقویت دیں',
      poweredBy: 'کے ذریعے',
      pypestreamCom: 'Pypestream.com',
      assistant: 'اسسٹنٹ',
      assistantThinking: 'اسسٹنٹ سوچ رہا ہے',
      youSaid: 'آپ نے کہا',
      assistantSays: 'اسسٹنٹ کہتا ہے',
      agentSays: '{{name}} کہتے ہیں',
      joinMeeting: 'میٹنگ میں شامل ہوں',
      meetingInProgress: 'میٹنگ جاری ہے — دوبارہ شامل ہونے کے لیے کلک کریں',
      meetingExpired: 'میٹنگ لنک (میعاد ختم)',
      embeddedContent: 'سرایت شدہ مواد',
      openInNewTab: 'نئے ٹیب میں کھولیں',
      skipToMain: 'مرکزی مواد پر جائیں',
      loadingCustomerSolution: '{{customerName}} کا حل لوڈ ہو رہا ہے',
      loadingSolution: 'حل لوڈ ہو رہا ہے',
      customerLogoAlt: '{{customerName}} کا لوگو',
      selectDate: 'تاریخ منتخب کریں',
      selectTime: 'وقت منتخب کریں',
      browseOptions: 'اختیارات دیکھیں',
      carouselRoleDescription: 'کیروسل',
      carouselSlideLabel: 'سلائیڈ {{current}} از {{total}}',
      carouselPrevious: 'پچھلا آئٹم',
      carouselNext: 'اگلا آئٹم',
      carouselGoToItem: 'آئٹم {{index}} پر جائیں',
      collapse: 'سکیڑیں',
      expand: 'پھیلائیں',
      messageHistory: 'پیغام کی تاریخ',
      reduce: 'چھوٹا کریں',
      today: 'آج',
      at: 'بوقت',
      a11yOptionsCount_zero: '{{count}} آپشنز ہیں۔',
      a11yOptionsCount_one: '1 آپشن ہے۔',
      a11yOptionsCount_two: '{{count}} آپشنز ہیں۔',
      a11yOptionsCount_few: '{{count}} آپشنز ہیں۔',
      a11yOptionsCount_many: '{{count}} آپشنز ہیں۔',
      a11yOptionsCount_other: '{{count}} آپشنز ہیں۔',
      listpickerSelectAll: 'سب منتخب کریں',
      listpickerSelectOption: 'ایک آپشن منتخب کریں',
      listpickerSearchAriaLabel: 'فلٹر اختیارات تلاش کریں',
      listpickerSearchPlaceholder: 'تلاش کریں…',
      listpickerNoResults: 'کوئی مماثل اختیار نہیں۔',
      listpickerResults_zero: '{{count}} نتائج',
      listpickerResults_one: '1 نتیجہ',
      listpickerResults_two: '{{count}} نتائج',
      listpickerResults_few: '{{count}} نتائج',
      listpickerResults_many: '{{count}} نتائج',
      listpickerResults_other: '{{count}} نتائج',
      listpickerCondensed_zero: '{{count}} منتخب',
      listpickerCondensed_one: '1 منتخب',
      listpickerCondensed_two: '{{count}} منتخب',
      listpickerCondensed_few: '{{count}} منتخب',
      listpickerCondensed_many: '{{count}} منتخب',
      listpickerCondensed_other: '{{count}} منتخب',
      listpickerSelectAction: 'منتخب کریں',
      scrollToLatest: 'تازہ ترین پیغام پر سکرول کریں',
      scrollToUnread_zero: '{{count}} نئے پیغامات، تازہ ترین پر جائیں',
      scrollToUnread_one: '1 نیا پیغام، تازہ ترین پر جائیں',
      scrollToUnread_two: '{{count}} نئے پیغامات، تازہ ترین پر جائیں',
      scrollToUnread_few: '{{count}} نئے پیغامات، تازہ ترین پر جائیں',
      scrollToUnread_many: '{{count}} نئے پیغامات، تازہ ترین پر جائیں',
      scrollToUnread_other: '{{count}} نئے پیغامات، تازہ ترین پر جائیں',
      showPassword: 'محفوظ مواد دکھائیں',
      hidePassword: 'محفوظ مواد چھپائیں',
      clear: 'صاف کریں',
      send: 'بھیجیں',
      yesterday: 'کل',
      chatEndedActions: 'چیٹ ختم ہونے کے بعد کے اعمال',
      openConversationDialog: '{{title}} کے ساتھ گفتگو کا ڈائیلاگ کھولیں',
      agentTyping: 'ایجنٹ ٹائپ کر رہا ہے',
      agentAway: 'ہمارے ایجنٹس اس وقت دستیاب نہیں ہیں۔',
      agentBusy: 'ہمارے ایجنٹس اس وقت مصروف ہیں۔ براہ کرم انتظار کریں...',
      waitingForAgent: 'آپ کو ایک ایجنٹ سے منسلک کیا جا رہا ہے...',
      waitingForAgentWithSkill:
        'آپ کو {{skill}} کے ایجنٹ سے منسلک کیا جا رہا ہے...',
      talkingWithAgent: '{{name}} سے گفتگو',
      home: 'ہوم',
      back: 'واپس',
      menu: 'مینو',
      minimize: 'چھوٹا کریں',
      endConversation: 'چیٹ ختم کریں',
      engageWithUs: 'ہم سے رابطہ کریں',
      noMessagesYet: 'ابھی تک کوئی پیغام نہیں',
      tryAgain: 'دوبارہ کوشش کریں',
      rating: 'درجہ بندی',
      shareLocation: 'مقام شیئر کریں',
      locationShared: 'مقام شیئر کر دیا گیا',
      locationError: 'آپ کا مقام حاصل نہیں کیا جا سکا',
      locationPermissionDenied: 'مقام کی اجازت مسترد کر دی گئی',
      geolocationUnavailable: 'مقام کی خدمات دستیاب نہیں ہیں',
      selectFile: 'ایک فائل منتخب کریں',
      upload: 'اپ لوڈ کریں',
      uploadComplete: 'اپ لوڈ مکمل',
      uploadFailed: 'اپ لوڈ ناکام',
      fileTooLarge: 'فائل بہت بڑی ہے',
      dragOrClick: 'فائل گھسیٹیں یا منتخب کرنے کے لیے کلک کریں',
      document: 'دستاویز',
      audioContent: 'آڈیو مواد',
      videoContent: 'ویڈیو مواد',
      unsupportedContent: 'غیر معاون مواد',
      unavailable: {
        error: {
          title: 'کچھ غلط ہو گیا',
          body: 'ہم چیٹ لوڈ نہیں کر سکے۔ براہ کرم دوبارہ کوشش کریں۔',
          retry: 'دوبارہ کوشش کریں',
        },
        maintenance: {
          title: 'چیٹ عارضی طور پر دستیاب نہیں',
          body: 'ہم طے شدہ دیکھ بھال کر رہے ہیں۔ براہ کرم جلد واپس آئیں۔',
        },
      },
      image: 'تصویر',
    },
  },
  {
    lang: 'vi',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'Cuộc trò chuyện này đã kết thúc.',
      agentConnected: 'Bạn đã được kết nối thành công với nhân viên hỗ trợ.',
      downloadTranscript: 'Tải xuống bản ghi',
      startNewConversation: 'Bắt đầu cuộc trò chuyện mới',
      returnToConversation: 'Quay lại cuộc trò chuyện',
      connecting: 'Đang kết nối...',
      retry: 'Thử lại',
      network: {
        retry: 'Kết nối lại',
      },
      reconnecting: 'Đang kết nối lại...',
      connectionLost: 'Đã mất kết nối internet',
      reconnectDescription:
        'Đã mất kết nối internet. Nhấp vào Kết nối lại để thử lại.',
      typeMessage: 'Nhập tin nhắn',
      inputSelect: 'Chọn một tùy chọn',
      inputSelectOrType: 'Chọn một tùy chọn hoặc nhập tin nhắn',
      secureInput: 'Nhập tin nhắn bảo mật',
      secureValueHidden: 'Giá trị bảo mật ẩn',
      startChat: 'Bắt đầu trò chuyện',
      settings: 'Cài đặt',
      cancel: 'Hủy',
      confirm: 'Xác nhận',
      close: 'Đóng',
      next: 'Tiếp theo',
      brandingTagline:
        'Tăng cường doanh nghiệp của bạn với các tác nhân AI thông minh',
      poweredBy: 'Được cung cấp bởi',
      pypestreamCom: 'Pypestream.com',
      assistant: 'Trợ lý',
      assistantThinking: 'Trợ lý đang suy nghĩ',
      youSaid: 'Bạn đã nói',
      assistantSays: 'Trợ lý nói',
      agentSays: '{{name}} nói',
      joinMeeting: 'Tham gia cuộc họp',
      meetingInProgress: 'Cuộc họp đang diễn ra — nhấp để tham gia lại',
      meetingExpired: 'Liên kết cuộc họp (đã hết hạn)',
      embeddedContent: 'Nội dung nhúng',
      openInNewTab: 'Mở trong tab mới',
      skipToMain: 'Chuyển đến nội dung chính',
      loadingCustomerSolution: 'Đang tải giải pháp {{customerName}}',
      loadingSolution: 'Đang tải giải pháp',
      customerLogoAlt: 'Logo {{customerName}}',
      selectDate: 'Chọn ngày',
      selectTime: 'Chọn giờ',
      browseOptions: 'Duyệt các tùy chọn',
      carouselRoleDescription: 'Băng chuyền',
      carouselSlideLabel: 'Trang chiếu {{current}} trên {{total}}',
      carouselPrevious: 'Mục trước',
      carouselNext: 'Mục tiếp theo',
      carouselGoToItem: 'Đến mục {{index}}',
      collapse: 'Thu gọn',
      expand: 'Mở rộng',
      messageHistory: 'Lịch sử tin nhắn',
      reduce: 'Thu nhỏ',
      today: 'Hôm nay',
      at: 'lúc',
      a11yOptionsCount_zero: 'Có {{count}} tùy chọn.',
      a11yOptionsCount_one: 'Có 1 tùy chọn.',
      a11yOptionsCount_two: 'Có {{count}} tùy chọn.',
      a11yOptionsCount_few: 'Có {{count}} tùy chọn.',
      a11yOptionsCount_many: 'Có {{count}} tùy chọn.',
      a11yOptionsCount_other: 'Có {{count}} tùy chọn.',
      listpickerSelectAll: 'Chọn tất cả',
      listpickerSelectOption: 'Chọn một tùy chọn',
      listpickerSearchAriaLabel: 'Tìm kiếm tùy chọn bộ lọc',
      listpickerSearchPlaceholder: 'Tìm kiếm…',
      listpickerNoResults: 'Không có tùy chọn nào phù hợp.',
      listpickerResults_zero: '{{count}} kết quả',
      listpickerResults_one: '1 kết quả',
      listpickerResults_two: '{{count}} kết quả',
      listpickerResults_few: '{{count}} kết quả',
      listpickerResults_many: '{{count}} kết quả',
      listpickerResults_other: '{{count}} kết quả',
      listpickerCondensed_zero: 'Đã chọn {{count}}',
      listpickerCondensed_one: 'Đã chọn 1',
      listpickerCondensed_two: 'Đã chọn {{count}}',
      listpickerCondensed_few: 'Đã chọn {{count}}',
      listpickerCondensed_many: 'Đã chọn {{count}}',
      listpickerCondensed_other: 'Đã chọn {{count}}',
      listpickerSelectAction: 'Chọn',
      scrollToLatest: 'Cuộn đến tin nhắn mới nhất',
      scrollToUnread_zero: '{{count}} tin nhắn mới, cuộn đến mới nhất',
      scrollToUnread_one: '1 tin nhắn mới, cuộn đến mới nhất',
      scrollToUnread_two: '{{count}} tin nhắn mới, cuộn đến mới nhất',
      scrollToUnread_few: '{{count}} tin nhắn mới, cuộn đến mới nhất',
      scrollToUnread_many: '{{count}} tin nhắn mới, cuộn đến mới nhất',
      scrollToUnread_other: '{{count}} tin nhắn mới, cuộn đến mới nhất',
      showPassword: 'Hiện nội dung bảo mật',
      hidePassword: 'Ẩn nội dung bảo mật',
      clear: 'Xóa',
      send: 'Gửi',
      yesterday: 'Hôm qua',
      chatEndedActions: 'Hành động sau khi trò chuyện kết thúc',
      openConversationDialog: 'Mở hộp thoại trò chuyện với {{title}}',
      agentTyping: 'Nhân viên đang nhập',
      agentAway: 'Nhân viên của chúng tôi hiện không có mặt.',
      agentBusy: 'Nhân viên của chúng tôi hiện đang bận. Vui lòng chờ...',
      waitingForAgent: 'Đang kết nối bạn với nhân viên hỗ trợ...',
      waitingForAgentWithSkill: 'Đang kết nối bạn với nhân viên {{skill}}...',
      talkingWithAgent: 'Đang trò chuyện với {{name}}',
      home: 'Trang chủ',
      back: 'Quay lại',
      menu: 'Menu',
      minimize: 'Thu nhỏ',
      endConversation: 'Kết thúc trò chuyện',
      engageWithUs: 'Liên hệ với chúng tôi',
      noMessagesYet: 'Chưa có tin nhắn',
      tryAgain: 'Thử lại',
      rating: 'Đánh giá',
      shareLocation: 'Chia sẻ vị trí',
      locationShared: 'Đã chia sẻ vị trí',
      locationError: 'Không thể lấy vị trí của bạn',
      locationPermissionDenied: 'Quyền truy cập vị trí bị từ chối',
      geolocationUnavailable: 'Dịch vụ định vị không khả dụng',
      selectFile: 'Chọn tệp',
      upload: 'Tải lên',
      uploadComplete: 'Tải lên hoàn tất',
      uploadFailed: 'Tải lên thất bại',
      fileTooLarge: 'Tệp quá lớn',
      dragOrClick: 'Kéo tệp hoặc nhấp để chọn',
      document: 'Tài liệu',
      audioContent: 'Nội dung âm thanh',
      videoContent: 'Nội dung video',
      unsupportedContent: 'Nội dung không được hỗ trợ',
      unavailable: {
        error: {
          title: 'Đã xảy ra lỗi',
          body: 'Chúng tôi không thể tải cuộc trò chuyện. Vui lòng thử lại.',
          retry: 'Thử lại',
        },
        maintenance: {
          title: 'Trò chuyện tạm thời không khả dụng',
          body: 'Chúng tôi đang bảo trì theo lịch. Vui lòng quay lại sau.',
        },
      },
      image: 'Hình ảnh',
    },
  },
  {
    lang: 'yi',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: 'די דאָזיקע שמועס האָט זיך געענדיקט.',
      agentConnected:
        'איר זײַט מיט דערפאָלג פֿאַרבונדן געוואָרן מיט אַן אַגענט.',
      downloadTranscript: 'אַראָפּלאָדן טראַנסקריפּט',
      startNewConversation: 'אָנהייבן אַ נײַע שמועס',
      returnToConversation: 'צוריק צו דער שמועס',
      connecting: 'פֿאַרבינדן...',
      retry: 'פּרוּווט נאָך אַ מאָל',
      network: {
        retry: 'פֿאַרבינדט זיך נאָך אַ מאָל',
      },
      reconnecting: 'פֿאַרבינדן זיך נאָך אַ מאָל...',
      connectionLost: 'די אינטערנעץ־פֿאַרבינדונג איז פֿאַרלוירן געוואָרן',
      reconnectDescription:
        'די אינטערנעץ־פֿאַרבינדונג איז פֿאַרלוירן געוואָרן. קליקט „פֿאַרבינדט זיך נאָך אַ מאָל“ צו פּרוּוון נאָך אַ מאָל.',
      typeMessage: 'שרײַבט אַ מעלדונג',
      inputSelect: 'קלײַבט אַן אָפּציע',
      inputSelectOrType: 'קלײַבט אַן אָפּציע אָדער שרײַבט אַ מעלדונג',
      secureInput: 'שרײַבט אַ זיכערע מעלדונג',
      secureValueHidden: 'באַהאַלטענער זיכערער ווערט',
      startChat: 'אָנהייבן שמועס',
      settings: 'אײַנשטעלונגען',
      cancel: 'אָפּזאָגן',
      confirm: 'באַשטעטיקן',
      close: 'פֿאַרמאַכן',
      next: 'ווײַטער',
      brandingTagline: 'שטאַרקט אײַער געשעפֿט מיט קלוגע KI־אַגענטן',
      poweredBy: 'אָנגעטריבן דורך',
      pypestreamCom: 'Pypestream.com',
      assistant: 'אַסיסטענט',
      assistantThinking: 'דער אַסיסטענט טראַכט',
      youSaid: 'איר האָט געזאָגט',
      assistantSays: 'דער אַסיסטענט זאָגט',
      agentSays: '{{name}} זאָגט',
      joinMeeting: 'בײַטרעטן צו דער זיצונג',
      meetingInProgress: 'די זיצונג גייט אָן — קליקט צו בײַטרעטן נאָך אַ מאָל',
      meetingExpired: 'זיצונג־לינק (אויסגעגאַנגען)',
      embeddedContent: 'אײַנגעבעטער אינהאַלט',
      openInNewTab: 'עפֿן אין אַ נײַעם טאַב',
      skipToMain: 'שפּרינגט צום הויפּט־אינהאַלט',
      loadingCustomerSolution: 'לאָדן די {{customerName}} לייזונג',
      loadingSolution: 'לאָדן די לייזונג',
      customerLogoAlt: '{{customerName}} לאָגאָ',
      selectDate: 'קלײַבט אַ דאַטע',
      selectTime: 'קלײַבט אַ צײַט',
      browseOptions: 'בלעטערט אָפּציעס',
      carouselRoleDescription: 'קאַרוסעל',
      carouselSlideLabel: 'בילד {{current}} פֿון {{total}}',
      carouselPrevious: 'פֿריִערדיקער אײַנטראָג',
      carouselNext: 'ווײַטערדיקער אײַנטראָג',
      carouselGoToItem: 'גייט צו אײַנטראָג {{index}}',
      collapse: 'צונויפֿקלאַפּן',
      expand: 'פֿאַרברייטערן',
      messageHistory: 'מעלדונג־געשיכטע',
      reduce: 'פֿאַרקלענערן',
      today: 'הײַנט',
      at: '',
      a11yOptionsCount_zero: 'עס זײַנען דאָ {{count}} אָפּציעס.',
      a11yOptionsCount_one: 'עס איז דאָ 1 אָפּציע.',
      a11yOptionsCount_two: 'עס זײַנען דאָ {{count}} אָפּציעס.',
      a11yOptionsCount_few: 'עס זײַנען דאָ {{count}} אָפּציעס.',
      a11yOptionsCount_many: 'עס זײַנען דאָ {{count}} אָפּציעס.',
      a11yOptionsCount_other: 'עס זײַנען דאָ {{count}} אָפּציעס.',
      listpickerSelectAll: 'קלײַבט אַלץ',
      listpickerSelectOption: 'קלײַבט אַן אָפּציע',
      listpickerSearchAriaLabel: 'זוכט פֿילטער־אָפּציעס',
      listpickerSearchPlaceholder: 'זוכן…',
      listpickerNoResults: 'קיין פּאַסיקע אָפּציעס.',
      listpickerResults_zero: '{{count}} רעזולטאַטן',
      listpickerResults_one: '1 רעזולטאַט',
      listpickerResults_two: '{{count}} רעזולטאַטן',
      listpickerResults_few: '{{count}} רעזולטאַטן',
      listpickerResults_many: '{{count}} רעזולטאַטן',
      listpickerResults_other: '{{count}} רעזולטאַטן',
      listpickerCondensed_zero: '{{count}} געקליבן',
      listpickerCondensed_one: '1 געקליבן',
      listpickerCondensed_two: '{{count}} געקליבן',
      listpickerCondensed_few: '{{count}} געקליבן',
      listpickerCondensed_many: '{{count}} געקליבן',
      listpickerCondensed_other: '{{count}} געקליבן',
      listpickerSelectAction: 'קלײַבן',
      scrollToLatest: 'בלעטערט צו דער לעצטער מעלדונג',
      scrollToUnread_zero: '{{count}} נײַע מעלדונגען, צו דער לעצטער',
      scrollToUnread_one: '1 נײַע מעלדונג, צו דער לעצטער',
      scrollToUnread_two: '{{count}} נײַע מעלדונגען, צו דער לעצטער',
      scrollToUnread_few: '{{count}} נײַע מעלדונגען, צו דער לעצטער',
      scrollToUnread_many: '{{count}} נײַע מעלדונגען, צו דער לעצטער',
      scrollToUnread_other: '{{count}} נײַע מעלדונגען, צו דער לעצטער',
      showPassword: 'ווײַזן זיכערן אינהאַלט',
      hidePassword: 'באַהאַלטן זיכערן אינהאַלט',
      clear: 'רייניקן',
      send: 'שיקן',
      yesterday: 'נעכטן',
      chatEndedActions: 'אַקציעס נאָך דעם ענד פֿון שמועס',
      openConversationDialog: 'עפֿן שמועס־דיאַלאָג מיט {{title}}',
      agentTyping: 'דער אַגענט שרײַבט',
      agentAway: 'אונדזערע אַגענטן זײַנען דערווײַל נישט צוטריטלעך.',
      agentBusy: 'אונדזערע אַגענטן זײַנען דערווײַל פֿאַרנומען. וואַרט ביטע...',
      waitingForAgent: 'מיר פֿאַרבינדן אײַך מיט אַן אַגענט...',
      waitingForAgentWithSkill:
        'מיר פֿאַרבינדן אײַך מיט אַ {{skill}}־אַגענט...',
      talkingWithAgent: 'רעדן מיט {{name}}',
      home: 'היים',
      back: 'צוריק',
      menu: 'מעניו',
      minimize: 'פֿאַרקלענערן',
      endConversation: 'ענדיקן שמועס',
      engageWithUs: 'פֿאַרבינדט זיך מיט אונדז',
      noMessagesYet: 'נאָך קיין מעלדונגען',
      tryAgain: 'פּרוּווט נאָך אַ מאָל',
      rating: 'אָפּשאַצונג',
      shareLocation: 'טיילן אָרט',
      locationShared: 'אָרט געטיילט',
      locationError: "מ'האָט נישט געקענט באַקומען אײַער אָרט",
      locationPermissionDenied: 'אָרט־דערלויבעניש אָפּגעזאָגט',
      geolocationUnavailable: 'אָרט־דינסטן זײַנען נישט צוטריטלעך',
      selectFile: 'קלײַבט אַ טעקע',
      upload: 'אַרויפֿלאָדן',
      uploadComplete: 'אַרויפֿלאָדן פֿאַרטיק',
      uploadFailed: 'אַרויפֿלאָדן דורכגעפֿאַלן',
      fileTooLarge: 'די טעקע איז צו גרויס',
      dragOrClick: 'שלעפּט אַ טעקע אָדער קליקט צו קלײַבן',
      document: 'דאָקומענט',
      audioContent: 'אַודיאָ־אינהאַלט',
      videoContent: 'ווידעאָ־אינהאַלט',
      unsupportedContent: 'נישט־געשטיצטער אינהאַלט',
      unavailable: {
        error: {
          title: 'עפּעס איז געגאַנגען נישט ריכטיק',
          body: 'מיר האָבן נישט געקענט לאָדן די שמועס. פּרוּווט ביטע נאָך אַ מאָל.',
          retry: 'פּרוּווט נאָך אַ מאָל',
        },
        maintenance: {
          title: 'שמועס איז דערווײַל נישט צוטריטלעך',
          body: 'מיר פֿירן אויס אַ פּלאַנירטע וואַרטונג. קומט ביטע צוריק אין גיכן.',
        },
      },
      image: 'בילד',
    },
  },
  {
    lang: 'zh',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: '此对话已结束。',
      agentConnected: '您已成功接入人工客服。',
      downloadTranscript: '下载记录',
      startNewConversation: '开始新对话',
      returnToConversation: '返回对话',
      connecting: '正在连接…',
      retry: '重试',
      network: {
        retry: '重新连接',
      },
      reconnecting: '正在重新连接…',
      connectionLost: '网络连接已断开',
      reconnectDescription: '网络连接已断开。点击“重新连接”重试。',
      typeMessage: '输入消息',
      inputSelect: '选择选项',
      inputSelectOrType: '选择选项或输入消息',
      secureInput: '输入安全消息',
      secureValueHidden: '隐藏的安全值',
      startChat: '开始聊天',
      settings: '设置',
      cancel: '取消',
      confirm: '确认',
      close: '关闭',
      next: '下一步',
      brandingTagline: '借助智能 AI 代理为您的业务赋能',
      poweredBy: '技术支持',
      pypestreamCom: 'Pypestream.com',
      assistant: '助手',
      assistantThinking: '助手正在思考',
      youSaid: '您说',
      assistantSays: '助手说',
      agentSays: '{{name}} 说',
      joinMeeting: '加入会议',
      meetingInProgress: '会议进行中 — 点击重新加入',
      meetingExpired: '会议链接（已过期）',
      embeddedContent: '嵌入内容',
      openInNewTab: '在新标签页中打开',
      skipToMain: '跳到主要内容',
      loadingCustomerSolution: '正在加载 {{customerName}} 解决方案',
      loadingSolution: '正在加载解决方案',
      customerLogoAlt: '{{customerName}} 徽标',
      selectDate: '选择日期',
      selectTime: '选择时间',
      browseOptions: '浏览选项',
      carouselRoleDescription: '轮播',
      carouselSlideLabel: '第 {{current}} 张，共 {{total}} 张',
      carouselPrevious: '上一项',
      carouselNext: '下一项',
      carouselGoToItem: '转到第 {{index}} 项',
      collapse: '收起',
      expand: '展开',
      messageHistory: '消息历史',
      reduce: '缩小',
      today: '今天',
      at: '于',
      a11yOptionsCount_other: '共 {{count}} 个选项。',
      listpickerSelectAll: '全选',
      listpickerSelectOption: '选择一个选项',
      listpickerSearchAriaLabel: '搜索筛选选项',
      listpickerSearchPlaceholder: '搜索…',
      listpickerNoResults: '没有匹配的选项。',
      listpickerResults_other: '{{count}} 个结果',
      listpickerCondensed_other: '已选择 {{count}} 项',
      listpickerSelectAction: '选择',
      scrollToLatest: '滚动到最新消息',
      scrollToUnread_other: '{{count}} 条新消息，滚动到最新',
      showPassword: '显示安全内容',
      hidePassword: '隐藏安全内容',
      clear: '清除',
      send: '发送',
      yesterday: '昨天',
      chatEndedActions: '聊天结束操作',
      openConversationDialog: '打开与 {{title}} 的对话窗口',
      agentTyping: '客服正在输入',
      agentAway: '我们的客服当前不可用。',
      agentBusy: '我们的客服当前繁忙，请稍候…',
      waitingForAgent: '正在为您接入客服…',
      waitingForAgentWithSkill: '正在为您接入 {{skill}} 客服…',
      talkingWithAgent: '正在与 {{name}} 对话',
      home: '主页',
      back: '返回',
      menu: '菜单',
      minimize: '最小化',
      endConversation: '结束聊天',
      engageWithUs: '与我们互动',
      noMessagesYet: '暂无消息',
      tryAgain: '重试',
      rating: '评分',
      shareLocation: '共享位置',
      locationShared: '已共享位置',
      locationError: '无法获取您的位置',
      locationPermissionDenied: '位置权限被拒绝',
      geolocationUnavailable: '定位服务不可用',
      selectFile: '选择文件',
      upload: '上传',
      uploadComplete: '上传完成',
      uploadFailed: '上传失败',
      fileTooLarge: '文件过大',
      dragOrClick: '拖动文件或点击选择',
      document: '文档',
      audioContent: '音频内容',
      videoContent: '视频内容',
      unsupportedContent: '不支持的内容',
      unavailable: {
        error: {
          title: '出了点问题',
          body: '无法加载聊天，请重试。',
          retry: '重试',
        },
        maintenance: {
          title: '聊天暂时不可用',
          body: '我们正在进行计划维护，请稍后再来。',
        },
      },
      image: '图片',
    },
  },
  {
    lang: 'zh-HK',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: '此對話已結束。',
      agentConnected: '您已成功接入客服專員。',
      downloadTranscript: '下載記錄',
      startNewConversation: '開始新對話',
      returnToConversation: '返回對話',
      connecting: '連線中...',
      retry: '重試',
      network: {
        retry: '重新連線',
      },
      reconnecting: '重新連線中...',
      connectionLost: '網路連線已中斷',
      reconnectDescription: '網路連線已中斷。請按一下「重新連線」以重試。',
      typeMessage: '輸入訊息',
      inputSelect: '選擇選項',
      inputSelectOrType: '選擇選項或輸入訊息',
      secureInput: '輸入安全訊息',
      secureValueHidden: '隱藏的安全值',
      startChat: '開始對話',
      settings: '設定',
      cancel: '取消',
      confirm: '確認',
      close: '關閉',
      next: '下一步',
      brandingTagline: '以智慧型 AI 代理為您的業務賦能',
      poweredBy: '技術支援',
      pypestreamCom: 'Pypestream.com',
      assistant: '助理',
      assistantThinking: '助理正在思考',
      youSaid: '您說',
      assistantSays: '助理說',
      agentSays: '{{name}} 說',
      joinMeeting: '加入會議',
      meetingInProgress: '會議進行中 — 按一下以重新加入',
      meetingExpired: '會議連結（已過期）',
      embeddedContent: '嵌入內容',
      openInNewTab: '在新分頁中開啟',
      skipToMain: '跳至主要內容',
      loadingCustomerSolution: '正在載入 {{customerName}} 解決方案',
      loadingSolution: '正在載入解決方案',
      customerLogoAlt: '{{customerName}} 標誌',
      selectDate: '選擇日期',
      selectTime: '選擇時間',
      browseOptions: '瀏覽選項',
      carouselRoleDescription: '輪播',
      carouselSlideLabel: '第 {{current}} 張，共 {{total}} 張',
      carouselPrevious: '上一項',
      carouselNext: '下一項',
      carouselGoToItem: '前往第 {{index}} 項',
      collapse: '收合',
      expand: '展開',
      messageHistory: '訊息記錄',
      reduce: '縮小',
      today: '今天',
      at: '於',
      a11yOptionsCount_zero: '共有 {{count}} 個選項。',
      a11yOptionsCount_one: '有 1 個選項。',
      a11yOptionsCount_two: '共有 {{count}} 個選項。',
      a11yOptionsCount_few: '共有 {{count}} 個選項。',
      a11yOptionsCount_many: '共有 {{count}} 個選項。',
      a11yOptionsCount_other: '共有 {{count}} 個選項。',
      listpickerSelectAll: '全選',
      listpickerSelectOption: '選擇一個選項',
      listpickerSearchAriaLabel: '搜尋篩選選項',
      listpickerSearchPlaceholder: '搜尋…',
      listpickerNoResults: '沒有相符的選項。',
      listpickerResults_zero: '{{count}} 個結果',
      listpickerResults_one: '1 個結果',
      listpickerResults_two: '{{count}} 個結果',
      listpickerResults_few: '{{count}} 個結果',
      listpickerResults_many: '{{count}} 個結果',
      listpickerResults_other: '{{count}} 個結果',
      listpickerCondensed_zero: '已選擇 {{count}} 個',
      listpickerCondensed_one: '已選擇 1 個',
      listpickerCondensed_two: '已選擇 {{count}} 個',
      listpickerCondensed_few: '已選擇 {{count}} 個',
      listpickerCondensed_many: '已選擇 {{count}} 個',
      listpickerCondensed_other: '已選擇 {{count}} 個',
      listpickerSelectAction: '選擇',
      scrollToLatest: '捲動至最新訊息',
      scrollToUnread_zero: '{{count}} 則新訊息，捲動至最新',
      scrollToUnread_one: '1 則新訊息，捲動至最新',
      scrollToUnread_two: '{{count}} 則新訊息，捲動至最新',
      scrollToUnread_few: '{{count}} 則新訊息，捲動至最新',
      scrollToUnread_many: '{{count}} 則新訊息，捲動至最新',
      scrollToUnread_other: '{{count}} 則新訊息，捲動至最新',
      showPassword: '顯示安全內容',
      hidePassword: '隱藏安全內容',
      clear: '清除',
      send: '傳送',
      yesterday: '昨天',
      chatEndedActions: '對話結束操作',
      openConversationDialog: '開啟與 {{title}} 的對話視窗',
      agentTyping: '客服專員正在輸入',
      agentAway: '我們的客服專員目前無法提供服務。',
      agentBusy: '我們的客服專員目前忙碌中，請稍候...',
      waitingForAgent: '正在為您接入客服專員...',
      waitingForAgentWithSkill: '正在為您接入 {{skill}} 客服專員...',
      talkingWithAgent: '正在與 {{name}} 對話',
      home: '首頁',
      back: '返回',
      menu: '選單',
      minimize: '最小化',
      endConversation: '結束對話',
      engageWithUs: '與我們聯絡',
      noMessagesYet: '尚無訊息',
      tryAgain: '再試一次',
      rating: '評分',
      shareLocation: '分享位置',
      locationShared: '已分享位置',
      locationError: '無法取得您的位置',
      locationPermissionDenied: '位置權限遭拒',
      geolocationUnavailable: '無法使用定位服務',
      selectFile: '選擇檔案',
      upload: '上傳',
      uploadComplete: '上傳完成',
      uploadFailed: '上傳失敗',
      fileTooLarge: '檔案太大',
      dragOrClick: '拖曳檔案或按一下以選擇',
      document: '文件',
      audioContent: '音訊內容',
      videoContent: '影片內容',
      unsupportedContent: '不支援的內容',
      unavailable: {
        error: {
          title: '發生錯誤',
          body: '我們無法載入對話，請再試一次。',
          retry: '再試一次',
        },
        maintenance: {
          title: '對話暫時無法使用',
          body: '我們正在進行預定維護，請稍後再回來。',
        },
      },
      image: '圖片',
    },
  },
  {
    lang: 'zh-TW',
    namespace: 'pype',
    file: 'common',
    translations: {
      conversationEnded: '此對話已結束。',
      agentConnected: '您已成功接入客服專員。',
      downloadTranscript: '下載記錄',
      startNewConversation: '開始新對話',
      returnToConversation: '返回對話',
      connecting: '連線中...',
      retry: '重試',
      network: {
        retry: '重新連線',
      },
      reconnecting: '重新連線中...',
      connectionLost: '網路連線已中斷',
      reconnectDescription: '網路連線已中斷。請按一下「重新連線」以重試。',
      typeMessage: '輸入訊息',
      inputSelect: '選擇選項',
      inputSelectOrType: '選擇選項或輸入訊息',
      secureInput: '輸入安全訊息',
      secureValueHidden: '隱藏的安全值',
      startChat: '開始對話',
      settings: '設定',
      cancel: '取消',
      confirm: '確認',
      close: '關閉',
      next: '下一步',
      brandingTagline: '以智慧型 AI 代理為您的業務賦能',
      poweredBy: '技術支援',
      pypestreamCom: 'Pypestream.com',
      assistant: '助理',
      assistantThinking: '助理正在思考',
      youSaid: '您說',
      assistantSays: '助理說',
      agentSays: '{{name}} 說',
      joinMeeting: '加入會議',
      meetingInProgress: '會議進行中 — 按一下以重新加入',
      meetingExpired: '會議連結（已過期）',
      embeddedContent: '嵌入內容',
      openInNewTab: '在新分頁中開啟',
      skipToMain: '跳至主要內容',
      loadingCustomerSolution: '正在載入 {{customerName}} 解決方案',
      loadingSolution: '正在載入解決方案',
      customerLogoAlt: '{{customerName}} 標誌',
      selectDate: '選擇日期',
      selectTime: '選擇時間',
      browseOptions: '瀏覽選項',
      carouselRoleDescription: '輪播',
      carouselSlideLabel: '第 {{current}} 張，共 {{total}} 張',
      carouselPrevious: '上一項',
      carouselNext: '下一項',
      carouselGoToItem: '前往第 {{index}} 項',
      collapse: '收合',
      expand: '展開',
      messageHistory: '訊息記錄',
      reduce: '縮小',
      today: '今天',
      at: '於',
      a11yOptionsCount_zero: '共有 {{count}} 個選項。',
      a11yOptionsCount_one: '有 1 個選項。',
      a11yOptionsCount_two: '共有 {{count}} 個選項。',
      a11yOptionsCount_few: '共有 {{count}} 個選項。',
      a11yOptionsCount_many: '共有 {{count}} 個選項。',
      a11yOptionsCount_other: '共有 {{count}} 個選項。',
      listpickerSelectAll: '全選',
      listpickerSelectOption: '選擇一個選項',
      listpickerSearchAriaLabel: '搜尋篩選選項',
      listpickerSearchPlaceholder: '搜尋…',
      listpickerNoResults: '沒有相符的選項。',
      listpickerResults_zero: '{{count}} 個結果',
      listpickerResults_one: '1 個結果',
      listpickerResults_two: '{{count}} 個結果',
      listpickerResults_few: '{{count}} 個結果',
      listpickerResults_many: '{{count}} 個結果',
      listpickerResults_other: '{{count}} 個結果',
      listpickerCondensed_zero: '已選擇 {{count}} 個',
      listpickerCondensed_one: '已選擇 1 個',
      listpickerCondensed_two: '已選擇 {{count}} 個',
      listpickerCondensed_few: '已選擇 {{count}} 個',
      listpickerCondensed_many: '已選擇 {{count}} 個',
      listpickerCondensed_other: '已選擇 {{count}} 個',
      listpickerSelectAction: '選擇',
      scrollToLatest: '捲動至最新訊息',
      scrollToUnread_zero: '{{count}} 則新訊息，捲動至最新',
      scrollToUnread_one: '1 則新訊息，捲動至最新',
      scrollToUnread_two: '{{count}} 則新訊息，捲動至最新',
      scrollToUnread_few: '{{count}} 則新訊息，捲動至最新',
      scrollToUnread_many: '{{count}} 則新訊息，捲動至最新',
      scrollToUnread_other: '{{count}} 則新訊息，捲動至最新',
      showPassword: '顯示安全內容',
      hidePassword: '隱藏安全內容',
      clear: '清除',
      send: '傳送',
      yesterday: '昨天',
      chatEndedActions: '對話結束操作',
      openConversationDialog: '開啟與 {{title}} 的對話視窗',
      agentTyping: '客服專員正在輸入',
      agentAway: '我們的客服專員目前無法提供服務。',
      agentBusy: '我們的客服專員目前忙碌中，請稍候...',
      waitingForAgent: '正在為您接入客服專員...',
      waitingForAgentWithSkill: '正在為您接入 {{skill}} 客服專員...',
      talkingWithAgent: '正在與 {{name}} 對話',
      home: '首頁',
      back: '返回',
      menu: '選單',
      minimize: '最小化',
      endConversation: '結束對話',
      engageWithUs: '與我們聯絡',
      noMessagesYet: '尚無訊息',
      tryAgain: '再試一次',
      rating: '評分',
      shareLocation: '分享位置',
      locationShared: '已分享位置',
      locationError: '無法取得您的位置',
      locationPermissionDenied: '位置權限遭拒',
      geolocationUnavailable: '無法使用定位服務',
      selectFile: '選擇檔案',
      upload: '上傳',
      uploadComplete: '上傳完成',
      uploadFailed: '上傳失敗',
      fileTooLarge: '檔案太大',
      dragOrClick: '拖曳檔案或按一下以選擇',
      document: '文件',
      audioContent: '音訊內容',
      videoContent: '影片內容',
      unsupportedContent: '不支援的內容',
      unavailable: {
        error: {
          title: '發生錯誤',
          body: '我們無法載入對話，請再試一次。',
          retry: '再試一次',
        },
        maintenance: {
          title: '對話暫時無法使用',
          body: '我們正在進行預定維護，請稍後再回來。',
        },
      },
      image: '圖片',
    },
  },
];
